webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/3MTari/%3F1730410281305&title=The%20Eerdmans%20Dictionary%20of%20Early%20Judaism&summary=The%20Dictionary%20of%20Early%20Judaism%20is%20the%20first%20reference%20work%20devoted%20exclusively%20to%20Second%20Temple%20Judaism%20%28fourth%20century%20b.c.e.%20through%20second%20century%20c.e.%29.%20The%20first%20section%20of%20this%20substantive%20and%20incredible%20work%20contains%20thirteen%20major%20essays%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/3MTari/%3F1730410281305",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20Dictionary%20of%20Early%20Judaism%20is%20the%20first%20reference%20work%20devoted%20exclusively%20to%20Second%20Temple%20Judaism%20%28fourth%20century%20b.c.e.%20through%20second%20c%0Dhttps://textcafe.co/books/3MTari/%3F1730410281305&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/3MTari/%3F1730410281305&posttype=link&caption=The%20Dictionary%20of%20Early%20Judaism%20is%20the%20first%20reference%20work%20devoted%20exclusively%20to%20Second%20Temple%20Judaism%20%28fourth%20century%20b.c.e.%20through%20second%20century%20c.e.%29.%20The%20first%20section%20of%20this%20substantive%20and%20incredible%20work%20contains%20thirteen%20major%20essays%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/3MTari/%3F1730410281305&description=The%20Dictionary%20of%20Early%20Judaism%20is%20the%20first%20reference%20work%20devoted%20exclusively%20to%20Second%20Temple%20Judaism%20%28fourth%20century%20b.c.e.%20through%20second%20century%20c.e.%29.%20The%20first%20section%20of%20this%20substantive%20and%20incredible%20work%20contains%20thirteen%20major%20essays%20&media=https://textcafe.co/books/3MTari/tc-custom/9781467466097.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/0802825494?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=M8yAEAAAQBAJ&amp;rdid=book-M8yAEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467466097').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/3MTari/tc-custom/9781467466097.jpg?1730410281305',
        alt: 'The Eerdmans Dictionary of Early Judaism'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Preface", "007_Consulting_Editors", "008_Contributors", "009_Alphabetical_List", "010_Topical_List", "011_Map_List", "012_Chronology", "013_Abbreviations", "014_Chapter01", "015_Chapter02", "016_Chapter03", "017_Chapter04", "018_Chapter05", "019_Chapter06", "020_Chapter07", "021_Chapter08", "022_Chapter09", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/3MTari/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_FM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Consulting_Editors__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Consulting_Editors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Consulting_Editors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Contributors__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Contributors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Contributors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Alphabetical_List__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Alphabetical_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Alphabetical_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Topical_List__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Topical_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Topical_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Map_List__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Map_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_011_Map_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chronology__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chronology___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_012_Chronology__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Abbreviations__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_013_Abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter01__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_014_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter02__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_015_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter03__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_016_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter04__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_017_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Chapter05__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_018_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter06__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_019_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter07__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_020_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter08__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_021_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter09__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_022_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter10__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_023_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter11__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_024_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter12__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_025_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter13__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_026_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_027_BM01__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_027_BM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_027_BM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_028_Dictionary_A1__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_028_Dictionary_A1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_028_Dictionary_A1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_028_Dictionary_A2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_028_Dictionary_A2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_028_Dictionary_A2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_028_Dictionary_A3__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_028_Dictionary_A3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_028_Dictionary_A3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_029_Dictionary_B__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_029_Dictionary_B___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_029_Dictionary_B__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_030_Dictionary_C__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_030_Dictionary_C___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_030_Dictionary_C__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_031_Dictionary_D__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_031_Dictionary_D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_031_Dictionary_D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_032_Dictionary_E1__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_032_Dictionary_E1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_032_Dictionary_E1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_032_Dictionary_E2__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_032_Dictionary_E2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_032_Dictionary_E2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_033_Dictionary_F__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_033_Dictionary_F___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_033_Dictionary_F__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_034_Dictionary_G__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_034_Dictionary_G___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_034_Dictionary_G__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_035_Dictionary_H__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_035_Dictionary_H___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_035_Dictionary_H__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_036_Dictionary_I__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_036_Dictionary_I___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_036_Dictionary_I__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_037_Dictionary_J1__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_037_Dictionary_J1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_037_Dictionary_J1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_037_Dictionary_J2__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_037_Dictionary_J2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_037_Dictionary_J2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_038_Dictionary_K__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_038_Dictionary_K___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_038_Dictionary_K__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_039_Dictionary_L__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_039_Dictionary_L___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_039_Dictionary_L__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_040_Dictionary_M1__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_040_Dictionary_M1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_040_Dictionary_M1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_040_Dictionary_M2__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_040_Dictionary_M2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_040_Dictionary_M2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_041_Dictionary_N__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_041_Dictionary_N___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_041_Dictionary_N__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_042_Dictionary_O__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_042_Dictionary_O___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_042_Dictionary_O__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_043_Dictionary_P1__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_043_Dictionary_P1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_043_Dictionary_P1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_043_Dictionary_P2__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_043_Dictionary_P2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_043_Dictionary_P2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_043_Dictionary_P3__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_043_Dictionary_P3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_043_Dictionary_P3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_044_Dictionary_Q__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_044_Dictionary_Q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_044_Dictionary_Q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_045_Dictionary_R__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_045_Dictionary_R___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_045_Dictionary_R__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_046_Dictionary_S1__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_046_Dictionary_S1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_046_Dictionary_S1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_046_Dictionary_S2__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_046_Dictionary_S2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_046_Dictionary_S2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_046_Dictionary_S3__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_046_Dictionary_S3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_046_Dictionary_S3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_047_Dictionary_T__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_047_Dictionary_T___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_047_Dictionary_T__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_048_Dictionary_U__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_048_Dictionary_U___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_048_Dictionary_U__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_049_Dictionary_V__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_049_Dictionary_V___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_049_Dictionary_V__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_050_Dictionary_W__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_050_Dictionary_W___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_050_Dictionary_W__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_051_Dictionary_Y__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_051_Dictionary_Y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_051_Dictionary_Y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_052_Dictionary_Z__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_052_Dictionary_Z___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_052_Dictionary_Z__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_last__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_last__);
/*jshint esversion: 6 */





































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Preface",
    "name": "006_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default.a
  }, {
    "path": "/007_Consulting_Editors",
    "name": "007_Consulting_Editors",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Consulting_Editors___default.a
  }, {
    "path": "/008_Contributors",
    "name": "008_Contributors",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Contributors___default.a
  }, {
    "path": "/009_Alphabetical_List",
    "name": "009_Alphabetical_List",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Alphabetical_List___default.a
  }, {
    "path": "/010_Topical_List",
    "name": "010_Topical_List",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Topical_List___default.a
  }, {
    "path": "/011_Map_List",
    "name": "011_Map_List",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_011_Map_List___default.a
  }, {
    "path": "/012_Chronology",
    "name": "012_Chronology",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_012_Chronology___default.a
  }, {
    "path": "/013_Abbreviations",
    "name": "013_Abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_013_Abbreviations___default.a
  }, {
    "path": "/014_Chapter01",
    "name": "014_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter01___default.a
  }, {
    "path": "/015_Chapter02",
    "name": "015_Chapter02",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter02___default.a
  }, {
    "path": "/016_Chapter03",
    "name": "016_Chapter03",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter03___default.a
  }, {
    "path": "/017_Chapter04",
    "name": "017_Chapter04",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter04___default.a
  }, {
    "path": "/018_Chapter05",
    "name": "018_Chapter05",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_018_Chapter05___default.a
  }, {
    "path": "/019_Chapter06",
    "name": "019_Chapter06",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter06___default.a
  }, {
    "path": "/020_Chapter07",
    "name": "020_Chapter07",
    "component": __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter07___default.a
  }, {
    "path": "/021_Chapter08",
    "name": "021_Chapter08",
    "component": __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter08___default.a
  }, {
    "path": "/022_Chapter09",
    "name": "022_Chapter09",
    "component": __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter09___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_66__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John J. Collins, Daniel C. Harlow\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("John J. Collins")]), _vm._v(" is Holmes Professor of Old Testament Criticism and Interpretation at Yale Divinity School and a recognized expert in early Judaism and the Dead Sea Scrolls. His many other works include "), _c('I', [_vm._v("The Apocalyptic Imagination")]), _vm._v(", "), _c('I', [_vm._v("Beyond the Qumran Community")]), _vm._v(", "), _c('I', [_vm._v("The Scepter and the Star")]), _vm._v(", and (with Daniel C. Harlow) "), _c('I', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3MTari/tc-custom/9781467466097.jpg?1730410281305",
      "alt": "This image is the cover for the book The Eerdmans Dictionary of Early Judaism"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Eerdmans Dictionary of Early Judaism\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Dictionary of Early Judaism is the first reference work devoted exclusively to Second Temple Judaism (fourth century b.c.e. through second century c.e.). "), _c('br'), _c('br'), _vm._v("The first section of this substantive and incredible work contains thirteen major essays that attempt to synthesize major aspects of Judaism in the period between Alexander and Hadrian. The second — and significantly longer — section offers 520 entries arranged alphabetically. Many of these entries have cross-references and all have select bibliographies. Equal attention is given to literary and nonliterary (i.e. archaeological and epigraphic) evidence and New Testament writings are included as evidence for Judaism in the first century c.e. Several entries also give pertinent information on the Hebrew Bible. "), _c('br'), _c('br'), _vm._v("The Dictionary of Early Judaism is intended to not only meet the needs of scholars and students — at which it succeeds admirably — but also to provide accessible information for the general reader. It is ecumenical and international in character, bringing together nearly 270 authors from as many as twenty countries and including Jews, Christians, and scholars of no religious affiliation.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Consulting_Editors#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONSULTING")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDITORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Contributors#fm-3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONTRIBUTORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Alphabetical_List#fm-4"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALPHABETICAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Topical_List#fm-5"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOPICAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Map_List#fm-6"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MAPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chronology#fm-7"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHRONOLOGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Abbreviations#fm-8"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-parta"
  }, [_c('strong', [_vm._v("ESSAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter01#ch-1"
    }
  }, [_vm._v("Early Judaism in Modern Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter01#ch-1"
    }
  }, [_c('em', [_vm._v("John J. Collins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter02#ch-2"
    }
  }, [_vm._v("Jewish History from Alexander to Hadrian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter02#ch-2"
    }
  }, [_c('em', [_vm._v("Chris Seeman and Adam Kolman Marshak")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter03#ch-3"
    }
  }, [_vm._v("Judaism in the Land of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter03#ch-3"
    }
  }, [_c('em', [_vm._v("James C. VanderKam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter04#ch-4"
    }
  }, [_vm._v("Judaism in the Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter04#ch-4"
    }
  }, [_c('em', [_vm._v("Erich S. Gruen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter05#ch-5"
    }
  }, [_vm._v("The Jewish Scriptures: Texts, Versions, Canons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter05#ch-5"
    }
  }, [_c('em', [_vm._v("Eugene Ulrich")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/019_Chapter06#ch-6"
    }
  }, [_vm._v("Early Jewish Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/019_Chapter06#ch-6"
    }
  }, [_c('em', [_vm._v("James L. Kugel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/020_Chapter07#ch-7"
    }
  }, [_vm._v("Apocrypha and Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/020_Chapter07#ch-7"
    }
  }, [_c('em', [_vm._v("Loren T. Stuckenbruck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/021_Chapter08#ch-8"
    }
  }, [_vm._v("Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/021_Chapter08#ch-8"
    }
  }, [_c('em', [_vm._v("Eibert Tigchelaar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/022_Chapter09#ch-9"
    }
  }, [_vm._v("Early Jewish Literature Written in Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/022_Chapter09#ch-9"
    }
  }, [_c('em', [_vm._v("Katell Berthelot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Archaeology, Papyri, and Inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jürgen K. Zangenberg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jews among Greeks and Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Miriam Pucci Ben Zeev")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Judaism and Early Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Daniel C. Harlow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Judaism and Rabbinic Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lawrence H. Schiffman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-parta"
  }, [_c('span', {
    attrs: {
      "href": "#/027_BM01#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("DICTIONARY ENTRIES A-Z")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The field of Second Temple Judaism has emerged as a major area of study only in this generation. In large part, the flowering of the field has been due to the discovery of the Dead Sea Scrolls, which made available for the first time a wealth of primary sources for the period between the Bible and the Mishnah. There has also been a resurgence of interest in the Pseudepigrapha, the large and loosely defined corpus of literature transmitted by Christians that includes many works of Jewish origin. Despite the proliferation of studies, however, there has not hitherto existed a major reference work devoted specifically to this period. At the beginning of the twenty-first century, the time is ripe to take stock of this burgeoning field.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Naming and delimiting the field have been a problem. The old German label "), _c('em', [_vm._v("Spätjudentum")]), _vm._v(" (“Late Judaism”) had pejorative connotations, and in any case was largely based on the rabbinic literature, from a later period. Second Temple Judaism, strictly defined, includes most of the Hebrew Bible, while several major nonbiblical, nonrabbinic works were composed after the destruction of the Temple in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" (e.g., the writings of Josephus, some of the apocalypses). “Early Judaism” has been the accepted name for the Judaism of the Hellenistic and early Roman period in the Society of Biblical Literature for some time, and that is the name we have adopted here. The boundaries of the period are admittedly fuzzy. The primary focus falls on the period between Alexander the Great in the late fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and the Roman emperor Hadrian and the Bar Kokhba Revolt in the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" It is impossible to study this period, however, without taking some account of the Persian period and the postexilic biblical books, on the one hand, and of the subsequent development of rabbinic Judaism, on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This Dictionary has two parts. The first part contains thirteen major essays that attempt to synthesize major aspects of Judaism in this period. The second, substantially longer part offers 520 entries arranged alphabetically. Many of these entries have cross-references, and all have select bibliographies. Equal attention is given to literary and nonliterary evidence. The New Testament writings are included, as evidence for Judaism in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" This volume does not attempt full treatment of the Hebrew Bible or rabbinic Judaism, but it does contain some entries on these areas that provide the reader with at least initial reference information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The volume is intended to meet the needs of scholars and students, but also to provide accessible information for the general reader. It is ecumenical and international in character. Two hundred and sixty-six authors, from as many as twenty countries, have contributed. These include Jews, Christians, and people of no religious affiliation. Naturally, the opinions of these authors are diverse, but all are competent scholars with expertise in the subjects they address.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The completion of this Dictionary would not have been possible without help from several quarters. At Eerdmans Michael Thomson first broached the idea and asked us to undertake it. Klaas Wolterstorff over-saw the volume’s production at every stage with great care and expertise. Tim Straayer did the laborious work of electronic compositing. Nancy Collins was a great help with researching illustrations. Willem Mineur came up with a fetching cover design. Milton Essenburg put our pages through several rigorous rounds of proofreading. And Tracey Gebbia produced the ancient city maps. Calvin College provided Dan Harlow with a sabbatical in January and Spring 2005 so that he could lay the groundwork for this project. Several contributors went above and beyond the call of duty by providing replacement articles on short notice as the project drew to a close. To these, and to all our colleagues who took the time to write articles for this volume, we are deeply grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLINS")])]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANIEL")]), _vm._v(" C. H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLOW")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Consulting Editors")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STHER")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAZON")])]), _vm._v(" Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAYE")]), _vm._v(" J. D. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHEN")])]), _vm._v(" Harvard University, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVORAH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMANT")])]), _vm._v(" Haifa University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANAN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SHEL")])]), _vm._v("† Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RICH")]), _vm._v(" S. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUEN")])]), _vm._v(" University of California, Berkeley")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTHA")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMMELFARB")])]), _vm._v(" Princeton University, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" L. K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UGEL")])]), _vm._v(" Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDY")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AJMAN")])]), _vm._v(" University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EORGE")]), _vm._v(" W. E. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICKELSBURG")])]), _vm._v(" University of Iowa, Iowa City")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWRENCE A.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHIFFMAN")])]), _vm._v(" New York University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHAEL")]), _vm._v(" E. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TONE")])]), _vm._v(" Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" C. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANDERKAM")])]), _vm._v(" University of Notre Dame, Indiana")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('em', [_vm._v("Contributors")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Martin G. Abegg Jr.")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("War, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Samuel L. Adams")]), _vm._v(" Assistant Professor of Old Testament, Union Theological Seminary and Presbyterian School of Christian Education, Richmond, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Proverbs, Book of; Qoheleth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("William Adler")]), _vm._v(" Professor of Early Christianity and Judaism, North Carolina State University, Raleigh, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Chronography; Demetrius the Chronographer")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Patricia Ahearne-Kroll")]), _vm._v(" Assistant Professor of Religion, Ohio Wesleyan University, Delaware, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph and Aseneth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dale C. Allison Jr.")]), _vm._v(" Errett M. Grable Professor of Early Christianity, Pittsburgh Theological Seminary, Pittsburgh, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Abraham, Testament of; Elisha; Kingdom of God")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Amit")]), _vm._v(" Deputy Director, Department of Excavations and Surveys, Israel Antiquities Authority, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aqueducts; Cisterns and Reservoirs")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Randal A. Argall")]), _vm._v(" Associate Professor of Religion, Jamestown College, North Dakota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Persecuted Righteous Person")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel Assefa")]), _vm._v(" Assistant Professor of Sacred Scriptures, Capuchin Franciscan Institute of Philosophy and Theology, Addis Ababa, Ethiopia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dreams, Book of (1 Enoch 83–90); Ethiopic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kenneth Atkinson")]), _vm._v(" Associate Professor of Religion, University of Northern Iowa, Cedar Falls, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Gamla; Masada; Solomon, Psalms of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Harold W. Attridge")]), _vm._v(" The Reverend Henry L. Black Dean and Lillian Claus Professor of New Testament, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greek Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David E. Aune")]), _vm._v(" Professor of New Testament, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miracles and Miracle Workers; Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alan J. Avery-Peck")]), _vm._v(" Kraft-Hiatt Professor in Judaic Studies, College of the Holy Cross, Worcester, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Neusner, Jacob")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel P. Bailey")]), _vm._v(" Adjunct Professor of New Testament and Greek, Northern Seminary, Lombard, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Arch of Titus; Atonement; Suffering Servant")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carol Bakhos")]), _vm._v(" Associate Professor of Near Eastern Languages and Cultures, University of California at Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Midrash, Midrashim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Elitzur Avraham Bar-Asher")]), _vm._v(" Lecturer, School of Linguistics and Department of the Hebrew Language, The Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John M. G. Barclay")]), _vm._v(" J. B. Lightfoot Professor of Divinity, University of Durham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Assimilation, Acculturation, Accommodation; Apostasy; Grace; Josephus, Against Apion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Albert I. Baumgarten")]), _vm._v(" Professor of Jewish History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bickerman, Elias; Smith, Morton")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Bernat")]), _vm._v(" Assistant Professor of Bible, Hebrew College, Newton, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adiabene; Circumcision")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("Shani Berrin Tzoref")]), _vm._v(" Lecturer in Hebrew, Jewish, and Biblical Studies, University of Sydney, Australia")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pesharim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan Ben-Dov")]), _vm._v(" Lecturer in Bible, Haifa University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonian Culture; Calendars; Mishmarot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Beth A. Berkowitz")]), _vm._v(" Associate Professor of Talmud and Rabbinics, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonian Talmud")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Katell Berthelot")]), _vm._v(" Chargée de recherche au Centre National pour la Recherche Scientifique, Aix-en-Provence, France; Centre de Recherche Français de Jérusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Jewish Literature Written in Greek”; Hecataeus of Abdera; Universalism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("René S. Bloch")]), _vm._v(" Research Fellow, University of Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Orpheus, Pseudo-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gideon Bohak")]), _vm._v(" Senior Lecturer in Jewish Philosophy and Religious Studies, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Amulets; Divination and Magic; Gematria; Gentile Attitudes toward Jews and Judaism; Heliopolis; Oniads")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marianne Palmer Bonz")]), _vm._v(" Independent Scholar, Plymouth, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sardis")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Oded Borowski")]), _vm._v(" Professor of Middle Eastern Studies, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Agriculture in Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alejandro F. Botta")]), _vm._v(" Assistant Professor of Hebrew Bible, Boston University School of Theology, Boston, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elephantine, Elephantine Papyri; Sanballat; Slaves, Slavery")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ra")]), _c('span', {
    staticClass: "awbd"
  }, [_vm._v("ʿ")]), _c('strong', [_vm._v("anan Boustan")]), _vm._v(" Assistant Professor of History, University of California at Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hekhalot Literature; Ishmael b. Elisha; Yo")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("anan b. Zakkai")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Beverly A. Bow")]), _vm._v(" Assistant Professor of Religious Studies, Cleveland State University, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Birth, Miraculous")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James E. Bowley")]), _vm._v(" Professor of Religious Studies, Millsaps College, Jackson, Mississippi")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Abraham; Apollonius Molon; Aristobulus; Artapanus; Berossus; Cleodemus Malchus; Justus of Tiberius; Nicolaus of Damascus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Monica Brady")]), _vm._v(" Research Associate, Department of Theology, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Prophets, Pseudo-Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("George J. Brooke")]), _vm._v(" Rylands Professor of Biblical Criticism and Exegesis, University of Manchester, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Genesis and Exodus, Commentary on (4Q422); Florilegium (4Q174); Genesis Apocryphon; Testimonia (4Q175)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Magen Broshi")]), _vm._v(" Curator Emeritus, Shrine of the Book, Israel Museum, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Diet in Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joshua Ezra Burns")]), _vm._v(" Assistant Professor of Theology, Marquette University, Milwaukee, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Conversion and Proselytism; God-fearers")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Carr")]), _vm._v(" Professor of Hebrew Bible, Union Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Literacy and Reading; Pentateuch; Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Mark A. Chancey")]), _vm._v(" Associate Professor of Religious Studies, Southern Methodist University, Dallas, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jotapata; Romanization; Sanders, E. P.; Stone Vessels; Temple Tax")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David W. Chapman")]), _vm._v(" Associate Professor of New Testament and Biblical Archaeology, Covenant Theological Seminary, St. Louis, Missouri")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Family")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James H. Charlesworth")]), _vm._v(" George L. Collard Professor of New Testament, Princeton Theological Seminary, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Serpent")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Esther G. Chazon")]), _vm._v(" Senior Lecturer in Hebrew Literature, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Words of the Luminaries (4Q181)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Randall D. Chesnutt")]), _vm._v(" William S. Banowsky Chair in Religion, Pepperdine University, Malibu, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Solomon, Wisdom of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kelley Coblentz Bautch")]), _vm._v(" Associate Professor of Religious Studies, St. Edward’s University, Austin, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Geography, Mythic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Shaye J. D. Cohen")]), _vm._v(" Nathan Littauer Professor of Hebrew Literature and Philosophy, Harvard University, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ioudaios; Judaizing; Mishnah; Tosefta; Yavneh")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John J. Collins")]), _vm._v(" Holmes Professor of Old Testament Criticism and Interpretation, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism in Modern Scholarship”; Apocalypse; Apologetic Literature; Canon; Death and Afterlife; Enoch, Ethiopic Apocalypse of (1 Enoch); Eschatology; Exodus, the; Hecataeus, Pseudo-; Philo the Epic Poet; Tcherikover, Victor (Avigdor)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Edward M. Cook")]), _vm._v(" Associate Professor of Semitics, Catholic University of America, Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aramaic")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('strong', [_vm._v("Mary Rose D’Angelo")]), _vm._v(" Associate Professor of New Testament, University of Notre Dame, Indiana")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James R. Davila")]), _vm._v(" Professor of Early Jewish Studies, St. Mary’s College, University of St. Andrews, St. Andrews, Fife, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Liturgical Works from Qumran; Pseudepigrapha, Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Roland Deines")]), _vm._v(" Professor and Reader in New Testament, University of Nottingham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pharisees")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pascale Derron")]), _vm._v(" Librarian, Bibliothèque Cantonale et Universitaire de Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Phocylides, Pseudo-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Devorah Dimant")]), _vm._v(" George and Florence Wise Professor Emerita of Judaism in the Ancient World, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pesher on the Periods (4Q180); Wicked and Holy (4Q181)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lorenzo DiTommaso")]), _vm._v(" Associate Professor of Theology, Concordia University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Daniel, Additions to; Daniel, Book of; Daniel, Pseudo-Texts; Jerusalem, New; New Jerusalem Text; Sibylline Oracles")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert Doran")]), _vm._v(" Samuel Williston Professor of Greek and Hebrew, Amherst College, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antiochus IV Epiphanes; Eupolemus; Eupolemus, Pseudo-; Thallus; Theodotus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Henryk Drawnel")]), _vm._v(" Assistant Professor of Old Testament, Catholic University of Lublin, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Amram, Visions of; Elect of God (4Q534-536); Qahat, Admonitions of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jean Duhaime")]), _vm._v(" Professor of Biblical Interpretation, Faculté de Théologie, Université de Montreal, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("War Scroll (1QM)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James D. G. Dunn")]), _vm._v(" J. B. Lightfoot Professor of Divinity, Emeritus, University of Durham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jesus Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Yaron Eliav")]), _vm._v(" Jean and Samuel Frankel Associate Professor of Rabbinic Literature and Jewish History of Late Antiquity, University of Michigan, Ann Arbor, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baths; Medicine and Hygiene")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Peter Enns")]), _vm._v(" Senior Fellow, Biblical Studies, The Biologos Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Lives of the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tali Erickson-Gini")]), _vm._v(" Archaeological Inspector, Southern Negev District, Israel Antiquities Authority, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pottery")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Esther Eshel")]), _vm._v(" Senior Lecturer in Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Demons and Exorcism; Genesis Apocryphon; Jonathan the King Text (4Q448); Self-Glorification Hymn")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Hanan Eshel†")]), _vm._v(" Professor of Land of Israel Studies and Archaeology, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bar Kokhba Caves; Bar Kokhba Revolt; Na")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("al")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("ever; Murabba")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("at, Wadi")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Craig A. Evans")]), _vm._v(" Payzant Distinguished Professor of New Testament, Acadia Divinity School, Wolfville, Nova Scotia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elders; Joshua, Apocryphon of; Mark, Gospel of; Sanhedrin; Tan")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("umim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel K. Falk")]), _vm._v(" Associate Professor of Religious Studies, University of Oregon, Eugene")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Festivals and Holy Days; Moses; Moses Texts from Qumran; Rule of Blessings (1QSb); Sabbath")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David A. Fiensy")]), _vm._v(" Professor of New Testament, Kentucky Christian University, Grayson")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Homily")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stephen Finlan")]), _vm._v(" Adjunct Professor of Religious Studies, Manhattan College, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Atonement")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Frances Flannery")]), _vm._v(" Associate Professor of Religion, James Madison University, Harrisonburg, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dream and Vision Reports")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Peter W. Flint")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Papyri from Qumran Cave 7; Psalm 151; Psalms Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael F. Fox")]), _vm._v(" Halls-Baxcom Professor of Hebrew Emeritus, University of Wisconsin, Madison, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Esther, Book of; Esther, Greek Version of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven D. Fraade")]), _vm._v(" Mark Taper Professor of the History of Judaism, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Targum, Targumim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jörg Frey")]), _vm._v(" Professor of New Testament, University of Zurich, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Essenes; Hengel, Martin; Schürer, Emil")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sean Freyne")]), _vm._v(" Director of Mediterranean and Near Eastern Studies, Emeritus Professor of Theology, Trinity College, Dublin, Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Galilee; Iturea")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('strong', [_vm._v("Deirdre N. Fulton")]), _vm._v(" Lecturer in Classics and Ancient Mediterranean Studies, Pennsylvania State University, University Park, Pennsylvania")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Esdras, First Book of; Genealogies")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Katharina Galor")]), _vm._v(" Adjunct Professor of Art History, Rhode Island School of Design and Adjunct Assistant Professor of Judaic Studies, Brown University, Providence, Rhode Island")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tiberias")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sandra Gambetti")]), _vm._v(" Associate Professor of History, College of Staten Island, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Diadochi; Ptolemies; Roman Emperors; Seleucids")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Simon Gathercole")]), _vm._v(" Lecturer in New Testament Studies and Fellow, Fitzwilliam College, Cambridge University, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Covenantal Nomism; Election; Wisdom (Personified)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Susan Gelb Rosenberg")]), _vm._v(" Research Fellow in Classics, University of Texas at Austin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Transjordan")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gary Gilbert")]), _vm._v(" Associate Professor of Religious Studies, Claremont McKenna College, Claremont, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aphrodisias; Gentiles, Jewish Attitudes toward")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Yonder M. Gillihan")]), _vm._v(" Assistant Professor of Theology, Boston College, Chestnut Hill, Massachusetts "), _c('em', [_vm._v("Associations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Haim Gitler")]), _vm._v(" Curator of Numismatics, Israel Museum, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Coins")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matthew Goff")]), _vm._v(" Associate Professor of Religious Studies, Florida State University, Tallahassee, Florida")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Beatitudes (4QBeatitudes); Instruction (4QInstruction); Wisdom Literature; Wisdom Texts at Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert Goldenberg")]), _vm._v(" Professor of History and Judaic Studies, Stony Brook University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pagan Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Roger Good")]), _vm._v(" Editor, Living Stream Ministry, Anaheim, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jacob")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lester L. Grabbe")]), _vm._v(" Professor of Theology, University of Hull, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonians; Mesopotamia, Media, and Babylonia; Parthians; Persian Period; Popular Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David F. Graf")]), _vm._v(" Professor of Religious Studies, University of Miami, Coral Gables, Florida")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Nabatea")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Deborah A. Green")]), _vm._v(" Greenberg Assistant Professor of Hebrew Language and Literature, University of Oregon, Eugene, Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tales of the Persian Court (4Q550)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Leonard J. Greenspoon")]), _vm._v(" Klutznick Chair in Jewish Civilization, Creighton University, Omaha, Nebraska")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Septuagint")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bradley C. Gregory")]), _vm._v(" Assistant Professor of Theology and Religious Studies, University of Scranton, Scranton, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Wealth and Poverty")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Andrew David Gross")]), _vm._v(" Assistant Professor of Semitic Languages, Catholic University of America, Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Oaths and Vows; Temple Scroll (4QTemple)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Erich S. Gruen")]), _vm._v(" Gladys Rehard Wood Professor of History and Classics, Emeritus, University of California, Berkeley")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Judaism in the Diaspora”; Hellenism, Hellenization")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Oren Gutfeld")]), _vm._v(" Lecturer in Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Araq el-Amir; Jericho")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Noah Hacham")]), _vm._v(" Lecturer in Jewish History, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Fasting")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rachel Hachlili")]), _vm._v(" Professor of Archaeology, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Architecture; Art; Burial Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gideon Hadas")]), _vm._v(" Director, Ein Gedi Oasis Excavations, Kibbutz Ein Gedi, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ein Gedi")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert G. Hall")]), _vm._v(" Elliot Professor of Religion, Hampden-Sydney College, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah, Ascension of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Betsy Halpern-Amaru")]), _vm._v(" Professor Emerita of Religion, Vassar College, Poughkeepsie, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judith, Book of; Land, Concept of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel C. Harlow")]), _vm._v(" Professor of Religion, Calvin College, Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism and Early Christianity”; Abraham, Apocalypse of; Ascent to Heaven; Baruch, Third Book of; Demons and Exorcism; Fortresses and Palaces; Joseph, Prayer of; Messianic Apocalypse (4Q521); Phoenix")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel J. Harrington, S.J.")]), _vm._v(" Professor of New Testament, Boston College, Chestnut Hill, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Apocrypha; Baruch, First Book of; Ethics; Jeremiah, Letter of; Maccabean Revolt; Paul")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('strong', [_vm._v("Hannah K. Harrington")]), _vm._v(" Professor of Old Testament, Patten University, Oakland, California")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Holiness; Purity and Impurity; Sin; Tohorot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Charlotte Hempel")]), _vm._v(" Birmingham Fellow, Department of Theology and Religion, University of Birmingham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Damascus Document")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Henshke")]), _vm._v(" Professor of Talmud, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tithing")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matthias Henze")]), _vm._v(" Watt J. and Lilly G. Jackson Associate Professor of Biblical Studies, Rice University, Houston, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baruch, Second Book of; Nebuchadnezzar; Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jens Herzer")]), _vm._v(" Professor of New Testament Exegesis and Theology, University of Leipzig, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baruch, Fourth Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Karina Martin Hogan")]), _vm._v(" Assistant Professor of Theology, Fordham University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezra, Fourth Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Anders Hultgård")]), _vm._v(" Professor Emeritus of the History of Religions, University of Uppsala, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Persian Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Larry W. Hurtado")]), _vm._v(" Professor of New Testament Language, Literature, and Theology, School of Divinity, New College, University of Edinburgh, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mediator Figures; Monotheism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tal Ilan")]), _vm._v(" Professor of Jewish Studies, Institut für Judaistik, Freie Universität, Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Women")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Instone-Brewer")]), _vm._v(" Research Fellow, Tyndale House, Cambridge, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Marriage and Divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matt Jackson-McCabe")]), _vm._v(" Associate Professor of Religious Studies, Niagara University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("James, Epistle of; Jude, Epistle of; Peter, Epistles of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Naomi Jacobs")]), _vm._v(" Postdoctoral Fellow in Hebrew Bible and Biblical Hebrew, Washington University in St. Louis, Missouri")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tobit, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sara Raup Johnson")]), _vm._v(" Associate Professor of Classics, University of Connecticut, Hartford")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Court Tales; Maccabees, Third Book of; Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jutta Jokiranta")]), _vm._v(" Lecturer in Old Testament, University of Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sectarianism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christine E. Joynes")]), _vm._v(" Associate Director, Centre for Reception History of the Bible, University of Oxford, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elijah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Richard Lee Kalmin")]), _vm._v(" Theodore R. Racoosin Professor of Rabbinic Literature, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rabbis")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John I. Kampen")]), _vm._v(" Academic Dean and Professor of New Testament, Methodist Theological School in Ohio, Delaware, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hasideans")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ranon Katzoff")]), _vm._v(" Professor of Classical Studies and General History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babatha Archive; Contracts from the Judean Desert")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Allen Kerkeslager")]), _vm._v(" Associate Professor of New Testament, Saint Joseph’s University, Philadelphia, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Athletics; Cyprus; Cyrenaica; Gymnasium")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Angela Kim Harkins")]), _vm._v(" Assistant Professor of Religious Studies, Fairfield University, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hymns, Prayers, and Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael A. Knibb")]), _vm._v(" Samuel Davidson Professor Emeritus of Old Testament Studies, King’s College London, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enoch, Similitudes of (1 Enoch 37–71)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James L. Kugel")]), _vm._v(" Professor of Bible and Director, Institute for the History of the Jewish Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Jewish Biblical Interpretation”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert A. Kugler")]), _vm._v(" Paul S. Wright Professor of Christian Studies, Lewis and Clark College, Portland, Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aaron; Dead Sea Scrolls; Herakleopolis Papyri; Levi; Naphtali, Testament of (4Q215); Priests; Testaments")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David A. Lambert")]), _vm._v(" Assistant Professor of Religious Studies, University of North Carolina, Chapel Hill, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan D. Lawrence")]), _vm._v(" Associate Professor of Religious Studies and Theology, Canisius College, Buffalo, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Washing, Ritual")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kyong-Jin Lee")]), _vm._v(" Assistant Professor of Biblical Studies, Spring Arbor University, Spring Arbor, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Almsgiving; Righteousness/Justice")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('strong', [_vm._v("Mary J. W. Leith")]), _vm._v(" Associate Professor of Religious Studies, Stonehill College, Easton, Massachusetts")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Seals and Seal Impressions; Daliyeh, Wadi ed-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tracy Lemos")]), _vm._v(" Assistant Professor of Hebrew Bible, Rhodes College, Memphis, Tennessee")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Intermarriage")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jutta Leonhardt-Balzer")]), _vm._v(" Lecturer in New Testament, King’s College, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dualism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dan Levene")]), _vm._v(" Senior Lecturer in History, University of Southampton, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Magic Bowls and Incantations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lee I. Levine")]), _vm._v(" Professor of Jewish History and Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Caesarea Maritima; Jerusalem; Synagogues; Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John R. Levison")]), _vm._v(" Professor of New Testament, Seattle Pacific University School of Theology, West Seattle, Washington")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adam and Eve; Spirit, Holy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bert Jan Lietaert Peerbolte")]), _vm._v(" Professor of New Testament, University of Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antichrist")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Timothy H. Lim")]), _vm._v(" Professor of Hebrew Bible and Second Temple Judaism, New College, University of Edinburgh, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Multilingualism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James M. Lindenberger")]), _vm._v(" Professor of Hebrew Bible, Vancouver School of Theology, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marilyn J. Lundberg")]), _vm._v(" Associate Director, West Semitic Research Project, Rolling Hills Estates, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Leviticus Targum (4Q156); Paleo-Hebrew Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel A. Machiela")]), _vm._v(" Assistant Professor of Religious Studies, McMaster University, Hamilton, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babel, Tower of; Flood; Noah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jodi Magness")]), _vm._v(" Kenan Distinguished Professor for Teaching Excellence in Early Judaism, University of North Carolina at Chapel Hill, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ein Feshka; Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christl E. Maier")]), _vm._v(" University Professor of Old Testament, Philipps-Universität Marburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ruth, Book of; Song of Songs")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Paul Mandel")]), _vm._v(" Lecturer in Hebrew and Comparative Literature, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hillel; Shammai")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adam Marshak")]), _vm._v(" Lecturer in Classical Studies, Gann Academy, Waltham, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Jewish History from Pompey to Hadrian”; Fortresses and Palaces; Herod the Great; Herodian Dynasty; Idumea")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John W. Marshall")]), _vm._v(" Associate Professor of Religion, University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Revelation, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eric Mason")]), _vm._v(" Associate Professor of Biblical Studies, Judson University, Elgin, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hebrews, Epistle to the; Melchizedek Scroll (11Q13)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steve Mason")]), _vm._v(" Professor of Humanities & Ancient History and Canada Research Chair in Cultural Identity and Interaction, York University, Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Josephus; Josephus, Jewish Antiquities")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Byron R. McCane")]), _vm._v(" Albert C. Outler Professor of Religion, Wofford College, Spartanburg, South Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miqva")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ot; Ossuaries")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carmel McCarthy")]), _vm._v(" Professor Emerita of Hebrew and Syriac, University College Dublin, Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Peshi")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ta")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James S. McClaren")]), _vm._v(" Senior Lecturer in Theology, Australian Catholic University, Fitzroy, Victoria")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Imperial Cult, Jews and the; Josephus, Jewish War; Resistance Movements")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven L. McKenzie")]), _vm._v(" Professor of Hebrew Bible, Rhodes College, Memphis, Tennessee")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Deuteronomistic History")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Doron Mendels")]), _vm._v(" Max and Sophie Mydans Professor of Humanities, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexander Polyhistor; Historiography")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sarianna Metso")]), _vm._v(" Professor of Hebrew Bible, University of Toronto at Mississauga, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rule of the Community (1QS + Fragments)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David P. Moessner")]), _vm._v(" Professor of Biblical Theology, University of Dubuque Theological Seminary, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Luke-Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David G. Monaco")]), _vm._v(" Ph.D. Candidate, University of Chicago Divinity, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Menander, Sentences of the Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stewart Moore")]), _vm._v(" Ph.D. Candidate in Religious Studies, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Moore, George Foote")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Frederick J. Murphy")]), _vm._v(" Professor of Religious Studies, College of the Holy Cross, Worcester, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Biblical Antiquities (Pseudo-Philo)")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('strong', [_vm._v("Hindy Najman")]), _vm._v(" Associate Professor of Jewish Studies, University of Toronto, Ontario")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Decalogue; Torah and Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gordon D. Newby")]), _vm._v(" Professor and Chair, Department of Middle Eastern and South Asian Studies, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Arabian Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Judith H. Newman")]), _vm._v(" Associate Professor of Old Testament, Emmanuel College, University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Psalms, Book of; Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carol A. Newsom")]), _vm._v(" C. H. Candler Professor of Old Testament, Candler School of Theology, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Job, Book of; Songs of the Sabbath Sacrifice; Theodicy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("George W. E. Nickelsburg")]), _vm._v(" Daniel J. Krumm Professor Emeritus of New Testament, University of Iowa, Iowa City")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Charles, Robert Henry; Resurrection; Son of Man")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Maren Niehoff")]), _vm._v(" Senior Lecturer in Jewish Thought, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph; Philo, Allegorical Commentary; Philo, Exposition of the Law")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bilhah Nitzan")]), _vm._v(" Associate Professor of Hebrew Culture, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Berakhot (4Q286-290)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Brent Nongbri")]), _vm._v(" Postdoctoral Fellow in Classics, Macquarie University, New South Wales, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bousset, Wilhelm; Greek Authors on Jews and Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Noy")]), _vm._v(" Lecturer in Classics, University of Wales, Lampeter Ceredigion, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexander the Great; Egypt; Papyri")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gerbern S. Oegema")]), _vm._v(" Professor of Religious Studies, McGill University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Creation; Zephaniah, Apocalypse of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Saul M. Olyan")]), _vm._v(" Professor of Religious and Judaic Studies, Brown University, Providence, Rhode Island")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sacrifices and Offerings")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Aharon Oppenheimer")]), _vm._v(" Professor of Jewish History, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("People of the Land")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Andrei Orlov")]), _vm._v(" Associate Professor of Theology, Marquette University, Milwaukee, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enoch; Enoch, Slavonic Apocalypse of (2 Enoch); Melchizedek; Metatron; Slavonic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("J. Andrew Overman")]), _vm._v(" Professor of Classics, Macalester College, St. Paul, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Matthew, Gospel of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alexander Panayotov")]), _vm._v(" Leverholme Postdoctoral Research Fellow, School of Divinity, University of St. Andrews, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greece and the Aegean")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Donald W. Parry")]), _vm._v(" Abraham O. Smoot Professor of Hebrew Bible, Brigham Young University, Provo, Utah")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joseph Patrich")]), _vm._v(" Professor of Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Entertainment Structures; Samaria-Sebaste")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael Peppard")]), _vm._v(" Assistant Professor of Theology, Fordham University, New York, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Music")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dorothy M. Peters")]), _vm._v(" Assistant Professor of Biblical Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph, Apocryphon of (4Q371 and 4Q342)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jean-Pierre Pettorelli")]), _vm._v(" Independent Scholar, Port-Louis, France")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adam and Eve, Life of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stephen J. Pfann")]), _vm._v(" President, University of the Holy Land, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Scripts and Scribal Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("D. Nathan Phinney")]), _vm._v(" Associate Professor of Biblical Studies, Malone College, Canton, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezekiel, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michele Piccirillo†")]), _vm._v(" Professor of Archaeology, Biblical Geography and History, Studium Biblicum Franciscarum, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mosaics")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Chad Pierce")]), _vm._v(" Assistant Professor of New Testament, Central College, Pella, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Satan and Related Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kenneth E. Pomykala")]), _vm._v(" Professor of Religion, Calvin College, Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Catenae (4Q177, 4Q182); David; David Apocryphon; Judah; Kingship; Messianism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Mladen Popović")]), _vm._v(" Director, Qumran Institute, University of Groningen, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Astronomy and Astrology; Determinism; Horoscopes;")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot; Sun and Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan J. Price")]), _vm._v(" Professor of Classics and Ancient History, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Revolt, First Jewish")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Miriam Pucci Ben Zeev")]), _vm._v(" Professor of Jewish History, Ben Gurion University, Beersheva, Israel")])]), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('em', [_vm._v("“Jews among Greeks and Romans”; Diaspora Uprisings")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('em', [_vm._v("(116-117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("); Manetho; Rights of Jews in the Roman World")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Reinhard Pummer")]), _vm._v(" Professor of Religious Studies, Ottawa University, Ottawa, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Gerizim, Mount; Samaria; Samaritan Pentateuch; Samaritanism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rebecca Raphael")]), _vm._v(" Assistant Professor of Religious Studies, Texas State University, San Marcos, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Healing; Sickness and Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Uriel Rappaport")]), _vm._v(" Professor of Jewish History, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judas Maccabaeus; Maccabees, First Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Annette Yoshiko Reed")]), _vm._v(" Assistant Professor of Religious Studies, University of Pennsylvania, Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Fallen Angels; Jewish Christianity; Job, Testament of; Parting of the Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John C. Reeves")]), _vm._v(" Blumenthal Professor of Judaic Studies, University of North Carolina at Charlotte")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enosh; Giants; Gnosticism; Seth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eyal Regev")]), _vm._v(" Senior Lecturer, Land of Israel Studies and Archaeology, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Boethusians")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adele Reinhartz")]), _vm._v(" Associate Vice-President of Research, University of Ottawa, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("John, Gospel of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin E. Reynolds")]), _vm._v(" Honorary Research Fellow in Divinity and Religious Studies, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Faith/Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James N. Rhodes")]), _vm._v(" Visiting Assistant Professor of Religious Studies, Saint Michael’s College, Colchester, Vermont")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adversus Judaeos Literature; Allegory")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jason Ripley")]), _vm._v(" Assistant Professor of Religion, St. Olaf College, Northfield, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aqedah; Isaac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Deborah W. Rooke")]), _vm._v(" Lecturer in Old Testament Studies, King’s College London, England "), _c('em', [_vm._v("Joshua (Jeshua), the High Priest; Zadokites")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Renate Rosenthal-Heginbotton")]), _vm._v(" Independent Scholar, Grossolt, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jewelry")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Rothstein")]), _vm._v(" Assistant Professor of Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Phylacteries and Mezuzot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christopher Rowland")]), _vm._v(" Dean Ireland’s Professor of the Exegesis of Holy Scripture, Queen’s College, University of Oxford, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Apocalypticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David T. Runia")]), _vm._v(" Master of Queen’s College and Professorial Fellow, University of Melbourne, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Questions and Answers on Genesis and Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Leonard V. Rutgers")]), _vm._v(" Professor of Late Antiquity, Institute of History, Utrecht University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Catacombs; Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("E. P. Sanders")]), _vm._v(" Arts and Sciences Professor of Religion Emeritus, Duke University, Durham, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jesus of Nazareth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joachim Schaper")]), _vm._v(" Reader in Old Testament, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Levites")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lawrence H. Schiffman")]), _vm._v(" Ethel and Irvin A. Edelman Professor of Hebrew and Judaic Studies, New York University")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism and Rabbinic Judaism”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alison Schofield")]), _vm._v(" Assistant Professor of Hebrew Bible and Judaic Studies, University of Denver, Colorado")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Exile; Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eileen M. Schuller")]), _vm._v(" Professor of Religious Studies, McMaster University, Hamilton, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hodayot (1QH and Related Texts); Psalms, Apocryphal")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel R. Schwartz")]), _vm._v(" Professor of the History of the Jewish People, Hebrew University, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tobiads; Maccabees, Second Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joshua J. Schwartz")]), _vm._v(" Professor of Historical Geography of Ancient Israel, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judea; Pilgrimage")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adiel Schremer")]), _vm._v(" Professor of Jewish History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Celibacy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven Schweitzer")]), _vm._v(" Academic Dean and Associate Professor of Old Testament, Bethany Theological Seminary, Richmond, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Chronicles, Books of; Cyrus the Great; Sheshbezzar; Tobiah; Zerubbabel")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James M. Scott")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Covenant; Restoration")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Judith Lynn Sebesta")]), _vm._v(" Professor of Classics, University of South Dakota, Vermillion, South Dakota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Clothing and Dress")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('strong', [_vm._v("David Rolph Seely")]), _vm._v(" Professor of Ancient Scripture, Brigham Young University, Provo, Utah")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Barki Nafshi (4Q434-438)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Chris Seeman")]), _vm._v(" Assistant Professor of Religion, Coe College, Cedar Rapids, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Jewish History from Alexander to Pompey”; Phoenicia")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alan F. Segal")]), _vm._v(" Professor of Religion and Ingeborg Rennert Professor of Jewish Studies, Barnard College, Columbia University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mysticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Arthur Segal")]), _vm._v(" Professor of Archaeology, Zimman Institute of Archaeology, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Decapolis; Theaters")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael Segal")]), _vm._v(" Senior Lecturer in Bible, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jubilees, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alexei Sievertsev")]), _vm._v(" Assistant Professor of Religious Studies, DePaul University, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Family Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carolyn Sharp")]), _vm._v(" Associate Professor of Old Testament, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jeremiah and Lamentations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Israel Shatzman")]), _vm._v(" Professor of History, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Military, Jews in")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Aharon Shemesh")]), _vm._v(" Professor of Talmud, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Legal Texts; Ordinances (4QOrdinances)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joseph Sievers")]), _vm._v(" Professor of Jewish History and Literature in the Hellenistic Period, Pontifical Biblical Institute, Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hasmoneans")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dennis E. Smith")]), _vm._v(" Professor of New Testament, Philipps Theological Seminary, Tulsa, Oklahoma")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel L. Smith-Christopher")]), _vm._v(" Professor of Old Testament, Loyola Marymount University, Los Angeles, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezra, Book of; Nehemiah, Book of; Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin D. Sommer")]), _vm._v(" Professor of Bible, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Günter Stemberger")]), _vm._v(" Professor of Jewish Studies Emeritus, Institut für Jüdaistik, University of Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sadducees")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gregory E. Sterling")]), _vm._v(" Professor of Theology, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Apologetic Treatises")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ryan Stokes")]), _vm._v(" Ph.D. Candidate in Religious Studies, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Belial; Evil; Sons of God; Watchers, Book of the (1 Enoch 1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael E. Stone")]), _vm._v(" Gail Levin de Nur Professor of Religious Studies and Professor of Armenian Studies, Hebrew University of Jerusalem, Israel "), _c('em', [_vm._v("Aramaic Levi Document; Armenian")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James F. Strange")]), _vm._v(" Distinguished University Professor, University of South Florida, Tampa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sepphoris")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Loren T. Stuckenbruck")]), _vm._v(" Richard J. Dearborn Professor of New Testament, Princeton Theological Seminary, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Apocrypha and Pseudepigrapha”; Enoch, Epistle of (1 Enoch 91–108); Giants, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David W. Suter")]), _vm._v(" Professor of Religious Studies, Saint Martin’s University, Lacey, Washington")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hermon, Mount; Paneion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marvin A. Sweeney")]), _vm._v(" Professor of Hebrew Bible, Claremont School of Theology and Graduate University School of Religion, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Minor Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joan E. Taylor")]), _vm._v(" Adjunct Senior Lecturer, University of Waikato, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("John the Baptist; Therapeutae")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("D. Andrew Teeter")]), _vm._v(" Assistant Professor of Hebrew Bible, Harvard Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Scribes and Scribalism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eibert Tigchelaar")]), _vm._v(" Research Professor, Faculty of Theology, Katholieke Universiteit, Leuven, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“The Dead Sea Scrolls”; Job Targum (4Q157, 11Q10)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Samuel Thomas")]), _vm._v(" Assistant Professor of Religion, California Lutheran University, Thousand Oaks")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Goodenough, Erwin Ramsdell; Mystery; Mystery Religion, Judaism as")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Thomas H. Tobin, S.J.")]), _vm._v(" Professor of Theology, Loyola University, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Logos")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pablo A. Torijano")]), _vm._v(" Associate Professor of Hebrew Philosophy, Universidad Complutense de Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Solomon; Solomon, Testament of")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('strong', [_vm._v("Paul Trebilco")]), _vm._v(" Professor of New Testament Studies, University of Otago, Dunedin, New Zealand")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antioch (Pisidian); Asia Minor")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Julio Trebolle Barrera")]), _vm._v(" Professor of Hebrew and Aramaic Studies and Director, Instituto de Ciencias de las Religiones, Universidad Complutense, Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Latin Versions of the Hebrew Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Johannes Tromp")]), _vm._v(" Professor of the History and Literature of Early Judaism, Leiden University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Cain and Abel; Idols and Images; Latin; Moses, Assumption of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Fabian E. Udoh")]), _vm._v(" Visiting Professor of New Testament, McGill University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Economics; Tribute and Taxes")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eugene Ulrich")]), _vm._v(" John A. O’Brien Professor of Hebrew Scriptures, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“The Jewish Scriptures: Texts, Versions, Canons”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jan Willem van Henten")]), _vm._v(" Professor of New Testament, Hellenistic-Jewish, and Early Christian Literature, University of Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Maccabees, Fourth Book of; Martyrdom")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jacques van Ruiten")]), _vm._v(" Senior Lecturer in Old Testament and Early Jewish Studies, University of Groningen, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Garden of Eden — Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Annewies van den Hoek")]), _vm._v(" Lecturer in Greek and Latin, Harvard Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Philosophical Works")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pieter W. van der Horst")]), _vm._v(" Professor of Early Judaism and Ancient Christianity, Universiteit Utrecht, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezekiel the Tragedian; Greek; Inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James C. VanderKam")]), _vm._v(" John A. O’Brien Professor of Hebrew Bible, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Judaism in the Land of Israel”; Enoch, Astronomical Book of (1 Enoch 72–82); High Priests")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marjorie Venit")]), _vm._v(" Professor of Art History and Archaeology, University of Maryland, College Park, Maryland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexandria")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benedict Thomas Viviano, O.P.")]), _vm._v(" Professor of New Testament, University of Fribourg, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Education")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Hanne von Weissenberg")]), _vm._v(" Lecturer in Biblical Studies, University of Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miq")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("at Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("a")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("ê ha-Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rodney A. Werline")]), _vm._v(" Senior Minister, First Christian Church, Greensboro, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Manasseh, Prayer of; Penitential Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven Weitzmann")]), _vm._v(" Professor of Jewish Studies, Stanford University, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Copper Scroll (3Q15); Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("L. Michael White")]), _vm._v(" Ronald Nelson Smith Chair in Classics and Director, Institute for the Study of Antiquity and Christian Origins, University of Texas at Austin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ostia")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sidnie White Crawford")]), _vm._v(" Professor of Hebrew Bible, University of Nebraska, Lincoln")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Reworked Pentateuch (4QRP)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("K. William Whitney, Jr.")]), _vm._v(" Independent Scholar, Arlington, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Behemoth; Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Margaret H. Williams")]), _vm._v(" Research Fellow in Classical Studies, The Open University, Milton Keynes, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Julius Caesar, Gaius; Latin Authors on Jews and Judaism; Roman Generals; Roman Governors")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lawrence M. Wills")]), _vm._v(" Ethelbert Talbot Professor of Biblical Studies, Episcopal Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Asceticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Winston")]), _vm._v(" Professor Emeritus of Hellenistic and Judaic Studies, Graduate Theological Union, Berkeley, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greek Philosophy; Wolfson, Harry Austryn")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael O. Wise")]), _vm._v(" Professor of Hebrew Bible and Ancient Languages, Northwestern College, St. Paul, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Archives and Libraries; Bar Kokhba Letters; Crucifixion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Archie Wright")]), _vm._v(" Associate Professor of Biblical Studies, Regent University, Virginia Beach, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Angels; Michael, the Archangel")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin G. Wright III")]), _vm._v(" Professor of Religious Studies, Lehigh University, Bethlehem, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aristeas, Letter of; Ben Sira, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("J. Edward Wright")]), _vm._v(" Professor of Hebrew Bible and Early Judaism, University of Arizona, Tucson")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Cosmology; Heaven; Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jed D. Wyrick")]), _vm._v(" Associate Professor of Religious Studies, California State University, Chico")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Animal Worship; Pseudepigraphy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Geza Xeravits")]), _vm._v(" Professor of Bible, Sapientia Theological College, Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rule of the Congregation (1Q28a); Son of God")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('strong', [_vm._v("Azzan Yadin")]), _vm._v(" Associate Professor of Jewish Studies, Rutgers University, New Brunswick, New Jersey")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Akiba (Aqiva)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adela Yarbro Collins")]), _vm._v(" Buckingham Professor of New Testament Criticism and Interpretation, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Blasphemy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kent L. Yinger")]), _vm._v(" Associate Professor of New Testament, George Fox University, Newberg, Oregon "), _c('em', [_vm._v("Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Molly Zahn")]), _vm._v(" Lecturer, Religious Studies, University of Kansas, Lawrence, Kansas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Text Types, Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jürgen K. Zangenberg")]), _vm._v(" Professor of New Testament Exegesis and Early Christian Literature, Leiden University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Archaeology, Papyri, and Inscriptions”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Magnus Zetterholm")]), _vm._v(" Adjunct Associate Professor of Culture and Communication, Linköping University, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antioch (Syrian); Damascus; Syria")])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('em', [_vm._v("Alphabetical List of Entries")])])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aaron")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Abraham, Apocalypse of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Abraham, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Adam and Eve")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Adam and Eve, Life of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Adiabene")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Adversus Judaeos Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Agriculture in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Akiba (Aqiva)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Alexander the Great")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Alexander Polyhistor")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Alexandria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Allegory")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Almsgiving")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Amram, Visions of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Amulets")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Angels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Animal Worship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Antichrist")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Antioch (Pisidian)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Antioch (Syrian)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Antiochus IV Epiphanes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aphrodisias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apocalypse")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apocalypticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apocrypha, Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apollonius Molon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apologetic Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Apostasy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aqedah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aqueducts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Arabian Peninsula")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aramaic Levi Document")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Araq el-Amir")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Architecture")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Archives and Libraries")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Arch of Titus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aristeas, Letter of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Aristobulus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Art")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Artapanus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ascent to Heaven")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Asceticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Asia Minor")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Assimilation, Acculturation, Accommodation")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Associations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Astronomy and Astrology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Athletics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Atonement")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Babatha Archive")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Babel, Tower of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Babylonian Culture")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Babylonians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Babylonian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Barki Nafshi (4Q434-438)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Bar Kokhba Caves")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Bar Kokhba Letters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Bar Kokhba Revolt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Baruch, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Baruch, Second Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Baruch, Third Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Baruch, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Baths")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Beatitudes (4QBeatitudes)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Behemoth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Belial")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ben Sira, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Berakhot (4Q286-290)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Berossus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Biblical Antiquities (Pseudo-Philo)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Bickerman, Elias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Birth, Miraculous")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Blasphemy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Boethusians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Bousset, Wilhelm")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Burial Practices")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Caesarea Maritima")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cain and Abel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Calendars")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Canon, Canonization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Catacombs")])]), _c('p', {
    staticClass: "fm-alp"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v(" Catenae (4Q177, 4Q182)")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Celibacy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Charles, Robert Henry")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Chronicles, Books of 1–2")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Chronography")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Circumcision")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cisterns and Reservoirs")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cleodemus Malchus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Clothing and Dress")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Coins")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Contracts from the Judean Desert")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Conversion and Proselytism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Copper Scroll (3Q15)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cosmology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Court Tales")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Covenant")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Covenantal Nomism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Creation")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Crucifixion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cyprus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cyrenaica")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Cyrus the Great")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Daliyeh, Wadi ed-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Damascus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Damascus Document")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Daniel, Additions to")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Daniel, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Daniel, Pseudo-Texts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("David")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("David Apocryphon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Dead Sea Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Death and Afterlife")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Decalogue")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Decapolis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Demetrius the Chronographer")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Demons and Exorcism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Determinism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Deuteronomistic History")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Diadochoi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Diaspora Uprisings (116-117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Diet in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Divination and Magic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Domestic Dwellings in Roman Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Dream and Vision Reports")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Dreams, Book of (1 Enoch 83–90)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Dualism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Economics in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Education")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Ein Feshkha")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Ein Gedi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Elders")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Election")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Elect of God (4Q534-536)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Elephantine, Elephantine Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Elijah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Elisha")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch, Astronomical Book of (1 Enoch 72–82)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch, Epistle of (1 Enoch 91–108)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch, Ethiopic Apocalypse of (1 Enoch)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch, Similitudes of (1 Enoch 37–71)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enoch, Slavonic Apocalypse of (2 Enoch)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Enosh")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Entertainment Structures")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Eschatology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Esdras, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Essenes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Esther, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Esther, Greek Version of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ethiopic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Eupolemus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Eupolemus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Evil")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Exile")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Exodus, the")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ezekiel, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ezekiel the Tragedian")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ezra, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ezra, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Faith/Faithfulness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Fallen Angels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Family")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Family Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Fasting")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Festivals and Holy Days")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Flood")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Florilegium (4Q174)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Fortresses and Palaces")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Gabriel, Vision of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Galilee")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gamla")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Garden of Eden — Paradise")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gematria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Genealogies")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Genesis and Exodus, Commentary on (4Q422)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Genesis Apocryphon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Genesis Commentaries (4Q252-254)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gentile Attitudes toward Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gentiles, Jewish Attitudes toward")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Geography, Mythic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gerizim, Mount")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Giants")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Giants, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gnosticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("God-fearers")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Goodenough, Erwin Ramsdell")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Grace")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Greece and the Aegean")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Greek")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Greek Authors on Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Greek Philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Greek Religions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Gymnasium")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Hasideans")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hasmoneans")])]), _c('p', {
    staticClass: "fm-alp"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v(" Healing")])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Heaven")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hebrews, Epistle to the")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hecataeus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hecataeus of Abdera")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hekhalot Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Heliopolis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hellenism, Hellenization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hengel, Martin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Herakleopolis Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hermon, Mount")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Herod the Great")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Herodian Dynasty")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("High Priests")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hillel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Historiography")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hodayot (1QH and Related Texts)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Holiness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Homily")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Horoscopes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Hymns, Prayers, and Psalms")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Idols and Images")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Idumea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Imperial Cult, Jews and the")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Inscriptions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Instruction (4QInstruction)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Intermarriage")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ioudaios")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Isaac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Isaiah, Ascension of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Isaiah, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Isaiah Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ishmael ben Elisha")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Iturea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Jacob")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("James, Epistle of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jeremiah, Letter of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jeremiah and Lamentations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jericho")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jerusalem, New")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jesus Movement")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jesus of Nazareth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jewelry")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jewish Christianity")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Job, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Job, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Job Targum (4Q157, 11Q10)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("John, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("John the Baptist")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jonathan the King Text (4Q448)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joseph")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joseph, Apocryphon of (4Q371-373)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joseph, Prayer of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joseph and Aseneth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Josephus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Josephus, Against Apion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Josephus, Jewish Antiquities")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Josephus, Jewish War")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joshua, Apocryphon of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Joshua (Jeshua), the High Priest")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jotapata")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jubilees, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judaizing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judas Maccabaeus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Jude, Epistle of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Judith, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Julius Caesar, Gaius")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Justus of Tiberias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Kingdom of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Kingship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Land, Concept of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Latin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Latin Authors on Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Latin Versions of the Hebrew Bible")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Legal Texts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Letters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Levi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Leviathan")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Leviticus Targum (4Q156)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Literacy and Reading")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Liturgical Works from Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Lives of the Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Logos")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Luke-Acts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Maccabean Revolt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Maccabees, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Maccabees, Second Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Maccabees, Third Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Maccabees, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Magic Bowls and Incantations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Manasseh, Prayer of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Manetho")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mark, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Marriage and Divorce")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Martyrdom")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Masada")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Matthew, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Meals")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mediator Figures")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Medicine and Hygiene")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Melchizedek")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Melchizedek Scroll (11Q13)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Menander, Sentences of the Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mesopotamia, Media, and Babylonia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Messianic Apocalypse (4Q521)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Messianism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Metatron")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Michael, the Archangel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Midrash, Midrashim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Military, Jews in")])]), _c('p', {
    staticClass: "fm-alp"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("Minor Prophets")])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Miq"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _vm._v("at Ma"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("aśê ha-Torah (MMT)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Miqva"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("ot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Miracles and Miracle Workers")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mishmarot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mishnah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Monotheism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Moore, George Foote")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mosaics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Moses")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Moses, Assumption of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Moses Texts from Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Multilingualism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Wadi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Music")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mystery Religion, Judaism as")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Mysticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Nabatea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Names")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Naphtali, Testament of (4Q215)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Nebuchadnezzar")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Nehemiah, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Neusner, Jacob")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("New Jerusalem Text")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Nicolaus of Damascus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Noah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Novels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Oaths and Vows")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Oniads")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ordinances (4QOrdinances)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Orpheus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ossuaries")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ostia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("Otot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Pagan Religions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Paleo-Hebrew Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Palestinian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Paneion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Papyri from Qumran Cave 7")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Parthians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Parting of the Ways")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Patriarchs, Testaments of the Twelve")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Paul")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Peace")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Penitential Prayer")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("People of the Land")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Persecuted Righteous Person")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Persian Period")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Persian Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pesharim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pesher on the Periods (4Q180)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Peshi"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṭ")]), _vm._v("ta")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Peter, Epistles of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pharisees")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo, Allegorical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo, Apologetic Treatises")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo, Exposition of the Law")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo, Philosophical Works")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo, Questions and Answers on Genesis and Exodus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Philo the Epic Poet")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Phocylides, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Phoenicia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Phoenix")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Phylacteries and Mezuzot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pilgrimage")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Popular Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pottery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Priests")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Prophecy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Prophets, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Proverbs, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Psalm 151")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Psalms, Apocryphal")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Psalms, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Psalms Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pseudepigrapha, Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Pseudepigraphy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ptolemies")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Purity and Impurity")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Qahat, Admonitions (Testament) of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Qoheleth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Rabbis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Repentance")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Resistance Movements")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Restoration")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Resurrection")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Revelation, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Revolt, First Jewish")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Reworked Pentateuch (4QRP)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Righteousness/Justice")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Rights of Jews in the Roman World")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Roman Emperors")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Roman Generals")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Roman Governors")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Romanization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Rome")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Rule of Blessings (1QSb)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Rule of the Community (1QS + fragments)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Rule of the Congregation (1Q28a)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Ruth, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Sabbath")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sacrifices and Offerings")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sadducees")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Samaria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Samaria-Sebaste")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Samaritanism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Samaritan Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sanballat")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sanders, Ed Parish")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sanhedrin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sardis")])]), _c('p', {
    staticClass: "fm-alp"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_vm._v(" Satan and Related Figures")])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Schürer, Emil")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Scribes and Scribalism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Scripts and Scribal Practice")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Seals and Seal Impressions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sectarianism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Seleucids")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Self-Glorification Hymn")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sepphoris")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Serpent")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Seth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sexuality")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Shammai")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sheshbazzar")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sibylline Oracles")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sickness and Disease")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Slaves, Slavery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Slavonic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Smith, Morton")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Solomon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Solomon, Psalms of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Solomon, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Solomon, Wisdom of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Song of Songs")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Songs of the Sabbath Sacrifice")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Son of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Son of Man")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sons of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Spirit, Holy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Stars")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Stone Vessels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Suffering Servant")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Sun and Moon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Synagogues")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Syria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Tales of the Persian Court (4Q550)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tan"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("umim (4Q176)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Targum, Targumim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tcherikover, Victor (Avigdor)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Temple, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Temple Scroll (11QTemple)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Temple Tax")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Testimonia (4Q175)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Text Types, Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Thallus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Theaters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Theodicy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Theodotus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Therapeutae")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tiberias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tiberius Julius Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tithing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tobiads")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tobiah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tobit, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tohorot (4Q274, 276-277, 278)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Torah and Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tosefta")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Transjordan")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Tribute and Taxes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Universalism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Violence")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("War, Book of (4Q285, 11Q14)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("War Scroll (1QM)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Washing, Ritual")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Watchers, Book of the (1 Enoch 1–36)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wealth and Poverty")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wicked and Holy (4Q181)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wilderness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wisdom (Personified)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wisdom Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wisdom Literature at Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Wolfson, Harry Austryn")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Women")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Words of the Luminaries (4Q504-506)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Worship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Writing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Yavneh")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Yo"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("anan Ben Zakkai")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp1"
  }, [_vm._v("Zadokites")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Zephaniah, Apocalypse of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-alp"
  }, [_vm._v("Zerubbabel")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_c('em', [_vm._v("Topical List of Entries")])])]), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Primary Languages of Jews in the")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Second Temple Period")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Greek")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Secondary Languages in Which")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Early Jewish Literature Is Preserved")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ethiopic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Latin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Slavonic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Literary Genres")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Adversus Judaeos Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Allegory")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Apocalypse")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Apologetic Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Calendars")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Chronography")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Contracts from the Judean Desert")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Court Tales")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Dream and Vision Reports")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gematria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Genealogies")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Historiography")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Homily")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hymns, Prayers, and Psalms")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Legal Texts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Letters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Novels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wisdom Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Biblical Texts, Versions, and Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Canon, Canonization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Latin Versions of the Hebrew Bible")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Peshi"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṭ")]), _vm._v("ta")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Samaritan Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Text Types, Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Hebrew Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Chronicles, Books of 1-2")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Daniel, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Deuteronomistic History")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Esther, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ezekiel, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ezra, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Isaiah, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jeremiah and Lamentations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Job, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Minor Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Nehemiah, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Proverbs, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Psalms, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Qoheleth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ruth, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Song of Songs")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Apocrypha, Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Baruch, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ben Sira, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Daniel, Additions to")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Esdras, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Esther, Greek Version of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ezra, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jeremiah, Letter of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Maccabees, First Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Maccabees, Second Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Maccabees, Third Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Maccabees, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Manasseh, Prayer of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Psalm 151")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Solomon, Wisdom of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tobit, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Pseudepigrapha and Hellenistic Jewish Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Abraham, Apocalypse of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Abraham, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Adam and Eve, Life of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aristeas, Letter of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aristobulus")])]), _c('p', {
    staticClass: "fm-entries"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_vm._v(" Artapanus")])]), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Baruch, Second Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Baruch, Third Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Baruch, Fourth Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Biblical Antiquities (Pseudo-Philo)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cleodemus Malchus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Demetrius the Chronographer")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Dreams, Book of (1 Enoch 83–90)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch, Astronomical Book of (1 Enoch 72–82)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch, Epistle of (1 Enoch 91–108)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch, Ethiopic Apocalypse of (1 Enoch)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch, Similitudes of (1 Enoch 37–71)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch, Slavonic Apocalypse of (2 Enoch)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Eupolemus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Eupolemus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ezekiel the Tragedian")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gabriel, Vision of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hecataeus of Abdera")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hecataeus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Isaiah, Ascension of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Job, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Joseph and Aseneth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Joseph, Prayer of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jubilees, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Lives of the Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Menander, Sentences of the Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Moses, Assumption of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Orpheus, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Patriarchs, Testaments of the Twelve")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo the Epic Poet")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Phocylides, Pseudo-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pseudepigrapha, Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sibylline Oracles (Jewish)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Solomon, Psalms of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Solomon, Testament of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Thallus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Theodotus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Watchers, Book of the (1 Enoch 1–36)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Zephaniah, Apocalypse of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Dead Sea Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Liturgical Works from Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Paleo-Hebrew Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pesharim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wisdom Literature at Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('em', [_vm._v("Documents arranged here by cave number are arranged by document title in the A–Z entries")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1QapGen (Genesis Apocryphon)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1QH and Related Texts (Hodayot)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1QIsa"), _c('sup', [_vm._v("a, b")]), _vm._v(" (Isaiah Scrolls)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1QM (War Scroll)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1QS (Rule of the Community)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q21 etc. (Aramaic Levi Document)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q22, 2Q21 etc. (Moses Texts from Qumran)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q23-24 (Giants, Book of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q26 etc. (Instruction)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q28a (Rule of the Congregation)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q28b (Rule of Blessings)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("1Q32 etc. (New Jerusalem)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("2Q22 (David Apocryphon)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("3Q15 (Copper Scroll)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q156 (Leviticus Targum)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q157, 11Q10 (Job Targum)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q158, 364-367 (Reworked Pentateuch)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q159 etc. (Ordinances)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q174 (Florilegium)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q175 (Testimonia)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q176 (Tan"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("umim)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q177, 182 (Catenae)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q180 (Pesher on the Periods)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q181 (Wicked and Holy)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q186, 534, 561 (Horoscopes)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q215 (Naphtali, Testament of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q242-245, 246 (Daniel, Pseudo-Texts)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q252-254 (Genesis Commentaries)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q265-273, etc. + CD (Damascus Document)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q274 etc. (Tohorot)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q285, 11Q14 (War, Book of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q286-290 (Berakhot)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q319 ("), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("Otot)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q320 etc. (Mishmarot)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q371-373 (Joseph, Apocryphon of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q378-379 (Joshua, Apocryphon of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q380-381 (Psalms, Apocryphal)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q385-390 (Prophets, Pseudo-)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q394-399 (Miq"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _vm._v("at Ma"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("aśê ha-Torah)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q400-407 etc. (Songs of the Sabbath Sacrifice)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q422 (Genesis and Exodus, Commentary on)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q434 etc. (Barki Nafshi)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q448 (Jonathan the King Text)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q491 etc. (Self-Glorification Hymn)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q504-506 (Words of the Luminaries)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q521 (Messianic Apocalypse)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q525 (Beatitudes)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q534-536 (Elect of God)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q542 (Admonitions [Testament] of Qahat)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q543-548 (Amram, Visions of)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("4Q550 (Tales of the Persian Court)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("7Q1 etc. (Papyri from Qumran Cave 7)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("11Q11 etc. (Psalms Scrolls)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("11Q13 (Melchizedek Scroll)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entriesa"
  }, [_vm._v("11Q19 (Temple Scroll)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Philo of Alexandria")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo, Allegorical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo, Apologetic Treatises")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo, Exposition of the Law")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo, Philosophical Works")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Philo, Questions and Answers on Genesis and Exodus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Josephus")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Josephus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Josephus, Against Apion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Josephus, Jewish Antiquities")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Josephus, Jewish War")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Greek and Latin Authors on Jews and Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Greek Authors on Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Latin Authors on Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Alexander Polyhistor")])]), _c('p', {
    staticClass: "fm-entries"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_vm._v("Apollonius Molon")])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Berossus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hecataeus of Abdera")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Manetho")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hebrews, Epistle to the")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("James, Epistle of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("John, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jude, Epistle of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Luke-Acts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mark, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Matthew, Gospel of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Paul")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Peter, Epistles of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Revelation, Book of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Rabbinic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Babylonian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hekhalot Literature")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Midrash, Midrashim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mishnah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Palestinian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Targum, Targumim")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tosefta")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("NONLITERATURE ARTICLES")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Groups and Dynasties")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Babylonians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Boethusians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Diadochi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Elders")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Essenes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("God-fearers")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hasideans")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hasmoneans")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Herodian Dynasty")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("High Priests")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ioudaios/oi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jesus Movement")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jewish Christianity")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Oniads")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Parthians")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("People of the Land")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pharisees")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Priests")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Prophecy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ptolemies")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Rabbis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Resistance Movements")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Roman Emperors")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Roman Generals")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Roman Governors")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sadducees")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Scribes and Scribalism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Seleucids")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Therapeutae")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tobiads")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Zadokites")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Groups in Society")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Family")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Military, Jews in")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Slaves, Slavery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Women")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Social, Political, Economic, and Cultural Life")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Agriculture in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Architecture")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Archives and Libraries")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Art")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Associations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Athletics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Baths")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Burial Practices")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Clothing and Dress")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Diet in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Economics in Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Education")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gymnasium")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hellenism, Hellenization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Imperial Cult, Jews and")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Kingship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Medicine and Hygiene")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Music")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Names")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Parting of the Ways")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Peace")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Persian Period")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Rights of Jews in the Roman World")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Romanization")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Temple Tax")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Theaters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tribute and Taxes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Violence")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Biblical Figures in Early Jewish Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aaron")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Adam and Eve")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cain and Abel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("David")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Elijah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Elisha")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enoch")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Enosh")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Isaac")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jacob")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Joseph")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Judah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Levi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Melchizedek")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Moses")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Noah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Seth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Solomon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Historical Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Akiba (Aqiva)")])]), _c('p', {
    staticClass: "fm-entries"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_vm._v(" Alexander the Great")])]), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Antiochus IV Epiphanes")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cyrus the Great")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Herod the Great")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hillel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ishmael ben Elisha")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jesus of Nazareth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("John the Baptist")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Joshua (Jeshua), the High Priest")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Judas Maccabaeus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Julius Caesar, Gaius")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Justus of Tiberius")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Nebuchadnezzar")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Nicolaus of Damascus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sanballat")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Shammai")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sheshbazzar")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tiberius Julius Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tobiah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Zerubbabel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Yo"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("anan ben Zakkai")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Mythological and Primordial Figures,")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Places, and Events")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Angels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aqedah")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Babel, Tower of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Behemoth")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Belial")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Creation")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Demons and Exorcism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Exodus, the")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Fallen Angels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Flood")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Garden of Eden — Paradise")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Geography, Mythic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Giants")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Heaven")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jerusalem, New")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Leviathan")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Logos")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Metatron")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Michael, the Archangel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Phoenix")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Satan and Related Figures")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Serpent")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sons of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Stars")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sun and Moon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wisdom (Personified)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Religious Beliefs and Influences")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Animal Worship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Antichrist")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Apocalypticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Apostasy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ascent to Heaven")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Atonement")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Babylonian Culture")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Birth, Miraculous")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Blasphemy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cosmology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Covenant")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Covenantal Nomism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Death and Afterlife")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Decalogue")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Determinism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Dualism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Election")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Eschatology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Evil")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Exile")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Faith, Faithfulness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gentile Attitudes toward Jews and Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gentiles, Jewish Attitudes toward")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gnosticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Grace")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Greek Philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Greek Religions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Holiness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Idols and Images")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Kingdom of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Land, Concept of")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Martyrdom")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mediator Figures")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Messianism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Miracles and Miracle Workers")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Monotheism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mystery Religion, Judaism as")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mysticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pagan Religions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Persecuted Righteous Person")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Persian Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Repentance")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Restoration")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Resurrection")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Righteousness/Justice")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Samaritanism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sickness and Disease")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Son of God")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Son of Man")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Spirit, Holy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Suffering Servant")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Theodicy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Torah and Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Universalism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wealth and Poverty")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wilderness")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Almsgiving")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Asceticism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Assimilation, Acculturation, Accommodation")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Astronomy and Astrology")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Burial Practices")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Celibacy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Circumcision")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Conversion and Proselytism")])]), _c('p', {
    staticClass: "fm-entries"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_vm._v("Crucifixion")])]), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Divination and Magic")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Family Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Fasting")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Healing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Intermarriage")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Judaizing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Literacy and Reading")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Marriage and Divorce")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Meals")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Multilingualism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Oaths and Vows")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Penitential Prayer")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Popular Religion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pseudepigraphy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pilgrimage")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Purity and Impurity")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sabbath")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sacrifices and Offerings")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Scripts and Scribal Practices")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sectarianism")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sexuality")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tithing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Washing, Ritual")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Worship")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Writing")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Religious Institutions")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Festivals and Holy Days")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sanhedrin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Synagogues")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Temple, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Jewish Revolts")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Bar Kokhba Revolt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Diaspora Uprisings (116-117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Maccabean Revolt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Revolt, First Jewish")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Cities, Countries, and Regions:")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Jews and Judaism in")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Adiabene")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Alexandria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Antioch (Pisidia)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Antioch (Syria)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aphrodisias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Arabian Peninsula")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Asia Minor")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Caesarea Maritima")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cyprus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cyrenaica")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Damascus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Decapolis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Elephantine, Elephantine Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Galilee")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gamla")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Greece and the Aegean")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Heliopolis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Idumea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Iturea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jericho")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jotapata")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Judea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mesopotamia, Media, and Babylonia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Nabatea")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ostia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Paneion")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Rome")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Samaria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Samaria-Sebaste")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sardis")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sepphoris")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Syria")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tiberias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Transjordan")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Yavneh (Jamnia)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Archaeology:")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Specific Sites in or near the Land of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Araq el-Emir")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Daliyeh, Wadi ed-")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Ein Feshka")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Ein Gedi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Gerizim, Mount")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hermon, Mount")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Masada")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Wadi")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Qumran")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Archaeology:")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_c('strong', [_vm._v("Structures, Artifacts, Written Remains")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Amulets")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Aqueducts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Arch of Titus")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Babatha Archive")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Bar Kokhba Caves")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Bar Kokhba Letters")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Catacombs")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Cisterns and Reservoirs")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Coins")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Domestic Dwellings in Roman Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Entertainment Structures")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Fortresses and Palaces")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Herakleopolis Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Inscriptions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Jewelry")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Magic Bowls and Incantations")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Miqva"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("ot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Mosaics")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Ossuaries")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Phylacteries and Mezuzot")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Pottery")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Seals and Seal Impressions")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Stone Vessels")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries1"
  }, [_c('strong', [_vm._v("Modern Interpreters of Early Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Bickerman Elias")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Bousset, Wilhelm")])]), _c('p', {
    staticClass: "fm-entries"
  }, [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_vm._v("Charles, Robert Henry")])]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Goodenough, Erwin Ramsdell")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Hengel, Martin")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Moore, George Foote")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Neusner, Jacob")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Sanders, Ed Parish")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Schürer, Emil")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Smith, Morton")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Tcherikover, Victor (Avigdor)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-entries"
  }, [_vm._v("Wolfson, Harry Austryn")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }, [_c('em', [_vm._v("List of Maps")])])]), _c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _c('a', {
    attrs: {
      "href": "#/028_DictionaryA1#fig317"
    }
  }, [_vm._v("The Extent of Alexander’s Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/028_DictionaryA1#fig319"
    }
  }, [_vm._v("Alexandria in the Early Roman Period")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/028_DictionaryA2#fig337"
    }
  }, [_vm._v("Ancient Antioch (in Syria)")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/028_DictionaryA3#fig393"
    }
  }, [_vm._v("Ephesus in the First Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/030_DictionaryC#fig453"
    }
  }, [_vm._v("Caesarea Maritima")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/031_DictionaryD#fig521-2"
    }
  }, [_vm._v("The Dead Sea Region")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/031_DictionaryD#fig538"
    }
  }, [_vm._v("The Near East under the Diadochoi")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/032_DictionaryE1#fig564"
    }
  }, [_vm._v("Egypt in the Early Roman Period")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/032_DictionaryE2#fig622"
    }
  }, [_vm._v("Jerusalem in the Postexilic Period")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/035_DictionaryH#fig706"
    }
  }, [_vm._v("Palestine under the Hasmoneans")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/035_DictionaryH#fig725"
    }
  }, [_vm._v("The Jewish Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/035_DictionaryH#fig730"
    }
  }, [_vm._v("The Kingdom of Herod the Great")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/035_DictionaryH#fig732"
    }
  }, [_vm._v("Herod the Great’s Building Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/037_DictionaryJ1#fig795"
    }
  }, [_vm._v("Jerusalem in the First Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/041_DictionaryN#fig989"
    }
  }, [_vm._v("The Nabatean Empire at Its Greatest Extent")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/043_DictionaryP1#fig1028"
    }
  }, [_vm._v("The Parthian Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/043_DictionaryP1#fig1046"
    }
  }, [_vm._v("Palestine under Persian Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/043_DictionaryP3#fig1118"
    }
  }, [_vm._v("The Near East under Ptolemaic Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/044_DictionaryQ#fig1130"
    }
  }, [_vm._v("Location of the Qumran Caves")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/045_DictionaryR#fig1145"
    }
  }, [_vm._v("Asia Minor with the Churches Addressed in the Book of Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/045_DictionaryR#fig1155"
    }
  }, [_vm._v("The Roman Empire in the First Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/045_DictionaryR#fig1165"
    }
  }, [_vm._v("Ancient Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/045_DictionaryR#fig1166"
    }
  }, [_vm._v("Jewish Communities in Ancient Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-map"
  }, [_c('a', {
    attrs: {
      "href": "#/046_DictionaryS2#fig1213"
    }
  }, [_vm._v("The Seleucid Empire")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }, [_c('em', [_vm._v("Chronology")])])]), _c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("538-332")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Palestine ruled by the Persians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("before 525")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jewish Temple erected at Elephantine in Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("516/515")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jerusalem Temple rebuilt (traditional date)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("458-445")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Careers of Ezra and Nehemiah in Jerusalem")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("332-323")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Conquests of Alexander the Great")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("322-301")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wars of the Diadochi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("301-198")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Palestine ruled by the Ptolemies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("259-258")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zenon, secretary to a finance minister of Ptolemy II, visits Palestine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ca. 250")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Translation of Torah into Greek")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("222-187")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antiochus III rules the Seleucid Empire")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("198-142")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Palestine ruled by the Seleucids")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("190")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Battle of Magnesia: Antiochus III defeated by Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ca. 180")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hyrcanus ben Joseph of the Tobiad family builds a palatial estate at "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("Araq el-Emir in Transjordan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("177-164")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antiochus IV Epiphanes rules Seleucid Empire")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("175")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("High Priest Onias III deposed by Antiochus IV and replaced by Jason, who establishes a gymnasium in Jerusalem")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("172")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Menelaus outbids Jason and is appointed high priest")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("170")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Onias III killed by Menelaus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("169")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antiochus IV’s first Egyptian campaign; plunder of the Jerusalem Temple")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("168")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antiochus IV’s second Egyptian campaign (aborted); founding of the citadel in Jerusalem")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("167")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Desecration of the Jerusalem Temple and persecution of Judeans: beginning of the Maccabean Revolt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("164")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rededication of the Temple; death of Antiochus IV")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("162")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Menelaus executed; Alcimus appointed high priest")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("161")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judas defeats Nicanor and makes treaty with Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("160")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Battle of Elasa; Judas killed; Jonathan assumes leadership")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ca. 160")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Onias IV builds temple at Heliopolis in Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("159")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Death of Alcimus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("159-152")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jewish high priesthood vacant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("157")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Treaty between Jonathan and Bacchides; Syrians withdraw from Palestine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("152")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jonathan appointed high priest by Alexander Balas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("142")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Death of Jonathan and accession of Simon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("141")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Conquest of the Jerusalem citadel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("140")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Simon confirmed as high priest, commander, and ethnarch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("139")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Expulsion of Jews from Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("134")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Death of Simon and accession of John Hyrcanus; Antiochus VII invades and besieges Jerusalem; John Hyrcanus comes to terms with Antiochus VII; Judea temporarily under Seleucid domination")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("129/128")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antiochus VII dies; Judea is "), _c('em', [_vm._v("de facto")]), _vm._v(" independent; Hyrcanus campaigns in Transjordan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("126-104")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hasmonean expansion into Samaria, Idumea, and Galilee")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("112/111")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Samaritan temple on Mt. Gerizim destroyed by John Hyrcanus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("104-103")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aristobulus I high priest and king")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("103-76")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Alexander Jannaeus high priest and king")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("76-67")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Shelamzion Alexandra rules Judea as queen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("67-66")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hasmonean civil war breaks out; Hyrcanus II abdicates to Aristobulus II")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hyrcanus and Aretas the Nabatean besiege Aristobulus; Romans halt siege")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("64")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pompey annexes Syria: end of Seleucid rule")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("63")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pompey captures Jerusalem: end of Hasmonean rule")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("58-49")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("First Roman Triumvirate (Pompey, Crassus, Julius Caesar)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("49-45")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roman civil war between Julius Caesar and the "), _c('em', [_vm._v("optimates")]), _vm._v(" (conservative republicans), initially led by Pompey")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("48-47")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Antipater enlists Jewish support for Julius Caesar in Alexandria")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("47")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Phasael and Herod appointed "), _c('em', [_vm._v("stratēgoi")]), _vm._v(" in Galilee and Judea, respectively")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("44")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Assassination of Julius Caesar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("44-31")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Second Roman Triumvirate (Marc Antony, Lepidus, Octavian)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("42")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Phasael and Herod appointed tetrarchs by Marc Antony")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("40")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Parthians and Mattathias Antigonus invade Judea and besiege Jerusalem; Herod proclaimed King of Judea by Roman Senate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("37")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herod defeats last Hasmonean ruler, Mattathias Antigonus, and captures Jerusalem")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("31")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Battle of Actium: Octavian defeats Marc Antony")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roman conquest and annexation of Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("27")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Octavian given titles "), _c('em', [_vm._v("Augustus")]), _vm._v(" and "), _c('em', [_vm._v("Princeps;")]), _vm._v(" rules as "), _c('em', [_vm._v("de facto")]), _vm._v(" emperor until death in 14 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herod the Great dies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("-6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Archelaus rules Judea, Idumea, and Samaria; Antipas rules Galilee and Perea; Herod Philip II rules area northwest of Galilee until 34 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judas the Galilean and Zadok the Pharisee found the “fourth philosophy” and lead a revolt in protest of the Judean census")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("6-41")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judea made a Roman province ruled by prefects")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("14-37")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tiberius, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("26-36")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pontius Pilate, prefect of Judea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("27-30")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Public career of Jesus of Nazareth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("34-64")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Missionary career of Saul of Tarsus (Paul)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("37-41")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gaius Caligula, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("38")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anti-Jewish pogrom in Alexandria, Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("40")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Caligula orders a statue of himself to be installed in the Jerusalem Temple")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("41")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Edict of Claudius confirms rights of Jews in Alexandria but warns them not to strive for more than they have")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("41-44")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("King Agrippa I rules most of Palestine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("41-54")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Claudius, emperor; expels Jews from Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("44-66")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roman procurators govern most of Palestine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("54-68")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nero, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("60-66")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roman procurators Festus, Albinus, and Florus deal with brigands and popular uprisings in Judea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("62")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roman governor Flaccus seizes Jewish Temple tax from Apamea, Adramyttium, Laodicea, and Pergamum in Asia Minor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("64")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Fire in Rome Death of James (brother of Jesus), Paul, and Peter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("66")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anti-Jewish riots in Alexandria; Tiberius Julius Alexander enforces reprisals")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("66-70")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("First Jewish Revolt against Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("68-69")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Year of the four emperors (Galba, Otho, Vitellius, and Vespasian)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("69-79")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vespasian, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("70")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jerusalem Temple destroyed by Romans; "), _c('em', [_vm._v("fiscus Iudaicus")]), _vm._v(" imposed on Jews in lieu of Temple tax")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("73/74")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masada, the last refuge of Jewish rebels under Eleazar ben Ya"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("ir, falls to Romans Oniad temple at Leontopolis in Egypt destroyed by Romans")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("79-81")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Titus, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("80-90")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beginnings of rabbinic academy at Yavneh (Jamnia) House of Hillel gains ascendancy over the House of Shammai Yo"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("anan ben Zakkai is the leading rabbinic sage in Palestine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("81-96")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Domitian, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("90-115")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gamaliel II is the leading rabbinic sage")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("96-98")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nerva, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("98-117")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Trajan, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("100-135")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ishmael ben Elisha and Akiba ben Joseph are the leading rabbinic sages")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("116-117")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Diaspora Jewish uprisings in Egypt, Cyprus, and Cyrene")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("117-138")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hadrian, emperor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("132-135")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bar Kokhba Revolt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("200")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rabbi Judah the Patriarch edits the Mishnah")])])])])])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ABD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anchor Bible Dictionary,")]), _vm._v(" ed. D. N. Freedman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Abod. Zar.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Aboda Zara")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Abot. R. Nat.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Abot de Rabbi Nathan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Abr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Abrahamo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ach74")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Achaea inscription no. 74")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Add. Esth.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Additions to Esther")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Année Epigraphique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aet.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Aeternitate Mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ag. Ap.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Against Apion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Agr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Agricultura")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJS Review")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Association for Jewish Studies Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anim.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Animalibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANRW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aufstieg und Niedergang der römischen Welt,")]), _vm._v(" ed. H. Temporini and W. Haase")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Antiquities of the Jews")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AOT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Apocryphal Old Testament,")]), _vm._v(" ed. H. F. D. Sparks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ap")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Apocryphon (e.g., 1QapGen)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("APAT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Die Apokryphen und Pseudepigraphen des Alten Testmanents,")]), _vm._v(" ed. E. Kautzsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apoc. Abr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apocalypse of Abraham")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apoc. Mos.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apocalypse of Moses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apoc. Sedr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apocalypse of Sedrach")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apoc. Zeph.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Apocalypse of Zephaniah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("APOT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Apocrypha and Psuedepigrapha of the Old Testament,")]), _vm._v(" ed. R. H. Charles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ar")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aramaic (e.g., 4QMess ar)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Arak.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Arakin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aram.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aramaic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("As. Mos.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Assumption of Moses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Asc. Isa.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ascension of Isaiah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ASTI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Annual of the Swedish Theological Institute")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Babylonian Talmud tractate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("B. Bat.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Baba Batra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("B. Me")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v(".")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Baba Me")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("i")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("a")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("B. Qam.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Baba Qamma")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bar.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("2 Bar.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("2 Baruch (Syriac Apocalypse)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("3 Bar.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("3 Baruch (Greek Apocalypse)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("4 Bar.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("4 Baruch (Paraleipomena Jeremiou)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Barn.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Barnabas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Before the Common Era")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BCH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin de correspondance hellénique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bek.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bekorot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Benj.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Benjamin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ber.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Berakot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BGU")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Berliner Griechische Urkunden")]), _vm._v(" (Ägyptische Urkunden aus den Königlichen Museen zu Berlin), Berlin, 1895-1912")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib. Ant.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Antiquities (Liber Antiquitatum Biblicarum)")]), _vm._v(" of Pseudo-Philo")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bik.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bikkurim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BIOSCS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the International Organization for Septuagint and Cognate Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BJRL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the John Rylands University Library")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSOAS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the School of Oriental and African Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ca.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("circa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. Ord. Ptol.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus des Ordonnances des Ptolémées")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E")]), _vm._v(".")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Common Era")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cant.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Canticles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CAP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aramaic Papyri of the Fifth Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(",")]), _vm._v(" ed. A. E. Cowley, Oxford: Oxford University Press, 1923 (cited by document number)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCSG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Christianorum: Series Graeca")])])])])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cairo Genizah copy of the "), _c('em', [_vm._v("Damascus Document")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("chap(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("chapter(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cher.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Cherubim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CHJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cambridge History of Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Chron.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Chronicles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CIG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Inscriptionum Graecarum,")]), _vm._v(" ed. A. Boeckh, 4 vols., Berlin, 1828-1877")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CIJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Inscriptionum Judaicarum,")]), _vm._v(" ed. J.-B. Frey, Vatican City: Pontificio istituto di archeologia cristiana, 1936-52")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CIL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Inscriptionum Latinarum,")]), _vm._v(" 18 vols., Berlin, 1862-1989")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CIS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Inscriptionum Semiticarum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CJZC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus jüdischer Zeugnisse aus der Cyrenaika,")]), _vm._v(" ed. G. Lüderitz, Wiesbaden: Reichert, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("1 Clem.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("1 Clement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("2 Clem.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("2 Clement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("cm(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("centimeter(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("col(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("column(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Col.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Colossians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Conf.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Confusione Linguarum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Congr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Congressu Eruditionis Gratia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cont.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Vita Contemplativa")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cor.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corinthians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CPJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Papyrorum Judaicarum,")]), _vm._v(" ed. V. Tcherikover and A. Fuks, 3 vols., Cambridge: Harvard University Press, 1957-1964")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dan.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Daniel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Decal.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Decalogo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dem.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Demai")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Det.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quod Deterius Potiori Insidiari Solea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Deus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quod Deus Sit Immutabilis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deuteronomy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dial.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dialogue with Trypho the Jew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DJD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Discoveries in the Judaean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dead Sea Discoveries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DSS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dead Sea Scrolls")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ebr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Ebrietate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eccl.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ecclesiastes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ed.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("edited by, edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("e.g.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("exempli gratia")]), _vm._v(" (for example)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ed.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Eduyyot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Egyp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Egyptian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EncJud")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Encyclopedia Judaica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eng.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ep.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("epistle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ep. Arist.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Epistle of Aristeas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ep. Jer.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle of Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eph.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ephesians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Erub.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Erubin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esdr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esdras")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("esp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("especially")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("et al.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("et alii")]), _vm._v(" (and the others)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("etc.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("et cetera")]), _vm._v(" (and the rest)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exodus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ExpTim")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezek.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezekiel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("f(f).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("following pages, lines, verses, etc.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("fl.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("flourished")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Flacc.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("In Flaccum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("fol(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("folio(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("frg(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("fragment(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Frg. Tg.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Fragment Targum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Fr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("French")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Fug.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Fuga et Inventione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gal.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Galatians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GCS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Die griechische christliche Schriftsteller")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gen.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Genesis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Geog.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Geography")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ger.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("German")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gig.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Gigantibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gi")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gi")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em'), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("in")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GLAJJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Greek and Latin Authors on Jews and Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Greek")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hab.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Habbakuk")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hag.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Haggai")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ag.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("agiga")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("al.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("allah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Heb.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle to the Hebrews")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebrew")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hekh. Rab.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hekhalot Rabbati")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Her.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quis Rerum Divinarum Heres Sit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ev.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ev/Se")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever documents earlier attributed to Seiyal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hist. Eccl.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Church History")]), _vm._v(" of Eusebius of Caesarea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hom. adv. Jud.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Homiliae adversus Judaeos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hos.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hosea")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HSCP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Studies in Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ul.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ullin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hypoth.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hypothetica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ICS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Illinois Classical Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("i.e.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("id est")]), _vm._v(" (that is)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IGRR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Graece ad Res Romanas Pertinentes")]), _vm._v(" (1901-1927)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IJO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Judaicae Orientis,")]), _vm._v(" ed. D. Noy et al., 3 vols., Tübingen: Mohr-Siebeck, 2004")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ILS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Latinae Selectae,")]), _vm._v(" ed. H. Dessau, 3 vols. in 5 pts., Berlin, 1892-1916")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("INJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Israel Numismatics Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IOS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Israel Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isa.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isaiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Issa.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Issachar")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAAR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Academy of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JANES")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Ancient Near Eastern Society")])])])])])])]), _c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jas.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jahrbuch für biblische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JDS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jewish Desert Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jdt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judith")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JECS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Early Christian Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jer.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JIGRE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Inscriptions of Graeco-Roman Egypt,")]), _vm._v(" ed. W. Horbury and D. Noy, Cambridge: Harvard University Press, 1992")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JJS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Jewish Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JNES")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Near Eastern Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jos.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Josepho")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jos. & Asen.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Joseph and Aseneth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josh.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joshua")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JRA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Roman Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JRRW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Rights in the Roman World: The Greek and Roman Documents Quoted by Josephus Flavius,")]), _vm._v(" ed. M. Pucci Ben Zeev, Tübingen: Mohr-Siebeck, 1998.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSHRZ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jüdische Schriften aus hellenistischrömischer Zeit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of Judaism Supplement")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Pseudepigrapha")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSQ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Studies Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Semitic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jub.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jubilees")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jud.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Judah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judg.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("J.W.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish War")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ker.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Keritot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ketub.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ketubbot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("kg.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kilogram")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kgdms.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kingdoms")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KhQ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Khirbet Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("km(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("kilometer(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kourion")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Inscriptions of Kourion,")]), _vm._v(" T. B. Mitford, Philadelphia: American Philosophical Society, 1971")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LAB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Liber Antiquitatum Biblicarum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lam.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lamentations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lat.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Latin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Leg. Alleg.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Legum Allegoriae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Legat.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Legatio ad Gaium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leviticus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("lit.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("literally")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Liv. Pro.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lives of the Prophets")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("m.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("meter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("m.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mishnah tractate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aś.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aśerot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aś. Š.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aśer Šeni")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Macc.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Magn.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("To the Magnesians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mak.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Makkot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Makš.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Makširim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mal.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Malachi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mart. Isa.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Martyrdom of Isaiah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mart. Pol.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Martyrdom of Polycarp")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mas")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masada")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MasŠirŠabb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Songs of the Sabbath Sacrifice")]), _vm._v(" fragments from Masada")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matthew")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Meg.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Megilla")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mek.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mekilta")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mena")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v(".")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mena")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("mg.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("margin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mic.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Micah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mid.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Middot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Midr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Midraš (Midrash)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Migr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Migratione Abrahami")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Miqw.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Miqwa")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mird")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Khirbet Mird")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MMT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Miq")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("at Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aśê ha-Torah")]), _vm._v(" or "), _c('em', [_vm._v("Some of the Works of the Law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mos.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ms(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("manuscript(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mount")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mur")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Murray")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Excavations in Cyprus,")]), _vm._v(" A. S. Murray et al., London: British Museum, 1900")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mut.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Mutatione Nominum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("n.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("note")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nah.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nahum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Naph.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Naphtali")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ned.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nedarim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neg.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nega")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("im")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neotest")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neotestamentica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nez.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neziqin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NHC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nag Hammadi Codex")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nid.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Niddah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJPS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tanakh: The Holy Scriptures.")]), _vm._v(" New Jewish Publication Society Translation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("nos.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("numbers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("N.S.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("new series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Num.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Numbers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("O.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ostracon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Obad.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Obadiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Greek")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OGIS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Orientis Graeci Inscriptiones Selectae,")]), _vm._v(" 2 vols., ed. W. Dittenberger, Leipzig: Hirzel, 1903-1905")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ohol.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Oholot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Latin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxvi"
    }
  }, [_vm._v("OLP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orientalia Lovaniensia Periodica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Opif.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Opifìcio Mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Opusc. Arch.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Opuscula Archaeologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Or.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Orlah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Pseudepigrapha,")]), _vm._v(" 2 vols., ed. J. H. Charlesworth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("p(p).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("page(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("P.Dion.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dionysios Papyri = Les archives privés de Dionysios, fils de Kephalas,")]), _vm._v(" ed. P. W. Pestman and E. Boswinkel, Leiden: Brill, 1982")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("P.Harris")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Rendell Harris Papyri of Woodbrooke College, Birmingham,")]), _vm._v(" ed. J. E. Powell, Cambridge: Cambridge University Press, 1936")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("P.Teb.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Tebtunis Papyri,")]), _vm._v(" ed. B. P. Grenfell, A. S. Hunt, and J. G. Smyly, London: Henry Frowde, 1902")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PAAJR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Proceedings of the American Academy of Jewish Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("paleo")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paleo-Hebrew (e.g., 11QpaleoLev)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PAM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Palestine Archaeological Museum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pan.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epiphanius of Salamis, "), _c('em', [_vm._v("Panarion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("pap.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Papyrus (e.g., 4QpapParaExod gr)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bib")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("para.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("paraphrase")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("par(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("parallel(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Palestine Exploration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesa")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v(".")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesa")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("im")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesiq. R.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesiqta Rabbati")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesiq. Rab Kah.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pesiqta de Rab Kahana")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Pet.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Peter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Patrologia Graeca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PGM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Papyri Graecae Magicae,")]), _vm._v(" 3 vols., ed. K. Preisendanz, Leipzig: Teubner, 1928-1941")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Phil.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philippians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Phld.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("To the Philadelphians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pirqe R. El.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Pirqe Rabbi Eliezer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Patrologia Latina")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("pl(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("plate(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Plant.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Plantatione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Post.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Posteritate Caini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pr. Azar.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prayer of Azariah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pr. Man.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prayer of Manasseh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Praem.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Praemiis et Poenis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Praep. Evang.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Praeparatio Evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Prob.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quod Omnis Probus Liber Sit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Prov.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Providentia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prov.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Proverbs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps(s).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Psalm(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps.-")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pseudo-")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps.-Clem. "), _c('em', [_vm._v("Hom.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pseudo-Clementine "), _c('em', [_vm._v("Homilies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps.-Clem. "), _c('em', [_vm._v("Recog.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pseudo-Clementine "), _c('em', [_vm._v("Recognitions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Q")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1Q, 2Q, etc.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Numbered caves of Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QapGen")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Genesis Apocryphon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hodayot")]), _vm._v(" or "), _c('em', [_vm._v("Thanksgiving Hymns")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QIsa"), _c('sup', [_vm._v("a, b")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isaiah Scrolls")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Mil")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("amah")]), _vm._v(" or "), _c('em', [_vm._v("War Scroll")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QpHab")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Habakkuk Pesher")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Serek Haya")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _vm._v(" "), _c('em', [_vm._v("ad")]), _vm._v(" or "), _c('em', [_vm._v("Rule of the Community")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QSa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rule of the Congregation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QSb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rule of Blessings")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4QMMT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Miqsat Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("aśêha-Torah")]), _vm._v(" or "), _c('em', [_vm._v("Some of the Works of the Law")]), _vm._v(" from Qumran Cave 4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("11QMelch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Melchizedek Scroll")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("11QPs"), _c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Psalms Scroll"), _c('sup', [_vm._v("a")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("11QTemple")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Temple Scroll")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Qídd.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Qiddušin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("QE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quaestiones et Solutiones in Exodum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("QG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quaestiones et Solutiones in Genesim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Qod.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Qodašin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qoh.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Qoheleth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rab.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rabbah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("REJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue des études juives")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reub.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reuben")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rev.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Revelation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("rev. ed.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("revised edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevQ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue de Qumran")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RHPR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue d’histoire et de philosophie religieuses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rom.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Romans")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rom.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("To the Romans")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Roš Haš.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Roš Haššanah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("rpt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("reprint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RQ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Römische Quartalschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RSR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Recherches de science religieuse")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("S.")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Olam Rab.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Seder")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Olam Rabbah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šab.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šabbat")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sacr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Sacrificiis Abelis et Caini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Salamis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Greek and Latin Inscriptions from Salamis,")]), _vm._v(" ed. Terence B. Mitford and Ino K. Nicolaou, Nicosia: Department of Antiquities, 1974")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sam.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Samuel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sanh.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sanhedrin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SB V")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sammelbuch griechischer Urkunden aus Ägypten,")]), _vm._v(" vol. 5, ed. E. Kiessling, Wiesbaden, 1950")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SBLSP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Society of Biblical Literature Seminar Papers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("sc.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("scilicet")]), _vm._v(" (namely)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SCI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scripta Classica Israelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šeb.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šebi"), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _vm._v("it")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šebu.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šebu")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SEG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Supplementum Epigraphicum Graecum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šeqal.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šeqalim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sib. Or.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sibylline Oracles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sif. me")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v(". zab.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sifra me")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ora")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("zabim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sim.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Simeon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sin.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sinaiticus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sir.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sirach")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ŠirŠabb")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Šîrôt")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ôlat Haššabbat (Songs of the Sabbath Sacrifice)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJOT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scandinavian Journal of the Old Testament")])])])])])])]), _c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sobr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Sobrietate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Somn.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Somniis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sop.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Soperim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sacra Pagina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Spec. Leg.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Specialibus Legibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SPhA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studia Philonica Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studies in Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sukk.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sukka")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sus.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Susanna")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SVF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Stoicorum Veterum Fragmenta,")]), _vm._v(" 4 vols., ed. H. F. A. von Armin, Leipzig: Teubner, 1902-1904")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("t.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tosefta tractate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("T.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("T. 12. Patr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ta")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("an.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ta")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("anit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("T. Abr.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Testament of Abraham")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Textbook of Aramaic Documents from Ancient Egypt,")]), _vm._v(" ed. B. Porten and A. Yardeni, Jerusalem: Hebrew University, 1986-1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")]), _vm._v(" A = vol. 1, "), _c('em', [_vm._v("Letters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")]), _vm._v(" B = vol. 2, "), _c('em', [_vm._v("Contracts")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")]), _vm._v(" C = vol. 3, "), _c('em', [_vm._v("Literature and Lists")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")]), _vm._v(" D = vol. 4, "), _c('em', [_vm._v("Ostraca and Assorted")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TBT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Bible Today")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament,")]), _vm._v(" 10 vols., ed. G. Kittel and G. Friedrich, Grand Rapids: Eerdmans, 1964-1976")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ter.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Terumot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("tg")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Targum (e.g., 11QtgJob)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tg. Jer.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Targum Jeremiah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tg. Neof.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Targum Neofiti")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tg. Onq.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Targum Onqelos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tg. Ps.-J.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Targum Pseudo-Jonathan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thess.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thessalonians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tim.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Timothy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tob.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tobit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tohor.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tohorot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("trans.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("translated by, translation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TZ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("USQR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Union Seminary Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("v(v).")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("verse(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vigiliae Christianae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Verkundigung und Forschung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Virt.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("De Virtutibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("vol.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("volume")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("vs.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("versus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WDSP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wadi Daliyeh Samaria Papyri")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wis.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("y.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Palestinian (Jerusalem) Talmud tractate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Yad.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Yadayim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Yebam.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Yebamot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeb.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zebulun")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeba")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v(".")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeba")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("im")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zech.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zechariah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zeph.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zephaniah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zer.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zera")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("im")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])])])])])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxxviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('em', [_vm._v("Early Judaism in Modern Scholarship")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLINS")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Judaism in the period between the conquests of Alexander the Great in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and the last Jewish revolt against Rome in the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" has been characterized in various ways. For German scholars of the late nineteenth and early and mid-twentieth century, such as Emil Schürer and Wilhelm Bousset, this was "), _c('em', [_vm._v("Spätjudentum,")]), _vm._v(" “Late Judaism.” The “lateness” was relative to the teaching of the prophets, and bespoke decline as well as chronological sequence. The decline reached its nadir in rabbinic Judaism, understood as a religion of the Law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After the Holocaust, this way of characterizing ancient Judaism was widely (but not universally) recognized as not only offensive but dangerous. It was also inaccurate. On any reckoning, the history of Judaism since the Roman period is longer than the preceding history. Moreover, it is now increasingly apparent that the religion of ancient Israel and Judah before the Babylonian conquest was significantly different from the “Judaism” that emerged after the Exile. It has often been assumed that the reforms of Ezra in the fifth century marked the beginning of Judaism, but in fact we have little historical knowledge about these reforms, or indeed about Ezra himself. Shaye Cohen has argued persuasively that the Greek word "), _c('em', [_vm._v("Ioudaios")]), _vm._v(" originally meant “Judean,” a usage that never disappears, but that “in the latter part of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" is supplemented by a ‘religious’ or ‘cultural’ meaning: ‘Jew’” (Cohen 1999: 3; Mason 2007 disputes the supplementary meaning). The word “Judaism” derives from the Greek "), _c('em', [_vm._v("Ioudaismos,")]), _vm._v(" which first occurs in 2 Maccabees (2:21; 8:1; 14:38), as does its counterpart "), _c('em', [_vm._v("Hellenismos")]), _vm._v(" (4:13). The Jewish, or Judean, way of life was certainly recognized as distinctive before this. It was noted by Hecataeus of Abdera at the beginning of the Hellenistic period (ca. 300 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). The right of Judeans, even communities living outside of Judah, to live according to their ancestral laws was widely recognized by Hellenistic rulers, who were probably continuing Persian policy. But there are good grounds for regarding “Judaism” as a phenomenon of the Second Temple period. Accordingly, the period under review in this volume belongs to the early history of Judaism, even if the beginnings should be sought somewhat earlier.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("While some biblical books (Daniel and probably Qoheleth) date from the Hellenistic age, the primary evidence for Judaism in this period lies in literature and other evidence dated “between the Bible and the Mishnah” (Nickelsburg 2005). Accordingly, this has sometimes been called the “intertestamental” period. While this term does not have the derogatory character of "), _c('em', [_vm._v("Spätjudentum,")]), _vm._v(" it does reflect a Christian perspective. Moreover, it obscures the fact that the New Testament itself provides evidence for Judaism in this period, and that some of the important Jewish writings (e.g., Josephus, "), _c('em', [_vm._v("4 Ezra, 2 Baruch")]), _vm._v(") are contemporary with or later than some of the Christian Scriptures. In recent years, it has become customary to use the label “Second Temple Judaism” for this period (Stone 1984). Again, several relevant Jewish authors (most notably Josephus) worked after the destruction of the Second Temple, but the inaccuracy can be excused on the grounds that many of the later writings are still greatly preoccupied with the Temple and its destruction, and that the restructuring and reconceptualizing of the religion that we find in rabbinic literature did not occur immediately when Jerusalem fell. The Second Temple period, however, must begin with the Persians, and includes the editing, if not the composition, of much of the Hebrew Bible.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In this volume, we are mainly concerned with the evidence for Judaism between the Bible and the Mishnah. There is still overlap with the later biblical books, and the rabbinic corpus, compiled centuries later, also contains material relevant to the earlier period. No characterization, and no exact delimitation, is without problems, but “Early Judaism” seems the least problematic label available. (The designation “Middle Judaism,” suggested by Gabriele Boccaccini [1991], might be applied more appropriately to the Middle Ages. It is hardly appropriate for prerabbinic Judaism.) The conquests of Alexander are taken as the "), _c('em', [_vm._v("terminus a quo,")]), _vm._v(" on the grounds that they marked a major cultural transition. Several extant postbiblical Jewish writings date from the third or early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", prior to the Maccabean Revolt, which has often served as a marker for a new era (e.g., in Schürer’s "), _c('em', [_vm._v("History")]), _vm._v("). The reign of Hadrian (117-138 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") and the Bar Kokhba Revolt (132-135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") are taken to mark the end of an era, but not the end of Judaism by any means. The rabbinic literature, which later tradition would take as normative, took shape in the following centuries, but it did so in conditions that were very different from those that had prevailed before the great revolts.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Recovery of the Pseudepigrapha")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("For much of Western history, there were relatively few sources for Judaism between the Bible and the Mishnah. The Apocrypha, or deuterocanonical books, were traditionally (and still are) part of the Bible of the Catholic Church. This is a very small selection of Jewish literature from the period 200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to 100 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" It includes the books of Maccabees, major wisdom books (Ben Sira and Wisdom of Solomon) and pious tales (Tobit, Judith), but apocalyptic writings are conspicuous by their absence. (2 Esdras, which includes the apocalypse of "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" is included in the Apocrypha but not in the deuterocanonical books that are part of the Catholic ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Bible.) The history of the period was well known because of the books of Maccabees and the writings of Josephus. In recent years these sources have been supplemented by archaeology, but few additional literary sources have come to light. Also, the great corpus of Philo of Alexandria’s works was transmitted by Christians, because of its similarity to the writings of the church fathers. The Hellenistic Jewish literature was of marginal interest for orthodox Jewish scholarship in the nineteenth century, but it was the subject of some important studies, notably in the work of Jacob Freudenthal (1874-1875; see Niehoff in Oppenheimer, ed. 1999: 9-28).")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There exists, however, an extensive class of writings attributed to Old Testament figures that is not included in the Apocrypha. These writings are called “pseudepigrapha” (falsely attributed writings). There is also a small number of pseudepigraphic writings attributed to figures of pagan antiquity, most prominently the Sibyl. Most of the Greek and Latin writings relating to the Old Testament, such as the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs,")]), _vm._v(" were collected by J. A. Fabricius in his "), _c('em', [_vm._v("Codex Pseudepigraphus Veteris Testamenti")]), _vm._v(" in 1713. But many important works were preserved only in less widely known languages, such as Ethiopic, Syriac, and Old Church Slavonic. The translations from Ethiopic of the "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(" (1819) and "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" (1821) by Richard Laurence inaugurated a new era in the study of ancient Judaism. During the latter half of the nineteenth century, several more important pseudepigrapha came to light — "), _c('em', [_vm._v("Jubilees, 2")]), _vm._v(" and "), _c('em', [_vm._v("3 Baruch, 2 Enoch,")]), _vm._v(" the "), _c('em', [_vm._v("Apocalypse of Abraham,")]), _vm._v(" and the "), _c('em', [_vm._v("Testament of Abraham.")]), _vm._v(" These discoveries greatly enlarged the corpus of apocalyptic works from around the turn of the era and potentially provided resources for a new view of ancient Judaism. At the beginning of the twentieth century, there were landmark editions of the collected Pseudepigrapha in German (Kautzsch 1900; Riessler 1928) and English (Charles 1913), but editions of the individual books had been available from the late nineteenth century.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Relevance of Rabbinic Writings")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("This newly available material was not immediately integrated into the study of ancient Judaism. Emil Schürer’s "), _c('em', [_vm._v("Geschichte des jüdischen Volkes im Zeitalter Jesu Christi")]), _vm._v(" (1886-1890) included surveys of Jewish literature (divided between “Palestinian Jewish” and “Hellenistic Jewish” literature), but his depiction of Jewish religion is drawn heavily from rabbinic writings. This is especially true of his treatment of “Life under the Law,” in which he drew primarily from the Mishnah, but even his account of messianic belief integrated data from the Pseudepigrapha with rabbinic beliefs. In the judgment of George Foote Moore, the chapter on the Law “was conceived, not as a chapter of the history of Judaism but as a topic of Christian apologetic; it was written to prove by the highest Jewish authority that the strictures on Judaism in the Gospels and the Pauline Epistles are fully justified” (Moore 1921: 240). Schürer’s work was a mine of information and historical detail. Its enduring value can be seen in the degree to which its structure, and much of its detail, are retained in the English edition revised by Geza Vermes and ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("his collaborators. The revisers “endeavoured to clear the notorious chapter 28, "), _c('em', [_vm._v("Das Leben unter dem Gesetz —")]), _vm._v(" here re-styled as ‘Life and the Law’ — and the section on the Pharisees … of the dogmatic prejudices of nineteenth-century theology” (Vermes et al. 1973-1987: 2:v; cf. 464 n. 1). Nonetheless, Schürer’s introductory claim is repeated: “The chief characteristic of this period was the growing importance of Pharisaism … the generalities of biblical law were resolved into an immense number of detailed precepts … this concern with the punctilious observance of the minutiae of religion became the hallmark of mainstream Judaism” (Vermes et al. 1973-1987: 1:1). Likewise, the section on messianism retained the systematic presentation, which synthesizes data from rabbinic sources and the Pseudepigrapha.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first scholar to offer a reconstruction of Jewish religion based primarily on the Pseudepigrapha was Wilhelm Bousset, whose "), _c('em', [_vm._v("Religion des Judentums im neutestamentlichen Zeitalter")]), _vm._v(" first appeared in 1903. It was greeted by a storm of criticism from Jewish scholars (Wiese 2005: 159-215). Bousset’s view of Judaism was more differentiated than that of Schürer. In addition to the legalistic aspect of Pharisaism, he also detected a universalistic strand on which the teaching of Jesus could build. Some of his Jewish critics objected to “this dogmatic reduction of Judaism to a ‘praeparatio evangelica’” (Wiese 2005: 180). But there was also a fundamental disagreement on the question of appropriate sources. Felix Perles praised Bousset’s treatment of the piety of apocalyptic and Hellenistic Judaism but objected to the prominence accorded to this material and the lack of a systematic description of “normative Judaism,” as represented by rabbinic literature. Bousset, he claimed, had missed the “center of the Jewish religion” (Perles 1903: 22-23; Wiese 2005: 181). Bousset responded that one must differentiate between “the scholarship of the scribes,” which became normative after 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", and the more diverse “popular piety” of the earlier period, and he charged that Perles was “incapable of understanding the richer and more diverse life of Jewish popular religion before the destruction of the Jewish nation, because he is focused on the Mishnah and the Talmud and the entire later history of the scribes” (Bousset 1903b; Wiese 2005: 186). Few scholars would now accept Bousset’s characterization of the Pseudepigrapha as “popular religion” without qualification, but the issue of the relevance of rabbinic literature for the Second Temple period persists as a live issue down to the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("R. H. Charles, the scholar who did most to advance the study of the Pseudepigrapha, did not attempt a comprehensive study of ancient Judaism. While his own work focused largely on the apocalypses, he held that “Apocalyptic Judaism and legalistic Judaism were not in pre-Christian times essentially antagonistic. Fundamentally their origin was the same. Both started with the unreserved recognition of the supremacy of the Law” (Charles 1913: vii). Charles viewed the apocalyptic material positively, as a bridge between the prophets and early Christianity. His view of Judaism in this period as comprising two main strands is one of the major paradigms that has been adapted with various nuances in later scholarship (see VanderKam in Boccaccini and Collins 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perles’s criticisms of Bousset were echoed almost two decades later by the American Christian scholar, George Foot Moore:")])]), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The censure which Jewish scholars have unanimously passed on "), _c('em', [_vm._v("Die Religion des Judentums")]), _vm._v(" is that the author uses as his primary sources almost exclusively the writings commonly called Apocrypha and Pseudepigrapha, with an especial penchant for the apocalypses; and only secondarily, and almost casually the writings which represent the acknowledged and authoritative teachings of the school and the more popular instruction of the synagogue. This is much as if one should describe early Christianity using indiscriminately for his principal sources the Apocryphal Gospels and Acts, the Apocalypses of John and Peter, and the Clementine literature. (Moore 1921: 243)")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("While acknowledging the problem of the date of the rabbinic material, Moore insisted: “it is clear that the author ought not to have called his book "), _c('em', [_vm._v("Die Religion des Judentums,")]), _vm._v(" for the sources from which his representation is drawn are those to which, so far as we know, Judaism never conceded any authority, while he discredits and largely ignores those which it has always regarded as normative” (244).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But as F. C. Porter pointed out in his review of Moore’s own masterwork (Moore 1927-1930), “When Moore speaks of the sources which Judaism has always regarded as authentic, he means ‘always’ from the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" onward…. Was there then no other type of Judaism in the time of Christ that may claim such names as ‘normative,’ ‘normal,’ ‘orthodox’?” (Porter 1928; cf. Neusner 1981: 9). More fundamentally, one might question whether notions of normativity are appropriate to a discussion of the history of a religion at all. As Jacob Neusner, with all due appreciation for Moore’s goodwill, pointed out: “Moore’s is to begin with not really a work in the history of religions at all….His research is into theology. It is organized in theological categories, not differentiated by historical periods at all” (Neusner 1981: 7). Neusner was no less critical of Jewish scholarship at the beginning of the twentieth century. The attempt to draw a direct line from the Hebrew Bible to a “normative” Judaism defined by the rabbis was an anachronism, motivated by apologetics (Neusner 1984: 101; Wiese 2005: 213).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The mantle of Moore was taken up half a century later by E. P. Sanders, with some qualifications. Sanders recognizes that the tannaitic literature (i.e., literature traditionally ascribed to the period between 70 and 200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") cannot be assumed to provide “an accurate picture of Judaism or even of Pharisaism in the time of Jesus and Paul, although it would be surprising if there were no connection” (Sanders 1977: 60). He also recognizes that Jewish literature from this period, including the tannaitic literature, is very varied. Yet he argues that “a common pattern can be discerned which underlies otherwise disparate parts of tannaitic literature” (Sanders 1977: 70), which he describes as “covenantal nomism.” The Law must be seen in the context of election and covenant. It provides for a means of atonement, so that the covenantal relationship can be reestablished or maintained. All who are maintained in the covenant will be saved. Salvation, then, does not depend on purely individual observance of the Law. Sanders finds this pattern not only in tannaitic literature but also in the Dead Sea Scrolls, Apocrypha, and Pseudepigrapha, with the single exception of "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" (Sanders 1977: 422-23). He concludes that his study “lends no support to those who have urged that apocalypticism and legalism constitute substantially different religious types or ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("streams in the Judaism of the period” (Sanders 1977: 423) and denies that apocalypticism constituted a distinct type of religion (Sanders 1992: 8). The case for the compatibility of concern for the Law with apocalyptic beliefs finds strong support in the Dead Sea Scrolls.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Sanders’s view, “covenantal nomism does not cover the entirety of Jewish theology, much less the entirety of Judaism” (Sanders 1992: 262). It is nonetheless an aspect of “common” or “normal” Judaism. Mindful of the criticism directed at Moore, Sanders is careful to qualify the word “normative”: “whatever we find to have been normal was based on internal assent and was ‘normative’ only to the degree that it was backed up by common opinion — which has a good deal of coercive power, but which allows individuals who strongly dissent to break away” (Sanders 1992: 47). The pillars of common Judaism were the belief in one God, the Scriptures, especially the Torah, and the Temple. Within a common framework, considerable variation was possible. Sanders’s approach is focused on practice rather than belief. Even when he draws his data from Josephus or other Second Temple sources, the kinds of issues on which he focuses are generally similar to those that predominate in the Mishnah. Apocalyptic speculations about the heavens or the end of history tell us little about the authors’ daily observances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sanders’s portrait of common Judaism is less vulnerable to critique than Moore’s normative Judaism, and it enjoys wide acceptance (see, e.g., Goodman 2002: 38). It does not deny that diversity existed but places the emphasis on what all (or at least most) Jews had in common. One could also place more emphasis on diversity with equal validity. The other end of the spectrum from Sanders is occupied by Jacob Neusner, who insists on speaking of “Judaisms” rather than “Judaism” (e.g., Neusner, Green, and Frerichs 1987: ix). The plural has been adopted by some scholars (e.g., Boccaccini) but is infelicitous: to speak of “a Judaism” requires the overarching concept of “Judaism” in the singular. While Neusner’s insistence that each corpus of Jewish literature (say, the Dead Sea Scrolls) be analyzed in its own right and not read through the lens of another corpus (say, the Mishnah) is salutary, it does not follow that each corpus represents a distinct religious system. Insistence on radical diversity distorts the data just as much as an essentialist approach that would exclude ostensibly Jewish material that does not conform to a norm (see the remarks of Green 1994: 298 on Sanders’s "), _c('em', [_vm._v("Paul and Palestinian Judaism:")]), _vm._v(" “Paul’s writings are analyzed in juxtaposition to Judaism rather than as part of it”).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("In his recent attempt at a sweeping characterization of early Judaism, Seth Schwartz is sharply critical of Neusner: “I reject the characterization of Judaism as multiple, as well as the atomistic reading of the sources that justifies it” (Schwartz 2001: 9). He continues: “The notion that each piece of evidence reflects a discrete social organization is obviously wrong.” It is not apparent, however, that Neusner associates his different “Judaisms” with “discrete social organizations.” Schwartz goes on to distinguish broadly between “apocalyptic mythology” and “covenantal ideology” (Schwartz 2001: 78-82). He regards these as “incongruous systems”: “The covenant imagines an orderly world governed justly by the one God. The apocalyptic myth imagines a world in disarray, filled with evil; a world in which people do not get what they deserve. God is not in control in any obvious way; ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("indeed the cosmology of the myth is dualist or polytheist….” The accuracy of this sketch of “the apocalyptic myth” might be questioned, especially with regard to whether God is in control, but there is no doubt that there are real differences here. Schwartz notes “the repeated juxtaposition of the covenant and the myth in ancient Jewish writing” and infers that “though the systems are logically incongruous, they did not for the most part generate social division.” Thus he agrees with Sanders that “apocalyptic Judaism” was not a separate entity. He is also dubious about “covenantal Judaism.” Rather, he supposes that “the apocalyptic myth” was “a more or less fully naturalized part of the ideology of Judaism.” Insofar as he recognizes “incongruous systems,” Schwartz may not be as far removed from Neusner as he thinks, although the latter would surely insist on a greater variety of systems. At the same time, Schwartz can avoid the impression of fragmentation that is conveyed by Neusner’s insistence on multiple Judaisms.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Place of the Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In his critique of Bousset, Moore acknowledged that critical use of the rabbinic writings is difficult, but he argued that the critical problems presented by the Pseudepigrapha are no less difficult: “How wide, for example, was the currency of these writings? Do they represent a certain common type of ‘Volksfrömmigkeit,’ or did they circulate in circles with peculiar notions and tendencies of their own? How far do they come from sects regarded by the mass of their countrymen as heretical?” (Moore 1921: 244). Perhaps the most fundamental question to be asked about the use of the Pseudepigrapha in the reconstruction of ancient Judaism is whether they are in fact Jewish at all. Most of these texts were preserved by Christians, not by Jews. Robert Kraft has argued repeatedly that these texts should first be understood in their Christian context (Kraft 1994; 2001). At the same time, it is incontrovertible that some pseudepigraphic writings which were preserved only by Christians were composed by Jews in the centuries around the turn of the era. Fragments of most sections of "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" and of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" were found in Aramaic and Hebrew, respectively, among the Dead Sea Scrolls. It does not necessarily follow that all pseudepigrapha attributed to Old Testament figures are of Jewish origin. Since most Christian literature refers explicitly to Christ, and Christians often added references to Christ to Jewish writings, the tendency has been to assume that any Old Testament pseudepigraphon that has nothing explicitly Christian in it is in fact Jewish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This tendency has recently been challenged by James Davila (2005). We have a considerable corpus of writings from antiquity that are indisputably Jewish, because of their language or the context of their discovery (most notably, the Dead Sea Scrolls). On the basis of these texts Davila attempts to identify “signature features” that can reliably indicate the Jewish origin of a work:")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" substantial Jewish content, and evidence of a pre-Christian date;")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" compelling evidence that a work was translated from Hebrew;")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" sympathetic concern with the Jewish ritual cult;")])]), _c('p', {
    staticClass: "bullet"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" sympathetic concern with Jewish Law/Torah and halakah;")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" concern with Jewish ethnic and national interests. (Davila 2005: 65)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("These “signature features” are not necessarily foolproof, but they can help establish a balance of probability. They enable Davila to authenticate as Jewish a work like "), _c('em', [_vm._v("2 Baruch,")]), _vm._v(" which was clearly written by a Torah-observant Jew, against the objections of Rivkah Nir (2003), who argues that several of its apocalyptic motifs are typical of Christianity rather than Judaism (Davila 2005: 131). He rightly argues that Nir’s concept of ancient Judaism is “narrow to the point of being procrustean,” as she does not even include works like "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" and "), _c('em', [_vm._v("Jubilees")]), _vm._v(" in her control corpus of Jewish material. He also defends the Jewish origin of the "), _c('em', [_vm._v("Similitudes of Enoch")]), _vm._v(" ("), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 37–71), which shows no interest in Torah observance, and which was regarded as a late Christian work by J. T. Milik (1976: 89-98). In this case the conclusive consideration is the apparent identification of Enoch, not Jesus, with the Son of Man in "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 71:14 (Davila 2005: 134). The identification, though, is not as unambiguous as Davila claims (Collins 1998: 187-91), but it is inconceivable that a Christian author would have allowed any ambiguity as to the identification of the Son of Man. Other cases are more difficult to decide. The Jewish origin of "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" has been questioned forcefully by Ross Kraemer (1998). Davila fails to detect either Jewish or Christian signature features that would decide the issue (Davila 2005: 193). Neither does the "), _c('em', [_vm._v("Testament of Job")]), _vm._v(" offer any decisive evidence, although it fits quite comfortably in the context provided by the oldest attestation, in Christian circles in Egypt in the early fifth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" He also finds the "), _c('em', [_vm._v("Testament of Abraham")]), _vm._v(" congenial to a late antique Christian setting. Less plausibly, he finds nothing in the Wisdom of Solomon “that prohibits or even renders unlikely its having been written by a gentile Christian in the second half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v("” (Davila 2005: 225). But there is no parallel for Christian composition of a pseudepigraphic writing in the name of an Old Testament figure at such an early date, and the retelling of the exodus story in Wisdom of Solomon 11–19 surely meets the criterion of concern for Jewish ethnic and national interests. Davila’s reasoning is not persuasive in every instance, but he has advanced the discussion by showing that the evidence for Jewish origin is much clearer in some instances than in others.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("There is plenty of evidence that Christians sometimes composed works in the names of Old Testament figures (e.g., Isaiah, Ezra, Elijah, Daniel). It is also plausible that they inserted explicit Christian passages into Jewish works to render them more suitable for Christian devotion (see, e.g., Harlow 1996 on 3 "), _c('em', [_vm._v("Baruch;")]), _vm._v(" Collins in Charlesworth 1983: 330-53 on "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" 1 and 2). The more extensive the Christian redaction, the more hazardous the reconstruction of the underlying Jewish work becomes. The most celebrated problem case in this regard is the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs.")]), _vm._v(" This collection is clearly Christian in its present form. One of its distinctive features is the expectation of a messiah from Levi and Judah, who is evidently identified as Christ. He will be priest and king, God and man ("), _c('em', [_vm._v("T. Sim.")]), _vm._v(" 7:2). He is referred to as “the lamb of God” ("), _c('em', [_vm._v("T. Jos.")]), _vm._v(" 19:6). "), _c('em', [_vm._v("Testament of Judah")]), _vm._v(" 24 speaks of a man from the tribe of Judah, for whom the heavens will be opened and in whom no sin will be found. Scholars have argued that each of these ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("references can be justified in a Jewish context, or that they are Christian insertions in a text that is basically Jewish (Charles 1913: 291). The cumulative evidence, however, is far more easily explained on the assumption of Christian authorship (de Jonge 1953).")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nonetheless, there are good reasons to think that the "), _c('em', [_vm._v("Testaments")]), _vm._v(" draw heavily on Jewish traditions. The association of the messiah with both Levi and Judah inevitably recalls the two messiahs of the Dead Sea Scrolls. Partial parallels to the "), _c('em', [_vm._v("Testament of Levi,")]), _vm._v(" in Aramaic, and to the "), _c('em', [_vm._v("Testament of Naphtali,")]), _vm._v(" in Hebrew, have been found among the Dead Sea Scrolls. It is possible, however, that these were source documents used by the Christian authors of the "), _c('em', [_vm._v("Testaments")]), _vm._v(" (de Jonge 2000). We do not have conclusive evidence for a Jewish "), _c('em', [_vm._v("Testaments of Twelve Patriarchs")]), _vm._v(" (as distinct from apocryphal writings associated with individuals such as Levi). The ethical teachings of the "), _c('em', [_vm._v("Testaments")]), _vm._v(" can be explained satisfactorily in the context of either Hellenistic Judaism or early Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In cases where the Christian elements are not extensive, and somewhat incongruous, a stronger case can be made for Jewish authorship. The fifth "), _c('em', [_vm._v("Sibylline Oracle")]), _vm._v(" contains only one overtly Christian verse (arguably two) in a composition of 531 verses. Verse 257 qualifies the “exceptional man from the sky” with the line “who stretched out his hands on the fruitful wood.” The following verse says that he will one day cause the sun to stand. Most commentators excise either one or both verses as an interpolation (Collins in Charlesworth 1983: 399). The reference to causing the sun to stand could be regarded as part of the interpolation because of a play on Jesus/Joshua). Davila allows that this is possible, but finds it unnecessary: “Sibylline Oracles 5 as a whole reads comfortably as a work by a Jewish-Christian who was outraged by the Roman destruction of Jerusalem and who put after-the-fact prophecies in the mouth of the Sibyl both to condemn the Romans and the other polytheistic nations and to predict the coming of Jesus as the eschatological redeemer” (Davila 2005:189). But while the outrage over the destruction is loud and clear in this work, the identification of Jesus as the eschatological redeemer is perceptible only in this one passage, and is not very explicit even there. Davila notes that "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" 5 shows no interest in circumcision, dietary laws, or the Sabbath, and virtually reduces the Law to idolatry and sexual sins. But this is quite typical of Jewish writings from the Hellenistic Diaspora (Collins 2000: 155-85). As this example shows, the identification of a given text as Jewish depends on the profile of Judaism one is willing to accept. In some cases, arguments against Jewish provenance reflect a narrow, normative view of Judaism (Efron 1987: 219-86 on the "), _c('em', [_vm._v("Psalms of Solomon;")]), _vm._v(" Nir on "), _c('em', [_vm._v("2 Baruch")]), _vm._v("). This is not true of Davila, however, and the questions may be justified in some cases. The boundaries of Judaism cannot be restricted to concern for the Torah or covenantal nomism. Conversely, arguments for Jewish diversity based on pseudepigraphic texts of uncertain origin cannot bear the full weight of evidence unless they are supported by parallels in texts that are clearly Jewish.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("The Place of Apocalypticism")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The controversy over the use of the Pseudepigrapha in the reconstruction of early Judaism is due in large part to the prominence of apocalyptic literature. Even pseudepigraphic books that are not formally apocalypses, such as the "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" the "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" or the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")]), _vm._v(" have much in common with them, especially in their view of history and eschatology. Only one apocalyptic writing, the book of Daniel, was included in the Hebrew Bible, and the apocalyptic tradition was rejected by rabbinic Judaism. The noncanonical apocalypses were transmitted by Christians, and were not preserved in Hebrew or Aramaic, although Aramaic fragments of "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" and Hebrew fragments of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" have been found in the Dead Sea Scrolls. It has been said that apocalypticism is the mother of Christian theology. R. H. Charles saw it as the link between biblical prophecy and early Christianity, and the view that it was “the child of prophecy” has always been popular in English-language scholarship (Rowley 1944). Bousset, in contrast, attributed its rise to Zoroastrian influence. Other sources, both biblical (wisdom literature, von Rad 1965: 2:315-30) and foreign (Babylonian traditions, e.g., Kvanvig 1988) have occasionally been proposed. Only in the last quarter of the twentieth century has apocalypticism been recognized as a phenomenon in its own right rather than as a mutation (or degeneration) of something else (Collins 1998: 26-42).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After the great burst of creative energy expended on the Pseudepigrapha in the late nineteenth and early twentieth centuries, this literature received little scholarly attention for more than half a century. (This neglect must be seen in the context of a general shift in focus from history of religion to biblical theology in this period.) Many of the more influential scholars who addressed it, such as Rowley and von Rad, were biblical scholars who naturally enough tried to assimilate the strange noncanonical material to biblical categories. Much of the scholarship that purported to deal with “apocalyptic” actually dealt with postexilic prophecy or with the letters of Paul. The discovery of the Dead Sea Scrolls, however, led to renewed interest in Judaism between the Bible and the Mishnah. From the 1970s onward there was extensive work on the Pseudepigrapha both in the United States and in Europe, which bore fruit in the two-volume translation of Old Testament Pseudepigrapha edited by Charlesworth (1983-1985), which included much more material than the older edition of Charles, and the German series of fascicles "), _c('em', [_vm._v("Jüdische Schriften aus hellenistisch-römischer Zeit.")]), _vm._v(" Now the apocalypses came to be studied in the context of the contemporary pseudepigraphic literature and the Dead Sea Scrolls. This in turn led to a change in focus from “apocalyptic” as a kind of theology, usually studied with an eye to its relevance for the New Testament, to the literary genre apocalypse (Koch 1972; Collins ed. 1979).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Three results of the study of the genre are noteworthy. First, apocalypses are not only concerned with historical eschatology (the end of the present age) in the way familiar from Daniel and the book of Revelation. They are also, even primarily, revelations of heavenly mysteries (Rowland 1983). A whole subtype of the genre is concerned with otherworldly journeys, and this material is important for the early history of Jewish mysticism (Himmelfarb 1993). Second, since only one book in the Hebrew Bible, Daniel, could be said to exemplify the genre, discussion of")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v(" “apocalyptic” or “protoapocalyptic” in the prophetic literature became increasingly dubious. Third, the genre is not peculiar to Judaism and Christianity, but has important parallels in Persian tradition and throughout the Greco-Roman world, especially in the case of the heavenly journeys (Hellholm 1983).")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another byproduct of the focus on the genre apocalypse and on the context of the Pseudepigrapha was increased interest in the collection of writings known as "), _c('em', [_vm._v("1 Enoch.")]), _vm._v(" Charles had already realized that some parts of "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" were older than Daniel. Interest was greatly increased by the publication of the Aramaic fragments found among the Dead Sea Scrolls (Milik 1976). The Italian scholar Paolo Sacchi argued that the root of apocalypticism should be found in the "), _c('em', [_vm._v("Book of the Watchers")]), _vm._v(" ("), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 1–36), one of the earliest segments of the tradition (Sacchi 1997). The generative question was the origin of evil, and the answer was that it was brought to earth by fallen angels. Sacchi tended to identify apocalypticism with the Enochic tradition, in contrast even to the book of Daniel. His student, Gabriele Boccaccini, has proceeded to argue, in Neusnerian fashion, that "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" testifies to “Enochic Judaism,” which he further identifies with the Essenes, whom he regards as the parent movement of the Qumran sect (Boccaccini 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even if one were to grant that the "), _c('em', [_vm._v("Book of the Watchers")]), _vm._v(" is the earliest Jewish apocalypse, the whole phenomenon cannot be defined only on the basis of its earliest exemplar. The differences between Daniel and Enoch show only that there was some diversity within apocalypticism, and that it should not be restricted to a single social movement. Again, while the books of Enoch were preserved at Qumran (except for the "), _c('em', [_vm._v("Similitudes")]), _vm._v("), they were not the only, or even the primary source of sectarian ideology, and there is no evidence whatever that would warrant identifying them with the Essenes. Nonetheless, the early Enoch books attest to a kind of Judaism that is significantly different from the covenantal nomism of “common Judaism.” As George Nickelsburg has argued, “the general category of covenant was not important for these authors” (Nickelsburg 1998: 125). Enoch rather than Moses is the mediator of revelation. Unlike the book of "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" which is closely related to Enoch in some respects, there is no attempt to read back Mosaic legislation into the primeval period. Even the "), _c('em', [_vm._v("Animal Apocalypse,")]), _vm._v(" which touches on the exodus and the ascent of Mt. Sinai in the course of a “prophecy” of the history of Israel, conspicuously fails to mention either the making of a covenant or the giving of the Law. In all of this there is no polemic against the Mosaic Torah, but the Torah is not the explicit frame of reference. Moreover, the Enoch literature attests to a soli-lunar calendar different from the lunar calendar that was observed in the Jerusalem Temple (at least in later times), but similar to the one found in "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the Dead Sea Scrolls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The idea of a movement within Judaism that is not centered on the Mosaic Torah may seem anomalous in the context of the Hellenistic age, but it was not without precedent. The biblical wisdom literature is distinguished precisely by its lack of explicit reference to either the Mosaic Torah or the history of Israel, and it retains this character as late as the book of Qoheleth, which may be roughly contemporary with the early Enoch literature. Charles, then, was not correct when he claimed that “apocalyptic Judaism” “started with the unreserved recognition of the supremacy of the Law.” At least in the case of the early Enoch literature, this was not the case.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("What is true of the Enoch literature, however, is not necessarily true of all the Pseudepigrapha, or even of all apocalyptic literature. The book of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" adapts the myth of the fallen angels from "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" (Segal 2007: 103-43), and shares with it the solar (364-day) calendar. It can be viewed as an example of “rewritten Bible,” or biblical paraphrase, but it is also an apocalypse, in the sense that it is a revelation mediated by an angel. But the recipient of the revelation is none other than Moses, and the content is a paraphrase of the book of Genesis. Moreover, this paraphrase is informed throughout by a keen interest in halakic issues. The sectarian writings of the Dead Sea Scrolls are at once apocalyptic and focused on the exact interpretation of the Law of Moses. The Torah also plays a central role in the apocalypses of "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch,")]), _vm._v(" which were composed after the destruction of the Temple, at the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" The relationship between apocalyptic literature and the Torah is illustrated most vividly by "), _c('em', [_vm._v("4 Ezra.")]), _vm._v(" At the end of the book, Ezra is commissioned to replace the books of the Law that had been burnt. He is given a fiery liquid to drink, and inspired to dictate the books. In all, ninety-four books are written. Of these, twenty-four are made public so that the worthy and unworthy may read them. But the seventy others are kept secret, in order that they may be given to the wise among the people. The extra or hidden books contain “the spring of understanding, the fountain of wisdom and the river of knowledge.” "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" is neither critical of the Torah nor opposed to it, but it claims to have further revelation, which provides the context within which the Torah must be understood. This claim of higher revelation is one of the defining characteristics of apocalyptic literature. In the words of Seth Schwartz, “it was a way of compensating for the deficiencies of the covenantal system” (Schwartz 2001: 83). The covenant promised life and prosperity to those who observed it and threatened disaster to those who did not, but life evidently did not work this way. One of the major topics of apocalyptic revelation was judgment after death and the contrasting fates of the righteous and wicked in the hereafter. Belief in life after death was not confined to apocalyptic literature; the immortality of the soul was widely accepted in Greek-speaking Judaism, and the Pharisees, who may have subscribed to apocalyptic ideas to various degrees, believed in resurrection. But belief in the judgment of the dead and a differentiated afterlife is first attested in Judaism in the books of "), _c('em', [_vm._v("Enoch")]), _vm._v(" and Daniel, and it is the primary factor that distinguishes apocalyptic eschatology from that of the prophets (Collins 1997b: 75-97).")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Dead Sea Scrolls")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The most important development for the study of early Judaism in the past century was undoubtedly the discovery and eventual publication of the Dead Sea Scrolls. The scrolls were found in proximity to a ruined settlement at Khirbet Qumran, south of Jericho, by the Dead Sea. Cave 4, where the main trove of texts was found, is literally a stone’s throw from the site. Most scholars have assumed that the texts constituted the library of a sectarian settlement at Qumran (VanderKam 1994: 12-27). The Roman writer Pliny says that there was an Essene settlement in this region ("), _c('em', [_vm._v("Natural History")]), _vm._v(" 5.73), and there are extensive parallels between the rule books ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("found at Qumran, especially the "), _c('em', [_vm._v("Serek Ha-Ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad,")]), _vm._v(" or "), _c('em', [_vm._v("Community Rule,")]), _vm._v(" and the accounts of the Essenes by Philo and Josephus (Beall 1988). Both the association with the site and the identification with the Essenes have been contested, often vociferously, in recent years (Galor, Humbert, and Zangenberg 2006). Norman Golb has insisted that such an extensive corpus of scrolls could have come only from the Jerusalem Temple, and that the multiplicity of hands belies composition in a single community (Golb 1995). With regard to the identification with the Essenes, the main point in dispute has been the issue of celibacy, which is noted by all ancient writers on the Essenes but is never explicitly required in the scrolls. Also, the accounts of the Essenes do not hint at messianic expectation or at the kind of apocalyptic expectations found in the "), _c('em', [_vm._v("War Scroll")]), _vm._v(" and other texts at Qumran.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The discussion has been obscured by a tendency among scholars to think of Qumran as a single, monastery-like institution. In fact, the rule books make clear that there was a network of communities, which could have as few as ten people, at various locations. The accounts of the Essenes (other than Pliny) also emphasize that they had many settlements. Josephus notes that there were two orders of Essenes, one of which accepted marriage. One of the rule books found at Qumran, the so-called "), _c('em', [_vm._v("Damascus Document,")]), _vm._v(" also appears to distinguish between “those who live in camps and marry and have children” and others who presumably do not. It is unlikely that all the scrolls were copied at Qumran. An alternative scenario is that Essenes from other settlements fled to Qumran in face of the advancing Romans in 68 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and brought their scrolls with them. This would account for the high number of sectarian texts and also for the presence of different editions of the rule books in the caves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In any case, it is clear that the corpus of texts found at Qumran includes many that were not sectarian in origin, although they may been used in a sectarian context. These include the biblical books, but also compositions like the books of "), _c('em', [_vm._v("Enoch")]), _vm._v(" and "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" which apparently were composed before the formation of the sect in the middle or late second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and circulated more widely. But also many texts that were not known before the discovery of the scrolls may have been in broader use in the Judaism of the time. Yet the scrolls cannot be taken as a random sampling of Second Temple literature. On the one hand, the proportion of clearly sectarian texts, including sectarian rule books, is too great. On the other hand, several important writings from this period are conspicuously absent from Qumran. These include 1 Maccabees, the propagandistic history of the Hasmonean family, and the "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" which has often been suspected of Pharisaic ideology. Nothing in the Dead Sea Scrolls can be identified as Pharisaic, and only one text (4Q448, the "), _c('em', [_vm._v("Prayer for King Jonathan")]), _vm._v(") can be read as supportive of the Hasmoneans. The corpus is not narrowly sectarian, in the sense of containing only sectarian literature, but it is nonetheless selective and excludes some literature for ideological reasons.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The first scrolls were discovered on the eve of the Arab-Israeli war that led to the division of Palestine. When partition occurred, Qumran was on the Jordanian side of the border. The seven scrolls originally found in Cave 1 ("), _c('em', [_vm._v("Community Rule, War Scroll, Hodayot, Habakkuk Pesher, Genesis Apocryphon,")]), _vm._v(" and two copies of the book of Isaiah) were acquired by Eliezer Sukenik and his son Yigael Yadin, but ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Jewish scholars would have no access to the rest of the corpus until after the Six-Day War in 1967. The international team appointed to edit the fragments included no Jewish scholars. The first phase of scholarship on the scrolls, then, was dominated by Christian scholars, and Christian interests took priority. There were many comparisons of the community behind the scrolls to early Christianity, and such matters as eschatology and messianism received great attention (see, e.g., Cross 1995). In 1967, however, both Qumran and the Rockefeller Museum where the scrolls were stored came under Israeli control. This did not at first lead to any change in the editorial team, but it had a profound impact on scholarship in another way. Yadin, who was a general in the Israeli army, appropriated a long text, known as the "), _c('em', [_vm._v("Temple Scroll,")]), _vm._v(" from the antiquities dealer Kando, and he published it a decade later (Yadin 1977, 1983). This scroll contains a rewriting of biblical laws, and its interests are primarily halakic. Its publication aroused new interest in the aspects of the scrolls that were continuous with rabbinic rather than with Christian interests. Even more revolutionary was the disclosure in 1984 of a halakic work known as 4QMMT (Qimron and Strugnell 1994). This document is apparently addressed to a leader of Israel, and it outlines the reasons for the separation of a sectarian group from the majority of the people. The reasons had to do with issues of calendar and purity, and the scroll shows that halakic issues (issues of religious law) were vital to the raison d’être of the sect. The positions taken on these issues typically disagreed with those associated with the Pharisees in rabbinic literature and agreed with those of the Sadducees on some points. The scroll showed beyond any doubt that the kinds of issues debated in the Mishnah and Talmud were of great concern already in the late Second Temple period (Schiffman in Oppenheimer 1999: 205-19), and that in this respect any account of Judaism based only on the Apocrypha and Pseudepigrapha would be incomplete.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A third phase in the study of the scrolls began when the entire corpus became generally available in the early 1990s, and the editorial team was greatly expanded under the leadership of Emanuel Tov. It is now possible to get a more balanced view of the entire corpus.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Whatever their relation to “Enochic Judaism,” the scrolls testify to the pervasive authority and influence of the Mosaic Torah. They provide important evidence about the development of the biblical text. The majority of the textual witnesses are close to the Masoretic Text, but there were also other textual forms in circulation. In some cases it is difficult to decide whether a given text is a variant form of the biblical text or a deliberate adaptation of it, in the manner of “rewritten bible,” such as we find in "), _c('em', [_vm._v("Jubilees.")]), _vm._v(" The "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" reinterprets the legal traditions of Leviticus and Deuteronomy by presenting them in rewritten form as a revelation to Moses. In this way the writer’s interpretation of the biblical laws is invested with the authority of the revelation at Sinai. Some scholars have argued that the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" was intended to replace the Torah as the definitive law for the end of days (Wacholder 1983; Wise 1990: 184). It is more likely, however, that it presupposes the authority of the biblical text and is intended as a companion piece and guide to its interpretation (Najman 1999). The scrolls also contain many examples of explicit commentary, most notably in the pesharim, which date from the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and are the oldest extant formal biblical commentaries. The ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("commentaries are primarily on prophetic texts, including Psalms, and relate them to the history of the sect and the “end of days.” Especially interesting is the so-called "), _c('em', [_vm._v("Pesher on Genesis")]), _vm._v(" (4Q252), which combines a paraphrase of the flood story with a pesher-style interpretation of the Blessing of Jacob in Genesis 49.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The scrolls also provide ample evidence for an extensive literature associated with biblical figures, in the manner of the Pseudepigrapha (Dimant 1994; Flint in Flint and VanderKam 1998-1999: 2:24-66). Since most of this literature is fragmentary, it is difficult to be sure of literary genre of many compositions. Related to the Enoch literature is a fragmentary "), _c('em', [_vm._v("Book of Giants.")]), _vm._v(" Possible apocalypses found at Qumran include the "), _c('em', [_vm._v("Visions of Amram,")]), _vm._v(" which describes dualistic angelic-demonic powers, the so-called "), _c('em', [_vm._v("Aramaic Apocalypse")]), _vm._v(" or "), _c('em', [_vm._v("Son of God")]), _vm._v(" text (4Q246), the "), _c('em', [_vm._v("New Jerusalem")]), _vm._v(" text (a vision in the tradition of Ezekiel 40–48), and a “four kingdoms” prophecy where the four kingdoms are symbolized by four trees (4Q552-553). There are also prophecies after the fact attributed to Daniel (4Q243-244, 245) and a similar text, 4Q390, variously identified as "), _c('em', [_vm._v("Pseudo-Moses")]), _vm._v(" or "), _c('em', [_vm._v("Jeremiah Apocryphon.")]), _vm._v(" There are Aramaic texts relating to "), _c('em', [_vm._v("Levi")]), _vm._v(" and "), _c('em', [_vm._v("Qahath,")]), _vm._v(" and an Aramaic "), _c('em', [_vm._v("Genesis Apocryphon.")]), _vm._v(" The Aramaic literature found at Qumran is not perceptibly sectarian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Since so many of the scrolls are dependent on biblical texts, there is a tendency to assume derivation from biblical prototypes. In some cases, this is justified. There are Targums of Leviticus and Job, and the "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" and "), _c('em', [_vm._v("Aramaic Levi Document")]), _vm._v(" are obviously related to the biblical text. But this literature is not all derivative. The "), _c('em', [_vm._v("Prayer of Nabonidus")]), _vm._v(" may have been a source for the book of Daniel, but it does not depend on it, and at least some of the pseudo-Daniel literature also appears to be independent. The text sometimes known as "), _c('em', [_vm._v("Proto-Esther")]), _vm._v(" (4Q550) is related to Esther only insofar as both are tales set in the Persian court. The book of Tobit, which is included in the Apocrypha and is found at Qumran in both Hebrew and Aramaic, is another example of a narrative work that is not derived from a biblical story, although it draws on various biblical motifs. The scrolls also expand significantly our corpus of nonbiblical wisdom literature, including an extensive and important text, 4QInstruction (Goff 2007). Fragments of Ben Sira were also found. The corpus of liturgical texts is also enlarged (Nitzan 1994; Falk 1998). The sapiential and liturgical texts are in Hebrew, but in many cases they are not necessarily sectarian. The scrolls, then, support the view that Jewish literature in the late Second Temple period was quite diverse. Some of it certainly shared the halakic interests of the later rabbis, but much of it also exhibited concerns similar to those attested in the Apocrypha and Pseudepigrapha.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most distinctive literature found in the scrolls consists of sectarian rule books (Metso 1998). The "), _c('em', [_vm._v("Community Rule")]), _vm._v(" and "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" describe a complex sectarian movement that had more than one form of community life. They exhibit important parallels with Greek voluntary associations (Weinfeld 1986), but they are conceived in terms of membership in a new covenant. These rules show extensive similarity to the descriptions of the Essenes in Philo and Josephus, with regard to admission procedures, common property, and community life. The Essenes were not the only sectarian movement to emerge in Judaism in the last centuries before the turn of the era. Rather, sectarianism was a feature of the age, and the scrolls are an important witness to the phenomenon (Baumgarten 1997).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The movement described in the scrolls has often been called an “apocalyptic community,” with good reason (Collins 1997c). The "), _c('em', [_vm._v("War Scroll")]), _vm._v(" and the Treatise on the Two Spirits in the "), _c('em', [_vm._v("Community Rule")]), _vm._v(" are prime examples of what Seth Schwartz has called “the apocalyptic myth” (Schwartz 2001: 74-82). Yet the community does not seem to have used the literary form of apocalypse to any significant degree. In this case, the Torah of Moses was unequivocally regarded as the primary source of revelation. Moreover, the figure called the Teacher of Righteousness was revered as the authoritative interpreter, and rendered pseudonymous mediators such as Enoch or Daniel superfluous. In this respect, the sect was quite unique. It shows, however, that there was no necessary conflict between the veneration of the Torah and interest in apocalyptic revelations.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Judaism and Hellenism")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout the period under consideration in this volume, Jews lived in a world permeated by Hellenistic culture. The pervasiveness of Hellenistic influence can be seen even in the Dead Sea Scrolls (where there is little evidence of conscious interaction with the Greek world), for example, in the analogies between the sectarian communities and voluntary associations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Modern scholarship has often assumed an antagonistic relationship between Hellenism and Judaism. This is due in large part to the received account of the Maccabean Revolt, especially in 2 Maccabees. The revolt was preceded by an attempt to make Jerusalem into a Hellenistic "), _c('em', [_vm._v("polis.")]), _vm._v(" Elias Bickerman (1937) even argued that the persecution was instigated by the Hellenizing high priest Alcimus, and in this he was followed by Martin Hengel (1974). Yet the revolt did not actually break out until the Syrian king, Antiochus IV Epiphanes, had disrupted the Jerusalem cult and given the Temple over to a Syrian garrison. The revolt was not directed against Hellenistic culture but against the policies of the king, especially with regard to the cult. Judas allegedly sent an embassy to Rome and availed of the services of one Eupolemus, who was sufficiently proficient in Greek to write an account of Jewish history. The successors of the Maccabees, the Hasmoneans, freely adopted Greek customs and even Greek names. Arnaldo Momigliano wrote that “the penetration of Greek words, customs, and intellectual modes in Judaea during the rule of the Hasmoneans and the following Kingdom of Herod has no limits” (Momigliano 1994: 22; see also Hengel 1989; Levine 1998). Herod established athletic contests in honor of Caesar and built a large amphitheater, and even established Roman-style gladiatorial contests. He also built temples for pagan cults, but not in Jewish territory, and he had to yield to protests by removing trophies, which involved images surrounded by weapons, from the Temple. In all cases where we find resistance to Hellenism in Judea, the issue involves cult or worship (Collins 2005: 21-43). Many aspects of Greek culture, including most obviously the language, were inoffensive. The revolt against Rome was sparked not by cultural conflict but by Roman mismanagement and social tensions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Because of the extensive Hellenization of Judea, the old distinction between “Palestinian” Judaism and “Hellenistic” (= Diaspora) Judaism has been eroded to ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("a great degree in modern scholarship. Nonetheless, the situation of Jews in the Diaspora was different in degree, as they were a minority in a pagan, Greek-speaking environment, and the Greek language and cultural forms provided their natural means of expression (Gruen 1998, 2002). The Greek community in Alexandria, the Diaspora community of which we are most fully informed, regarded themselves as akin to the Greeks, in contrast to the Egyptians and other "), _c('em', [_vm._v("Barbaroi.")]), _vm._v(" The Torah was translated into Greek already in the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Thereafter, Jewish authors experimented with Greek genres — epic, tragedy, Sibylline oracles, philosophical treatises (Goodman in Vermes et al. 1973-1987: 3:1.470-704; Collins 2000). This considerable literary production reached its apex in the voluminous work of the philosopher Philo in the early first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" This Greco-Jewish literature has often been categorized as apologetic, on the assumption that it was addressed to Gentiles. Since the work of Victor Tcherikover (1956), it is generally recognized that it is rather directed to the Jewish community. Nonetheless, it has a certain apologetic dimension (Collins 2005: 1-20). It is greatly concerned to claim Gentile approval for Judaism. In the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" the Ptolemy and his counselors are greatly impressed by the wisdom of the Jewish sages. "), _c('em', [_vm._v("Aristeas")]), _vm._v(" affirms that these people worship the same God that the Greeks know as Zeus, and the roughly contemporary Jewish philosopher Aristobulus affirms that the Greek poets refer to the true God by the same name. The Sibyl praises the Jews alone among the peoples of the earth. Philo, and later Josephus, is at pains to show that Jews exhibit the Greek virtue of "), _c('em', [_vm._v("philanthrōpia.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To some degree, Hellenistic Jewish authors wrote to counteract perceptions of Jews that circulated in the Hellenistic world (Berthelot 2003). Already at the beginning of the Hellenistic era, Hecataeus of Abdera wrote that Moses had introduced “a somewhat unsocial and inhospitable mode of life.” He told a garbled story of Jewish origins which conflated the Jews with the Hyksos, the Syrian invaders of the second millennium "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" whose memory in Egypt was accursed. The story was elaborated by the Egyptian historian Manetho. It is unlikely that either Manetho or Hecataeus knew the exodus story in its biblical form, or that either had more than an incidental interest in the Jews. The association of the Jews with this tradition was highly negative. Many of the negative stereotypes and calumnies of the Jews were collected by the Alexandrian grammarian Apion in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" We owe their preservation, ironically, to the refutation by Josephus, in his tract "), _c('em', [_vm._v("Against Apion.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There has been a tendency in modern scholarship to find in this material the roots of anti-Semitism (Gager 1983; Schäfer 1997). But the portrayal of Jews was not uniformly negative (Feldman 1993: 177-287). Moses was often praised as a lawgiver, even already by Hecataeus. Moreover, we should bear in mind that the Jews were by no means the only ethnic group in the Hellenistic world who were subjected to ridicule (Isaac 2004). In the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", however, antagonism moved beyond ridicule to violence, in the form of a virtual pogrom in 38 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Violent conflict would eventually consume the Jewish Egyptian community in the revolt under Trajan (Pucci ben Zeev 2005). The alleged anti-Semitism in Alexandria must be seen in the concrete historical and social circumstances of this conflict")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Jews had prospered in Egypt in the Ptolemaic period, despite occasional ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("tensions. Some had served as generals in Ptolemaic armies. Philo’s family became wealthy bankers. In the Roman era, however, their fortunes declined, and there were pogroms in Alexandria in the time of Caligula and again in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" The classic explanation of this conflict was offered by Tcherikover, who made good use of papyrological evidence (1959: 296-332; Tcherikover and Fuks 1957-1964; cf. Modrzejewski 1995). For purposes of taxation, the Romans drew a sharper line between citizen and noncitizen than was the case the Ptolemaic era. Jews responded by trying to infiltrate the gymnasium, as a way of attaining citizenship. The Alexandrians resisted, and conflict ensued. The evidence for this construction of events is admittedly fragile, as Erich Gruen especially has pointed out (Gruen 2002: 54-83). It is doubtful whether the Jews actually sought citizenship, which would presumably have entailed some acknowledgment of the Greek gods (Kasher 1985). Rather, they wanted a status equal to that of citizens. What is apparent is that the Roman conquest of Egypt intensified ethnic rivalry in Alexandria. The Alexandrian citizens were jealous of their diminished status. Jews resented being classified with Egyptians. The role of the Roman governor in manipulating the conflict for his own ends is less than clear. The details of the case are a subject of ongoing debate (Collins 2005: 181-201).")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Diaspora Judaism, no less than its counterpart in the land of Israel, had its frame of reference in the Torah, which in its Greek translation is the great well-spring of Greco-Jewish literature. Many of the fragmentary writings can be described as parabiblical, even if they are cast in Greek forms. The retelling of the exodus in the form of a Greek tragedy by one Ezekiel is a case in point. There has been growing appreciation in recent years of the role of exegesis of the Torah as a unifying element across the full spectrum of ancient Judaism (Kugel 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Egyptian Judaism, however, was distinctive in important ways. Philo, the greatest exegete of Alexandrian Judaism, viewed the Torah through a prism of Greek philosophy, which led to a very different understanding from anything we find in Hebrew or Aramaic sources. Few Alexandrian Jews would have shared Philo’s philosophical sophistication, but virtually all the writings we have from this community use Greek literary forms and categories to appropriate the biblical tradition. In contrast to the Dead Sea Scrolls, the Diaspora literature makes minimal reference to halakhic issues or purity laws. It does, however, insist on Jewish monotheism, and frequently ridicules pagan idolatry. It also insists on the superiority of Jewish sexual ethics and the fact that Jews refrain from infanticide. These were matters which enlightened Greeks could, in principle, appreciate, and they are indicative of the self-image cultivated by Diaspora Jewry. Complete assimilation to the Gentile way of life certainly occurred. (The most famous example is Philo’s nephew, Tiberius Julius Alexander, who became prefect of Egypt and assisted in putting down the Jewish revolt against Rome.) But the Jewish community as a whole preserved a distinct identity, even while embracing most aspects of Hellenistic culture other than idolatry. (On the degrees of assimilation and acculturation, see Barclay 1996.)")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('strong', [_vm._v("Conclusion")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The story of modern scholarship on early Judaism is largely a story of retrieval. None of the literature of this period was preserved by the rabbis. The Greek literature of the Diaspora may not have been available to them. Much of the apocalyptic literature and of the material in the Dead Sea Scrolls was rejected for ideological reasons. The recovery of this literature in modern times presents us with a very different view of early Judaism than was current in the nineteenth century, and even than more recent accounts that impose a rabbinic paradigm on the period in the interests of normativity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No doubt, our current picture of early Judaism is also incomplete. Despite the important documentary papyri from the Judean Desert dating to the Bar Kokhba period (Cotton in Oppenheimer, ed. 1999: 221-36), descriptions of the "), _c('em', [_vm._v("realia")]), _vm._v(" of Jewish life still rely heavily on rabbinic sources that are possibly anachronistic. The overdue study of women in this period is a case in point (Ilan 1995). One of the salutary lessons of the Dead Sea Scrolls is that they revealed aspects of Judaism that no one would have predicted before the discovery. And yet this was only the corpus of writings collected by one sect. To do justice to early Judaism we would need similar finds of Pharisaic, Sadducean, and other groups, and further documentary finds similar to those that have shed at least limited light on Egyptian Judaism and on Judah in the Bar Kokhba period.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. 1996. "), _c('em', [_vm._v("Jews in the Mediterranean Diaspora.")]), _vm._v(" Edinburgh: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Baumgarten, Albert I. 1997. "), _c('em', [_vm._v("The Flourishing of Jewish Sects in the Maccabean Era: An Interpretation.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Beall, Todd S. 1988. "), _c('em', [_vm._v("Josephus’ Description of the Essenes Illustrated by the Dead Sea Scrolls.")]), _vm._v(" Cambridge: Cambridge University.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Berthelot, Katell. 2003. "), _c('em', [_vm._v("Philanthropia Judaica: Le débat autour de la ‘misanthropie’ des lois juives dans l’antiquité.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bickerman, Elias J. 1937. "), _c('em', [_vm._v("Der Gott der Makkabäer.")]), _vm._v(" Berlin: Schocken.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Boccaccini, Gabriele. 1991. "), _c('em', [_vm._v("Middle Judaism: Jewish Thought, 300 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])]), _vm._v("–"), _c('em', [_vm._v("200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1998. "), _c('em', [_vm._v("Beyond the Essene Hypothesis: The Parting of the Ways between Qumran and Enochic Judaism.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———, ed. 2005. "), _c('em', [_vm._v("Enoch and Qumran Origins: New Light on a Forgotten Connection.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Boccaccini, Gabriele, and John J. Collins, eds. 2007. "), _c('em', [_vm._v("The Early Enoch Literature.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bousset, Wilhelm. 1903a. "), _c('em', [_vm._v("Die Religion des Judentums in neutestamentlichen Zeitalter.")]), _vm._v(" Berlin: Reuther und Reichard.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1903b. "), _c('em', [_vm._v("Volksfrömmigkeit und Schriftgelehrtentum: Antwort auf Herrn Perles’ Kritik meiner ‘Religion des Judentums im N.T. Zeitalter.’")]), _vm._v(" Berlin: Reuther und Reichard.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charles, R. H., ed. 1913. "), _c('em', [_vm._v("The Apocrypha and Pseudepigrapha of the Old Testament.")]), _vm._v(" 2 vols. Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charlesworth, James H., ed. 1983-1985. "), _c('em', [_vm._v("The Old Testament Pseudepigrapha.")]), _vm._v(" 2 vols. New York: Doubleday.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cohen, Shaye J. D. 1999. "), _c('em', [_vm._v("The Beginnings of Jewishness: Boundaries, Varieties, Uncertainties.")]), _vm._v(" Berkeley: University of California Press.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Collins, John J., ed. 1979. "), _c('em', [_vm._v("Apocalypse: The Morphology of a Genre.")]), _vm._v(" Semeia 14. Missoula, Mont.: Scholars Press.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1997a. "), _c('em', [_vm._v("Jewish Wisdom in the Hellenistic Age.")]), _vm._v(" Louisville: Westminster John Knox.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1997b. "), _c('em', [_vm._v("Seers, Sibyls and Sages in Hellenistic-Roman Judaism.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1997c. "), _c('em', [_vm._v("Apocalypticism in the Dead Sea Scrolls.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1998. "), _c('em', [_vm._v("The Apocalyptic Imagination: An Introduction to Jewish Apocalyptic Literature.")]), _vm._v(" Rev. ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2000. "), _c('em', [_vm._v("Between Athens and Jerusalem: Jewish Identity in the Hellenistic Diaspora.")]), _vm._v(" Rev. ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2005. "), _c('em', [_vm._v("Jewish Cult and Hellenistic Culture: Essays on the Jewish Encounter with Hellenism and Roman Rule.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cross, Frank Moore. 1995. "), _c('em', [_vm._v("The Ancient Library of Qumran.")]), _vm._v(" 3d ed. Sheffield: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Davila, James R. 2005. "), _c('em', [_vm._v("The Provenance of the Pseudepigrapha: Jewish, Christian, or Other?")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dimant, Devorah. 1994. “Apocalyptic Texts at Qumran.” In "), _c('em', [_vm._v("The Community of the Renewed Covenant: The Notre Dame Symposium on the Dead Sea Scrolls.")]), _vm._v(" Ed. Eugene Ulrich and James VanderKam. Notre Dame: University of Notre Dame Press, 175-91.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Efron, Joshua. 1987. "), _c('em', [_vm._v("Studies on the Hasmonean Period.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fabricius, J. A. 1713. "), _c('em', [_vm._v("Codex Pseudepigraphus Veteris Testamenti.")]), _vm._v(" Leipzig: Liebezeit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Falk, Daniel K. 1998. "), _c('em', [_vm._v("Daily, Sabbath, and Festival Prayers in the Dead Sea Scrolls.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feldman, Louis H. 1993. "), _c('em', [_vm._v("Jew and Gentile in the Ancient World: Attitudes and Interactions from Alexander to Justinian.")]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flint, Peter W., and James C. VanderKam, eds. 1998-1999. "), _c('em', [_vm._v("The Dead Sea Scrolls after Fifty Years: A Comprehensive Assessment.")]), _vm._v(" 2 vols. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gager, John G. 1985. "), _c('em', [_vm._v("The Origins of Anti-Semitism: Attitudes toward Judaism in Pagan and Christian Antiquity.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Galor, Katharina, Jean-Baptiste Humbert, and Jürgen Zangenberg, eds. 2006. "), _c('em', [_vm._v("Qumran: The Site of the Dead Sea Scrolls: Archaeological Interpretations and Debates.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goff, Matthew J. 2007. "), _c('em', [_vm._v("Discerning Wisdom: The Sapiential Literature of the Dead Sea Scrolls.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Golb, Norman. 1995. "), _c('em', [_vm._v("Who Wrote the Dead Sea Scrolls? The Search for the Secret of Qumran.")]), _vm._v(" New York: Scribner.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodman, Martin. 2002. “Jews and Judaism in the Second Temple Period.” In "), _c('em', [_vm._v("The Oxford Handbook of Jewish Studies.")]), _vm._v(" Ed. M. Goodman. Oxford: Oxford University Press, 36-52.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Green, William S. 1994. “Ancient Judaism: Contours and Complexity.” In "), _c('em', [_vm._v("Language, Theology and the Bible: Essays in Honour of James Barr.")]), _vm._v(" Ed. S. E. Balentine and J. Barton. Oxford: Oxford University Press, 293-310.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gruen, Erich S. 1998. "), _c('em', [_vm._v("Heritage and Hellenism: The Reinvention of Jewish Tradition.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2002. "), _c('em', [_vm._v("Diaspora: Jews amidst Greeks and Romans.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harlow, Daniel C. 1996. "), _c('em', [_vm._v("The Greek Apocalypse of Baruch (3 Baruch) in Hellenistic Judaism and Early Christianity.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hellholm, David. 1983. "), _c('em', [_vm._v("Apocalypticism in the Mediterranean World and the Near East.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hengel, Martin. 1974. "), _c('em', [_vm._v("Judaism and Hellenism: Studies in Their Encounter in Palestine in the Early Hellenistic Period.")]), _vm._v(" 2 vols. Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1989. "), _c('em', [_vm._v("The Hellenization of Judaea in the First Century after Christ.")]), _vm._v(" Philadelphia: Trinity Press International.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("———. 1990. “Der alte und der neue Schürer.” "), _c('em', [_vm._v("JSS")]), _vm._v(" 35: 19-64.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Himmelfarb, Martha. 1993. "), _c('em', [_vm._v("Ascent to Heaven in Jewish and Christian Apocalypses.")]), _vm._v(" New York: Oxford.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ilan, Tal. 1995. "), _c('em', [_vm._v("Jewish Women in Greco-Roman Palestine: An Inquiry into Image and Status.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Isaac, Benjamin. 2004. "), _c('em', [_vm._v("The Invention of Racism in Classical Antiquity.")]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jonge, Marinus de. 1953. "), _c('em', [_vm._v("The Testaments of the Twelve Patriarchs: A Study of Their Text Composition and Origin.")]), _vm._v(" Assen: van Gorcum.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2000. “The Testaments of the Twelve Patriarchs and Related Qumran Fragments.” In "), _c('em', [_vm._v("For a Later Generation: The Transformation of Tradition in Israel, Early Judaism and Early Christianity.")]), _vm._v(" Ed. Randall A. Argall, Beverly A. Bow, and Rodney A. Werline. Harrisburg, Penn.: Trinity Press International, 63-77.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kasher, Aryeh. 1985. "), _c('em', [_vm._v("The Jews in Hellenistic and Roman Egypt.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kautzsch, Emil. 1900. "), _c('em', [_vm._v("Die Apokryphen und Pseudepigraphen des Alten Testaments.")]), _vm._v(" Tübingen: Mohr.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Koch, Klaus. 1972. "), _c('em', [_vm._v("The Rediscovery of Apocalyptic.")]), _vm._v(" Naperville, Ill.: Allenson.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kraemer, Ross S. 1998. "), _c('em', [_vm._v("When Aseneth Met Joseph: A Late Antique Tale of the Biblical Patriarch and His Egyptian Wife, Reconsidered.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kraft, Robert A. 1994. “The Pseudepigrapha in Christianity.” In "), _c('em', [_vm._v("Tracing the Threads: Studies in the Vitality of Jewish Pseudepigrapha.")]), _vm._v(" Ed. John C. Reeves. Atlanta: Scholars Press, 55-86.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2001. “The Pseudepigrapha and Christianity Revisited: Setting the Stage and Framing Some Central Questions.” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 32: 371-95.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kugel, James L. 1998. "), _c('em', [_vm._v("Traditions of the Bible: A Guide to the Bible As It Was at the Start of the Common Era.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kvanvig, Helge S. 1988. "), _c('em', [_vm._v("Roots of Apocalyptic: The Mesopotamian Background of the Enoch Figure and of the Son of Man.")]), _vm._v(" Neukirchen-Vluyn: Neukirchener Verlag.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Laurence, Richard. 1821. "), _c('em', [_vm._v("The Book of Enoch the Prophet.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Levine, Lee. I. 1998. "), _c('em', [_vm._v("Judaism and Hellenism in Antiquity: Conflict or Confluence?")]), _vm._v(" Seattle: University of Washington Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mason, Steve. 2007. “Jews, Judaeans, Judaizing, Judaism: Problems of Categorization in Ancient History.” "), _c('em', [_vm._v("JJS")]), _vm._v(" 38: 457-512.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Metso, Sarianna. 1997. "), _c('em', [_vm._v("The Textual Development of the Qumran Community Rule.")]), _vm._v(" Leiden/New York: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Milik, J. T. 1976. "), _c('em', [_vm._v("The Books of Enoch.")]), _vm._v(" Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Modrzejewski, Joseph Mélèze. 1995. "), _c('em', [_vm._v("The Jews of Egypt: From Rameses II to Emperor Hadrian.")]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Momigliano, Arnaldo. 1994. "), _c('em', [_vm._v("Essays on Ancient and Modern Judaism.")]), _vm._v(" Chicago: University of Chicago Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Moore, George Foote. 1921. “Christian Writers on Judaism.” "), _c('em', [_vm._v("HTR")]), _vm._v(" 14: 197-254.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1927-1930. "), _c('em', [_vm._v("Judaism in the First Centuries of the Christian Era: The Age of the Tannaim.")]), _vm._v(" 3 vols. Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Najman, Hindy. 1999. "), _c('em', [_vm._v("Seconding Sinai: The Development of Mosaic Discourse in Second Temple Judaism.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Neusner, Jacob. 1981. "), _c('em', [_vm._v("Judaism: The Evidence of the Mishnah.")]), _vm._v(" Chicago: University of Chicago Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1984. "), _c('em', [_vm._v("Das pharisäische und talmudische Judentum.")]), _vm._v(" Ed. Hermann Lichtenberger. Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Neusner, Jacob, William S. Green, and Ernst Frerichs, eds. 1987. "), _c('em', [_vm._v("Judaisms and Their Messiahs at the Turn of the Christian Era.")]), _vm._v(" Cambridge: Cambridge University Press.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Nickelsburg, George W. E. 1998. “Enochic Wisdom: An Alternative to the Mosaic Torah?” In ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('em', [_vm._v("Hesed ve-emet: Studies in Honor of Ernest S. Frerichs.")]), _vm._v(" Ed. Jodi Magness and Seymour Gitin. Atlanta: Scholars Press, 123-32.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2005. "), _c('em', [_vm._v("Jewish Literature between the Bible and the Mishnah.")]), _vm._v(" 2d ed. Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nir, Rivkah. 2003. "), _c('em', [_vm._v("The Destruction of Jerusalem and the Idea of Redemption in the Syriac Apocalypse of Baruch.")]), _vm._v(" Atlanta: Society of Biblical Literature.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nitzan, Bilhah. 1994. "), _c('em', [_vm._v("Qumran Prayer and Religious Poetry.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Oppenheimer, Aharon, ed. 1999. "), _c('em', [_vm._v("Jüdische Geschichte in hellenistisch-römischer Zeit: Wege der Forschung, Vom alten zum neuen Schürer.")]), _vm._v(" Munich: Oldenbourg.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Perles, Felix. 1903. "), _c('em', [_vm._v("Bousset’s")]), _vm._v(" Religion des Judentums im neutestamentlichen Zeitalter "), _c('em', [_vm._v("kritisch untersucht.")]), _vm._v(" Berlin: Peiser.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Porter, F. C. 1928. Review of "), _c('em', [_vm._v("Judaism in the First Centuries of the Christian Era: The Age of the Tannaim")]), _vm._v(" by G. F. Moore in "), _c('em', [_vm._v("Journal of Religion")]), _vm._v(" 8: 30-62.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pucci ben Zeev, Miriam. 2005. "), _c('em', [_vm._v("Diaspora Judaism in Turmoil, 11")]), _vm._v("6/1"), _c('em', [_vm._v("17 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v(": Ancient Sources and Modern Insights.")]), _vm._v(" Leuven: Peeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Qimron, Elisha, and John Strugnell. 1994. "), _c('em', [_vm._v("Qumran Cave 4, V. Miq")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("at Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("a")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("ê Ha-Torah.")]), _vm._v(" DJD 10. Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rad, Gerhard von. 1965. "), _c('em', [_vm._v("Theologie des Alten Testament.")]), _vm._v(" 4th ed. Munich: Kaiser.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Riessler, Paul. 1928. "), _c('em', [_vm._v("Altjüdisches Schrifttum ausserhalb der Bibel.")]), _vm._v(" Augsburg: Filer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rowland, Christopher. 1983. "), _c('em', [_vm._v("The Open Heaven: A Study of Apocalyptic in Judaism and Early Christianity.")]), _vm._v(" New York: Crossroad.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rowley, H. H. 1944. "), _c('em', [_vm._v("The Relevance of Apocalyptic.")]), _vm._v(" London: Athlone.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sacchi, Paolo. 1997. "), _c('em', [_vm._v("Jewish Apocalyptic and Its History.")]), _vm._v(" Sheffield: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sanders, E. P. 1977. "), _c('em', [_vm._v("Paul and Palestinian Judaism.")]), _vm._v(" Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1985. "), _c('em', [_vm._v("Jesus and Judaism.")]), _vm._v(" Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1990. "), _c('em', [_vm._v("Jewish Law from Jesus to the Mishnah.")]), _vm._v(" London: SCM.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1992. "), _c('em', [_vm._v("Judaism: Practice and Belief, 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v("–"), _c('em', [_vm._v("66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")])]), _vm._v(". Philadelphia: Trinity Press International.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schäfer, Peter. 1997. "), _c('em', [_vm._v("Judeophobia: Attitudes toward the Jews in the Ancient World.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schiffman, L. H. 1999. “Halakha and History: The Contribution of the Dead Sea Scrolls to Recent Scholarship.” In "), _c('em', [_vm._v("Jüdische Geschichte.")]), _vm._v(" Ed. A. Oppenheimer. Munich: Oldenbourg, 205-19.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schürer, Emil. 1886-1911. "), _c('em', [_vm._v("Geschichte des jüdischen Volkes im Zeitalter Jesu Christi.")]), _vm._v(" 2 vols. Leipzig: Hinrichs (1886-1890; 3d ed., 3 vols., 1898-1901; 4th ed., 1901-1909, with index volume, 1911; English translation of 3d ed.: "), _c('em', [_vm._v("A History of the Jewish People in the Time of Jesus Christ,")]), _vm._v(" 3 vols., Edinburgh: Clark, 1890-1893).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schwartz, Seth. 2001. "), _c('em', [_vm._v("Imperialism and Jewish Society, 200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to 640 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Segal, Michael. 2007. "), _c('em', [_vm._v("The Book of Jubilees: Rewritten Bible, Redaction, Ideology and Theology.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stone, Michael E., ed. 1984. "), _c('em', [_vm._v("Jewish Literature of the Second Temple Period.")]), _vm._v(" Assen: Van Gorcum; Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tcherikover, Victor. 1956. “Jewish Apologetic Literature Reconsidered.” "), _c('em', [_vm._v("Eos")]), _vm._v(" 48: 169-93.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1959. "), _c('em', [_vm._v("Hellenistic Civilization and the Jews.")]), _vm._v(" Philadelphia: Jewish Publication Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tcherikover, Victor, and Alexander Fuks. 1957-64. "), _c('em', [_vm._v("Corpus Papyrorum Judaicarum.")]), _vm._v(" 3 vols. Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("VanderKam, James C. 2010. "), _c('em', [_vm._v("The Dead Sea Scrolls Today.")]), _vm._v(" Rev. ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vermes, Geza et al., eds. 1973-1987. "), _c('em', [_vm._v("The History of the Jewish People in the Age of Jesus Christ (175 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.–A.D.")]), _vm._v(" 135) by Emil Schürer: A New English Edition Revised and Edited.")]), _vm._v(" 3 vols., vol. 3 in 2 parts. Edinburgh: Clark.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Wacholder, Ben Zion. 1983. "), _c('em', [_vm._v("The Dawn of Qumran: The Sectarian Torah and the Teacher of Righteousness.")]), _vm._v(" Cincinnati: Hebrew Union College.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Weinfeld, Moshe. 1986. "), _c('em', [_vm._v("The Organizational Pattern and the Penal Code of the Qumran Sect.")]), _vm._v(" Göttingen: Vandenhoeck & Ruprecht.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wiese, Christian. 2005. "), _c('em', [_vm._v("Challenging Colonial Discourse: Jewish Studies and Protestant Theology in Wilhelmine Germany.")]), _vm._v(" Trans. B. Harshav and C. Wiese. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wise, Michael O. 1990. "), _c('em', [_vm._v("A Critical Study of the Temple Scroll from Qumran Cave 11.")]), _vm._v(" Chicago: Oriental Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Yadin, Yigael. 1977. "), _c('em', [_vm._v("Megillat ha-Miqdash.")]), _vm._v(" 3 vols. Jerusalem: Israel Exploration Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1983. "), _c('em', [_vm._v("The Temple Scroll.")]), _vm._v(" 3 vols. Jerusalem: Israel Exploration Society.")])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('em', [_vm._v("Jewish History from Alexander to Hadrian")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h1', {
    staticClass: "chapter-subtitle"
  }, [_vm._v("From Alexander to Pompey")]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-author1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRIS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The conquests of Alexander the Great had far-reaching consequences for the Jews. In the course of a single decade (334-324 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), Jewish communities everywhere found themselves subjects of a new world empire ruled by Macedonians and connected with Greek culture. Macedonian monarchs would continue to dominate the Near East for the next three centuries, while Hellenism itself would cast a still longer shadow over the region and its peoples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These new realities carried with them both peril and prospect for the Jews of Asia Minor, the Levant, Egypt, Mesopotamia, and Iran. The inability of Alexander’s successors to hold together his far-flung dominions condemned those lands to chronic interstate warfare and incessant dynastic instability. Physical displacement, economic hardship, political factionalism, enslavement, and other woes are prominent themes of this era. But Jews could also benefit from the opportunities created by so volatile an environment. Some found ready employment in the military and bureaucratic sectors of the Hellenistic states. Others engaged in interregional trade networks and participated in the cosmopolitan life of Greek cities. By the second half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", the Hasmoneans were able to forge a sovereign, Jewish state in Palestine — the first in almost 500 years. The Hellenistic age brought Jews into contact with a wider world; it also brought them to the notice of that world. When the Roman general Pompey set foot in Palestine in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", the Jews had become a people to be reckoned with.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('strong', [_vm._v("Before Alexander")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Before the conquests of Alexander, all Jews (so far as we are aware) resided within the confines of the Persian Empire. Stretching from Anatolia in the west to Afghanistan in the east and from the Caspian steppe in the north to Upper Egypt in the south, the multiethnic domain of the Achaemenid dynasty sustained numerous Jewish communities. Most of these are known to us only through indirect or retrospective testimony. Thus, our present understanding of Jewish life on the eve of Alexander’s conquests is imperfect, especially outside of Palestine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("An obscure biblical allusion and a stray Aramaic inscription "), _c('em', [_vm._v("may")]), _vm._v(" attest to a Jewish presence in Asia Minor before Alexander, but their interpretation and dating are contested. In the absence of stronger evidence, it is more defensible to treat the Jewish settlement of western Anatolia as a Hellenistic development.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Babylonian Diaspora is a major focus of the prophetic corpus of the Hebrew Bible. The later flowering of talmudic culture in that region spawned a wealth of traditions concerning the Jews of Mesopotamia. But the historicity of the latter is often suspect, and the former deals mostly with the Neo-Babylonian period. This gap in reliable testimony is partly remedied by economic documents that locate individual Jews (as well as at least one predominantly Jewish town) in the Babylon-Borsippa and Nippur regions. As yet, there is no cuneiform evidence for a Jewish presence in the city of Babylon itself during Achaemenid times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Less certain still is the extent of pre-Hellenistic Jewish penetration of lands of the Zagros arc — Armenia, Adiabene, Media, Elam — or the vast Iranian plateau beyond. Late antique sources attest to an Achaemenid deportation of Jews to distant Hyrcania around 340 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", and the subsequent appearance of “Hyrcanus” as a Jewish name has been cited as corroboration for this tradition. It is possible, however, that the alleged deportation has been chronologically misplaced and that it actually happened six centuries later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The geopolitical situation of Palestine has traditionally linked it with Egypt. The Bible is rife with references to pro-Egyptian factions collaborating with allies on the Nile. Such interstate cooperation appears to have supplied the occasion for the emergence of a Jewish military colony at Elephantine (Yeb) in Upper Egypt. Although there were certainly other Jewish settlements in Egypt, the Elephantine garrison is the only one whose persistence into Achaemenid times has been verified by papyri. Unfortunately, this documentation peters out by the end of the fifth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" One Hellenistic text, the largely fictional "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" claims additional colonists settled in Egypt with the advent of Persian rule, but no precise chronology is offered. Still, it is a reasonable inference that there were Jews living in Egypt at the time of Alexander’s capture of that country in 332 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The pattern of military settlement certainly continued under Macedonian rule.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("We are better informed about Palestinian Jewry than any other, though the picture remains woefully incomplete. Survey archaeology has revealed a gradual demographic expansion during late Achaemenid times, as well as significant commercial involvement with the Greek world via the Phoenician coast. Recent excavations on Mt. Gerizim have firmly dated the construction of a Samaritan temple there to the mid-fifth century, though it remains unclear whether or to what ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("extent this event reflects the developed Jewish-Samaritan rivalry of the Hellenistic period.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The wars of Alexander and his successors undoubtedly disrupted Jewish life in the late fourth century, but the core areas of Jewish settlement persisted and, in time, expanded. By the time of Pompey, Jews could be found not only within the lands of the former Persian Empire, but also in the Aegean, the Greek mainland, North Africa, even the city of Rome. The consolidation of the Hasmonean state in the late second and early first centuries extended Jewish settlement (or at least control) over much of Palestine, transforming Judea from a minute, land-locked, temple community into a major regional power. In Achaemenid times, many Jews — perhaps a majority — inhabited the hinterlands of the great urban centers of the Near East. This was to change during the age of Alexander. In the course of the Hellenistic period, many Jews would be drawn to the Greek "), _c('em', [_vm._v("polis")]), _vm._v(" and would absorb and appropriate its culture (selectively) as their own. This development, more than any other, propelled the creative genius of early Judaism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Alexander and the Diadochoi")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The principal Greek and Roman historians who chronicled the campaigns of Alexander make no mention of the Jews, who appear to have played little or no active role in the titanic clashes of that decisive decade. The first-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Jewish historian, Flavius Josephus, conjures up a very different picture. In his account, Alexander visited Jerusalem after his capture of Gaza in 332, attributed his victories to the favor of the Jewish god, guaranteed all Jews the right to live by their ancestral laws, and invited any who wished to join the Macedonians in their war against Persia ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 11.325-39). Hecataeus of Abdera (or, more likely, a Jewish pseudepigrapher writing in his name) preserves episodes involving Jewish soldiers in Alexander’s forces ("), _c('em', [_vm._v("apud")]), _vm._v(" Josephus, "), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 1.192, 200-204). Although judged to be fictional by most scholars, these and other imaginative reconstructions reflect the fact that Jews did serve in the armies of the Hellenistic monarchies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alexander died in 323 without a viable heir and apparently without any clear instructions for choosing one. The result was a series of ultimately unsuccessful attempts by his former companions to prevent the fragmentation of Alexander’s realm. The rival maneuverings of these generals, collectively dubbed the Diadochoi (“Successors”) by later historians, turned the lands of the Near East into an incessant battleground. The loss of Alexander’s natural kin to attrition removed the Macedonian royal house as a putative object of common allegiance, impelling each of the Diadochoi in turn to proclaim himself king. The failure of the strongest of these to achieve ascendancy over his rivals at the Battle of Ipsus in 301 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" precipitated a division of territory that would eventually harden into three relatively stable monarchies: Antigonid Greece, Seleucid Asia, and Ptolemaic Egypt.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("References to Jewish fortunes during the early wars of the Diadochoi are sparse. The Alexandrian historian Agatharchides of Cnidus relates that Ptolemy I captured Jerusalem, probably in 312 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" ("), _c('em', [_vm._v("apud")]), _vm._v(" Josephus, "), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 1.209-11; cf. ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('em', [_vm._v("Ant.")]), _vm._v(" 12.6). The "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" states that Ptolemy enslaved some of its inhabitants and relocated others to Egypt, absorbing roughly a third of the latter into his defense forces. "), _c('em', [_vm._v("Aristeas’")]), _vm._v(" numbers (100,000 deportees) are clearly exaggerated; but even if the story oversimplifies a more complicated series of population transfers, it surely reflects at least one source of Egypt’s Jewish population during the early Hellenistic period. Josephus also claims Jews served in the armies of Seleucus I (ruled 305-281) and were rewarded with citizenship in the cities he founded ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.119). As with the Ptolemaic tales, this tradition smacks of retrospection by later Jewish inhabitants of these cities — especially those of the Seleucid capital at Antioch ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.120-24). A precise chronology of early Jewish settlement within the Ptolemaic and Seleucid realms is not recoverable.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Third Century")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Ptolemaic Empire dominates the historical record of Jewish life in the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" From the Battle of Ipsus until the Seleucid seizure of Palestine in 198, roughly half the world’s Jews were subjects of the House of Ptolemy. (Of the other half, we possess virtually no evidence for this period.) From an Egyptian core, centered on the maritime metropolis of Alexandria, the Ptolemies projected their power across the eastern Mediterranean. Cyrenaica, Cyprus, Crete, the islands of the Aegean, the coasts of Anatolia and the Levant, along with much of the Syrian and Palestinian hinterlands, all felt the hand of Ptolemaic rule.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Egypt itself provides the greatest wealth of documentation for Jews in the Ptolemaic realm. Third-century papyri reveal Jewish military settlements in the Fayyum, while funerary inscriptions from the vicinity of Alexandria indicate an early concentration of Jews there. This picture is reinforced by inscriptions from Schedia and Arsinoe-Crocodilopolis dedicating prayer houses to Ptolemy III (ruled 246-221 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). The presence of one such building at Schedia on the Nile may also lend some credence to Josephus’ claim that Jews had been involved in official oversight of river traffic ("), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.64).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The vexed and ultimately insoluble problem of dating the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" need not detain us. Most scholars conjecture a late second- or early first-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" setting; but whatever the date of its creation, "), _c('em', [_vm._v("Aristeas")]), _vm._v(" must have postdated (probably by several generations) the actual event of the Pentateuch’s translation into Greek. Since there is no convincing reason to question Alexandria as the site of the translation, we may infer that, by the end of the third century, the Ptolemaic capital supported a Greek-speaking Jewish population numerous enough to warrant such an extensive undertaking. It is unnecessary to account for the existence of this community by any single event or cause. A century of Ptolemaic rule, along with the city’s economic importance, is sufficient grounds for Alexandria’s reputation as the largest urban Jewish settlement of the Hellenistic age.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The Libyan pentapolis of Cyrenaica was incorporated into the Ptolemaic realm already by the late fourth century. Predictably, Josephus attributes the origins of Jewish presence there to an act of Ptolemy I, bent on consolidating his hold over this tenuous frontier ("), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.44). More substantial testimony for Jewish ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("habitation of North Africa emerges only in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", and so can tell us little about its possible beginnings two hundred years earlier ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.115).")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As for Jewish settlement elsewhere in the Ptolemaic Empire (apart from Palestine), we have no direct third-century evidence. The book of 1 Maccabees, probably composed in the late second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", contains a list of cities and countries, including Cyrene and many other communities that fell within the zone of Ptolemaic hegemony (1 Macc. 15:22-23). This list, which refers to a Roman request that the addressees extradite any Jews who may be seeking asylum among them, has sometimes been construed as evidence for Jewish habitation in those places. This, however, is neither stated nor implied in the passage, which is itself historically suspect. It is possible that Jews penetrated the islands and coasts of the Ptolemaic-controlled Mediterranean by this time or earlier, but firmer statements to this effect must await new discoveries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Our two primary sources for the history of Ptolemaic Palestine itself are Josephus and the so-called Zenon Papyri. Numismatic and archaeological data contribute to the assessment of this written testimony but also complicate its interpretation. Josephus’ narrative focuses upon the fortunes of the Tobiads, a clan of Jewish notables who achieved prominence as collaborators and mediators of Ptolemaic rule. These colorful tales depict Judea as a distinct ethnic unit within Palestine whose tributary relations with Alexandria are mediated by the high priest in Jerusalem — until, that is, this role is transferred to the Tobiads. Tensions with his countrymen (possibly coincident with the conquest of Palestine by the Seleucids) eventually prompt Hyrcanus, one scion of the family, to withdraw to Transjordan, where he establishes himself as an independent strongman ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.154-222).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Josephus’ account suffers from historical inaccuracies, and many features of the Tobiad cycle are patently folkloric. The Zenon Papyri, a dossier detailing the economic activities of an agent of the chief finance minister for Ptolemy II, reveals a much more centrally controlled fiscal regime than that envisioned by Josephus. Being occasional by its very nature, Zenon’s correspondence can offer only vignettes of Ptolemaic Palestine, not a comprehensive panorama. No reference is made in them, for example, to the high priest (or the Tobiads) as the nexus of Ptolemaic administration. Strikingly, though, one papyrus does verify a Tobiad military presence in Transjordan a half century prior to Hyrcanus’ settling in that region. Excavations have positively identified ‘Araq el-Emir and its environs with the fortified estate Josephus attributes to Hyrcanus (and possibly with the military colony of Hyrcanus’ ancestor, Tobias, associated by Zenon with “Birta in Ammanitis”). But scholarly consensus on the chronology of the surviving structures has yet to be achieved. What does emerge with certainty is that the institution of military settlement continued to be an important anchor for Macedonian control in the region, and that Jews could and did acquire power and prominence in other areas of life through that initial channel.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Another avenue of inquiry into the history of third-century Palestine is afforded by coinage. A series of small silver denomination, dubbed by numismatists “Yehud coins,” crosscuts the boundary between the Persian and Hellenistic eras, and is coextensive with the period of Ptolemaic rule. Two features of these coins ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("have attracted historical notice. The first is the fact that the name of the local governor (who apparently had acted as the minting authority under the Persians) disappears from the third-century issues. This absence, combined with the centrality of high priests in the literary sources, has led many to the conclusion that the Jewish high priest assumed an enlarged secular role under the Ptolemies. In addition to the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" and the Tobiad romance, other texts referential to this period (1 Macc. 12:20-23; Sirach 50; 3 Maccabees 2; Hecataeus "), _c('em', [_vm._v("apud")]), _vm._v(" Diodorus 40.3.5-6) are unanimous in presenting the high priest as representative and leader of the Jewish people. These portraits may well be idealized, but the presumption that they reflect some degree of reality remains a defensible hypothesis. The modification of the coin legend "), _c('em', [_vm._v("Yehud")]), _vm._v(" to "), _c('em', [_vm._v("Yehudah")]), _vm._v(" on the later groups may indicate an administrative reorganization (perhaps during the reign of Ptolemy II). Advocates of the high priest-as-political-leader thesis often see the coins as indirect corroboration that the office was melding into a combination of cultic, diplomatic, and municipal roles. Enticing as these theories are, the numismatic evidence remains mute and therefore amenable to other interpretations. Whatever else they may point to, the coins do reveal that the coming of Ptolemaic rule did not involve a total break with existing institutions.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Ptolemaic rule was not to last. Seleucus I’s claim upon the lands of the Levant was never forgotten by his heirs, who, over the course of the third century, launched no fewer than five successive campaigns to recover the region. The last of these, fought between 202 and 198, definitively wrested Palestine from the Ptolemies, ushering in a century of Seleucid dominance.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Antiochus III")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With the reign of Antiochus III (223-187 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), Jewish history became inextricably bound up with the fortunes of the Seleucid dynasty. When he came to power, Antiochus presided over a failing empire. Challenged internally by secessionist forces and confined from without by Ptolemy IV, the young monarch spent the better part of two decades reconsolidating Seleucid hegemony over Syria, Asia Minor, Mesopotamia, Iran, and central Asia. Jews appear to have played some role in this process. Josephus reproduces the text of a letter announcing Antiochus’ decision to transplant 2,000 Jewish families from Mesopotamia and Babylonia to western Asia Minor, in hopes of establishing a loyalist presence in the rebellious satrapies of Phrygia and Lydia ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.148-53).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The letter is not dated but cannot have been penned earlier than 213, the year Antiochus completed his reduction of Anatolia and began turning his attention to eastern affairs. If authentic, it supplies the earliest unambiguous testimony for Jewish settlement here. It also implies that Antiochus had reason to trust the Jewish communities of Babylonia and Mesopotamia. The justifications offered in the letter, however, are less than convincing (devotion to their God and loyalty toward the king’s forefathers), prompting some to regard the document as a pious fiction — but one undoubtedly concocted by Jewish inhabitants of the regions mentioned. (Other documents in Josephus relating to Asia Minor in the ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("late second and mid-first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" provide ample evidence for Jews living there.)")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The death of Ptolemy IV in 204 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" offered Antiochus a window of opportunity to recapture the southern Levant (which he had been forced to evacuate after an abortive conquest a decade and a half earlier). The details of the Fifth Syrian War that followed are imperfectly known. For the Jews of Palestine, the decisive turning point was the Battle of Panion (200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), which put Ptolemaic forces on the run. Subsequent coastal victories over Sidon (199) and Gaza (198) sealed Seleucid control over the region. According to Polybius ("), _c('em', [_vm._v("apud")]), _vm._v(" Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.136), Jerusalem was captured soon after Panion, the Jews having assisted Antiochus in dislodging the city’s Egyptian garrison ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.138).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Josephus adduces two documents of Antiochus regarding Jerusalem and its people in the aftermath of Panion. The first promises royal financial underwriting for the Temple service and its physical repair from damages suffered in the conflict, mandates restoration to their homes of war captives and other displaced persons, guarantees the Jews shall live according to their traditional laws, exempts Temple personnel and other notables from certain taxes, and offers partial remission of tribute until the city and its hinterland recover from the ravages of war ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.138-44). The second document asserts the sanctity of the Temple and its city, upholding purity regulations defined by “the ancestral law” and prescribing a fine to be paid in the event of their violation ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.145-46).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first of these documents is presented as a letter from Antiochus to a “Ptolemy” (probably to be identified with the Seleucid governor of Coele-Syria and Phoenicia attested in other contemporary sources). Its historicity is today generally accepted on the grounds that it conforms in most respects to known patterns of Seleucid beneficence. The second document is more problematic because it lacks a preamble identifying the king as its author. Some of the prohibitions it mandates find echoes in the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" from Qumran (thought to have been composed half a century later). If Antiochus did promulgate such a decree, its stipulations were clearly governed by Jewish conceptualities, rather than conventional Hellenistic notions of temple inviolability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Having secured his southern frontier against Egypt, Antiochus trained his gaze westward to the remaining Ptolemaic dependencies along the coasts of Anatolia. But his ambitions went beyond neutralizing the Ptolemaic Empire. In that same year (197), the Romans defeated Philip V of Macedon, erstwhile hegemon of Antigonid Greece. Stepping into this political vacuum, Antiochus crossed the Hellespont in 196 and began projecting Seleucid power into Europe. Four years later, the king’s involvement in Greece precipitated war with Rome. Repulsed by Roman arms, Antiochus withdrew to Asia, where he was defeated at the Battle of Magnesia late in 190. Two years later, the humbled monarch ratified the Peace of Apamea, whose terms included a sizable war-indemnity, the transfer to Rome of royal hostages as surety for the king’s good behavior, and a total ban on military involvement in Anatolia or Europe.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Antiochus himself died the following year on campaign in the east. But the terms of Apamea remained in force, and would have a significant impact on Seleucid relations with Judea for the next twenty-five years. The imperative to raise ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("money to pay off annual installments of the indemnity frequently strained Seleucid resources. It may be that the attempt by Seleucus IV (Antiochus’ son and successor) to plunder the Jerusalem Temple treasury a decade after Apamea reflects these pressures (2 Maccabees 3). The shadow of Apamea undoubtedly also increased the willingness of Antiochus’ descendants to accept monetary bribes from rival Jewish aspirants to the high priestly office, setting a precedent that would persist even after the indemnity was paid off. Another long-term effect of Apamea on Jewish-Seleucid relations was the political instability it engendered. The treaty’s stipulation that a scion of the House of Seleucus be held hostage in Rome created, in effect, a potential usurper “waiting in the wings.” Dynastic rivalry resulting from this heightened the claimants’ need to solicit support from their subjects. The factionalism fueled by this dynamic would prove to be one of the central engines of Jewish history during the second half of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Antiochus IV")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Upon the death of Seleucus IV, his younger brother Antiochus IV seized power. Our principal source for Jewish history during the early years of the new Antiochus’ reign is 2 Maccabees, which focuses on events in Palestine. Central to this narrative is the Seleucid-backed acquisition of the high priesthood by two successive candidates, and the civil strife ensuing from their rivalry. The first of these, Jason, secured not only the high priesthood but also the king’s permission “to establish, through his authority, a gymnasium and an "), _c('em', [_vm._v("ephebeion,")]), _vm._v(" and to enroll the Antiochenes in Jerusalem” (2 Macc. 4:9). Having been granted these requests in exchange for a hefty donation to the royal coffers, Jason proceeded to promote a Greek way of life in Jerusalem among “the noblest of the young men” and among his fellow priests (2 Macc. 4:11-15).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No scholarly consensus exists as to the meaning of the petition concerning “the Antiochenes in Jerusalem.” This group is mentioned on only one other occasion, in the context of a delegation sent by Jason to an athletic competition held in the Phoenician city of Tyre (2 Macc. 4:19). The dominant view is that Jason was requesting a Greek city to be founded within Jerusalem (“Antioch in Jerusalem”), and that the ephebic institutions he established were intended for the training of a citizen body for the new "), _c('em', [_vm._v("polis.")]), _vm._v(" This interpretation trades on Antiochus’ attested reputation elsewhere in the empire as a "), _c('em', [_vm._v("ktist")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("s")]), _vm._v(" (city-founder). However, given its unusual wording, other readings of this line are possible. Whatever the nature of Jason’s actions as high priest, the key historical issue is whether these actions contributed to the political strife that erupted a decade later.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("It is not at all obvious that they did. When Jason’s high-priestly tenure was terminated three years later by the bribe of one Menelaus, the author of 2 Maccabees attributes this to the latter’s corruption, not to any dissatisfaction with Jason’s policies (4:23-25). Having lost royal support, Jason took refuge in Transjordan, leaving Menelaus in possession of the high priesthood. For his part, Menelaus, finding himself unable to pay off his royal patron by legitimate means, consolidated his position (so the hostile narrative claims) by doling out Temple vessels as gifts to ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Seleucid officials and neighboring cities, and by engineering the murder of Onias when the ex–high priest threatened to expose his sacrilege (2 Macc. 4:32-34). Nefariousness, not Hellenism, appears to have motivated Menelaus’ behavior.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("During the winter of 170/169, Antiochus invaded Egypt, preemptively halting Ptolemaic designs to recapture his Levantine possessions. By the following summer, the king controlled most of Lower Egypt and had installed a pliant youth on the throne. But this détente swiftly deteriorated, prompting a second Seleucid invasion in 168. Though victorious in battle, Antiochus was compelled to call off the campaign under threat of Roman intervention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the course of his contest with Egypt, Antiochus paid two visits to Jerusalem that seriously tried the allegiance of his Jewish subjects. The first involved a fleecing of the Temple’s adornments, probably with a view to replenishing the king’s war chest in the wake of his Egyptian expedition. The second visitation came in response to a violent upheaval among the Jews themselves. While the king was occupied with Egypt, the ex–high priest, Jason, marched against Jerusalem at the head of an army, intent on deposing Menelaus and his supporters (an objective he failed to achieve). Antiochus, unable or unwilling to discriminate aggressors from defenders, brought down bloody slaughter upon Jerusalem. Not long after this debacle, the king dispatched a sizeable force to garrison Jerusalem indefinitely, an event (according to our hostile sources) accompanied by gratuitous violence and brutality. Menelaus remained in power, guarded by the Seleucid garrison (the “Akra”), which also came to serve as a place of refuge for Jewish loyalists of Antiochus’ regime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some scholars are skeptical of the Maccabean narrative, contending that the king’s repressive measures are unintelligible, unless the Jerusalemites as a whole had in fact attempted to cast off Seleucid rule. The absence of direct testimony for such a revolt necessarily renders any speculation moot. Yet even if the revolt hypothesis were substantiated, it would not account for Antiochus’ actions following his installation of the Akra: the suppression of Judaism itself. A litany of horrors describing this unparalleled persecution are paraded in both Maccabean accounts: the Temple and its worship were profaned in every conceivable way, its altar rededicated to Olympian Zeus; other altars were erected throughout Judea and cultic celebrations prescribed in honor of Dionysus and the king’s birthday; Torah scrolls were burned, and anyone found in possession of one or abiding by its laws was put to death (1 Macc. 1:41-61; 2 Macc. 6:1-11). According to 2 Maccabees, similar resolutions were adopted by the neighboring coastal town of Ptolemais (2 Macc. 6:8-9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Maccabean tradition offers no credible explanation for this unprecedented revolution in Seleucid policy. Second Maccabees simply casts Antiochus into the biblical mold of the arrogant tyrant who unwittingly executes God’s judgment upon rebellious Israel. First Maccabees alleges a royal decree, addressed to all Seleucid subjects, demanding “that all become one people, and that each abandon his [own] customs” (1 Macc. 1:41-42). If Antiochus ever issued such a decree, its implementation is nowhere in evidence (except, of course, in Judea itself). In fact, nowhere in either account is there any insinuation that the king’s suppression of Judaism extended to Jews living elsewhere in the Seleucid realm. Whatever the motivation for the Antiochene persecution, Palestine was its sole focus.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("The persecution itself lasted approximately three years. Jewish responses ranged from outright collaboration with (or acquiescence in) the king’s policies, to passive noncooperation, to willing martyrdom or militant resistance. The last of these take center stage in the Maccabean accounts, making it difficult to analyze the others. In particular, the tradition downplays the role of Menelaus and his supporters in bringing the persecution to an end through negotiation, a development attested in a dossier of letters preserved in 2 Maccabees. The Maccabean narrative focuses instead upon the purification and rededication of the Temple half a year later and continued Jewish (i.e., Maccabean) dissatisfaction with the Seleucid-backed high priesthood.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Antiochus himself did not personally preside over the Judean theater for long. Financial pressures and the imperative to reassert Seleucid sovereignty over the eastern satrapies drew him away in 165; he named his under-aged son, Antiochus V, coruler under the supervision of a guardian, Lysias. Cuneiform sources confirm that Antiochus IV died on campaign in the east near the end of the following year. News of the king’s death precipitated the first of many succession struggles that would influence Judean affairs for the next half century.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Maccabean Revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Armed resistance to Antiochus IV’s decrees quickly gravitated around the priestly family of Hashmonay (hence, “Hasmoneans”). Following the death of the family’s patriarch Mattathias in 166, his son Judas Maccabaeus assumed leadership of the insurgency. Over the next two years, Judas distinguished himself in battle against local Seleucid commanders. But it was not until 164 that Lysias himself undertook a full-scale expedition to stamp out the revolt. The Seleucid vizier combined his military efforts against Judas with diplomatic overtures toward other Jewish groups. In spite of the success of these negotiations, Judas fought on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the military front, Lysias’ expedition failed to achieve its goal. He besieged Judas in the strategic town of Beth Zur, but withdrew to Antioch before taking it. This withdrawal enabled Judas to enter Jerusalem and take control of the Temple Mount, which he appointed priests to cleanse and rededicate. The joint decision by “Judas and his brothers and all the assembly of Israel” (1 Macc. 4:59) to commemorate the event as an annual festival, and his garrisoning of Jerusalem and Beth Zur, indicate that by the end of 164 Judas had acquired recognition by a significant segment of his countrymen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The death of Antiochus IV constrained Lysias to devote the better part of the following year to consolidating his power as guardian of the royal heir. This respite gave Judas and his brothers an opportunity to launch expeditions into the surrounding territories where Jews were a vulnerable minority in need of protection. One result of these raids was the relocation of Jewish refugees to Judea, thus increasing Judas’ reservoir of potential recruits for his growing forces. Early in 162, Judas felt his position strong enough to launch a direct attack against the Akra.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("This bold move provoked Lysias to lead a substantial force into Judea in May of that year with the boy-king Antiochus V in tow. Judas’ forces were overwhelmed ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("and forced to retreat, while Lysias and the king pressed on to Jerusalem and besieged the Temple Mount. Within two months, however, news of an insurrection at Antioch by a rival general brought the siege to a standstill. A truce with the Temple’s defenders was affected, but Judas’ fortifications were demolished. The absence of Judas from 1 Maccabees’ narrative of events following his defeat by Lysias is conspicuous. Second Maccabees claims he was received by the king in conjunction with the truce; but this account also denies that Judas was defeated, thus casting suspicion on its reliability. Either way, the events of 162 were a setback for the Maccabean movement.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The deterioration of Judas’ position continued. Later that same year, a new aspirant to the Seleucid throne, Demetrius I, seized power in Syria and executed Lysias along with Antiochus V. This abrupt regime change prompted an embassy from the Jews led by one Alcimus, who obtained from Demetrius the high priesthood (Menelaus having been done away with by Antiochus V). Alcimus received military assistance in subjugating Judas and his agitators. This precipitated a series of military engagements between Syrian forces and Alcimus’ Jewish opponents, culminating in Judas’ death in the spring of 161.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was in the midst of these campaigns, immediately following a dramatic victory over Demetrius’ general, Nicanor, that Judas is said to have sent an embassy to Rome seeking friendship and alliance. According to 1 Maccabees, the Senate acceded to Judas’ request, conferring a treaty of mutual assistance and delivering a heated letter of condemnation to Demetrius (1 Macc. 8:23-31). The authenticity of the treaty and its attendant letter has had its share of detractors, but there are no persuasive reasons for rejecting either document out of hand. The more pertinent question is why Judas would have appealed to Rome in the first place. Second Maccabees reports the involvement of Roman envoys in negotiations conducted between Lysias and the Jews three years earlier, but their role appears to have been marginal (2 Macc. 11:34-38); it supplied no obvious precedent for Judas’ action in 161. Nor is it likely that Judas seriously expected Roman arms to defend the Maccabean cause. A more plausible interpretation would see the overture as a propaganda ploy on Judas’ part to shore up his claim to act as representative and defender of the Jewish people. Conversely, a senatorial rebuke of Demetrius, casting him in the role of aggressor, would serve to discredit Alcimus’ regime. Whatever its intent, Judas’ Roman mission had no tangible impact on the ground. It did, however, set in motion a tradition of diplomacy that Judas’ successors would intermittently draw upon as part of their arsenal of legitimation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alcimus died (seemingly of natural causes) not long after Judas’ own demise. Demetrius made no move to appoint a new high priest, and apparently no candidates stepped forward. This anomalous state of affairs would persist for seven years, indicating that the contending Jewish factions had reached some kind of stalemate. During this period, Judas’ surviving supporters gathered around his brother Jonathan, who continued to agitate the status quo. The stalemate broke down around 158, when Jonathan’s enemies summoned a Seleucid force to eliminate his guerilla band. The plan backfired when the commander of this force made peace with Jonathan and returned to Antioch. But the position of the Maccabean group did not change dramatically until 153.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("In that year, the rule of Demetrius was challenged by a pretender, Alexander Balas, who established himself at Ptolemais. This development strategically positioned Judea as a potential asset to both contenders. Jonathan exploited the situation, eventually siding with Balas, who appointed him high priest and friend of the king. Alexander’s final victory over Demetrius in 152 or 151 further strengthened Jonathan’s authority as a Seleucid appointee, securing him immunity from domestic rivals. Subsequent struggles for the Seleucid throne over the next decade replayed this scenario. For Jonathan, the downfall of one monarch merely meant the prospect of new honors from the next. Local “renegades” occasionally attempted to stir up trouble for him, but they could be dealt with by bribery. In short, Jonathan maintained his legitimacy through exactly the same methods employed by his high-priestly predecessors — Jason, Menelaus, and Alcimus. Jonathan is often thought to be the “Wicked Priest” referred to in the biblical commentaries "), _c('em', [_vm._v("(pesharim)")]), _vm._v(" from Qumran. The “wickedness” in question, however, has to do with his opposition to the sectarian leader known as the Teacher of Righteousness, not with his political machinations.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In 143, Jonathan fell victim to the game of kings in which he had embroiled himself. His brother Simon took up his mantle by rejoining the fray, obtaining the high priesthood from Demetrius II, son of the monarch whom Judas had fought against. Like other Seleucids before him, Demetrius sweetened the deal with numerous concessions, releasing Judea from tribute, acknowledging Simon’s possession of all Maccabean strongholds, and inviting Jewish troops to enroll in the royal forces. For these achievements, Simon was credited with the “removal of the yoke of the Gentiles” (1 Macc. 13:41). Notably though, Demetrius’ concessions did not cede control over the Akra. But by June of 141, Simon had starved its inhabitants into submission, thus bringing all of Jerusalem under his power. The last memorial of Antiochus IV’s infamy had been swept away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The following year, a great assembly of the Jewish people commemorated Simon, who had “fought off the enemies of Israel and established its freedom” (1 Macc. 14:26). In recognition of these achievements, a resolution was passed that Simon")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("… should be their leader and high priest indefinitely (until a trustworthy prophet should arise), and that he should be their general, and that he should be given custodianship of the sanctuary and that he should appoint men over its functions and over the countryside and over the weapons and over the fortresses, and that he should be obeyed by all, and that all contracts in the country should be written in his name, and that he should wear purple and gold. And it shall be forbidden for anyone of the people or of the priests to abrogate any of these things or to oppose things said by him or to convene an assembly in the country without him or to wear purple or to put on a golden buckle, and whoever acts contrary to these things or abrogates any of them shall be liable for punishment. (1 Macc. 14:41-45)")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("The pro-Maccabean narrative in which this decree is embedded presents it as a spontaneous, voluntary, unanimous expression of the popular will. The ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("dictatorial character of the privileges bestowed upon Simon belie that image, indicating the presence (or prospect) of significant internal challenges to his leadership. Simon’s death at the hands of a would-be usurper half a decade later lends weight to this interpretation, as does the extradition clause in a Roman diplomatic missive penned on his behalf (1 Macc. 15:16-21). The Simon decree signals a shift in the orientation of the Maccabean movement toward "), _c('em', [_vm._v("de facto")]), _vm._v(" monarchy.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beyond the cleansing of the Temple, the repeal of Antiochus IV’s decrees, and the removal of the Akra garrison, it is notoriously difficult to discern what the ultimate aims of the Maccabean revolt actually were. Resistance to Seleucid authority cannot be disentangled from the Maccabees’ struggles against native rivals who enjoyed Seleucid support. Once the possibility of negotiation with the Macedonian overlord had become a viable option, Judas and his brothers embraced it wholeheartedly as a tool of entrenchment against their Jewish adversaries. In time, the descendants of Simon would achieve enduring political independence from Seleucid suzerainty; but this achievement was ultimately a function of Seleucid weakness, not of Hasmonean strength.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Oniads in Egypt")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another Jewish family narrative surfaces during the latter half of the second century. Excluded from office by the upheavals of the Seleucid-backed high priesthood, Onias IV, son of the murdered high priest of the same name, fled to Egypt. There he obtained a land grant and permission from the reigning monarchs (Ptolemy VI and Cleopatra II) to erect a temple modeled on that of Jerusalem in the eastern Nile Delta. Conflicting sources obscure the precise timing and intent of this undertaking, but it is evident that (as so often with Jewish settlement in the Hellenistic age) the Oniad district and its temple functioned as a military colony, providing internal security for Lower Egypt, as well as supplying manpower for the Ptolemaic army when called upon.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Although Jewish inhabitants of the region embroiled themselves in Egyptian conflicts as late as Julius Caesar’s Alexandrine War (48 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), testimony for the career of the Oniad family itself is confined to the period of the dynastic intrigues of Cleopatra II and Cleopatra III (145-102 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). In his refutation of Apion’s diatribe against the Jews of Alexandria, Josephus tells of two Jewish generals, Onias and Dositheos, who supported Cleopatra II’s claim to the throne against her brother, Physcon, and his Alexandrian partisans, following the death of her husband in 145 ("), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.49-56). Although Josephus does not explicitly connect this Onias with the expatriate Jerusalemite, the probability of their identification seems quite strong. (The identity of Dositheos and his relationship to Onias cannot be determined with certainty.) Two sons of Onias IV — Chelkias and Ananias — likewise emerge as generals during the reign of Cleopatra III (whose titulature and propaganda reveal a consistent effort to win over and maintain the allegiance of her mother’s traditional support base). In 103, Chelkias and Ananias led an Egyptian army into Palestine against the queen’s would-be usurper, her elder son Ptolemy Lathyrus. Chelkias fell in battle, but Ananias (if Josephus is to be believed) ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("influenced Cleopatra’s decision to forge an alliance with the Judean king, Alexander Jannaeus ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 13.324-55).")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After this episode, information on the Oniads dries up. But epigraphic evidence testifies to the continued vitality of the community Onias founded. More than seventy Jewish funerary inscriptions have been recovered from Tell el-Yahudiyya (ancient Leontopolis) dating as late as the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" One epitaph explicitly names the “Land of Onias” as the patrimony of the deceased ("), _c('em', [_vm._v("JIGRE")]), _vm._v(" 38). Like the Maccabean narrative, the Oniad saga illustrates the capacity of Jews to operate within the framework of the Hellenistic monarchies. But whereas the Oniads were absorbed into the Ptolemaic hierarchy, the relationship of the Hasmoneans to the Seleucid state was to develop along quite a different path.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Hasmonean Dynasty")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Seleucid interference in Judean affairs was not ended. But unlike earlier ventures, which had as their goal the elimination of the Maccabean insurgents, containment or curtailment of Hasmonean power now became their prime objective. Ongoing dynastic quarrels were complicated by an increasingly belligerent Parthian menace. The Parthian annexation of Babylonia in 140 posed a major threat to the coherence of Macedonian rule in the east, and the invaders’ readiness to play off one Seleucid against another compounded the crisis. The diversion of energies to meet these pressing new problems loosened the Seleucids’ grip on their ambitious Jewish clients. In response, Simon’s successors applied themselves to the pursuit of Hellenistic statecraft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Territorial acquisition commenced in earnest under Simon’s son, John Hyrcanus I (ruled 135/134-104), who extended Hasmonean hegemony into Idumea, Samaria, and Galilee. Aggrandizement accelerated during the tenure of Hyrcanus’ own sons, who pushed their conquests as far north as Iturea, while absorbing much of the Transjordanian and coastal zones. The transition to Hasmonean rule was not a smooth one. The Samarian campaign resulted in the demolition of the temple on Mt. Gerizim, intensifying Jewish-Samaritan animosity. Circumcision and adherence to Jewish laws became mandatory for continued residence within the newly subjugated Idumean and Iturean domains. Pompey’s later liberation of Greek cities controlled by the Hasmoneans signals both the extent of their military success and the unwelcome, imposed character of their rule.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Militarism demanded manpower, which in turn required money. Hyrcanus is said to have plundered the tomb of David in order to buy off Antiochus VII and to supplement his own force with mercenaries. His son, Alexander Jannaeus (ruled 103-76), is known to have continued this practice, his territorial gains doubtlessly enhancing his purchasing power. With the development of standing armies beholden to their Hasmonean paymaster rather than to their fellow countrymen came overt monarchic assertion. Hyrcanus’ son, Aristobulus I (ruled 104-103), was the first to claim royal honors, and Jannaeus followed suit. And with kingship came dynastic struggles whose divisive potential and destructive impact was only amplified by the resources at each side’s disposal. Between 67 and 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", the ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("sons of Jannaeus — Aristobulus II and Hyrcanus II — became embroiled in a contest for the kingship that ultimately terminated the career of the Hasmonean state.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Already under Hyrcanus I, Hasmonean pretensions met with Jewish resistance. Internal opposition reached its apogee during Jannaeus’ reign. So intense was their detestation of the king that his enemies actually appealed to the reigning Seleucid monarch for assistance in ousting him. The ouster failed. But the brutality of Jannaeus’ repressive regime thwarted any possibility of peace between himself and his alienated subjects. (Qumran texts remember him as the “Lion of Wrath.”) A more conciliatory situation appears to have developed under Jannaeus’ wife, Shelamzion (Salome) Alexandra, who succeeded him (ruled 76-67).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Josephus, a key ingredient in Alexandra’s success was her cultivation of the Pharisees, a group whose existence is first mentioned in the context of the time of Jonathan. Josephus himself ascribes anti-Hasmonean activity to Pharisaic instigation, a thesis that gains some plausibility from his claim that Jannaeus crucified 800 members of the sect. Alexandra, at any rate, placated the populace by involving the Pharisees in her administration. It is clear, however, that for some Jews, the excesses of Jannaeus and the sectarian flip-flopping of Hyrcanus were symptoms of a more fundamental wrong: monarchic rule itself. When the contentious sons of Alexandra appealed to Pompey for arbitration of their competing claims in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", they were challenged by a third party, comprising more than 200 of the most prominent men of Judea. Virulently opposed to both Hasmoneans, these Jewish notables demonstrated to the Roman general that their own forebears")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("had negotiated with the Senate, and had received the leadership of the Jews as a free and autonomous people — the title of king not having been taken, but with a high priest set over the nation. But that now these men [Aristobulus II and Hyrcanus II] were holding power by virtue of the fact that they had annulled the ancestral laws and had unjustly reduced the citizenry to slavery; for by a mass of mercenaries and by outrages and by many impious murders they had acquired royal power for themselves. (Diodorus 40.2)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The significance of this indictment, delivered at so pivotal a moment in Jewish history (the eve of Rome’s first direct intervention into Judean affairs), lies not in the historical veracity of its claims (which are debatable). Its importance lies rather in the contrast it draws between two visions of early Judaism: the ideal temple-community, governed by the Torah and presided over by a high priest; and the historical contingencies of a sovereign state, struggling to maintain its independence amidst the successor-kingdoms of Alexander the Great. In 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", both the Hasmonean princes and their aristocratic opponents viewed Rome as the key to preserving their vision.")])]), _c('h1', {
    staticClass: "chapter-subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("From Pompey to Hadrian")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('h1', {
    staticClass: "chapter-author1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAM")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLMAN")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARSHAK")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The period from the conquest of Jerusalem by Pompey the Great in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to the violent repression of the revolt under the emperor Hadrian in 135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" was one of both tremendous accomplishments and incredible setbacks for the Jews as a people and Judea as a kingdom. This period began with the violation of the Jerusalem Temple and ended with the expulsion of the Jews from Jerusalem, during which the city morphed from the Jewish city of Jerusalem to the Roman "), _c('em', [_vm._v("polis")]), _vm._v(" Aelia Capitolina. At the same time, Hadrian changed the name of the province from Judea to Syria Palestina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is not to say that life for Jews in Judea during this period was a perpetual nightmare. Indeed, for the majority of the 200 years from Pompey’s conquest to Bar Kokhba’s revolt, Jews in Judea lived in peaceful coexistence within the Roman Empire. Moreover, during this period, Jews were spreading all over the Diaspora and settling in or expanding within the major cities of the empire. Significant populations of Jews could be found in Egypt, Asia Minor, Syria, the Greek islands, and even Rome itself. Thus, although many of the major events in this period were ruinous for the Jews, there were prolonged periods of peace and prosperity.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The End of Hasmonean Rule and the Rise of the Antipatrids")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The twenty-year period from Pompey’s siege of Jerusalem to the accession of Herod the Great was one of almost constant civil war between two factions of the Hasmonean family led by John Hyrcanus II and Judah Aristobulus II, the sons of Alexander Jannaeus and Salome Alexandra. Both sides appealed to Rome for support. Pompey sided with Hyrcanus, and in response Aristobulus and his supporters barricaded themselves within fortresses and the Temple itself. Pompey and his army besieged Jerusalem and the Temple, and in the ensuing siege, the city was badly damaged. Aristobulus’ faction was massacred inside the Temple precinct itself, and Pompey himself violated the sanctity of the Temple by entering the Holy of Holies. After establishing order in the city, Pompey restored Hyrcanus to the high priesthood but stripped him of his royal title and political authority.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("During the next nine years, an Idumean family of courtiers, the Antipatrids, rose to preeminence in the Hasmonean court. They first achieved prominence during the reign of Alexander Jannaeus when he appointed an Idumean noble named Antipas as "), _c('em', [_vm._v("strat")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("gos")]), _vm._v(" of Idumea. It is likely that Antipas’ son, Antipater, succeeded him. Antipater quickly became the real power behind the Hasmonean throne. He was a consummate politician who excelled at cultivating and exploiting friendships with local rulers as well as with leading Romans. Antipater first secured the friendship of Pompey and then of Julius Caesar when he eclipsed Pompey. In 48 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", Julius Caesar found himself besieged in Alexandria by native Egyptians. Antipater came to his aid by enlisting the support of local rulers as well ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("as personally leading an army into Egypt. In recognition of his support, Caesar bestowed Roman citizenship on Antipater and his family ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.187-94; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.127-39).")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although Antipater was now clearly the main man at court, he still had powerful enemies, who assassinated him in 43 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.225-26; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.280-84). Herod and his brother Phasael, who had been appointed "), _c('em', [_vm._v("strat")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("goi")]), _vm._v(" of Galilee and Judea respectively (47 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), assumed the leadership of their family as well their father’s position as the dominant courtiers in the Hasmonean court. Their power and influence increased further in 42, when Marc Antony appointed them tetrarchs ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.244; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.326). However, in 40 the Parthians and their ally, the Hasmonean Mattathias Antigonus, the son of Aristobulus II, invaded Judea and besieged Jerusalem. While on a diplomatic mission to the Parthians, Phasael and Hyrcanus were arrested and imprisoned. Phasael chose to commit suicide by dashing his head against a rock. Herod, on the other hand, fled to Rome to secure its support against the Parthians and Antigonus. With the support and lobbying of the triumvirs Antony and Octavian, the Roman senate proclaimed Herod King of Judea and promised him military aid in his war against Antigonus ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.282-85; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.381-89). It took Herod three years to defeat Antigonus and capture Jerusalem, but in Spring 37 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" he entered Jerusalem as both "), _c('em', [_vm._v("de jure")]), _vm._v(" and "), _c('em', [_vm._v("de facto")]), _vm._v(" King of Judea ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.349-57; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.476-91).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Herod, King of Judea and Client of Rome")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Herod the Great was arguably the most powerful and influential Jewish monarch in history. During his long reign (40-4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), he amassed extraordinary wealth, implemented an elaborate and comprehensive building program, and transformed Judea from a small petty kingdom into an economic center of the Eastern Mediterranean. Jerusalem, too, changed from a crowded and dilapidated provincial city into a major pilgrimage site and tourist attraction of the Greco-Roman world. Despite his significant achievements, Herod’s reign was not a smooth one. In his early years, one of his major concerns was establishing and maintaining his own legitimacy. As a usurper who had risen to power through Roman support, his claims to legitimacy were somewhat suspect. In addition to legitimacy issues, he also had to contend with the ambitions of Cleopatra, who wanted to reclaim the Ptolemaic Empire and annex Judea to her kingdom. Through astute political maneuvering, he was able to keep Cleopatra at bay and rule in relative security until 30 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" In that year, Herod’s patron Antony, along with Cleopatra, was defeated by Octavian Caesar at the Battle of Actium. Like his father before him, Herod wisely saw the benefit of switching loyalties, so he quickly sailed to Rhodes to persuade the victorious Octavian that he could fit well into his new regime as a loyal and friendly client king. Octavian confirmed Herod’s position and enlarged his kingdom ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.386-97; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 15.187-201). For the next twenty-six years, Herod provided a stable and friendly ally on the eastern border and promoted economic development and Romanization in Judea. As a reward for his services, Octavian, who after 27 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" was known as Augustus, bestowed upon Herod additional territories ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("such as Trachonitis, Batanea, and Auranitis in 24/23 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and Ulatha and Paneas in 20. He also ceded Herod control of the copper mines on Cyprus and half of their revenue. Thus, by the end of his reign, Herod ruled over a kingdom that rivaled all previous Jewish monarchies in size, wealth, and importance within the Mediterranean world.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Despite his numerous political and economic successes, Herod’s reign was also marked by considerable domestic difficulties. His relationship with his Jewish subjects was periodically strained partially due to his somewhat ambiguous attitude toward Judaism. Internal dissension among his own family also caused Herod numerous problems and resulted in the execution of three sons and one wife as well as several other relatives and friends. Finally, a series of riots and disturbances broke out after his death in 4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Such social disorder suggests considerable dissatisfaction with the regime among many of his subjects. Despite these failings, Herod achieved enough legitimacy and security during his reign to rule without any significant threat to the stability of his kingdom. Furthermore, he was able to bequeath his kingdom to his three chosen successors, his sons Herod Archelaus, Herod Antipas, and Herod Philip.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Herod’s Sons and Successors")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After Herod’s death, there was a struggle among his sons over who was going to succeed him, and the rival delegations traveled to Rome to solicit the princeps’ opinion. In the end, Augustus chose to honor Herod’s last will and divide the kingdom among the three named sons. Archelaus received Judea, Samaria, and Idumea, but only the title of ethnarch instead of king. Herod Philip, who became a tetrarch, received Batanea, Trachonitis, Auranitis, and other nearby territories. Finally, Galilee and Perea went to Herod Antipas, who received the title of tetrarch ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.14-15, 20-38, 80-100; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 17.219-49, 299-320). These three brothers ruled Herod’s territory with varied success for the next thirty years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Archelaus’ short reign was a disaster from the beginning. His cruelty and oppressive measures enraged his subjects, and in 6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Augustus banished him to Vienne in Gaul. Judea then became a province governed by a procurator ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.39-79, 111-17; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 17.250-98, 339-55). His half-brother Herod Philip, on the other hand, ruled in relative peace for approximately thirty-eight years, and although little is known of his reign, it seems to have been successful and benign. Jews were a minority in his kingdom, and most of the inhabitants were of Syrian or Arab descent. During his reign, he rebuilt the city of Paneas and renamed it Caesarea Philippi in honor of himself and Augustus. He also expanded and embellished Bethsaida, renaming it Julias, in honor of Augustus’ daughter Julia ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.168; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.28). When Philip died childless in 34 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", the emperor Tiberius attached his realm to the province of Syria ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.106-8).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Of the three successors to Herod the Great, Herod Antipas is the one about whom we know the most. He reigned for more than forty years, longer than either of his brothers, and throughout his reign he was a valuable ally and client king to Rome. He rebuilt Sepphoris in Galilee and Betharamphtha in Perea, renaming ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("them Autocratoris and Livias, respectively ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.168; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.27). His most expansive urban project, however, was the construction of a new capital city, Tiberias, in honor of the emperor Tiberius. According to coin evidence, this city was dedicated in the twenty-fourth year of Antipas’ reign (19/20 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). Although pious Jews initially refused to live in the city because of its construction atop a graveyard, eventually it became a center of Jewish learning and study ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.168; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.36-38).")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As with his father, Antipas’ personal life was less stable than his political rule. After several years of marriage, he abandoned his first wife Phasaelis, the eldest daughter of King Aretas IV and married his niece, Herodias, who had also been married to two of Antipas’ half-brothers, Herod Philip and Herod son of Mariamne, the daughter of Simon Boethus. As a result, he incurred the wrath of both his former father-in-law and the charismatic preacher John the Baptist (Mark 6:14-29; Matt. 14:1-12; Luke 3:19-20; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.116-19). Antipas’ defeat in battle against Aretas and his army was seen by his subjects as just punishment from God for the execution of John ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.113-16).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Despite his defeat by the Nabatean army, Antipas’ positive relationship with Tiberius enabled him to survive on his throne. However, upon the death of Tiberius in 37 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and the accession of Gaius Caligula, Antipas’ status severely declined. One of Gaius’ early acts was to appoint Antipas’ nephew Herod Agrippa, who was also Herodias’ brother, king in the territory of Herod Philip. Herodias, who was supposedly jealous of her brother’s rise in power, believed that her husband also should receive the royal title. She therefore urged him to go to Rome and petition the new emperor. However, because of the machinations of Herod Agrippa, who disliked and distrusted his uncle, Gaius decided that Antipas was a traitor and exiled him to Lugdunum in Gaul (present-day Lyon). Because of her status as Agrippa’s sister, Gaius was willing to permit Herodias to retain her property and not go into exile with her husband. Nevertheless, she voluntarily chose to share Antipas’ fate ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 1.181-83; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.237-54).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Judea under Roman Rule (6-41 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, since Archelaus’ deposition in 6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", a Roman prefect or procurator had governed Judea and Samaria, beginning with Coponius. Josephus’ narratives provide most of the information about this period in Judean history, although the Gospels also provide some information, specifically about Pontius Pilate. Coin evidence and some archaeological material supplement Josephus’ testimony, but for the most part scholars rely upon Josephus’ account. In general, his depiction of the Roman administrators is decidedly negative, and he asserts that their mismanagement played a fundamental role in the downward spiral of the relationship between Rome and its Judean subjects. In this first stage of Roman occupation, however, Josephus’ narrative is rather neutral, and the majority of these early governors receive minimal mention, which suggests somewhat peaceful interactions ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.2, 29, 31-35). The sole exception to this is the tenure of Pontius Pilate (26-36 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(").")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Outside of literary sources such as Philo, Josephus, and the Gospels, the name Pontius Pilate appears in only one inscription, which records his dedication of a ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('em', [_vm._v("Tiberieum")]), _vm._v(" and was discovered in the theater at Caesarea. In the literary sources, two main images appear. In the Gospels, Pilate is depicted as the blameless instrument of Roman justice. In both Philo and Josephus, however, he appears as a ruthless administrator who openly offended Jewish sensibilities and reveled in brutal methods of suppressing dissent. Philo calls him “a man of inflexible, stubborn and cruel dispositions” whose tenure was characterized by “venality, violence, robbery, assault, abusive behavior, frequent executions without trial, and endless savage ferocity” ("), _c('em', [_vm._v("Legatio")]), _vm._v(" 301–2). On more than one occasion, Pilate blatantly disrespected Jewish religious sensibilities, and his response to their complaints was often to resort to violence ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.169-77; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.55-62, 85-87). Finally, in ca. 36/37 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", he was recalled by the governor of Syria, Lucius Vitellius, and ordered to return to Rome to explain his conduct to the emperor.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Things were relatively quiet in Judea until the Winter of 39/40 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", when the non-Jewish minority of Jamnia erected an altar to the imperial cult, which the Jewish inhabitants of the town promptly destroyed. The imperial procurator in Jamnia, Gaius Herrenius Capito, reported the incident to the new emperor, Gaius Caligula, who was enraged at the supposed insult to his majesty. He ordered the new governor of Syria, Publius Petronius, to march into Judea with two of the four legions stationed in Syria and to erect a golden statue of Gaius in the Temple. If the Jews resisted, Petronius was ordered to suppress them by force ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.184-85; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.261-62; Philo, "), _c('em', [_vm._v("Legatio")]), _vm._v(" 198–207). Realizing that Jewish resistance was inevitable, Petronius attempted to delay constructing the statue.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Herod Agrippa I")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the midst of Petronius’ delaying tactics, Herod Agrippa, the grandson of Herod the Great and ultimately his successor as King of Judea, also took up the Judean cause. He had been educated in Rome alongside the imperial family, in particular the future emperor Claudius ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.143, 165). With the rise of Gaius to the throne, Agrippa finally achieved prominence. He had become close friends with Gaius, and his friendship was rewarded with the tetrarchy of his recently deceased uncle Herod Philip ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.181; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.237). After the banishment of Antipas in 39 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Caligula enlarged Agrippa’s kingdom by annexing Galilee and Perea ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.252).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Agrippa arrived in Italy in the midst of the statue crisis. Through either a letter ("), _c('em', [_vm._v("Legatio")]), _vm._v(" 261–334) or a banquet ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.289-301), Agrippa successfully persuaded Gaius to forgo his plans for the statue, at least temporarily. However, both Philo and Josephus describe Gaius reneging on his promise not to place the statue in the Temple, and only the emperor’s assassination saved the Jews from open conflict with Rome ("), _c('em', [_vm._v("Legatio")]), _vm._v(" 337–38; "), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.202-3; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.302-9). This incident only increased tensions between Rome and Judea.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Shortly before the assassination of Gaius, Agrippa returned to Rome, and after the emperor’s murder, Agrippa was a crucial advisor to his successor, Claudius, and helped to secure his accession as emperor ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.204-13; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.236-67). As a reward for his services, Claudius appointed Agrippa king over the territory once ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("ruled by his grandfather. Claudius also appointed Agrippa’s brother Herod as ruler of Chalcis in Lebanon ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.215-17; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.274-77).")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Herod Agrippa returned to Judea and governed it for the next three years (41-44 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). He sought to further enhance the prestige of Judea. To this end, he initiated a building program around the Levant that, while not equaling his grandfather’s, still enabled him to enhance his status and that of his kingdom. Among other projects, he built a theater in Berytus and a new city wall in Jerusalem across the northern edge of the city that enclosed the suburb of Bezetha. This wall, however, was not completed during Agrippa’s reign because the governor of Syria, Vibius Marsus, was suspicious of Agrippa’s intentions and persuaded Claudius to prohibit its completion. Jewish rebels hastily completed this wall after the outbreak of revolt in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As part of this campaign to aggrandize his position within the Eastern Mediterranean, Herod Agrippa called together a meeting of the region’s rulers at Tiberias, including the kings of Commagene, Emesa, Armenia Minor, and Pontus, as well as his brother, the ruler of Chalcis. Although Marsus feared that Agrippa was planning a revolution at this meeting, this is extremely unlikely. More likely, Agrippa was seeking to establish himself as the preeminent client king of the Eastern Mediterranean. His efforts, therefore, were directed more toward his neighbors than toward Claudius.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("During Passover in 44 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", Agrippa traveled to Caesarea to attend the games being held there in honor of Claudius. According to Josephus, in the midst of the festival, Agrippa fell ill with violent pains and died five days later ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 19.343-52; Acts 12). At the time of his death, Agrippa’s heir and namesake, Herod Agrippa II, was approximately seventeen. Because of the age and inexperience of the younger Agrippa, Claudius returned Judea to the rule of a Roman procurator ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.220; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.362-63).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Road to Revolution (44-66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Despite its size and importance to both the Roman economy and political system, when Judea again became a Roman province following the death of Agrippa I, it was not upgraded to proconsular status. Instead, as before, an equestrian procurator governed from Caesarea under the supervision of the governor of Syria. For the next twenty years, these procurators would govern a province that became increasingly unstable and hostile to Roman rule. Ultimately, their mismanagement of the province would be one of the major causes of the outbreak of the Great Jewish Revolt in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Josephus attributes the outbreak of revolution in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" to the following other factors: Roman oppression, socioeconomic tensions, religious incitement, and quarrels with local Gentiles. Some scholars have added another factor ignored by Josephus: the failure of the Judean elite to control the province and its restive population (Goodman 1987). As with any complex event, it is more likely that the culmination of these factors, as opposed to one or another, caused the revolt.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('strong', [_vm._v("The First Jewish Revolt")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Revolution broke out in Judea in the early summer of 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Some Jewish young men had parodied the greed and stinginess of the procurator Florus. In response, he marched to Jerusalem and demanded that the elders of the city hand over the youths for punishment. The local authorities refused to comply, and Florus let loose his soldiers upon the city. According to Josephus, he even crucified some Jewish "), _c('em', [_vm._v("equites")]), _vm._v(" ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.294-308). Some members of the Jerusalem ruling elite attempted to defuse the situation, but this proved impossible. Florus made the situation more volatile by demanding a public display of submission and ordering the Jewish populace to greet the two cohorts he had sent to Jerusalem as reinforcement of the city garrison. However, the soldiers of these cohorts behaved so arrogantly toward the populace that more riots broke out, forcing Florus to withdraw to Caesarea. Meanwhile, Herod Agrippa II and his sister Berenice, who had heard about the disturbances in the city, tried to appeal for calm. Nonetheless, their efforts ultimately failed, and they were expelled from the city ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.309-14, 334-35, 343-406). In May/June 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", some of the young priests, incited and led by the captain of the Temple, Eleazer ben Ananias, terminated the sacrifices offered daily at the Temple on behalf of the emperor. In essence, this served as an open proclamation of revolution and war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fighting broke out between various factions over both control of the city and the resumption of the daily sacrifices. This internecine fighting became even more violent when "), _c('em', [_vm._v("sicarii")]), _vm._v(" led by a certain Menahem ben Judah entered the city and joined with Eleazer. Eleazer’s father and uncle, who were the leaders of the faction trying to avoid war with Rome, were murdered by Menahem and his men, and the soldiers sent into the city by Agrippa II to restore order either joined the rebels or were driven out of the city. A small contingent of Roman auxiliaries, who found themselves trapped inside the city, tried to escape, but were killed by Eleazer’s men. The rebellion thus quickly became unavoidable and irrevocable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Given this situation, Jews from all over Judea took the opportunity to rise up against their non-Jewish neighbors and vice versa. Seeing that the situation had gotten out of control, the governor of Syria, Cestius Gallus, collected a large army including the Twelfth Legion and some auxiliaries supplied by Agrippa and began marching south to Judea. Gallus reached Ptolemais in September and secured Galilee with little opposition. However, in October, his forces met Jewish resistance, which plundered his baggage train before he had even reached Jerusalem. Nevertheless, Gallus marched his army to Jerusalem and seized the northern suburbs, especially the district of Bezetha, with little difficulty. Despite this success, Gallus quickly determined that he could not take the city that year, so he ordered a retreat to the coast, but this withdrawal was completely disorderly, and the Jewish army took the opportunity to inflict heavy casualties on the retreating Roman forces.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("At this point, the Jewish rebels now began to organize themselves as a revolutionary government. Joseph ben Gurion and Ananus ben Ananus became joint leaders of the provisional government, and they appointed generals to conduct the war. Josephus himself was selected to be the general of the forces in Galilee. In Rome, Nero dispatched Titus Flavius Vespasianus, who had distinguished himself ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("in the invasion of Britain during the reign of Claudius. By June 67 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", Vespasian reached Galilee with his army, which had secured the region through brutal tactics. Josephus, who lacked proper troops and armaments, was reduced to protecting little more than small hilltop fortresses and was finally captured at the siege of Jotapata. He managed to ingratiate himself with Vespasian by hailing him as the next emperor of Rome. The other Jewish resistance fighter in the region, John of Gischala, attempted to continue the war against Vespasian, but he was forced to flee to Jerusalem in late summer 67.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Back in Jerusalem, the situation was becoming increasingly unstable. The population was dissatisfied with the provisional government because of its inability to hold Galilee. Dissatisfaction only increased in the spring of 68 when Vespasian began to march toward and encircle Jerusalem. Opposition to Ananus was bolstered partially by rural peasants, who had fled into the city because their homes and farms had been captured or threatened by the Roman army. In this hotbed of factionalism rose a new group of elite priests, who described themselves as Zealots because of their zeal for the Temple and its cult. These Zealots accused the provisional government of not prosecuting the war with enough enthusiasm. Such a charge may have been unfair, but it was strengthened by the reality that many original members of Ananus’ faction, including Josephus, had by this time defected to the Roman side. Regardless, the Zealots ultimately barricaded themselves within the Temple, where they were soon joined by John of Gischala and his men as well as a large force of Idumeans who had come to Jerusalem to defend the city. This new faction was able to overthrow the provisional government and execute Ananus and his closest supporters, including Josephus’ friend and patron Joshua ben Gamala. Now firmly in power, John and the Zealots began a bloody purge of their enemies within the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Meanwhile, back in Rome Nero committed suicide, and with his death ended Vespasian’s mandate as imperial legate. Because of this development, Vespasian suspended his campaign and waited to see what would happen. His campaign resumed in May/June of 69, and by the time that he was proclaimed emperor in July, his army had recovered the land previously conquered and just finished encircling Jerusalem again. For a second time, the Roman campaign against Jerusalem was suspended as Vespasian turned to securing control of the empire.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("While the Romans were engaged in a civil war known as the “Year of the Four Emperors,” the Jews in Jerusalem were involved in their own civil war. In the year 68 some of the factional leaders, whom John and the Zealots had ousted from power, left the city and joined the army of Simon bar Gioras, a commander in the battle against Cestius Gallus who had been sidelined by Ananus’ government. With Ananus now dead, Simon entered the fray, again capturing Hebron in spring 69 and then camping outside of Jerusalem. With the help of the Idumeans, who had become disenchanted with the Zealots and John, Simon was able to seize control of all of Jerusalem except the Temple itself. John eventually split from the Zealots and occupied the outer precincts of the Temple, while the Zealots holed up in the inner Temple. This tripartite division of the city lasted until Vespasian’s son Titus and his army arrived before the walls of Jerusalem in March 70 and began to ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("besiege the city. With the arrival of the Roman army, the three factions set aside their differences and began coordinating their defenses.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Titus could have tried to starve the city into submission, but the new Flavian regime needed a magnificent victory, and so he determined to take the city by force. By May 70, the Romans had captured the third wall. The Antonia fortress fell in June, and by August the Romans had captured and burned the Temple itself. As autumn began, the Roman army focused its attention on crushing any pockets of resistance that remained in the Upper City. It then turned its attention to the handful of Herodian fortresses occupied by Jewish resistance. The most famous of these, Masada, was not taken until 73/74, after its defenders committed mass suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Judea was placed under the control of a praetorian legate, and a legion was permanently stationed in Jerusalem. Vespasian also established a veteran colony at Emmaus to keep the peace ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 7.217). The Temple was not rebuilt, and its plundered riches were transported to Rome, where they played a central role in the Flavian triumph. Simon Bar Gioras, who had been captured in the siege, was also taken to Rome, forced to march in the triumph, and then ritually executed ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 7.153-55). The Jewish political state ceased to exist. With the loss of the Temple, the people of Judea were forced to survive in radically different circumstances.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Jewish Diaspora from Pompey to 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The late-Hellenistic and early Roman periods saw a tremendous expansion of the Jewish Diaspora. By the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", large and prosperous Jewish communities existed all over the Mediterranean from Syrian Antioch to Asia Minor and from Greece to Alexandria in Egypt. There was some settlement in Italy and in Rome, but there is no evidence for Jews in the Western Mediterranean until the Late Roman period. Although there were some Jews living in the countryside, in general during the Roman period, the Diaspora was an urban phenomenon. In cities such as Alexandria, Jews lived in self-regulating communities, which were isolated either by law or by custom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The heart of any Diaspora community was the synagogue, and each Jewish community had at least one, although larger communities had several. These synagogues evolved into more than just meeting places. Especially after the destruction of the Temple in 70, they became the main location for religious expression and communal interaction. The Septuagint, a Greek translation of the Hebrew Bible composed in Alexandria, was the most standard version of Scripture in the Diaspora. Indeed, for Jews such as Philo, the Septuagint had divine authority.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("In terms of religious practice, there was a certain amount of regional variation among Diaspora communities. Nevertheless, according to the often-negative comments by non-Jewish authors, the religious practices of Diaspora Jews were quite similar to those in Judea. Diaspora Jews practiced circumcision, kept kosher, and observed the Sabbath. During the reign of Herod the Great, an embassy of Ionian Jews appealed to the king to intercede with Marcus Agrippa on their behalf. One of their complaints was that their Gentile neighbors were dragging them into court ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("on Shabbat and their other holy days ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 16.27). Such an incident attests to the importance of Sabbath observance for Diaspora Jews. The Diaspora also supported the Temple in Jerusalem by paying the half-shekel tax incumbent upon all Jewish men. In the Ionian Jews’ petition to Herod, another of their complaints was that the money they had raised to be sent to Jerusalem was being unlawfully seized by the non-Jewish government ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 16.28). Further evidence of this practice appears in a speech by Cicero in 59 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" in which he defended the proconsul of Asia, Lucius Valerius Flaccus (Cicero, "), _c('em', [_vm._v("Pro Flacco")]), _vm._v(" 28.66-69).")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In general, Diaspora Jews seem to have coexisted peacefully with their non-Jewish neighbors. The massacres and violence perpetrated by both sides in the wake of the First Revolt probably reflect local conflicts and disputes that had originated years before and about whose causes and origins we can only speculate. Roman officials usually protected Jewish rights and interests, and a number of edicts and letters that appear in Josephus’ narratives show Roman leaders such as Caesar, Antony, Augustus, and Agrippa upholding Jewish rights and condoning their religious, political, and social distinctiveness ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.186-267, 306-23; 16.166-73). Violations did occur, but in most cases the Roman government quickly remedied the situation. When Marcus Agrippa heard about the offenses against the rights of the Jews of Ionia, he immediately ruled in their favor ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 16.58-61). When the Jews of Asia and Cyrenaica again experienced discrimination and the confiscation of the money they had raised for the Temple tax, they complained directly to Augustus, who ruled in their favor ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 16.160-65). Although these incidents testify to periodic tension between Jews and non-Jews, in general Diaspora Jews were tolerated by their pagan neighbors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Diaspora community about which we know the most is Alexandria. The Jewish community of this city had thrived under the later Ptolemies because of direct royal patronage. During this period, the Jews enjoyed a civil status almost equal to that of their Greek neighbors. However, the situation changed with the end of the Ptolemaic dynasty. When Augustus took control of the country, he demoted them to a status equivalent to that of the native Egyptians because it was consistent with his policy of entrusting the government and political power to the Greeks of the Eastern Mediterranean. Such relegation was extremely irksome to many Alexandrian Jews, who felt themselves to be fully immersed within the wider Greco-Roman culture, despite maintaining their distinct Jewish identity. The history of Alexandrian Jewry during the Roman period is marked by a consistent drive to remove the ignominious burden of the "), _c('em', [_vm._v("laographia")]), _vm._v(" (poll tax) and achieve "), _c('em', [_vm._v("isopoliteia")]), _vm._v(" (political autonomy).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("The troubles of the Alexandrian Jews reached a dangerous level in 38 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", when the newly appointed King Herod Agrippa I visited Alexandria on his way to Judea. His presence in the city stirred up an unruly mob of non-Jews, who publicly insulted him by parading a local madman into the arena and using him to parody Agrippa. Then the mob started calling for graven images to be placed within the synagogues of the city. As a result, the mob attacked and desecrated the synagogues and eventually started attacking the Jews themselves, shutting them off into one section of the city and causing hundreds of casualties. Homes were ransacked and businesses were destroyed (Philo, "), _c('em', [_vm._v("In Flaccum")]), _vm._v(" 25–85, 95–96). In his ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('em', [_vm._v("Embassy to Gaius,")]), _vm._v(" Philo again describes the anti-Jewish riots of 38, but in this text he blames the violence on Emperor Gaius and the anti-Jewish Alexandrians rather than on the Alexandrians and Flaccus.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once peace had been restored to the city, both sides sent embassies to Gaius in order to exonerate themselves of blame for the riots and to seek an imperial edict codifying the position of the Jews within the city. According to Philo, the emperor was stirred against the Jews by a small group of Alexandrian advisors, especially a certain Helicon. Ultimately, neither embassy achieved its goal of receiving an official answer from Gaius. At the time of his murder, the issue was still open. Claudius finally settled the matter when he ordered both sides to behave but telling the Jews that they lived in a city not their own, and warning them not to aim for more than what they had ("), _c('em', [_vm._v("CPJ")]), _vm._v(" 153; the edict of Claudius, as reported by Josephus in "), _c('em', [_vm._v("Ant.")]), _vm._v(" 19.280-91 is much more positive toward the Jews than the papyrus, and is of doubtful authenticity).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Roman Jews also experienced mixed relations with their non-Jewish neighbors. The Jewish community in the city of Rome was composed mostly of the descendants of slaves brought to the capital after Pompey’s conquest in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and that of Gaius Sosius in 37. This community had expanded during the early Principate, and under Augustus many of these slaves received their freedom. Despite their new liberty, these Jews largely remained within the lower classes of the city, living across the Tiber in Trastevere. Yet even in the face of the usual toleration granted by the government, the Jews of Rome periodically experienced official persecution, such as their expulsion under Tiberius (Tacitus, "), _c('em', [_vm._v("Annales")]), _vm._v(" 11.85; Suetonius, "), _c('em', [_vm._v("Tiberius")]), _vm._v(" 36; Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.65-84) and later under Claudius (Acts 18:2; Suetonius, "), _c('em', [_vm._v("Claudius")]), _vm._v(" 25; Dio 60.6). During both expulsions, it is unlikely that many Jews actually went farther than Rome’s suburbs. Even if they did, the Jewish community quickly returned. By the end of the Roman period, as evidenced by the catacombs in Rome, a large Jewish population inhabited the city.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Judea between the Revolts")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The tragic outcome of the Great Revolt substantially changed life in Judea, but it also had a strong ripple effect on the Diaspora as well. Jerusalem and the Temple were destroyed and the priesthood disbanded. The Sanhedrin ceased to function, and the old ruling class vanished. Although Herod Agrippa II was rewarded for his loyalty in 75 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" with additional territory in Lebanon and the "), _c('em', [_vm._v("ornamenta praetoria,")]), _vm._v(" he received no new territory in Judea. And yet, Jewish life managed to continue. The prestige of the priesthood persisted, and individual priests were still receiving tithes, but as their religious utility declined, so too did their influence and power. It is highly likely that the Jews of this period continued to hope for a restoration of the Temple. Both Josephus and the author of "), _c('em', [_vm._v("1 Clement")]), _vm._v(" write under the assumption that the Temple would be rebuilt and the priesthood restored. In practice, however, Judaism became localized and centered on the village synagogue. The local scribes, whose skill at interpreting Torah had made them influential, filled the power vacuum, and some of these scribes ultimately became the rabbis.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Rabbinic tradition tells of the fortuitous escape and surrender of Yo"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("anan ben Zakkai during the siege of Jerusalem. According to the story, while other rabbis such as Simon ben Gamaliel participated fully in the revolt and defense of Jerusalem, ben Zakkai decided that resistance was futile. He therefore smuggled himself out of the city as a corpse and then surrendered to the Romans. He impressed Vespasian by predicting his accession as emperor. Vespasian therefore granted ben Zakkai’s request to found a new center of Jewish law at Yavneh (Jamnia). In the generations following ben Zakkai, the rabbis continued to study Torah and attempt to rebuild Jewish religious and cultural life. It is not entirely clear how much political or religious power the rabbis actually possessed during this early period, and it is likely that acceptance of their leadership by Jews was gradual and perhaps only in its infancy when rebellion again broke out in Judea in 132 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Diaspora between the Revolts")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Few Jews in the Diaspora had been inspired to join in the revolt of 66. There was a brief uprising in Alexandria, but it was short-lived. Roman retaliation against the Jews also included the forced closure of the Oniad temple at Leontopolis in 72 and its precincts in 73, even though it had never been a center of unrest or disloyalty since its foundation in the mid-second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Titus’ destruction of the Jerusalem Temple in 70, however, severely strained Diaspora Jews’ loyalty. Further complicating matters was the imposition after 70 of the "), _c('em', [_vm._v("fiscus Iudaicus,")]), _vm._v(" an annual payment made to Jupiter Capitolinus by all Jews, regardless of gender, in lieu of payment of the Temple tax. This tax weighed heavily on the Jews, especially the poorer ones with large households, and its rigorous application by the emperor Domitian only made conditions worse (Suetonius, "), _c('em', [_vm._v("Domitian")]), _vm._v(" 12).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Alexandria, local conditions and grievances made the status of the Jewish community quite unstable. A single papyrus, the "), _c('em', [_vm._v("Acta Hermaisci,")]), _vm._v(" recounts rival embassies from Alexandria to Emperor Trajan only a decade before the outbreak of another uprising. Although the account has been heavily fictionalized, it speaks to the tensions between Alexandrian Jews and non-Jews. Some scholars have argued that there were additional factors leading up to the rebellions (Pucci Ben Zeev 2005). In particular, rebels who had fled Judea after the suppression of the First Revolt continued to cause problems, which only heightened tensions between Jews and non-Jews. There was a general rise in messianic aspirations and expectations of Rome’s collapse, especially after an earthquake that occurred in Antioch during a visit of Emperor Trajan in 115.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("In 115/116, these tensions exploded into full-scale revolt in Egypt, Cyrene, Cyprus, and Mesopotamia. This revolt, also called the War of Quietus after the general Lusius Quietus who suppressed the revolt in Mesopotamia, raged until 117. In Egypt, the Jewish rebels managed to take over much of the countryside including the Athribite district, the Fayum, Oxyrhynchus, and the nome of Herakleopolis. To the south, fighting broke out in the districts of Apollinopolis Magna, Hermopolis, Kynopolis, and Lycopolis. In Alexandria itself the rebellion seems to have involved destruction of pagan shrines, such as the shrine of Nemesis near Alexandria and ")]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("the tomb of Pompey (Appian, "), _c('em', [_vm._v("Bella Civilia")]), _vm._v(" 2.90). In Cyrene, the rebels, who were led by a certain Andreas (Dio 68.32.1) or Lukuas (Eusebius, "), _c('em', [_vm._v("Hist. Eccl.")]), _vm._v(" 4.2.3), killed several thousand non-Jews and destroyed several statues of the gods as well as several temples and sanctuaries, including the temples of Zeus and Hecate and parts of the sanctuaries of Apollo and Asclepius. Finally, perhaps in fear of a Roman military arrival by sea, the rebels smashed up the road connecting Cyrene to its port ("), _c('em', [_vm._v("CJZC")]), _vm._v(" 24-25). In Cyprus, a man named Artemion led an attack on the Gentile population and razed the city of Salamis. Not much information is known about the uprising in Mesopotamia except that Trajan sent Lusius Quietus to suppress the rebellion. It is possible that the Jews were simply one part of a general anti-Roman revolt within the region, and that the inhabitants there preferred Parthian control to Roman.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Roman response to the uprisings in Cyrene, Cyprus, and Egypt was swift and brutal. Trajan sent two forces to put down the rebellion: the VII Claudia legion to Cyprus and Quintus Marcius Turbo, with a large fleet and a number of legions, to Egypt and Cyrene. Egyptian papyri also indicate that local non-Jewish militias fought alongside the legions. Turbo sailed into Alexandria and defeated the rebels over the course of several battles in which his army killed several thousand Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The results of the war were cataclysmic for the Jewish populations of Egypt, North Africa, and Cyprus. Jews were banished from Cyprus and were prohibited from stepping foot on it on pain of death. After the revolt, there is no more evidence for Jewish settlement in the countryside of Egypt or Cyrene. Tragically, the great Jewish community of Alexandria disappeared and seems to have been destroyed, although there are a few traces of Jews left in the city afterward. Outside of the region under revolt, however, there does not seem to have been any anti-Jewish backlash. In the following years, large swaths of North African territory needed to be resettled and repopulated. Trajan and his successor Hadrian used confiscated Jewish property to fund the reconstruction efforts, especially the rebuilding of pagan temples.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Bar Kokhba Revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After suppressing the Jews of Mesopotamia, Lusius Quietus was elected consul, and Trajan then appointed him governor of Judea. There are no specific details concerning any war in Judea related to the Diaspora uprisings of 115-117, and none of the Greek or Latin sources refers to fighting in Judea during this period. Rabbinic sources ("), _c('em', [_vm._v("Seder")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Olam Rabbah")]), _vm._v(" 30; "), _c('em', [_vm._v("m. So")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ah")]), _vm._v(" 9:14) do mention a “War of Kitos” that occurred fifty-two years after Vespasian’s war and sixteen years before the Bar Kokhba Revolt. Like these two wars, the “War of Kitos” saw the passage of sumptuary laws by the rabbis and a prohibition of teaching Greek. Nevertheless, the rabbinic sources are ambiguous at best. Rabbinic tradition preserves an account of two martyrs, Julianus and Pappus, who supposedly died under Trajan, but these deaths could have taken place anywhere ("), _c('em', [_vm._v("m. So")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ah")]), _vm._v(" 9:14; "), _c('em', [_vm._v("Megillat Ta")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("anit")]), _vm._v(" 29).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("However, war and rebellion soon came to Judea, led by a charismatic leader, Shimon ben Kosiba. Later rabbinic sources claim that Ben Kosiba received the ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("support of Rabbi Aqiba, who renamed the revolutionary leader Bar Kokhba (Aramaic for “Son of the Star”) in reference to the prophecy in Num. 24:17 (“A star will come out of Jacob; a scepter will rise out of Israel”). Bar Kokhba does not make any messianic claim in his letters, but on his coins he is called “prince "), _c('em', [_vm._v("(na")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("i")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v(")")]), _vm._v(" of Israel,” a title that had a long history of messianic associations.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The immediate causes of the war are unclear because we lack a detailed narrative of its course. It is likely that economic distress, hatred of the Romans, and anger over the destruction of the Temple played major roles in inciting Jews to rebel. Further, land confiscations probably exacerbated economic hardship, and religious factors also seem to have been influential. According to the "), _c('em', [_vm._v("Historia Augusta,")]), _vm._v(" the revolt began because Hadrian issued an edict prohibiting circumcision (14.2). The ban was part of a wider, empire-wide prohibition on mutilation, including castration, but Hadrian must have known how the Jews would respond. Dio suggests that the emperor also had decided to turn Jerusalem into a new pagan city, Aelia Capitolina (Dio 69.12.1-2), and perhaps this prohibition was connected to that larger plan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The rebellion’s territorial extent is also unclear, but most evidence suggests a concentration in the part of Judea closest to Jerusalem and the Dead Sea. The Jews seem to have had some success in the beginning, but it is not clear if the Jewish rebels ever managed to seize Jerusalem. The rebel letters found in the desert refer to Herodion and not Jerusalem as the insurgent headquarters, and their last stronghold was Bethar, not Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Romans responded seriously to this new threat, and Hadrian sent Gaius Julius Severus from Britain to take over command of Judea in 134 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Dedicatory inscriptions indicate that legions from all over the empire were sent to Judea, but otherwise there is no indication of troop size or makeup. The paucity of evidence from Greco-Roman authors suggests hesitancy on the part of the imperial government to mention a brutal suppression of rebellion, which did not fit well with Hadrian’s image of benevolent patronage of the provinces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Dio, the Romans killed more than 500,000 Jews and destroyed 50 towns and 785 villages in the suppression of the revolt. He also claims that they enslaved many of the survivors (Dio 69.14.3). Although these numbers likely are inflated, the bones discovered in the Judean Desert caves testify to Roman thoroughness and ruthlessness. Rabbinic sources state that many sages were martyred, including Rabbi Aqiba, and a period of strict persecution followed in which Jews could not practice many facets of their religion, including studying Torah, observing the Sabbath, and circumcising their sons. Indeed, Jews did not receive permission to circumcise their sons until after Hadrian’s death. Perhaps the most long-lasting and devastating result of the war, however, was the expulsion of the Jews from Jerusalem (now called Aelia Capitolina) and its territory (Justin, "), _c('em', [_vm._v("Apology")]), _vm._v(" 7.6). Hadrianic coins celebrated the new city with a Greek figure representing it, and a temple dedicated to Hadrian was constructed atop the Temple Mount itself. Thus, what began as an attempt to liberate the Jews of Judea ultimately led to their death and to the enslavement and expulsion of Jews from their Holy City. With the failure of the Bar Kokhba Revolt, a major period of Jewish history comes to an end.")])]), _c('p', {
    staticClass: "bib-head"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Bagnall, Roger S. 1976. "), _c('em', [_vm._v("The Administration of the Ptolemaic Possessions outside Egypt.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bar-Kochva, Bezalel. 1989. "), _c('em', [_vm._v("Judas Maccabaeus: The Jewish Struggle against the Seleucids.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. 1996. "), _c('em', [_vm._v("Jews in the Mediterranean Diaspora.")]), _vm._v(" Edinburgh: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ben Zeev, Miriam Pucci. 2005. "), _c('em', [_vm._v("Diaspora Judaism in Turmoil, 11")]), _vm._v("6/"), _c('em', [_vm._v("117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v(": Ancient Sources and Modern Insights.")]), _vm._v(" Leuven: Peeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Berlin, Adele M., and J. Andrew Overman, eds. 2002. "), _c('em', [_vm._v("The First Jewish Revolt: Archaeology, History, and Ideology.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bickerman, Elias J. 1980. “La Charte séleucide de Jérusalem.” In "), _c('em', [_vm._v("Studies in Jewish and Christian History (Part Two).")]), _vm._v(" Leiden: Brill, 44-85.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1979. "), _c('em', [_vm._v("The God of the Maccabees: Studies on the Meaning and Origin of the Maccabean Revolt.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bouché-Leclercq, Auguste. 1903-1907. "), _c('em', [_vm._v("Histoire des Lagides.")]), _vm._v(" 4 vols. Paris: Leroux.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1913-1914. "), _c('em', [_vm._v("Histoire des Séleucides (323-64 J.-C.).")]), _vm._v(" 2 vols. Paris: Leroux.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brutti, Maria. 2006. "), _c('em', [_vm._v("The Development of the High Priesthood during the pre-Hasmonean Period: History, Ideology, Theology.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cohen, Getzel M. 2006. "), _c('em', [_vm._v("The Hellenistic Settlements in Syria, the Red Sea Basin, and North Africa.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Eshel, Hanan. 2008. "), _c('em', [_vm._v("The Dead Sea Scrolls and the Hasmonean State.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fischer, Thomas. 1980. "), _c('em', [_vm._v("Seleukiden und Makkabäer: Beiträge zur Seleukidengeschichte und zu den politischen Ereignissen in Judäa während der 1. Hälfte des 2. Jahrhunderts v. Chr.")]), _vm._v(" Bochum: Studienverlag Dr. Norbert Brockmyer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gafni, Isaiah. 1984. “The Historical Background.” In "), _c('em', [_vm._v("Jewish Writings of the Second Temple Period.")]), _vm._v(" Ed. Michael E. Stone. Assen: Van Gorcum; Philadelphia: Fortress, 1-31.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gera, Dov. 1998. "), _c('em', [_vm._v("Judaea and Mediterranean Politics, 219 to 161 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodblatt, David. 2006. "), _c('em', [_vm._v("Elements of Jewish Nationalism.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodman, Martin. 1987. "), _c('em', [_vm._v("The Ruling Class of Judea: The Origins of the Jewish Revolt "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 66-70.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Grabbe, Lester L. 1992. "), _c('em', [_vm._v("Judaism from Cyrus to Hadrian.")]), _vm._v(" 2 vols. Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Grainger, John D. 1997. "), _c('em', [_vm._v("A Seleukid Prosopography and Gazetteer.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Green, Peter. 1990. "), _c('em', [_vm._v("Alexander to Actium: The Historical Evolution of the Hellenistic Age.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gruen, Erich S. 1993. “Hellenism and Persecution: Antiochus IV and the Jews.” In "), _c('em', [_vm._v("Hellenistic History and Culture.")]), _vm._v(" Ed. P. Green. Berkeley: University of California Press, 238-55; 256-74.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2002. "), _c('em', [_vm._v("Diaspora: Jews amidst the Greeks and Romans.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hengel, Martin. 1989. "), _c('em', [_vm._v("The Zealots: Investigations into the Jewish Freedom Movement in the Period from Herod I until 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")])]), _vm._v(" Trans. David Smith. Edinburgh: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hoehner, Harold. 1972. "), _c('em', [_vm._v("Herod Antipas.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hölbl, Günther. 2001. "), _c('em', [_vm._v("A History of the Ptolemaic Empire.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, Sara R. 2004. "), _c('em', [_vm._v("Historical Fictions and Hellenistic Jewish Identity.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jones, A. H. M. 1938. "), _c('em', [_vm._v("The Herods of Judea.")]), _vm._v(" Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kasher, Aryeh. 1985. "), _c('em', [_vm._v("The Jews in Hellenistic and Roman Egypt.")]), _vm._v(" Tübingen: Mohr-Siebeck.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("———. 1990. "), _c('em', [_vm._v("Jews and the Hellenistic Cities in Eretz-Israel: Relations of the Jews in")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('em', [_vm._v("Eretz-Israel with the Hellenistic Cities during the Hellenistic and Roman Era (332 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v("–"), _c('em', [_vm._v("70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v(").")]), _vm._v(" Tübingen: Mohr-Siebeck.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Kokkinos, Nikos. 1998. "), _c('em', [_vm._v("The Herodian Dynasty: Origins, Roles in Society and Eclipse.")]), _vm._v(" Sheffield, England: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lipschits, Oded et al., eds. 2007. "), _c('em', [_vm._v("Judah and the Judeans in the Fourth Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])]), _vm._v(" Winona Lake: Eisenbrauns.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lüderitz, Gert, ed. 1983. "), _c('em', [_vm._v("Corpus Jüdischer Zeugnisse aus der Cyrenaika.")]), _vm._v(" Wiesbaden: Reichert.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mendels, Doron. 1992. "), _c('em', [_vm._v("The Rise of Jewish Nationalism: Jewish and Christian Ethnicity in Ancient Palestine.")]), _vm._v(" New York: Doubleday.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Meshorer, Ya"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("akov. 2001. "), _c('em', [_vm._v("A Treasury of Jewish Coins: From the Persian Period to Bar Kokhba.")]), _vm._v(" Nyack, N.Y.: Amphora.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Modrzejewski, Joseph Méléze. 1995. "), _c('em', [_vm._v("The Jews of Egypt: From Rameses II to Emperor Hadrian.")]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mørkholm, Otto. 1966. "), _c('em', [_vm._v("Antiochus IV of Syria.")]), _vm._v(" Copenhagen: Nordisk Forlag.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Netzer, Ehud. 2006. "), _c('em', [_vm._v("The Architecture of Herod, the Great Builder.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Neusner, Jacob. 1969. "), _c('em', [_vm._v("A History of the Jews in Babylonia,")]), _vm._v(" vol. 1, "), _c('em', [_vm._v("The Parthian Period.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Price, Jonathan. 1992. "), _c('em', [_vm._v("Jerusalem under Siege: The Collapse of the Jewish State 66-70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rajak, Tessa. 2002. "), _c('em', [_vm._v("Josephus: The Historian and His Society.")]), _vm._v(" 2d ed. London: Duckworth.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Richardson, Peter. 1996. "), _c('em', [_vm._v("Herod: King of the Jews and Friend of the Romans.")]), _vm._v(" Columbia: University of South Carolina Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rooke, Deborah W. 2000. "), _c('em', [_vm._v("Zadok’s Heirs: The Role and Development of the High Priesthood in Ancient Israel.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schäfer, Peter, ed. 2003. "), _c('em', [_vm._v("The Bar Kokhba War Reconsidered.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schalit, Abraham. 1969. "), _c('em', [_vm._v("König Herodes: Der Mann und sein Werk.")]), _vm._v(" Berlin: de Gruyter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schürer, Emil. 1973-1987. "), _c('em', [_vm._v("The History of the Jewish People in the Age of Jesus Christ.")]), _vm._v(" Rev. and ed. G. Vermes, F. Millar, and M. Goodman. 3 vols. Edinburgh: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schwartz, Daniel R. 1990. "), _c('em', [_vm._v("Agrippa I: The Last King of Judea.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schwartz, Seth. 2001. "), _c('em', [_vm._v("Imperialism and Jewish Society, 200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to 640 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Shatzman, Israel. 1991. "), _c('em', [_vm._v("The Armies of the Hasmonaeans and Herod.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sievers, Joseph. 1990. "), _c('em', [_vm._v("The Hasmoneans and Their Supporters.")]), _vm._v(" Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Smallwood, E. Mary. 1976. "), _c('em', [_vm._v("The Jews under Roman Rule: From Pompey to Diocletian.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tcherikover, Victor. 1959. "), _c('em', [_vm._v("Hellenistic Civilization and the Jews.")]), _vm._v(" New York: Jewish Publication Society. (Reprint: Peabody, Mass.: Hendrickson, 1999, with a preface by John J. Collins.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Trebilco, Paul R. 1991. "), _c('em', [_vm._v("Jewish Communities in Asia Minor.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("VanderKam, James C. 2004. "), _c('em', [_vm._v("From Joshua to Caiaphas: High Priests after the Exile.")]), _vm._v(" Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wilker, Julia. 2007. "), _c('em', [_vm._v("Für Rom und Jerusalem. Die herodianische Dynastie im 1. Jahrhundert n. Chr.")]), _vm._v(" Frankfurt am Main: Verlag Antike.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Yadin, Yigael. 1963-2002. "), _c('em', [_vm._v("The Finds from the Bar Kokhba Period in the Cave of Letters.")]), _vm._v(" 3 vols. Jerusalem: Israel Exploration Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1966. "), _c('em', [_vm._v("Masada: Herod’s Fortress and the Zealot’s Last Stand.")]), _vm._v(" New York: Random House.")])])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('em', [_vm._v("Judaism in the Land of Israel")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" C. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANDERKAM")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Judaism")]), _vm._v(" as a designation for the entire phenomenon of the Jewish ways of living and believing is a Greek term "), _c('em', [_vm._v("(Ioudaismos)")]), _vm._v(" first attested in 2 Macc. 2:21; 14:38. It is related to the name for the land where many Jews lived — the land of Judah or Judea — and seems to have been coined as a way of contrasting traditional Jewishness with Hellenism ("), _c('em', [_vm._v("Hellenismos;")]), _vm._v(" see 2 Macc. 4:13). This essay will focus on Judaism as it came to expression in the land of Israel.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Land of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Scriptures repeatedly mention God’s promise that the descendants of Abraham and Sarah would possess the land (Gen. 12:7; 13:14-17; 15:7, 17-21; etc.), and the book of Joshua shows how that promise came to fruition (e.g., Josh. 21:43-45). The people of Israel lived in the promised land for centuries, but finally their sins, according to the Deuteronomistic History (2 Kings 21:10-15; etc.), so sorely tried the divine patience that YHWH invoked the curses of the covenant upon them, and gave them into the power of their enemies, who torched Jerusalem and the Temple and exiled many from the land. Decades later a return to the land began and a new temple was constructed on the site of the old one. Though a large number of Jewish people by this time lived in the various diasporas, the land of Israel remained a powerful symbol for them, although this spiritual and national force did not necessarily impel them to live there. The Temple was a center for pilgrimages and gifts in addition to being the place where sacrifices were continually offered. The prophets had looked forward to a day when the dispersed people of God would be gathered to their home (e.g., Isa. 11:10-16; Ezek. 37:15-28), and that longing comes to expression in some of the literature written when the Second Temple stood, although the vast majority of Diaspora Jews remained where they were.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('strong', [_vm._v("The Temple")])])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("One phenomenon related to and underscoring the centrality of the land of Israel, one that exercised a strong attraction for Jews everywhere, was the Temple in Jerusalem. Other Jewish temples existed — one at Elephantine in Egypt and later one in Leontopolis, also in Egypt — but the sanctuary in Jerusalem held a special place. Ezra 6:13-18 dates the completion and dedication of the Second Temple to the sixth year of King Darius (515 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("); that building complex (with repairs) apparently lasted until 20 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" when King Herod began completely rebuilding it on a grander scale. Herod’s temple was to be destroyed with the city of Jerusalem in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If the Second Temple followed the structural plan of Solomon’s temple (see 1 Kings 6:2-6), the building itself would have had three rooms — the nave or vestibule, the Holy Place, and the Holy of Holies — along with several altars. These would have been set within at least two large courts and would have been surrounded by other structures required for the personnel and materials of sacrificial worship and other sanctuary-related activities. The Herodian temple area (see Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 15.391-420; "), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.102-4) included four courts with ever greater degrees of holiness: one accessible to all, including non-Jews, one for all Jews including women, one for Jewish men, and one for priests only. At various places there were marble columns and porticoes with steps and walls between enclosures. Only the high priest, on the Day of Atonement, could enter the Holy of Holies, the innermost room of the Temple itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Because of the central place occupied by the Temple in Jerusalem, the priests who served there exercised important functions in society, and some of them became its leading officials. According to the scriptural genealogies and laws, all qualified males of the tribe of Levi were clergy, but only the members of this tribe stemming from Aaron’s line were priests (Num. 8:5-26; see also Exod. 28:1-3; 29:1-37). The Levites performed other duties at the sanctuary and served the priests, the sons of Aaron (Num. 18:1-7; 4:46-49). At the head of the body of priests stood the high priest, who, in the early centuries of the Second Temple period, came from the family of Joshua/Jeshua (the first high priest of the Second Temple) and held the post in hereditary succession (Neh. 12:10-11). The high priest seems at times to have exercised political power as well, serving as the chief national official in the absence of a governor. Those Hasmoneans who held the high-priestly office from 152 until the Roman conquest in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" were not only heads of the cultic establishment but also chiefs of state and commanders of the army. During the years of Roman rule and before the defeat and destruction of Jerusalem in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", the high priests continued to be influential leaders in dealing both with Jewish and Roman officials.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("There were too many priests to allow all of them to serve at the Temple complex at the same time. 1 Chronicles 24:7-18 contains a list dividing the priests into twenty-four groups, one of which served at the Temple for a week, after which it was replaced by the next group on the list (Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 7.365-66; "), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.108). In this system, therefore, most of these divisions of priests were on duty at the Temple for only two weeks each year (twenty-four groups each serving two weeks would fill forty-eight weeks so that four would have to serve a third week) and at the ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("great festivals when more of them were needed because of the large numbers of people bringing offerings. The Levites may have been organized in a similar way; from among their ranks came the singers and gatekeepers at the Temple (1 Chronicles 25–26; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 7.367).")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Worship at the Temple followed and built upon the prescriptions in the Mosaic Law. Animal and grain offerings with their libations were regularly made there. Each day, as the Law prescribed, there were two sacrifices of a lamb with accompanying grain and liquid offerings — the morning and evening sacrifices described in Exod. 29:38-42; Num. 28:3-8 (see 1 Chron. 15:40; 2 Chron. 8:11; 31:3). There were other mandated sacrifices for the Sabbaths, the first of each month, and for the festivals (Numbers 28–29), and passages such as Leviticus 1–7 describe the many kinds of sacrifice — their contents, who offers them, and the occasions for them. The priests were the ones who performed the procedures carried out at the altar (Num. 18:1-7; 1 Chron. 6:49-53), and for their support priests received prescribed parts of offerings other than the whole burnt offering (e.g., Lev. 2:3, 10; 5:13; 6:16-18, 26, 29; 7:6-10, 14, 31-36; Num. 18:8-20) as well as other gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The festivals constituted an important if less frequent part of worship at the Temple in Jerusalem. The Law of Moses commanded that an Israelite male was to present himself before the Lord three times each year: at the Festival of Unleavened Bread, the Festival of Weeks, and the Festival of Tabernacles (Exod. 23:14-17; 34:18-24; Deut. 16:1-17). It came to be understood that the Jerusalem Temple was the place where one appeared before YHWH; as a result, thousands of Jews would travel to Jerusalem to celebrate those holidays, whether from the land or the Diaspora. Deuteronomy also stipulated that Passover be held at the sanctuary; consequently, large crowds converged on Jerusalem on the prescribed date (1/14); they could remain there for the Festival of Unleavened Bread, which followed immediately (from 1/15 to 1/21). The Day of Atonement (7/10) involved elaborate rites at the Temple, including several trips in and out of the Holy of Holies by the high priest (Leviticus 16). During Hasmonean times another Temple-related festival — Hanukkah — was added to the list in the Hebrew Bible; it celebrated and remembered the reconsecration of the Temple in 164 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" after it had been defiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Worship at the Temple also involved music. There are references in the literature to the singing of the Levites, with the books of Chronicles being especially rich in passages relating to this levitical function. They present the Levites as singers at the time of David and his royal successors, but these books may reflect more of the situation in Second Temple times when they were compiled. In 1 Chron. 6:31-48 David appoints Levites to provide music at the house of the Lord; among them are Asaph and Kohath, whose names are found in the titles of some psalms (sons of Korah: Psalms 42, 44–49, 84–85, 87–88; Asaph: Psalms 50, 73–83; in 1 Chron. 16:7-36 Asaph and his kin sing from Psalms 105, 95, and 106; see also 2 Chron. 29:25-30; 35:15). The king ordered the singers and instrumentalists to perform at the times of sacrifice, Sabbaths, and festivals (1 Chron. 23:30-31). When Jews presented their Passover offerings, the Levites sang the Hallel psalms (Psalms 113–18; "), _c('em', [_vm._v("m. Pesa")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v(".")]), _vm._v(" 5:7).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("The large costs incurred in connection with the forms of worship at the Temple and the maintenance of the structures were met through different means. As noted, support for the priests, who had no land to supply them with their needs, ")]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("came from the parts of sacrifices allotted to them by the Law, and they also received one of the tithes mentioned in the Scriptures. The Law provided that the Levites, who also lacked land, should receive tithes from the Israelites (cf. Deut. 14:28-29), and they in turn were to give a tithe from their tithe to the priests (Num. 18:21-32). Tobit 1:6-7 gives a summary of the firstfruits contributions and the clerically related payments as the protagonist describes his religious practice before he was exiled from his land: “I would hurry off to Jerusalem with the firstfruits of the crops and the firstlings of the flock, the tithes of the cattle, and the first shearings of the sheep. I would give these to the priests, the sons of Aaron, at the altar; likewise the tenth of the grain, wine, olive oil, pomegranates, figs, and the rest of the fruits to the sons of Levi who ministered at Jerusalem.”")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to these means of support for the clergy, the sources disclose other revenues. First, several foreign monarchs who ruled Judea made contributions to the Temple. This is attested for three Persian kings (Ezra 6:1-5 [Cyrus], 8-10 [Darius I]; 7:15-23 [Artaxerxes I]) and for the Seleucid rulers Antiochus III (Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.138-44) and Seleucus IV (2 Macc. 3:2-3; cf. 1 Macc. 10:40). The passage from 2 Maccabees claims: “it came about that the kings themselves honored the place and glorified the temple with the finest presents, even to the extent that King Seleucus of Asia defrayed from his own revenues all the expenses connected with the service of the sacrifices.” Ezekiel had envisaged that the prince in Jerusalem would pay for the sacrifices on holidays and Sabbaths (45:17; see also 45:22–46:15), but in reality it was foreign rulers who did so. Second, the Jewish populace worldwide supported the Temple through a tax. Exodus 30:11-16 records an imposition of one-half shekel that each Israelite male twenty years of age and above was to pay as an atonement; YHWH ordered Moses: “You shall take the atonement money from the Israelites and shall designate it for the service of the tent of meeting” (30:16; 38:25-28, where it is apparently for construction of the tabernacle; see also 2 Chron. 24:4-14; Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 3.194-96). Exodus attaches the payment to a census Moses was to take and does not say how often the Israelites were supposed to pay it. In the time of Nehemiah the people not only pledged to bring wood for the offerings at the Temple, the firsts of the crops and herds, and the tithes (10:34-39), but also obligated themselves to pay an annual tax of one-third of a shekel “for the service of the house of our God: for the rows of bread, the regular grain offering, the regular burnt offering, the Sabbaths, the new moons, the appointed festivals, the sacred donations, and the sin offerings to make atonement for Israel, and for all the work of the house of our God” (Neh. 10:32-33). The reader does not learn why the amount of this levy differed from the one in Exodus 30, but later one finds references in the sources to an annual half-shekel payment (see Matt. 17:24-27; "), _c('em', [_vm._v("m. Šeqal.")]), _vm._v(" 4:1-5) — one that Josephus mentions several times and indicates that it applied to Jews in the Diaspora as well as those in the land ("), _c('em', [_vm._v("Ag. Ap.")]), _vm._v(" 2.77; "), _c('em', [_vm._v("Ant.")]), _vm._v(" 16.163; 18.312-13 [Babylon]; see Philo, "), _c('em', [_vm._v("Spec. Leg.")]), _vm._v(" 1.76-78). After Jerusalem was destroyed in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", the Romans redirected the tax monies to the temple of Jupiter Capitolinus in Rome ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 7.218). It is interesting that a text from Qumran decrees that the tax be paid only once in a person’s lifetime (4Q159 1 ii 6-7) — perhaps a polemical view based on Exod. 30:11-16.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('strong', [_vm._v("Festivals")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Besides the daily and other sacrifices and ceremonies performed regularly at the Temple in Jerusalem, the cycle of festivals was centered there. As noted above, the Passover (1/14) and the three pilgrimage festivals took place at the sanctuary as the Mosaic Law directed. For the Passover, the representative of each household presented the paschal lamb at the Temple, where it was sacrificed. The Festival of Unleavened Bread, lasting from 1/15 to 1/21, coincided with the barley harvest; the Festival of Weeks, occurring at some unspecified point in the third month, marked the wheat harvest; and the Festival of Booths, celebrated on 7/15-21, came at the end of the entire harvest season. Each of the three pilgrimage holidays was also a firstfruits festival that required presentation of a part of the relevant crop at the sanctuary. The two additional firstfruits festivals mandated in the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" (of wine and oil) would have taken place at the Temple, if they were ever implemented (11QT"), _c('sup', [_vm._v("a")]), _vm._v(" 19:11–23:2). The Second Passover (2/14; for individuals who, for certain legitimate causes, were not able to celebrate the Passover in the first month [see Num. 9:16-14]) also was a Temple festival, while the ceremonies for the Day of Atonement (7/10) necessarily took place at the Temple (Leviticus 16). The book of Esther provides the dramatic story that gave rise to the holiday called Purim (lots), but there was no requirement that it be observed at the sanctuary. And Hanukkah, an eight-day festival commemorating and celebrating the rededication of the Temple in 164 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" (1 Macc. 4:36-59; 2 Macc. 10:1-8), was by definition associated with the Temple, but there was no requirement that one had to travel there to mark it properly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Each of the festivals summarized in Leviticus 23 and Numbers 28–29 required sacrifices at the Temple beyond the daily ones offered, and the firstfruits holidays, as noted, involved the appropriate offering from the harvest of that season. This entailed that the Temple became a very busy and crowded place on these occasions. As a result, the priests who happened to be on duty at the Temple at the time of a major festival were not able to handle the large increase in sacrifices and related activities; they were augmented by priests from the other rotations.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("It is not possible to infer from the way in which the Pentateuch dates festivals the nature of the calendar by which they were calculated. In the priestly portions of the Torah, the months are designated with ordinal numbers and the days are, of course, numbered as well. But no text indicates whether a solar calendar, a lunar calendar, or a combination of the two was used as the system in Second Temple times for the very practical issue of determining when public festivals occurred. Exodus 12:1 identifies the month of the Passover as the first month of the year; hence, for dating festivals, a Spring inception of the year was assumed. Psalm 104:19 could be taken as an indication that lunar considerations were involved in dating festivals (as they were later): “You have made the moon to mark the seasons [or: the festivals]; the sun knows its time for setting.” But nothing specific should be inferred from the verse. Sirach 43:6-8, after a section extolling the wonders of the sun, has been adduced as evidence that by the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" the moon determined festal dates. Note in particular 43:6-7: “It is the moon that marks the changing seasons, governing the times, their everlasting sign. From the ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("moon comes the sign for festal days, a light that wanes when it completes its course.” One prominent trait of "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 72–82, "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" and the sectarian literature from Qumran is the prominence of a solar year lasting 364 days; the festival dates are determined according to it.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is appropriate to append a short reference to synagogues to this survey of information about the Temple and worship in the land of Israel. It would seem that having only one temple could prove inconvenient for those who lived some distance from it, even though the area of Jewish settlement was not very large and a person was not often required to be at the Temple. Also, the traditional form of sacrificial worship at the Jerusalem Temple (the only place where it could be effected) may not have met all the religious needs of Jewish people. Whatever the reasons may have been, at some point or very gradually in the Second Temple period, synagogues, local places for worship and study, began to appear, perhaps at first in the Diaspora (there are third-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" references from Egypt), but also in the land of Israel (the earliest evidence is from the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). The Gospel of Luke documents the presence of a synagogue at Nazareth and the importance of Scripture reading and exposition in the Sabbath service there (Luke 4:16-30; notice that 4:15 refers to "), _c('em', [_vm._v("synagogues")]), _vm._v(" in Galilee). Others are known from Herodium, Masada, and Gamla, and there are references to synagogues in Jerusalem (e.g., Acts 6:8-9). The synagogue was a place for communal activities (see the Theodotus Inscription) including reading, studying, and expositing the Scriptures and prayer. Synagogues appear not to have been seen as rivals in some sense to the Temple but rather as complements to it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Institutions")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Temple was a dominant institution in the Judaism as practiced in the land, and later in the period synagogues served key functions, but there were other institutions that played central roles in society. Some information has survived regarding the political organization of the Jewish people in their land. A fundamental fact of life throughout the centuries of early Judaism was that Judah/Judea was under foreign control (Persia, the Hellenistic kingdoms of the Ptolemies and Seleucids, Rome), with the exception of a few decades when the Hasmoneans controlled the state and were somewhat independent of the Seleucid administration.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("There was a governor in Jerusalem at a number of times, although the evidence is insufficient to show that there was always an office of this sort. Sheshbazzar (Ezra 5:14) and Zerubbabel (Hag. 1:1), perhaps both descendants of David, are called governors in the late sixth century, and Nehemiah, who refers to his predecessors in the office (Neh. 5:15), served in the same capacity in the second half of the fifth century. An official named Bagohi/Bagoas/Bigvai was the governor at the end of the century according to one of the Elephantine papyri ("), _c('em', [_vm._v("TAD")]), _vm._v(" ["), _c('em', [_vm._v("Textbook of Aramaic Documents from Ancient Egypt")]), _vm._v("] A4.7 = "), _c('em', [_vm._v("CAP")]), _vm._v(" [Cowley, ed., "), _c('em', [_vm._v("Aramaic Papyri of the Fifth Century")]), _vm._v("] 30), and a certain Hezekiah is called governor on some coins from the end of the Persian and perhaps the beginning of the Hellenistic periods. After this, there is a lengthy gap in attestations of a governor, and it may be that the high ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("priest became the chief of state. This appears to be the case in the Tobiad Romance and also in Jerusalem as pictured at the beginning of the historical account in 2 Maccabees (3:1–4:6). In all of the narratives in 1-2 Maccabees, there is no mention of a governor other than a member of the Hasmonean family (the governor Philip in 1 Macc. 5:22 is a foreigner imposed from without for a short time).")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When the Hasmoneans became high priests (starting in 152 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), they also served as political leaders and army commanders. Beginning either in the short reign of Aristobulus I (104-103 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") or in that of Alexander Jannaeus (103-76), these rulers called themselves kings. They retained that office (with one queen, Salome Alexandra) until the Roman conquest of the area in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Yet, even after this date a high priest such as Hyrcanus II enjoyed very high positions in society and is still called "), _c('em', [_vm._v("king")]), _vm._v(" a few times, and Antigonus briefly claimed the royal office (40-37 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). Josephus indicates that in the first century the aristocratically constituted state of the Jews was led by the high priests ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 20.251), although this was done under Roman supervision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Herod’s appointment as king by the Roman senate profoundly changed the political landscape. From the time of his reign (37-4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") until the destruction of Jerusalem (and beyond), he and his descendants were dominant rulers among the Jews in the land. Herod held the office of king, as did two of his sons (Antipas [4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("–39 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("] and Philip [4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("–33/34 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("]) in parts of their father’s realm, while Archelaus (4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("–6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("), who inherited the rule of Judea, served as ethnarch until he was deposed for his incompetent and violent rule. In Judea the Romans then assumed more direct control by appointing prefects (from 6 to 41), among whom the best known is Pontius Pilate (26-36/37). King Agrippa I briefly reunited the kingdom of his grandfather Herod the Great (between 37 and 44) before dying at a young age. Following his death in 44 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", the Romans again assumed closer control by appointing procurators, an arrangement that lasted until the end of the revolt. During this latter period, Agrippa’s son Agrippa II came to have a significant influence in Jewish political and religious affairs.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("A second institution that seems to have occupied an important place in Jewish society was the council of elders ("), _c('em', [_vm._v("g")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("rousia")]), _vm._v(" in Greek) or Sanhedrin, if, as seems likely, the two terms refer to the same type of body. There are references in Ezra to “the elders” as an influential group, but whether they constituted a ruling body is not said (Ezra 5:5, 9; 6:7, 14; in these passages they are involved in rebuilding the Temple and negotiations about it). Apart from the book of Judith (e.g., 4:8), which has a weak claim to historicity, the earliest mention of a council of elders is in Josephus’ citation of the letter issued by Antiochus III (223-187 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") regarding the Jewish people: he says they with their senate "), _c('em', [_vm._v("(g")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("rousia)")]), _vm._v(" greeted him when he visited the city ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 12.138); later the king mentions the Jewish form of government and lists the senate among the groups exempt from three taxes (12.142). In 2 Macc. 4:4 the senate is the body that sends representatives to King Antiochus IV to press a case against the actions of the high priest Menelaus (vv. 43-50). In subsequent times the term continues to be used in official letters in which the leaders of the Jews are listed (e.g., 2 Macc. 1:10) or addressed (2 Macc. 11:27; 1 Macc. 12:6; 13:36 [where they are called “the elders”; see also 11:23; 12:35]; 14:20, 28 [in the section regarding the decree honoring Simon]). Josephus reports that Gabinius, a ")]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("Roman official, set up five sanhedrins in Jewish territory in the 50s "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 14.91), but not long afterward the historian relates the story of young Herod’s trial before the Sanhedrin (14.165-79). From this episode the judicial nature of the group’s work is clear, although it was definitely intimidated by the military power of Herod. The Sanhedrin as a judicial body is also evidenced in the trial of Jesus (Mark 14:53-65, where the members are identified as the high priest, the chief priests, elders, and scribes; Matt. 26:59-68; Luke 22:66-71) and that of his brother James ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 20.199-203). The book of Acts, among several references to the council, includes Paul’s appearance before it; there the members are the high priest along with representatives of the Pharisees and the Sadducees (22:30–23:12). Rabbinic sources know of a Sanhedrin that was a gathering of scholars who, among other activities, discussed matters of religious law. How that picture relates to the earlier references in Josephus and other Greek sources is not entirely clear.")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Groups")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As in any society, there were various groups among the Jewish people in the land of Israel. The sources for the earlier centuries of the period are sparse, but they indicate differing perspectives on some issues. So, for example, Ezra stands as a representative of a separatist point of view, one absolutely opposed to intermarriage with people of other races and nationalities; the book that bears his name includes information about many who had felt free to engage in exogamy and who were forced to dismiss their families. A number of scholars have argued that a fundamental tension in Judean society in the early Second Temple period was between those who found fulfillment of promises in the restored community and Temple and those of a more visionary bent who looked for more spectacular realizations of God’s plans for his people. Those expectations found expression in some late prophetic literature and perhaps in some texts with traits that would later characterize the apocalypses.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("During the early Hellenistic period there is evidence for some Jewish people who had greater ties with the Ptolemaic government (the Tobiad family, for one), while others seem to have favored the Seleucid administration (note the friendly reception of Antiochus III at Jerusalem). But the most famous division in Jewish society, one that became unmistakable in the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", is the one between those Jews who were more open to aspects of Greek culture and those who opposed the adoption of Greek ways. The contrast should not be pictured as absolute, since Hellenistic influence, such as the spread of the Greek language, was multifaceted and in part religiously neutral. But 2 Maccabees describes a situation in which a group of Jews, led by the usurping high priest Jason and with the approval of the Seleucid monarch Antiochus IV (175-164 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), introduced into Jerusalem the central institutions of Greek education and citizenship — a gymnasium and an ephebate. 1 Maccabees 1:11 presents the perspective embraced by such people in these words: “In those days certain renegades "), _c('em', [_vm._v("(paranomoi)")]), _vm._v(" came out from Israel and misled many, saying, ‘Let us go and make a covenant with the Gentiles around us, for since we separated from them many disasters have come ")]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("upon us.” The author adds that not only was the gymnasium built in Jerusalem but these people “removed the marks of circumcision, and abandoned the holy covenant. They joined with the Gentiles and sold themselves to do evil” (v. 15). Later, when the worship of a different god was set up in the Jerusalem Temple, not all Jews were opposed to the innovation although some, under Hasmonean leadership, violently fought it.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the context of the early Hasmonean period, specifically in his account of the reign of Jonathan as high priest and leader, Josephus ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 13.171-73) reports that there were three sects or schools of thought "), _c('em', [_vm._v("(haireseis)")]), _vm._v(" among the Jews and lists them as the Pharisees, the Sadducees, and the Essenes. Josephus mentions members of these groups in various places in his narratives and devotes a couple of sections to describing them, especially in "), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.119-66 (see also "), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.11-22). The information from Josephus regarding these groups can be supplemented from the Dead Sea Scrolls and from the New Testament. Rabbinic literature, too, refers to Pharisees and Sadducees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("About the Pharisees Josephus reports that they were known for their skill and accuracy in interpreting the Law of Moses ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.162), and to this he adds that “the Pharisees had passed on to the people certain regulations handed down by former generations and not recorded in the Laws of Moses” ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 13.297 [trans. R. Marcus]). This appears to be the oral Torah known from other sources, a tradition of commentary and interpretation that allowed the Pharisees to apply the ancient law to changed circumstances. Josephus, who mentions this Pharisaic trait while describing disagreements between Pharisees and Sadducees at the time of John Hyrcanus (134-104 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), says that these regulations of the Pharisees were not accepted by the Sadducees, who insisted “that only those regulations should be considered valid which were written down (in Scripture), and that those which had been handed down by former generations need not be observed” (13.297). The meaning of this distinction in views between the two groups has received much scholarly discussion, but it is clear enough that at issue between the two was the proper way for interpreting and applying the Mosaic Law, which both of course accepted as authoritative for practice. A number of the controversies between Jesus and the Pharisees reported in the Gospels present a similar picture of the Pharisees. When the “Pharisees and scribes” asked Jesus why his disciples “break the tradition of the elders” since they did not follow the practice of washing their hands before they ate, he answered: “And why do you break the commandment of God for the sake of your tradition?” (Matt. 15:3; see also v. 6; he cites their view about identifying goods as an offering and thus not using them to support parents as a violation of the fourth commandment).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Josephus identifies the Pharisees as an influential group within Jewish society. He claims that there were some 6,000 of them ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 17.42) but says they were able to bring the masses to their side and even compel rulers to act in accord with their teachings ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 13.288, 298; 18.15). Whether that was always true may be debated, but Josephus does tell about two periods when the Pharisees were especially influential with Hasmonean rulers and thus in the state. The background to his story about John Hyrcanus’ break with the Pharisaic party is that they were in his favor before this. In fact, Josephus calls John Hyrcanus a disciple of theirs; how long this ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("relationship had existed and whether it obtained in the time of his predecessors is not said. When Hyrcanus, convinced they had maligned him by telling him he should give up the high priesthood, changed to the side of the Sadducees, the Pharisees lost power and Jews were forbidden to practice their regulations. The dominance of the Sadducees with the Hasmonean rulers continued through the violent reign of Alexander Jannaeus, who apparently killed many Pharisees, but with his successor, his wife Salome Alexandra (76-67 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), the situation was reversed and the Pharisees regained a position of dominance. After this time the evidence becomes sketchy, and it is not apparent whether Pharisees continued to enjoy political as well as religious prominence.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Regarding their beliefs, Josephus mentions their moderate position on the issue of what he calls fate: they believed that both divine and individual human aspects were involved in human actions so that people had a measure of responsibility for what they did. According to him, they also anticipated a resurrection for the righteous and eternal punishment for the wicked. There is support for some of this description in Acts 23, where the Pharisees are identified as the members of the Sanhedrin who accept the belief that a resurrection would occur. It adds that they also believed there were angels and spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The next group in Josephus’ list, the Sadducees, he describes generally in contrast to the Pharisees. Their view of fate, for example, was not the moderate or balanced approach of the Pharisees: the Sadducees are supposed to have denied there was any thing such as fate that influenced human behavior, explaining rather that people are responsible for what they do. As noted above, the Sadducees rejected the validity of the tradition adopted by the Pharisees and insisted that the scriptural law alone was valid. It is difficult to imagine that the Sadducees had no tradition of how to interpret or apply scriptural law; whatever their way of interpreting may have been, it must have been different from the Pharisaic one. Acts 23:8 summarizes some of their theological disagreements with Pharisees in this way: “The Sadducees say that there is no resurrection, or angel, or spirit; but the Pharisees acknowledge all three.” In his appearance before the Sanhedrin, Paul, who identifies himself as a Pharisee, exploits the difference by appealing to the resurrection.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Josephus adds that, while the Pharisees were influential among the masses of the people, the Sadducees, whose number he does not estimate (although he says there were few of them), appealed to the wealthy. In the episode in which John Hyrcanus broke with the Pharisees, he is said to have gone over to the Sadducean side. As a result, the Sadducees were not dominant in the period before this time in his reign, but they retained their position of influence throughout the rest of Hyrcanus’ reign and apparently through that of Aristobulus I (104-103 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") and of Alexander Jannaeus (103-76), before the Pharisees returned to their previous status. Josephus presents, for later times, a strange situation: the few Sadducees were people of the highest rank, but when they assumed an office, they were compelled to follow the dictates of the Pharisees because the people otherwise would refuse to tolerate them ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.17). The point is related to the question whether the high priests — people who enjoyed the very highest rank — were Sadducees. The name Sadducee many be related to the Zadok, the leading priest in the time of David and Solomon, and an ancestor of the Second Temple high priests. John ")]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("Hyrcanus, a high priest, became a devotee of the Sadducees, and his sons Aristobulus I and John Hyrcanus may have been as well. But here the evidence grows very thin. In fact, the only other high priest who is identified as a Sadducee is Ananus ben Ananus who briefly held the office in 62 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Josephus says that Ananus, followed the Sadducean school and that Sadducees were noted for being harsher than others in judgment ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 20.199). A high priest is mentioned in connection with Sadducees in Acts 5:17, but he is not identified as a Sadducee.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Essenes, Josephus’ third group, are the one he describes at the greatest length ("), _c('em', [_vm._v("J.W.")]), _vm._v(" 2.119-61), perhaps because his source material was more complete or because their unusual character made them more interesting. He estimated there were some 4,000 of them throughout the land ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.21) and describes them as living a very disciplined form of life and gathered into communities of self-help and support. In their communities the members gave up their private property to the group so that the needs of all could be met. They avoided marriage, although there was a type of Essenes who did take wives and have children. They worked hard and were frugal in their ways; they were also known as the strictest in their keeping of the Sabbath. One of the topics regarding the Essenes that Josephus describes at some length is the process, several years in length, of admission into the group. He also notes their meetings and the rules that prevailed at them. Their view of fate, he reports, was that it determined everything — exactly the opposite of the view he attributes to the Sadducees; they also studied the writings of the ancients and were accurate predictors of events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholarly interest in the Essenes increased with the discovery and study of the Dead Sea Scrolls. Most experts have identified the group responsible for the scrolls at Qumran as a small band of Essenes, so the scrolls can now fill in the information from Josephus and elsewhere regarding the Essenes. It may be that Josephus’ comment about the Essenes’ view regarding fate is exemplified in 1QS 3:13–4:26, where the divine governance of the universe and human actions through two opposing spirits is the subject. The scrolls community also practiced a community of goods, and their entry procedures very much resemble the ones noted by Josephus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The scrolls probably allow us to see some of the controversies that separated the Essenes and the Pharisees. Several writers refer to their opponents as “the ones who look for smooth things,” probably a punning allusion to the Pharisees. These writers accuse them of taking a more relaxed approach to the Law of Moses and thus of violating the covenant. Some scrolls, especially the copies of 4QMMT, express some legal positions that are attributed to the Sadducees in rabbinic sources. This does not mean that the authors of the Scrolls were Sadducees, since they disagree with the Sadducees on basic theological points (e.g., fate); it probably means that both the Essenes and the Sadducees adopted conservative, stricter understandings of the Law.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("The community of the Dead Sea Scrolls illustrates the fact that the social makeup of early Judaism was more complex than our other sources suggested. Before they were discovered between 1947 and 1956, there was only a hint or two in the literature that such a group existed; there was no indication that it had a large library indicative of extensive study and much more. The scrolls reveal a community that had in protest separated itself physically from other Jews and that ")]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("apparently did not participate in worship at the Temple in Jerusalem. In the wilderness of Judea they pursued the way of life they thought was revealed in the Scriptures and looked to the day when, in a final war between the sons of light and the sons of darkness, the former would win a great victory and a new age would dawn.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These were not the only groups in the land of Israel in the later Second Temple period. Josephus also speaks of the Zealots as people who refused to accept human rule, although in other respects they agreed with the Pharisees ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.23). Josephus considered them and their violent ways instrumental in causing the revolt against Rome in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 18.6-10).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is no doubting that Jews in the land of Israel wrote a sizable literature in the centuries when the Second Temple stood, and a considerable amount of it has survived to the present in one form or another, that is, in whole or in part, in the original language or in translation. Rarely is there information about exactly when a book was written or who wrote it, but texts of a variety of literary genres were composed in the period. A number of those works are now incorporated into the Hebrew Bible, although it is not always certain which books date from the Second Temple era. There would be a large amount of agreement among experts about the following as coming from the postexilic age:")]), _vm._v(" "), _c('p', {
    staticClass: "p-t"
  }, [_vm._v("Final form of the Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("1-2 Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Ezra")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Nehemiah")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Esther")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Many of the psalms")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Ecclesiastes")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Daniel")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Third Isaiah (Isaiah 56–66)")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Joel")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Haggai")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Zechariah")]), _vm._v(" "), _c('p', {
    staticClass: "poem-p"
  }, [_vm._v("Malachi")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Perhaps there are other books or parts of books in the Hebrew Bible stemming from the years after the initial return from exile.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("In the later centuries of the period, Jews continued to write, and many of their compositions have survived to the present. One difficulty is that it is not always clear which books were written in Israel and which in the Diaspora. A possible indicator of location is language (if we happen to know the original language of the work): a book written in Hebrew or Aramaic is more likely to have been written in Judea (or Babylon) than in Egypt, while a work in Greek has a better chance of coming from Egypt or some other part of the Hellenistic world. But one should not ")]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("exclude the possibility that a Greek work comes from Israel. One other note should precede the survey of Jewish literature from Israel: in a sense Josephus, a prolific author whose works are invaluable for understanding early Judaism, is a writer from Israel. He spent the first thirty years or so of his life in Judea, where he was a prominent priest and occupied important positions. But the Judean Jew Josephus actually wrote his histories "), _c('em', [_vm._v("War")]), _vm._v(" and "), _c('em', [_vm._v("Antiquities")]), _vm._v(" and his "), _c('em', [_vm._v("Life")]), _vm._v(" and "), _c('em', [_vm._v("Against Apion")]), _vm._v(" while he was living in Rome after the end of the Jewish revolt in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" In that sense he is a Diaspora writer. He seems to have composed "), _c('em', [_vm._v("War")]), _vm._v(" in a Semitic language, but only the Greek version exists today.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is convenient to divide the books and other works that were probably written in Israel into different, rather general literary categories.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("History")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An important component of the Hebrew Scriptures is the set of histories that trace the great events of Israel’s sacred and not so sacred past (Genesis, Exodus, Numbers, Joshua, Judges, 1-2 Samuel, 1-2 Kings, 1-2 Chronicles, Ezra, Nehemiah). Writing in this vein continued in early Judaism. The most prominent example is 1 Maccabees. It is likely that the work was written in Hebrew. It presents a historical review of the period from Alexander the Great to the death of the Hasmonean Simon (from the late fourth century to 134 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("), but it covers the first centuries of this period in a few sentences and concentrates its attention on the approximately thirty years from about 175 to 134. The author is an advocate of the Hasmonean family, beginning with Mattathias, who sounded the call to revolt against the policies of Antiochus IV Epiphanes, and continuing with his sons Judas, Jonathan, and Simon, who led the nation in its struggle for the right to practice their traditional religion and to freedom from foreign rule. At first they led forces that were opposed to the suppression of ancestral religious practices and to the desecration of the Temple. After regaining the Temple Mount from Seleucid and renegade Jewish control, they purified the Temple and inaugurated the festival of Hanukkah to commemorate the event (it lasts eight days, beginning on 9/25). After Judas died in battle, leadership of the Hasmonean forces fell to Jonathan, who, in 152 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", was appointed the high priest. He held the office until his capture and death in 142, when his brother Simon assumed the leadership and the high priesthood. Simon was killed in 134, and the book ends with a notice about the reign of his son John Hyrcanus I. Despite its strong pro-Hasmonean bias, the book is a profoundly important history for the period covered. The author quotes official documents and offers a careful chronology of events. The book was written no later than 104 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" (the death of John Hyrcanus); it was translated into Greek and became a part of the Greek Bible (it is in Roman Catholic and Orthodox Bibles today but is considered apocryphal by Protestants and Jews).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("The other major histories of the period that are extant are Josephus’ "), _c('em', [_vm._v("War")]), _vm._v(" and "), _c('em', [_vm._v("Antiquities,")]), _vm._v(" although, as indicated above, they were not written in Judea. "), _c('em', [_vm._v("War")]), _vm._v(" is primarily an account of the First Jewish Revolt against Rome (66-70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") with a long prologue beginning just before Hasmonean times. "), _c('em', [_vm._v("Antiquities")]), _vm._v(" begins with the ")]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("scriptural stories (from the beginning of Genesis) and follows them to the end (Esther, Ezra-Nehemiah material) before continuing with events until Josephus’ own time. His coverage of large parts of the post-Hebrew Bible period is sketchy because of inadequate source material, but he offers extensive accounts from the Hasmonean period to the mid-first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and is often the only source of information about these times.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A number of narrative works that do not appear to be historical in intent express, often in highly entertaining ways, the theological and ethical views of the authors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Tobit may have been written in Israel, although it is not impossible that it comes from somewhere in the eastern Diaspora. The Aramaic work (copies of it have been found at Qumran [4Q196-199 in Aramaic, 4Q200 in Hebrew]) tells the parallel stories of two pious Jews whose lives had become tragedies, although they maintained their religious fidelity in dire circumstances, and who were delivered through the agency of the angel Raphael. The book commends pious deeds by Diaspora Jews such as almsgiving, care for fellow Jews, praise of God, prayer, and endogamy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Judith was written in Hebrew, although it is available only in a Greek translation. The author paints a confusing situation blending Babylonian, Persian, and perhaps other times, but its aim is to describe the deliverance God gave to his beleaguered people through the hand of a woman named Judith, whose extraordinary piety and remarkable bravery and cleverness brought about victory for the Jews in the land when the great general Holophernes and his massive army wished to destroy them. The book also presents an interesting example of a proselyte in the form of Achior the Ammonite.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Legal Texts")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("From early in the Second Temple period there is little evidence of legal literature in the sense of laws such as those in the Pentateuch. Those books may have reached their final form early in the period, but from the centuries that followed no such texts are attested until the literature found at Qumran. Among the scrolls are different sorts of works that deal with and expound the law of Moses; these are in addition to the numerous copies of the pentateuchal books found there. Examples are 4QMMT, which lists more than twenty legal points on which the group differs from those whom they address; and the "), _c('em', [_vm._v("Temple Scroll,")]), _vm._v(" which describes a grand future temple and all that will accompany it, such as the festivals, and represents and paraphrases a large part of the material in Exodus 25 through Deuteronomy. Additional texts, only fragmentarily preserved, deal with various aspects of the Law (e.g., ones that treat issues of purity and impurity [4Q274-279]; calendar texts [4Q317-330]). Other sorts of legal texts, ones that supply laws specifically for the group, are the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" and the "), _c('em', [_vm._v("Damascus Document,")]), _vm._v(" the latter of ")]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("which includes a lengthy halakic section. The legal texts from Qumran show that the kind of reflection that was later codified in the Mishnah and the Talmuds was at home in a much earlier time and was practiced by a group representing a very different point of view from the one found in the rabbinic works.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Wisdom Literature")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A major sapiential work, the Wisdom of Ben Sira, was written in Hebrew (more than half of which has been recovered) at some time in the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The lengthy book (51 chapters) stands in the tradition of Proverbs, offering wise teachings on a range of practical issues. It marks an additional step in the sapiential tradition by teaching that the place where wisdom is to be found is in the Law of Moses (see also Bar. 3:9–4:4) and that the essence of wise behavior is to fear God. Ben Sira also differs from earlier wisdom literature by surveying Israel’s history and the divine guidance in it. The Hebrew work was rendered into Greek by the author’s grandson, whose preface explains the situation, purpose, and time of the translation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A second example of a wisdom text is 4QInstruction, a work represented in several copies among the Dead Sea Scrolls (4Q415-418, 423; 1Q26). It offers prudent instructions to a younger person on familiar topics, but it also has characteristics which distinguish it from its predecessors in the wisdom tradition. One expression that appears a number of times is “the secret of what is/will be” — apparently meaning the secret teaching about the true character of the creation and of history. The work also incorporates eschatological teachings into a wisdom work.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Scriptural Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout early Judaism, interpretation of older scriptures was an important exercise. This is evident in the Hebrew Bible (e.g., Daniel 9) and outside it. Among the most interesting examples are a series of commentaries found at Qumran. These pesharim or interpretations offer comments on scriptural prophetic texts; they cite a passage and then explain it before proceeding to the next passage in the book (occasionally more than one book is involved). The best-preserved examples are the commentaries on Nahum (4Q169) and Habakkuk (1QpHab); altogether seventeen copies of pesharim have been identified (1QpHab; 1Q14-16; 4Q161-71, 173), treating Isaiah, Hosea, Micah, Nahum, Habakkuk, Zephaniah, and several Psalms. These lemmatized commentaries allow the reader to see how the Qumran community understood the ancient prophecies to be coming true in their own day; they also disclose some information about that time and important characters in their world. Other types of commentaries are not tied to particular texts but are more thematic and thus treat texts from various places in the scriptures. Among them are the "), _c('em', [_vm._v("Florilegium")]), _vm._v(" (4Q174) and the "), _c('em', [_vm._v("Melchizedek")]), _vm._v(" text (11Q13).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('em', [_vm._v("Scriptural interpretation")]), _vm._v(" may be the rubric under which to survey a set of works called by scholars Rewritten Bible or, better, Rewritten Scriptures. These texts take ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("the contents of an older scriptural work, in whole or in part, and represent them. At times the representation is so close to the original that the difference is practically negligible ("), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" from Qumran is an example), while in others there is a wide difference (such as in the "), _c('em', [_vm._v("Book of the Watchers")]), _vm._v(" ["), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 1–36]). The representation can accomplish several goals, such as clarifying obscure passages, adding to or subtracting from the older text in various ways to communicate the old message in a new form. Familiar examples that fall into this broad and diverse category are parts of "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" the "), _c('em', [_vm._v("Aramaic Levi Document,")]), _vm._v(" the "), _c('em', [_vm._v("Genesis Apocryphon,")]), _vm._v(" the "), _c('em', [_vm._v("Book of Jubilees,")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll. 1 Enoch")]), _vm._v(" 1–36 (the "), _c('em', [_vm._v("Book of the Watchers")]), _vm._v(") in part treats passages about Enoch and the immediate pre-flood period in Genesis 5–6 but expands considerably through an elaborate story of angels who descend, marry women, and have gigantic children whose misdeeds, with the illicit teachings of the angels, cause the flood. Enoch is presented as a mediator between God and the sinful angels and also as a traveling companion of angels on a tour of the world. The "), _c('em', [_vm._v("Aramaic Levi Document")]), _vm._v(" takes the rather problematic scriptural character Levi and greatly exalts him as a divinely appointed priest, the ancestor of a priesthood, and the recipient of revelations. The Aramaic "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" offers stories from the early chapters of Genesis until chap. 15 (where the manuscript breaks off). The book of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" more closely adheres to its scriptural base as it retells the stories from Genesis 1 to Exodus 24, all of which was revealed to Moses on Mt. Sinai. It packages them in its theologically eloquent chronology of fifty jubilee units and emphasizes the one, frequently renewed covenant between God and the chosen line, the importance of separating from the nations, the need to keep the Sabbath properly, and the significance of following the correct calendar of 364 days in a year. The "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" is a rewriting of the remaining parts of the Pentateuch (beginning with Exodus 24), while the "), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" is at times classified as scriptural and at times as Reworked Scripture.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Also within the area of scriptural interpretation are targums, Aramaic translations and interpretations of the Hebrew Scriptures. Although the major targums "), _c('em', [_vm._v("(Onqelos")]), _vm._v(" and "), _c('em', [_vm._v("Jonathan)")]), _vm._v(" date from much later times, the presence of Aramaic renderings of Job (4Q157; 11Q10) and apparently Leviticus (4Q156) at Qumran illustrate that this type of exercise has ancient roots.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Apocalypses")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Several works give an account of revelatory experiences given to exemplary leaders; the revelations to them disclose information about the future and the heavenly world. Among the apocalypses, perhaps the oldest is the Enochic "), _c('em', [_vm._v("Apocalypse of Weeks")]), _vm._v(" ("), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 93:1-10; 91:11-17), which divides all of history and the future judgments into ten “weeks” (long units of time). Other early instances are the various revelations in Daniel 7–12, which “predict” the attacks on Jews and Judaism by Antiochus IV as the climax of evil and distress before the deliverance of the people of God. The "), _c('em', [_vm._v("Animal Apocalypse")]), _vm._v(" ("), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 83–90) may come from nearly the same time. It surveys scriptural history, symbolizing almost all characters as various kinds of animals, and pictures a new age after the final woes caused by the nations ")]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("that rule Israel and the judgment on the sinners. A number of other works fit in this category: the "), _c('em', [_vm._v("Similitudes of Enoch")]), _vm._v(" ("), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 37–71), the "), _c('em', [_vm._v("Testament of Moses, 4 Ezra,")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch.")]), _vm._v(" The first two of these may have been written around the turn of the eras, while the latter two offer apocalyptic reflection upon the destruction of Jerusalem and the Temple. In some of the apocalypses a messianic leader plays a role in the final drama (e.g., "), _c('em', [_vm._v("Animal Apocalypse, Similitudes of Enoch, 4 Ezra, 2 Baruch")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is generally agreed that there was no canon of Scripture until perhaps the very end of the Second Temple period, but it is evident that there were ancient writings that exercised considerable influence and were acknowledged to contain God’s words. Those books would have included Genesis through Deuteronomy and the prophetic works and Psalms and probably more, but it is not possible, given the evidence at hand, to decide exactly which books were considered authoritative and by whom.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Poetic and Liturgical Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Psalms incorporated into the Hebrew Psalter served various functions in Temple worship and presumably in other settings as well, but these 150 poems hardly comprise the totality of poetic writing in the period. Again, the Qumran texts have offered abundant examples of such compositions. The "), _c('em', [_vm._v("Hodayot")]), _vm._v(" or "), _c('em', [_vm._v("Thanksgiving Hymns")]), _vm._v(" are sectarian poetic compositions which celebrate the greatness of God and his goodness to those whom he has chosen and other teachings of the group (such as divine predestination of events). Another set of poems has been labeled "), _c('em', [_vm._v("Noncanonical Psalms")]), _vm._v(" (4Q380-381). Among the scrolls are also texts that contain prayers for certain occasions (daily [4Q503] and festival [4Q507-509] prayers) and blessings for each day (4Q504-506; see also the "), _c('em', [_vm._v("Berakhot")]), _vm._v(" or "), _c('em', [_vm._v("Blessings")]), _vm._v(" texts, 4Q286-290). Considerable interest attaches to the "), _c('em', [_vm._v("Songs of the Sabbath Sacrifice")]), _vm._v(" (4Q400-407; 11Q17), which describes the heavenly worship on the first thirteen Sabbaths of a year and assumes a unity between the angelic worship offered in the celestial sanctuary and the worship offered by humans on earth. Poetry of a different nature is found in the "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" a first-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" work that, among other topics, speaks bitterly about the Hasmonean rulers and about Pompey, the Roman general who took Jerusalem in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" "), _c('em', [_vm._v("Psalms of Solomon")]), _vm._v(" 17 and 18 also offer some important statements about a Davidic messiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Other texts were written, but the above survey should suffice to give an idea of the range of Judean literature written in the period of early Judaism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Commonalities")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The surviving evidence exhibits a richness and diversity in Judaism of the Second Temple era, a diversity so great that some have resorted to the neologism “Judaisms” to express it. Yet, despite the undoubted diversity present in the texts, there are fundamental beliefs and practices that would have been accepted by virtually all Jews during those centuries and that justify retaining the singular noun Judaism.")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('strong', [_c('em', [_vm._v("Monotheism")])])])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("There were some Jews who rejected this doctrine, but the data, both Jewish and foreign, indicate that belief in one God was a defining characteristic of Judaism. Jews confessed that God was one and that he was the creator and sustainer of all, and non-Jews recognized monotheism as a trait that made Jews different from most others. In obedience to the second commandment, Jews made no representation of the God they worshiped, and in this regard, too, they were distinctive. The Temple in Jerusalem was unusual in that it contained no visible representation of the deity; he was thought to be enthroned upon the Ark of the Covenant between the cherubim, but there was no object representing him.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Covenant")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The one God had entered into a covenant with Abraham, the ancestor of the Jews and, later, with his descendants, the people of Israel. The covenant remained valid and binding; it not only defined a relationship between YHWH and his people but also took the concrete form of stipulating the way of life that the descendants of Abraham were to follow in order to remain in covenantal fellowship with him. The most specific form of that definition was the Law of Moses, which therefore had to be obeyed and interpreted as new situations arose. Among the laws that regulated the covenantal behavior of Jewish people, several stood out as particularly important and known to non-Jews: an aniconic worship of the one God and rejection of all other deities and idols associated with them, Sabbath observance, circumcision, food laws, festivals, and separation from others because of the theological danger of intermarriage and impurity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The history of the covenantal relationship that obtained between God and Israel took on special importance as evidence of divine election and guidance and as a source of lessons to be learned about the consequences of obedience or disobedience. Covenant violation was regarded as the root cause for catastrophes such as the destruction of Jerusalem and the Temple; the wise could learn from such instances and act accordingly. Amid disaster, Jews entertained hopes for a restoration of grander times; one such hope was for a messianic leader from David’s line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With the loss of the center — Jerusalem and the Temple — in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and carnage and loss throughout the land, an era in Jewish history ended and a new one began. Of necessity, the leadership of the nation changed, with no Jewish political leader and no class of priests in influential positions, but so rich was the heritage of Judaism that other aspects of it came to the fore as it moved into the age of the Tannaim and their work. Even the brutal Roman quashing of the Bar Kokhba Revolt (132-135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("), another disaster for the land and its populace, did not prevent the Jewish people from surviving, from continuing to believe in the one God, and from adhering to the covenant and the way of life entailed in it.")])]), _c('p', {
    staticClass: "bib-head"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Ådna, Achim. 1999. "), _c('em', [_vm._v("Jerusalemer Tempel und Tempelmarkt im 1. Jahrhundert n. Chr.")]), _vm._v(" Wiesbaden: Harrassowitz.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charlesworth, James H., ed. 1983-1985. "), _c('em', [_vm._v("The Old Testament Pseudepigrapha.")]), _vm._v(" 2 vols. Garden City, N.Y.: Doubleday.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Collins, John J. 1998. "), _c('em', [_vm._v("The Apocalyptic Imagination: An Introduction to Jewish Apocalyptic Literature.")]), _vm._v(" 2d ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Falk, Daniel K. 1998. "), _c('em', [_vm._v("Daily, Sabbath, and Festival Prayers in the Dead Sea Scrolls.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Grabbe, Lester L. 1992. "), _c('em', [_vm._v("Judaism from Cyrus to Hadrian.")]), _vm._v(" 2 vols. Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2000. "), _c('em', [_vm._v("Judaic Religion in the Second Temple Period: Belief and Practice from the Exile to Yavneh.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hengel, Martin. 1974. "), _c('em', [_vm._v("Judaism and Hellenism.")]), _vm._v(" 2 vols. London: SCM.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kugel, James L. 1998. "), _c('em', [_vm._v("Traditions of the Bible: A Guide to the Bible As It Was at the Start of the Common Era.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Levine, Lee I. 2002. "), _c('em', [_vm._v("Jerusalem: Portrait of the City in the Second Temple Period (538 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])]), _vm._v("–"), _c('em', [_vm._v("70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(").")]), _vm._v(" Philadelphia: Jewish Publication Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mantel, Hugo. 1961. "), _c('em', [_vm._v("Studies in the History of the Sanhedrin.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mendels, Doron. 1987. "), _c('em', [_vm._v("The Land of Israel as a Political Concept in Hasmonean Literature.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Murphy, Frederick J. 2002. "), _c('em', [_vm._v("Early Judaism: The Exile to the Time of Jesus.")]), _vm._v(" Peabody, Mass.: Hendrickson.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nickelsburg, George W. E. 2005. "), _c('em', [_vm._v("Jewish Literature between the Bible and the Mishnah.")]), _vm._v(" 2d ed. Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rajak, Tessa. 2002. "), _c('em', [_vm._v("Josephus: The Historian and His Society.")]), _vm._v(" 2d ed. London: Duckworth.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Richardson, Peter. 1996. "), _c('em', [_vm._v("Herod: King of the Jews and Friend of the Romans.")]), _vm._v(" Columbia: University of South Carolina Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rubenstein, Jeffrey L. 1995. "), _c('em', [_vm._v("The History of Sukkot in the Second Temple and Rabbinic Periods.")]), _vm._v(" Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Safrai, Shmuel. 1965. "), _c('em', [_vm._v("Pilgrimage at the Time of the Second Temple.")]), _vm._v(" Tel-Aviv: Am Hassefer (in Hebrew).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sanders, E. P. 1992. "), _c('em', [_vm._v("Judaism: Practice and Belief 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v("–"), _c('em', [_vm._v("66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")])]), _vm._v(". London: SCM; Philadelphia: Trinity Press International.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schiffman, Lawrence H. 1991. "), _c('em', [_vm._v("From Text to Tradition: A History of Judaism in Second Temple and Rabbinic Times.")]), _vm._v(" New York: KTAV.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1998. "), _c('em', [_vm._v("Texts and Traditions: A Source Reader for the Study of Second Temple and Rabbinic Judaism.")]), _vm._v(" New York: KTAV.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schürer, Emil. 1973-1987. "), _c('em', [_vm._v("The History of the Jewish People in the Age of Jesus Christ.")]), _vm._v(" Rev. and ed. G. Vermes, F. Millar, and M. Goodman. 3 vols. Edinburgh: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Segal, Judah Benzion. 1963. "), _c('em', [_vm._v("The Hebrew Passover from the Earliest Times to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 70.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sievers, Joseph. 1990. "), _c('em', [_vm._v("The Hasmoneans and Their Supporters: From Mattathias to the Death of John Hyrcanus I.")]), _vm._v(" Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stone, Michal, ed. 1984. "), _c('em', [_vm._v("Jewish Writings of the Second Temple Period: Apocrypha, Pseudepigrapha, Qumran Sectarian Writings, Philo, Josephus.")]), _vm._v(" Assen: Van Gorcum; Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ulfgard, Håkan. 1998. "), _c('em', [_vm._v("The Story of Sukkot: The Setting, Shaping, and Sequel of the Biblical Feast of Tabernacles.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("VanderKam, James C. 2001. "), _c('em', [_vm._v("An Introduction to Early Judaism.")]), _vm._v(" Grand Rapids: Eerdmans.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("———. 2004. "), _c('em', [_vm._v("From Joshua to Caiaphas: High Priests after the Exile.")]), _vm._v(" Minneapolis: Fortress.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("VanderKam, James C., and Peter W. Flint. 2002. "), _c('em', [_vm._v("The Meaning of the Dead Sea Scrolls: Their Significance for Understanding the Bible, Judaism, Jesus, and Christianity.")]), _vm._v(" San Francisco: HarperSanFrancisco.")])])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('em', [_vm._v("Judaism in the Diaspora")])])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RICH")]), _vm._v(" S. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUEN")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A Roman army destroyed the Temple in Jerusalem in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" For the Jews of antiquity the loss of the Temple not only constituted a devastating blow but signaled an enduring trauma. The reverberations of that event still resonate. The day of the Temple’s destruction, which, by a quirk of fate or (more probably) fabrication, coincides with that on which Jerusalem fell to the Babylonians six and a half centuries earlier, continues to receive annual commemoration in Israel. For many it shaped the consciousness of the Jewish Diaspora through the centuries to follow. The eradication of the center that had given meaning and definition to the nation’s identity obliged Jews to alter their sights, accommodate to a displaced existence, and rethink their own heritage in the context of alien surroundings.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Extent of the Jewish Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The focus on the consequences of the Temple’s destruction, however, overlooks a fact of immense significance: the Jewish Diaspora had a long history prior to Rome’s crushing of Jerusalem. Indeed, the notion of removal from the homeland is lodged deeply in the mythology of the nation. The curse of Cain, condemned to perpetual wandering over the earth, symbolizes it. So do the years of enslavement and oppression in Egypt prior to the exodus, followed by years of meandering in the wilderness. And that was just the beginning. The record of Jewish experience included the “Babylonian captivity” in the sixth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", ostensibly a serious dislocation from the homeland. The story may contain exaggeration and embellishment but does not deliver pure fiction. And, whatever the historicity of the “Return” from that displacement, the Diaspora was already a fact, not to be reversed. Jews dwelled in Egypt in the sixth century, as papyri from a Jewish military colony at Elephantine reveal. And an archive of documents from Babylon attests to Jews in a variety of trades and professions even after their supposed restoration to Judah.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("The pace quickened, however, and the scattering multiplied from the late ")]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The conquests of Alexander the Great sent Greeks into the Near East in substantial numbers. The collapse of the Persian Empire prompted a wave of migration and relocation. New communities sprang up, old ones were repopulated or expanded. Mobility increased, and a host of settlements beckoned to the restless and the adventurous. As Greeks found the prospects abroad enticing, so also did the Jews. A burgeoning Jewish Diaspora, it appears, followed in the wake of the Greek Diaspora.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Precise numbers elude us. But they were clearly substantial. By the late second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", the author of 1 Maccabees could claim that Jews had found their way not only to Egypt, Syria, Mesopotamia, and the Iranian plateau, but to the cities and principalities of Asia Minor, to the islands of the Aegean, to Greece itself, to Crete, Cyprus, and Cyrene. We know further of Jewish communities in Italy, including large settlements in Rome and Ostia. The Greek geographer Strabo, writing at the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" (and he had no axe to grind on the subject), remarked that there was hardly a place in the world that did not possess members of this tribe and feel their weight. And all of this occurred well before the demolition of the Temple. Even without explicit figures we may be confident that Jews abroad far outnumbered those dwelling in Palestine — and had done so for many generations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The fact needs to be underscored. Diaspora life in the Second Temple period was no aberration, not a marginal, exceptional, temporary, or fleeting part of Jewish experience. In important ways it constituted the most characteristic ingredient of that experience. The Temple stood in Jerusalem. Yet the vast majority of Jews dwelled elsewhere. The physical and emotional world of the Jews cannot be grasped without placing the Diaspora under scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What motivated the mass migration? Some of it, to be sure, was involuntary and unwelcome. Many of those who found themselves abroad had come as captives, prisoners of war, and slaves. Conflicts between the Egyptian and Syrian kingdoms in the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" caused periodic dislocation. Internal upheavals in Palestine in the following century created some political refugees and forced settlements. Roman intervention in the Near East temporarily accelerated the process. Pompey’s victories in Judea in 63 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", followed by battles on Palestinian soil over the next three decades, brought an unspecified number of Jews to Italy as human booty, the victims of conquest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Compulsory displacement, however, cannot have accounted for more than a fraction of the Diaspora. A host of reasons could motivate Jews to migrate voluntarily. Overpopulation in Palestine may have been a factor for some, indebtedness for others. But more than hardship was involved here. The new and expanded communities that sprang up in consequence of Alexander’s acquisitions served as magnets for migration. In a mobile society, a range of options presented themselves. Large numbers of Jews found employment as mercenaries, military colonists, or enlisted men in the regular forces of Hellenic cities or kingdoms. Others seized opportunities in business, commerce, or agriculture. All lands were open to them.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('strong', [_vm._v("The Jewish Conception of Diaspora")])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("How did Jews conceptualize the Diaspora? What sort of self-perception shaped the thinking of those who dwelled in Antioch, Alexandria, Rome, Cyrene, Ephesus, or anywhere outside Judea? The biblical reverberations of the scattering of Israel possessed a decidedly somber character, a dark cloud cast upon Jews whose memories of the homeland grew ever dimmer. The book of Leviticus had declared that divine retaliation for their sins would disperse Israelites among the nations. The anger of YHWH, so one reads in Deuteronomy, would pursue them in foreign lands where they would worship false gods and idols. Jeremiah’s pronouncements reinforced the message: the Israelites who turn their backs on YHWH will live as slaves of alien lords in alien parts, scattered among strange peoples where they will endure God’s punishment until their destruction. And Daniel warns that failure to heed divine commandments will provoke God to order the dispersal of Israel. Diaspora thus appears to emblematize enforced expulsion from the homeland, a condemnation for wickedness, with sinners languishing abroad in distant parts under the oppressive sway of hostile strangers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet dire biblical forecasts may bear little relevance to Diaspora life in the Hellenistic and Roman periods. Historical reality stands in the way. Can one plausibly conceive of Jews living abroad in countless numbers over many generations mired in misery and longing for the land of their forefathers? The scenario is preposterous. A sense of displacement did not dominate Jewish consciousness in communities strewn around the Mediterranean. It is noteworthy that Jews seem to have felt no need to fashion a theory of Diaspora. Those who inhabited a world of Greek culture and Roman power did not wrestle with or agonize over the fact of dispersal. It was an integral part of their existence and a central element of their identity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The very term “Diaspora” is a Greek one. It rarely appears as a noun in Hellenistic Jewish authors. And it nowhere serves as a translation of "), _c('em', [_vm._v("galut")]), _vm._v(" or "), _c('em', [_vm._v("golah")]), _vm._v(" with the connotation of “exile.” In fact, the authors of the Septuagint normally rendered such terms as “colony” or a version of “colony.” In normal Greek usage the word carried no negative overtones and, in fact, Hellenic colonies generally developed fully independent existences. The founding of Jerusalem is ascribed to Moses by a Greek author who labels it a “colony” and gives it a positive meaning. Jews evidently picked up this phraseology from the Gentiles. Philo alludes to the Hebrews led out of Egypt by Moses as a “colony.” And movement in the other direction receives the same designation: the Jews of Palestine sent out colonies to places all over the Mediterranean and the Near East. The migration generated a sense of pride, not an embarrassment or a lament. Jewish intellectuals did not fill their writings with complaints about being cut off from the center and confined to a truncated, isolated, and subservient existence. One hears no agonizing rationalizations, justifications, or apologias for Diaspora. That itself is telling.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Just how the Jews did feel about their circumstances abroad escapes direct notice. Indirect evidence has to suffice. And generalizations that encompass the Mediterranean world would be hazardous, if not downright misleading. The experience of Jewish communities in Asia Minor may have little bearing on that of the Jews in Babylon or Cyrene or Rome. The very notion of “Diaspora Judaism” ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("suggests a uniformity that is unlikely to have existed. Circumstances differed and reactions varied. It would be an error to imagine that Jews everywhere faced a choice of either maintaining tenacious adherence to a segregated existence or assimilating fully to an alien culture. There was much room in between, and Jews doubtless ranged themselves on all parts of the spectrum. Each individual area struck its balance differently and constructed its own peculiar mixture. It was rarely a conscious or calculated process.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Synagogues in the Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But common ground did exist. Substantial evidence attests to the near ubiquity of synagogues. The term itself, "), _c('em', [_vm._v("synagōg")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v(",")]), _vm._v(" may not always have been applied. Other designations like "), _c('em', [_vm._v("proseuch")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _vm._v(" (prayer house) or "), _c('em', [_vm._v("hieron")]), _vm._v(" (holy place) also appear. And the reference may be to a gathering or an assemblage rather than to a building. No model or pattern held throughout. A diversity of functions, physical characteristics, and institutional structures preclude any notion of uniformity. But impressive and widespread testimony demonstrates that the synagogue (in whatever form) could serve as a means to promote communal activity among Jews and advance a sense of collective identity. The evidence comes from literary texts, inscriptions, papyri, and archaeological finds that disclose outlines of the structures themselves. The bulk of it dates to the period after destruction of the Temple. But ample attestation in the Second Temple era shows the broad geographical range of the synagogue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A sanctuary at Elephantine in Upper Egypt served a Jewish military colony as early as the sixth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" That may have been exceptional, but it signals the natural inclination of Jews, wherever they were, to find a medium for expressing common interests. By the mid-third century, inscriptions reveal synagogues (termed "), _c('em', [_vm._v("proseuchai")]), _vm._v(") in Middle Egypt, dedicated by Jews in honor of the Ptolemies, the ruling family of the land. Royal favor extended to the Jewish "), _c('em', [_vm._v("proseuchai,")]), _vm._v(" even to the extent of granting the formal status of places of asylum, commonly accorded to pagan temples, a notable mark of official approval. A plethora of synagogues stood in Alexandria, noted by literary sources and epigraphic texts. The latter provide the standard formulas whereby the dedicators establish their "), _c('em', [_vm._v("proseuch")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _vm._v(" on behalf of Ptolemy and his household. Egyptian Jews were fully comfortable in hailing the Gentile rulers while simultaneously dedicating their synagogues to the “Most High God.” No tension or inconsistency troubled the two concepts. Jewish synagogues were a familiar part of the Egyptian landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jews also settled in Cyrenaica in significant numbers. Synagogues clearly sprang up. One inscription honors donors whose gifts helped to repair the synagogue in a Cyrenaic town. That a graphic declaration of gratitude to benefactors should be put on public display, in addition to the structure itself, which they hoped to refurbish, demonstrates that Jews took open pride in the maintenance of their own institutions and in announcing that maintenance to any interested party in the larger community.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Jews were to be found all over Asia Minor. The travels of Paul and his colleagues brought them regularly to Jewish synagogues of that region. And Roman ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("pronouncements, collected through the documentary researches of Josephus, guaranteed the rights of Jews to construct and assemble in synagogues.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The institution surfaces quite strikingly in Greek cities on the north and east coasts of the Black Sea. A remarkable group of documents from the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" records the emancipation of slaves by Jews in the synagogues of those cities and provides for the continued association of the freedmen with the Jewish community, which took responsibility for their guardianship — a clear sign of collective solidarity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Numerous other examples can illustrate the geographic spread of the synagogue. Paul’s journeys, for example, took him to synagogues in various cities of Macedon and Greece. An actual structure, almost certainly a synagogue, emerged from excavations at the island of Delos in the Aegean. That a Jewish community settled in that holy site, the legendary birthplace of Apollo, dramatically attests to the comfort of Jews and their own institutions even in a key center of pagan religion. Jews indeed went as far from the homeland as Italy to establish thriving communities. The presence of Jews in Rome is well attested not only by literary texts but by funerary epitaphs from the Jewish catacombs that convey the names of at least eleven synagogues in the city. And archaeologists have unearthed the remains of a synagogue in Ostia, the principal harbor of Rome, situated near the bank of the Tiber. Here, as often elsewhere, the finds disclose characteristic Jewish features like an apsidal structure for Torah scrolls and images like the menorah, lulav, shofar, and ethrog, thus making the identification clear. Jewish synagogues of the Second Temple period stretched from the Black Sea to North Africa, and from Syria to Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The synagogue supplied a vehicle for a wide range of activities that promoted the shared interests of Jews. These included study and instruction; discussion of the Scriptures, traditions, law, and moral teachings; prayers, rituals, and worship; communal dining, celebration of festivals, and commemoration of key events in Jewish history; adjudication of disputes, passage of decrees, meetings of members; maintenance of sacred monies, votive offerings, dedicatory inscriptions, and archives of the community. To be sure, not all synagogues performed all these functions. Local circumstances doubtless dictated numerous divergences. But the spectrum of services was broad. And they did not occur in hidden enclaves. Synagogues stood in public view; congregations had their own officialdom, leaders, and representatives; Gentiles frequently remarked about Sabbath services; inscriptions announced decisions of the membership; and the letters and decrees of Roman spokesmen gave public sanction to Jewish practices, most of which took place in the synagogue. The impressive testimony demonstrates the existence of thriving and vigorous Jewish communities, self-assured in the exhibition of their traditions and their special character.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Jews’ Participation in Social and Political Life")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("Explicit testimony on how Jews led their lives in the scattered cities of the Diaspora is hard to come by. But most of the fragmentary indications, clues, and indirect ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("signs suggest circumstances in which they could both partake of the social and cultural environment and maintain a separate identity. These were not mutually exclusive alternatives.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One might note, for example, the gymnasium, that most Hellenic of institutions. The gymnasium was a conspicuous feature of Greek education, at least for the elite, in communities throughout the Mediterranean. It catered to the corps of ephebes, the select youth of upper-echelon families, the training ground for generations of Hellenic leadership in the urban centers of Greek migration. That institution would appear to be the last place available to Jews. Yet unmistakable traces of their participation in gymnasia do exist. Ephebic lists include Jews in places as different as Alexandria in Egypt, Cyrene in North Africa, Sardis in western Asia Minor, Iasos in southwestern Asia Minor, and Korone in southern Greece. So even the preeminent bastion of Hellenism, the gymnasium, was, at least in several sites, open to Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The fullest information on Jewish life abroad (and it is very skimpy) comes from Egypt, where the papyri allow us to peer selectively into some corners of social and economic experience. The evidence, reinforced by some literary and epigraphic testimonia, shows that Jews served in the Ptolemaic armies and police forces, reached officer rank, and received land grants. Inscriptions in Aramaic and Greek from Alexandrian cemeteries disclose Jews, evidently mercenary soldiers, buried alongside Greeks from all parts of the Hellenic world. Jews had access to various levels of the administration as tax-farmers and tax-collectors, as bankers and granary officials. They took part in commerce, shipping, finance, farming, and every form of occupation. And they could even reach posts of prestige and importance. Juridically, the Jews, like other Greek-speaking immigrants to Egypt, were reckoned among the “Hellenes” — not singled out for prejudicial discrimination.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The nature of Jewish civic status remains obscure and controversial. The Jews did have an established place in Alexandria by the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Strabo, who had no Jewish agenda, reports that the Jews had a large portion of the city allotted to them, and had their own official, an ethnarch, to govern them, decide disputes, and oversee contracts and decrees. He plainly implies that Jews governed their own internal affairs but also took part in a larger Alexandrian entity to which they owed allegiance. Other evidence shows that they lived in all parts of the city, not restricted to a ghettoized existence. They could label themselves “Alexandrians,” a term that carried more than geographic designation. The Roman emperor Augustus, in fact, referred to them on a bronze stele as “citizens of the Alexandrians.” Whatever that means, it signals an acknowledged role in the political process of the city, a feature independently attested by Philo, who notes that Alexandrian Jews “shared in political rights.” Although we lack precise data, Jews clearly had some claim on civic prerogatives, just as they had on the social and economic life of the city.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("Elsewhere, the political status of Jews receives only occasional mention. At Herakleopolis in Egypt, recent papyrological finds reveal the existence of a Jewish "), _c('em', [_vm._v("politeuma,")]), _vm._v(" a self-governing body that could, among other things, adjudicate cases involving both Jews and non-Jews. A comparable "), _c('em', [_vm._v("politeuma")]), _vm._v(" existed in Cyrenaica, and we possess evidence indicating that Jews could serve in the governing body of ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("the larger Cyrenaic community as well. Citizen privileges of some sort also belonged to the Jews of Antioch, as they did for those in Sardis and the Ionian cities of Asia Minor. Moreover, Jews were eligible for Roman citizenship, well outside the city of Rome. Paul, a Jew from Tarsus and a Roman citizen, is only the most celebrated example. Just what prerogatives this involved and how far they were exercised remain controversial. But no barriers, it appears, excluded Jews from becoming full-fledged beneficiaries of Roman power.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Jews’ Participation in Cultural and Intellectual Life")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One can go further. Jews had access even to cultural life in the upper echelons of Hellenistic society. Jewish authors were well versed in most, perhaps all, forms of Hellenic writings. Those conversant with the conventions included epic poets like Theodotus and Philo, tragic dramatists like Ezekiel, writers of history like Demetrius and Eupolemus, philosophers like Aristobulus, composers of novellas and historical fiction like the authors of the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" 3 Maccabees, and "), _c('em', [_vm._v("Joseph and Aseneth,")]), _vm._v(" and those who engaged in cosmology and mythography like Pseudo-Eupolemus, and the authors of the "), _c('em', [_vm._v("Sibylline Oracles.")]), _vm._v(" The capacity to produce such works demonstrates that the writers could partake of higher education and engage deeply with Hellenic cultural traditions. They were themselves an integral part of the intelligentsia. Most of the names known to us come from Alexandria. But, as we have seen, gymnasium education was available to Jews elsewhere and doubtless spawned writers whose reputations do not survive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jewish writers clearly showed a wide familiarity with the genres, forms, and styles of Greek literature. They wrote in Greek and they adapted Greek literary modes. But they employed those conventions to their own ends. Jewish intellectuals may have embraced Hellenic canons of literature, but they had no interest in recounting the tale of Troy, the labors of Herakles, the house of Atreus, or the Greco-Persian wars, let alone the myths of the Olympian gods. Their heroes were Abraham, Joseph, and Moses. They appropriated Hellenism to the goals of rewriting biblical narratives, recasting the traditions of their forefathers, reinvigorating their ancient legends, and shaping the distinctive identity of Jews within the larger world of Hellenic culture. The challenge for the Jews was not how to surmount barriers, cross boundaries, or assimilate to an alien society. In a world where Hellenic culture held an ascendant position, they strove to present Judaic traditions and express their own self-definition through the media of the Greeks — and even to make those media their own.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("A particularly striking example can illuminate the point. Tragic drama is perhaps the quintessential Greek medium. This did not render it off limits to the Jews. The Alexandrian writer Ezekiel, working within the tradition of classical tragedy, produced a play, the "), _c('em', [_vm._v("Exagōg")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v(",")]), _vm._v(" based on the story of Moses leading the Israelites out of Egypt. Ezekiel hewed closely to the narrative line contained in the book of Exodus, while employing the conventions of the Greek theater. But he inserted some creativity of his own. This included a remarkable scene in which Moses recounts a dream vision of God sitting on a throne, summoning Moses to him, ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("handing over his diadem and scepter, and departing. The dramatist here not only exalts the grandeur of Moses but reconceives Moses’ relationship with God. The celestial realm appears as analogous to royal governance on earth. Moses’ ascension to the throne and acquisition of kingly emblems signal his appointment as YHWH’s surrogate in governing the affairs of men. This had clear resonance to the contemporaries of Ezekiel. Moses’ role as executor of God’s will on earth, with absolute authority, reflected royal rule in the Hellenistic realms. The author thus reinvents the position of Moses on the model of Hellenistic kingship while making him the precursor of Hellenistic kingship itself. Moses as supreme judge would expound the Law for all nations. The Israelite hero becomes a beacon for humankind, a representative of the divinity, described in phraseology that struck responsive chords among Ezekiel’s Hellenic or Hellenized compatriots. The tragic poet had effectively commandeered a preeminent Greek genre and deployed it as a source of esteem for his Jewish readership.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another celebrated composition illustrates both the intersection of Jew and Gentile in the Diaspora and the emphasis on the special qualities of the Jews. The "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" was drafted by a Hellenized Jew from Alexandria, probably in the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" It purports to recount the events that led to the translation of the Hebrew Bible into Greek. That undertaking came about in Alexandria around the middle of the third century, an episode of the highest importance for Diaspora Jewry. The need for a Greek Bible itself holds critical significance. It indicates that many Jews dwelling in the scattered communities of the Mediterranean had lost their mastery of Hebrew but nonetheless clung to the centerpiece of their tradition. If they were to read the Bible, it would have to be in Greek. The initial rendering or renderings eventually congealed into what became known as the Septuagint. For the vast majority of Jews living in the Greco-Roman period, it "), _c('em', [_vm._v("was")]), _vm._v(" the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" ascribes the translation’s origin to the initiative of the court of Ptolemy II, ruler of Egypt in the mid-third century. As the narrative has it, the impetus came from the chief librarian in Alexandria, who persuaded King Ptolemy to authorize the addition of “the laws of the Jews,” evidently the Pentateuch, to the shelves of the great library. This required translation, for the available Hebrew texts were carelessly and improperly drawn up. Ptolemy composed a letter to the high priest in Jerusalem, requesting translators. The high priest graciously complied and selected seventy-two Jewish scholars, six from each tribe, experts in both languages, to do the job. The Jewish sages reached Alexandria, where they were warmly welcomed, Ptolemy himself paying homage to the sacred scrolls that they had conveyed from Jerusalem. Indeed, he went beyond that to organize a seven-day banquet (serving kosher food!), during which the king put a different question to each of his seventy-two guests, largely concerning the appropriate means of governing wisely, and found reason to praise every one of them for his sagacity. The translators then repaired to the island of Pharos, where they went to work, periodically comparing drafts, agreed upon a common version, and completed their task in precisely seventy-two days. The priests and leaders of the Jewish community in Alexandria pronounced it a definitive version, not a line of it to be altered. Ptolemy joined them in admiration, paid reverence to the new Bible, and lavished gifts upon the Jewish scholars.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Such is the gist of the tale. None can doubt that it issued from the pen of a Jewish author cloaked in the garb of a learned official at the court of Ptolemy II. The particulars, of course, are largely, if not entirely, fictitious. But the author’s creation holds high significance. The "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" offers a showcase for the familiarity of Jewish intellectuals with diverse features and forms of Greek learning from ethnographic excursuses to textual exegesis and allegorical interpretation. The author is plainly steeped in Hellenic literature. On the face of it, this treatise would seem to be the most telling attestation of a cultural convergence between Judaism and Hellenism — at least as viewed from the Jewish side. The Hellenistic monarch promotes the project, and the Jewish scholars carry it out. The translators act at the behest of the king to enhance the pagan library, while the king pays deep homage to the sacred books of Israel. The pseudonymous narrator, Aristeas, even declares to Ptolemy that the Jews revere God, overseer and creator of all, who is worshipped by everyone, including the Greeks, except that they give him a different name, Zeus.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet cross-cultural harmony and blending do not tell the whole story. Another dimension carries equal importance. The "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" while fully conversant with Hellenic literary genres, adapted that knowledge to advertise the advantages of Jewish tradition. The distinctiveness of the Jews is never in question. The god to whom all bear witness, even though the Greeks may call him Zeus, is the Jewish god. The high priest happily sends Jewish scholars to Alexandria to render the Bible into Greek, but he reminds the Greeks of the superiority of the Jewish faith, ridiculing those who worship idols of wood and stone fashioned by themselves. He insists that Mosaic Law insulated the Hebrews from outside influences, erecting firm barriers to prevent the infiltration of tainted institutions. And the high priest observes that the Jews offer sacrifice to God to insure the peace and renown of the Ptolemaic kingdom — a neat reversal of the patron-client relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One can go further. The seven-day symposium may have been a fundamentally Hellenic practice, but the Jewish sages answered every query by the king with swift and pithy answers, adding a reference to God in each response, and earning the admiration not only of Ptolemy and his courtiers but of all the Greek philosophers in attendance, who acknowledged their inferiority to the sagacity of the guests. Ptolemy applauds and commends every answer by a Jew, no matter how commonplace and banal. The king hardly emerges as discerning or discriminating. The "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" to be sure, portrays Ptolemy as a wise, gentle, and generous ruler, a man of deep cultivation and learning. But the author carries his portrait somewhat beyond the sober and the plausible. He makes Ptolemy deferential to a fault. The king bows no fewer than seven times to the Hebrew scrolls upon their arrival in Alexandria, even bursts into tears at the sight of them, and then proclaims that the date of their arrival would henceforth be celebrated as an annual festival. The author extends this form of caricature to the Greek philosophers as well, turning them into awestruck witnesses of the superiority of Jewish learning. In short, the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" that quintessential text of harmony and collaboration between Jew and Gentile in a Diaspora setting, simultaneously underscores the distinctive character — and the precedence — of Jewish values.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("The very idea of rendering the Hebrew Bible into Greek has profound ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("significance for the Diaspora. The historicity of the tale in the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" is a secondary issue. Ptolemy II may or may not have had a hand in its creation. His reputation for learning made him a logical figure to whom a later writer could ascribe such an initiative. The need of Jews abroad to comprehend the holy books and laws of their tradition in the language that was now their own played a greater role. And, more fundamentally, the work of translation represents a signal instance of Jewish pride and self-esteem. It signified that the Jews had a legitimate claim on a place in the prevailing culture of the Mediterranean. Their Scriptures did not belong to an isolated and marginal group. They contained the record and principles of a people whose roots went back to distant antiquity but who maintained their prestige and authority in a contemporary society — and in a contemporary language. That may be the clearest sign that the Jews perceived themselves as an integral part of the Hellenistic cultural world.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Maintaining Jewish Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jewish comfort and familiarity with the Hellenistic world in no way entailed abandonment or compromise of their distinctive identity. Terms like “assimilation” and “accommodation” deliver misleading impressions that are best avoided, suggesting that the Jews needed to transform themselves in order to fit into an alien environment. On the contrary, they unabashedly called attention to their own characteristic features.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The issue of endogamy, for instance, recurs in Second Temple literature. The book of Tobit, among other things, exhorts those dwelling in the Diaspora to adhere to the teachings of their fathers, to hold their coreligionists to the highest ideals, and to reinforce the solidarity of the clan. The work enjoins Jews in the lands of the Gentiles to maintain their special identity through strict endogamy, a theme that runs throughout the tale, thus assuring survival of the tribe. The author of Tobit may indeed take the point too far, deliberately so, with a touch of irony. He has almost every character in the narrative, even husbands and wives, greet one another as brother and sister, with numbing repetition. This is endogamy with a vengeance, perhaps a parody of the practice — but also testimony to the practice. The author himself is evidently not partial to clannishness. He has Tobit’s deathbed speech offer a broader vision in which Jerusalem will eventually encompass Jew and Gentile alike, attracting all the nations of the world to its light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The matter of endogamy surfaces prominently also in the Jewish novella, "), _c('em', [_vm._v("Joseph and Aseneth,")]), _vm._v(" a grandiose elaboration on the brief scriptural notice of Joseph’s marriage to the daughter of an Egyptian priest. The romantic story underscores in no uncertain terms Joseph’s unbending resistance to marriage outside the clan, relenting only when Aseneth abandons all her heresies, smashes her idols, and seeks forgiveness through abject prayers to the god of Joseph. The author here too, by exaggerating Joseph’s priggishness and Aseneth’s debasement, may suggest the disadvantages of taking endogamy to extremes. But the importance of the practice as highlighting Jewish particularity is plain.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("Jews seem quite uninhibited in displaying in the Diaspora traits peculiar to ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("their ancestral traditions. One need only think of those practices remarked upon most often by Greek and Roman authors: observance of the Sabbath, dietary laws, and circumcision. The institution of the Sabbath frequently drew comment, generally amused comment. Pagan writers found it quite incomprehensible that Jews refused to fight on the Sabbath — thus causing Jerusalem to fall on three different occasions. And even if the prohibition did not cause disaster, it seemed a colossal waste of time: why did Jews waste one-seventh of their lives in idleness? Comparable mirth directed itself against the abstention from eating pork. Even Emperor Augustus, in reference to the notorious intrigues and murders that took place in the household of Herod, famously observed that “it’s better to be Herod’s pig than his son.” That quip implies that the Jewish dietary restriction was well known among the Romans. Satirists indeed had a field day with it. Petronius, author of the "), _c('em', [_vm._v("Satyricon,")]), _vm._v(" concluded that, if Jews don’t touch pork, they must worship a piggod. And Juvenal characterized Judea as a place where a long-standing indulgence permits pigs to reach a ripe old age. As for circumcision, it provided much grist for the jokesters’ mill. Philo reports that circumcision called forth considerable ridicule from non-Jews. Among the instances of this was Juvenal’s claim that Jews are so exclusive that they would not even give directions in the street to anyone who was not circumcised. None of this amounts, as has often been thought, to “anti-Semitism.” It represents mockery rather than animosity. But it demonstrates that Diaspora Jews had no qualms (and no fears) about practicing their conventional customs, thereby denoting their differences from Gentiles.")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, what struck pagan writers most was not Jewish assimilation but Jewish separateness. That emerges in Juvenal’s quip noted above. It recurs also in a comment by his contemporary, the historian Tacitus, who claimed that Jews took up circumcision precisely in order to express their distinctiveness from all other people. The impression of Jewish separatism appears, in fact, as early as the first extant Greek writer to take note of the Jews, Hecataeus of Abdera, a historian of the late fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Hecataeus, in an account generally favorable to Jews, indicates that they tended to keep to themselves and shun the company of others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The uncommon character of their customs both provided bonds among Diaspora Jews everywhere and announced their differences from other peoples. The surviving evidence underscores this again and again. The collection of an annual tax to be sent to the Temple from Jewish communities throughout the Mediterranean exemplifies it. So does the regular celebration of festivals that mark major milestones in the history of the nation. The Jews of Egypt kept the Passover at least as early as the fifth century, as the Aramaic papyri from Elephantine attest. Scattered testimony reveals observance of Shavuot, Sukkot, and Yom Kippur in Jewish communities outside Palestine, conspicuous links to ancient tradition. Later feasts have strong Diaspora connections. The Purim festival began in the Persian period, according to the book of Esther, and was celebrated annually by the Jews of Persia. A comparable anniversary occurred in Alexandria to celebrate a Jewish triumph, according to the narrative of 3 Maccabees. And the Jews of Jerusalem invited their compatriots in Egypt to commemorate the purification of the Temple in their own Diaspora location.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("As noted earlier, the structures in which Jews of the Diaspora met often carried ")]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("the designation of "), _c('em', [_vm._v("proseuchai")]), _vm._v(" or prayer houses. That term applies regularly to Jewish meeting places in Egypt but also in the Bosporan region, in Delos, in Halicarnassus, and doubtless in other communities where the evidence fails us. The implication seems clear enough: such gatherings included prayers, acts of worship of some sort that gave voice to the particular Jewish relationship with the divinity. Such places of assemblage, whether called "), _c('em', [_vm._v("proseuch")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _vm._v(" or "), _c('em', [_vm._v("synagōg")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v(",")]), _vm._v(" served also as a site for collective Torah study and for other instructional activity that reinforced the continued commitment to Jewish tradition.")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Philo, the learned Alexandrian Jew, places particular emphasis upon this aspect of synagogue activity, noting that the laws were read out to weekly meetings on the Sabbath. Priests or elders, according to Philo, took responsibility for reading and commenting on the sacred laws, even keeping the congregation at it for hours, and providing them with great impetus toward piety. In Philo’s portrayal, perhaps somewhat shaped by his own philosophic proclivities, congregants sit in their synagogues, read their sacred books, and discuss at length the particulars of their ancestral philosophy. He reckons the synagogue as a Jewish replica of a philosophical academy. The presentation may be slightly skewed but surely not far off the mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Acts portrays Paul repeatedly entering Jewish synagogues in various cities of the Diaspora, in Thessalonica, Athens, Corinth, and Ephesus, and arguing with Jews about the meaning of the Scriptures. Close attention to holy writ obviously remained central to Jewish activity outside Palestine — and to Jewish self-perception. The vitality of the Torah was undiminished. The stimulus for translation into Greek suffices to establish that. And, as Philo reports, the completion of the project receives annual celebration on the island of Pharos, where the translators allegedly worked, a strong signal of Jewish pride in the heritage that marked them out from others.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("The tenacious adherence to signature principles occurred perhaps most obviously in the Jewish insistence upon rejecting idolatry. The affirmation did not consist, strictly speaking, in pitting monotheism against polytheism. Jewish intellectuals recognized that Greek philosophic thinking often expressed itself in terms of a supreme deity or a single divine principle. What Jews resisted unequivocally was the worship of deities in the form of images. Such practice they reckoned as profaning the spiritual essence of God. The stance, of course, derives from the biblical commandment against graven images, and the struggle against idolaters fills the pages of the Torah and the Deuteronomistic history. The principle retained its power in the Second Temple. As we have seen, even the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" a prime document for accord between the Jewish and Hellenic worlds, draws the line firmly at idolatry, denouncing in harshest terms those who fashion their own gods in wood or stone and thus fundamentally misconceive the nature of divinity. Aseneth’s acceptance of Joseph’s god could come only when she pulverized every idol in the household. And the assault on idolatry gains voice also in the "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" composed by Jews who emphasized the failings and offenses of Gentiles. The incorporeal character of God represented an unshakable principle. Jewish aniconism was conspicuous and widely acknowledged by non-Jews. Some found it peculiar and puzzling, even akin to atheism. Others admired it. The Roman ")]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("historian Tacitus held up the Jewish practice as a worthy contrast with animal worship indulged in by Egyptians and with emperor worship, which Tacitus deplored. Indeed the most learned of Romans, the great scholar Varro, in the late first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", praised the imageless conception of the deity, likening it to ancient Roman custom as genuine piety before the Romans began to set up images and adulterate their creed. But whether questioning or admiring, pagan references to Jewish aniconism make clear that perseverance in this principle that set Jews apart from their neighbors received widespread notice. They erected no façade of assimilation.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Gentile Attraction to Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The insistence on distinctiveness, however, did not entail a closed society. Indeed the accessibility of Judaism to the outsider, a striking feature often overlooked, merits attention. A considerable number of non-Jews found Judaism enticing. We can no longer recover the reasons, and they doubtless varied from place to pace, and person to person. Some may have been attracted by its great longevity, by the ethical precepts, by the rigorous adherence to the Law, by the discipline demanded in its practices, by the social bonding of the synagogues, by the celebration of its festivals, or by the reputation not only for Eastern wisdom but for skills in both the practical and the occult sciences. We can only speculate on the motives. But the fact of Gentiles entering into Jewish society in some fashion is incontrovertible. This did not require conversion — nor necessarily an abandonment of previous identity and associations. It might take the form of imitating the Jewish way of life up to a point, like observing the Sabbath, or adopting certain codes of behavior, or taking part in synagogue activities, or providing material support for the Jewish community. The Jews did not turn such people away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We hear of several non-Jews who held Judaism in high esteem and showed genuine interest in it. The Gospel of Luke mentions a Roman centurion at Capernaum as one who loved Jews and had built them a synagogue. According to Philo, the Roman prefect of Syria had gained familiarity with Jewish philosophy and piety. Josephus indicates in several contexts the attraction of eminent women to Judaism, including even the wife of the emperor Nero. Gentile reverence for Jewish laws and mores appears with some frequency in Josephus’ works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Indeed, if Josephus is to be believed, pagans everywhere included observers of the Sabbath, people who adopted Jewish dietary practices, or those who attempted to imitate the Jews in their internal concord, their philanthropy, their skill in the crafts, and their adherence to the Law even under duress. Philo makes a similar claim, asserting that almost all people, especially those who place a premium upon virtue, pay homage to Jewish laws. The Jewish authors, to be sure, are hardly unbiased witnesses. But their statements, however exaggerated and embroidered, do not arise out of the void.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Non-Jewish sources supply corroboration. The Roman satirist Juvenal, writing in the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", refers in sardonic fashion to the appeal that Jewish practices have in Rome. He alludes to fathers who revere the Sabbath and ")]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("follow Jewish dietary restrictions. Their sons then go further: they worship a deity of the sky, draw no distinction between consuming swine’s flesh and cannibalism, and even engage in circumcision. A very different text, the Christian book of Revelation, composed about the same time, denounces those who falsely claim to be Jews but are not so. This may refer to Gentiles who have adopted Jewish behavior and institutions — without becoming Jews.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such persons seem even to have a name. “God-fearers” serves as the conventional designation (even if not technical terminology) for Gentiles seriously drawn to an association with Judaism or the Jewish community. The Acts of the Apostles contain several references to “those who fear God” or “those who revere God,” denoting Gentiles who were closely and sympathetically involved with the Jewish community and who lived in accord with at least some of its precepts. The terminology has a parallel in Josephus, who attributes the wealth of the Temple to contributions both from Jews and from “those who worship God” all over the world. Closely comparable phrases appear in inscriptions of somewhat later periods from a wide variety of regions ranging from Italy to the Black Sea. Gentiles in substantial numbers participated in some fashion (doubtless in diverse fashions) in Jewish synagogues and communities — and they were clearly welcomed.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Relations with the Homeland")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An important question remains. How did Diaspora Jews relate to the homeland? Did the land of Israel beckon to those dwelling in distant places, a prime objective of the displaced, the principal means of realizing the destiny of the people for whom the “Return” represented the fulfillment of Yahweh’s promise? Or had the Jews instead assimilated to life abroad, finding gratification in the concept that their identity resided in the “Book,” not in any territorial legitimation. For such Jews, restoration to the homeland was irrelevant and superfluous; the land of their residence rather than the home of the fathers constituted the cardinal attachment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The dichotomy misleads and deceives. The whole idea of valuing homeland over Diaspora or Diaspora over homeland is off the mark. Second Temple Jews need not have faced so stark a choice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Bible, of course, has YHWH promise eventually to return the children of Israel from the most remote regions to the land of their fathers. And similar comments recur in Jewish Hellenistic writers who deplore the dispersal and forecast the ingathering of the exiles, as in the book of Tobit, the "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" and "), _c('em', [_vm._v("Jubilees.")]), _vm._v(" But in each instance the termination of exile and the return to the homeland are connected to the reconstruction of the Temple. As a symbol of the faith, its demolition at the hands of Babylon had caused heartbreak and longing. But a comparable condition did not hold in the Hellenistic Diaspora. The Temple stood again in Jerusalem. And few Jews abroad were held there by constraint.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The generally satisfactory circumstances of the Diaspora defused any widespread passion for the “Return.” Jews, as we have seen, generally formed stable communities at places quite distant from Judea, entered into the social, economic, and political life of the nations they joined, and aspired to and obtained ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("civic privileges in the cities of the Hellenistic world. Josephus maintains that Jews have every right to call themselves Alexandrians, Antiochenes, or Ephesians. And Philo refers to his home as “our Alexandria.” An inscription from the Phrygian city of Acmonia, set up by a Jew or group of Jews, alludes to the fulfillment of a vow made to the “whole "), _c('em', [_vm._v("patris.")]), _vm._v("” This records a conspicuous and public pronouncement of local loyalty. Philo confirms the sentiment in striking fashion: Jews consider the holy city as their “metropolis,” but the states in which they were born and raised and which they acquired from their fathers, grandfathers, and distant forefathers they adjudge to be their "), _c('em', [_vm._v("patrides.")]), _vm._v(" That fervent expression denies any idea of the “doctrine of return.” Diaspora Jews, in Philo’s formulation at least, held a fierce attachment to the adopted lands of their ancestors.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("None of this, however, diminished the sanctity and centrality of Jerusalem in the Jewish consciousness. The city’s aura retained a powerful hold on Jews, wherever they happened to reside. Even the pagan geographer Strabo observed the Jews’ devotion to their sacred “acropolis.” Numerous other texts characterize Palestine as the “Holy Land.” That designation appears in works as different as 2 Maccabees, the Wisdom of Solomon, the "), _c('em', [_vm._v("Testament of Job,")]), _vm._v(" the "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" and Philo. Most, if not all, of those texts stem from the Diaspora. They underscore the reverence with which Jews around the Mediterranean continued to regard Jerusalem and the land of their fathers. But the authors who speak with reverence do not demand the “Return.” Commitment to one’s local or regional community was entirely compatible with devotion to Jerusalem. The two concepts in no way represented mutually exclusive alternatives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What meaning, then, did the notion of a homeland have for Jews dwelling in scattered Mediterranean communities? They never yielded the principle. Jewish attitudes here, as in many other regards, corresponded with those of their pagan neighbors. Loyalty to one’s native land represented a frequent sentiment in the rhetoric of the Hellenistic world. Philo more than once endorses the idea that adherence to one’s native land held singular power. He puts failure to worship God on a level with neglecting to honor parents, benefactors, and native land. It does not follow, however, that Diaspora Jews set their hearts upon a return to the fatherland. Broad pronouncements about love of one’s country accord with general Hellenistic expressions. They do not require that those native environs be reinhabited for life to be complete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerusalem as concept and reality remained a powerful emblem of Jewish identity — not supplanted by the Book or disavowed by those who dwelled afar. It appears again and again in the texts of Second Temple authors as a symbol of the highest appeal. Yet this tenacious devotion did not entail a widespread desire to pull up stakes and return to the fatherland.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Jews reminded themselves and others every year of their commitment to Jerusalem. The reminder came in the form of a tithe paid to the Temple annually by Jews all over the Mediterranean. The ritualistic offering carried deep significance as a bonding device. That fact is vividly illustrated by an episode in the mid 60s "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" A Roman governor of the province of Asia (essentially northwestern Asia Minor) banned the sending of gold by the Jews of the region to Jerusalem. This was part of a broader Roman policy and did not apply to Jews alone. But the solidarity ")]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("of Jewish reaction was impressive. Word got back in great haste to the Jewish community in Rome. Demonstrations mobilized and strong pressure mounted on the Roman government by Jews in the city expressing concern in unequivocal terms for their compatriots abroad. The event underscores the importance of Jewish commitment to provide funds annually to the Temple from Italy and from all the provinces of the Roman Empire. Clearly the plight of Asian Jews who were prevented from making their contributions had powerful resonance among fellow Jews far off in Rome. The latter expressed their sentiments in no uncertain terms. Jerusalem and the Temple remained emblematic of their common purpose across the Mediterranean.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("References to the gravity of the tithe abound. Josephus proudly observes that the donations came from Jews all over Asia and Europe, indeed from everywhere in the world, for countless years. When local authorities interfered with that activity, Jews would send up a howl to Rome — and usually get satisfaction. Areas beyond the reach of Roman power also tithed consistently. Jewish communities in Babylon and other satrapies under Parthian dominion sent representatives every year over difficult terrain and dangerous highways to deposit their contributions in the Temple. The value of paying homage to Jerusalem was undiminished. That annual act of obeisance constituted a repeated display of affection and allegiance, visible evidence of the unbroken attachment of the Diaspora to the center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The remittance, however, did not imply that Jews viewed the Diaspora as no more than a temporary exile to be terminated by an ingathering in Jerusalem. Indeed, it implied the reverse. The yearly contribution proclaimed that the Diaspora could endure indefinitely — and quite satisfactorily. The communities abroad had successfully entrenched themselves; they were now mainstays of the center. Their fierce commitment to the tithe did not signify a desire for the “Return.” It rendered the Return unnecessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A comparable institution reinforces that inference: the pilgrimage of Diaspora Jews to Jerusalem. Major festivals could attract them with some frequency and in substantial numbers. According to Philo, myriads came from countless cities for every feast, over land and sea, from all points of the compass, to enjoy the Temple as a serene refuge from the hurly-burly of everyday life abroad. Josephus informs us that the women’s court at the Temple was large enough to accommodate those who resided in the land and those who arrived from abroad — a clear sign that numerous female pilgrims came with some regularity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Holy City was a compelling magnet. But the demonstration of devotion did not entail a desire for migration. Pilgrimage, in fact, by its very nature, signified a temporary payment of respect. Jerusalem possessed an irresistible claim on the emotions of Diaspora Jews, forming a critical part of their identity. But home was elsewhere.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("The self-perception of Second Temple Jews projected a tight solidarity between center and Diaspora. Images of exile and separation did not haunt them. What affected the dwellers in Jerusalem affected Jews everywhere. The theme of intertwined experience and identity recurs with impressive frequency and variety in Second Temple literature. The two letters affixed to the beginning of 2 Maccabees illustrate the point. The Jews of Jerusalem take for granted the intimate ")]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("relationship that exists with their brethren in Egypt. The preamble of the first letter greets them as “brothers” to “brothers” and alludes to their common heritage: God’s covenant with Abraham, Isaac, and Jacob. And the concluding lines of the second letter make reference to the desired reunion of all Jews in the holy site. The latter delivers a summons to Egyptian Jews to attend the newly instituted festival, thus to celebrate the purification of the Temple, a reaffirmation of the solidarity among Jews everywhere. It reflects the practice of pilgrimage, not a program to dissolve the Diaspora.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" makes an equally forceful statement about the connection between Jerusalemites and other Jews. King Ptolemy’s missive to the high priest in Judea asserts that his motive in having the Hebrew Bible rendered into Greek is to benefit not only the Jews of Egypt but all Jews throughout the world, including those yet unborn. One may legitimately question whether the king ever made such a statement. But the Jewish author of the "), _c('em', [_vm._v("Letter")]), _vm._v(" conceived or conveyed it. And that is the point. At the conclusion of the work, when the scholars from Jerusalem complete their translation and have it read out to the Jews of Egypt, the large assembly bursts into applause, a dramatic expression of the unity of purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Historical events reinforce the evidence of literary creations. As we have seen, the demonstrations of Roman Jews on behalf of their compatriots in Asia whose contributions to the Temple were in jeopardy reveal a strong sense of Jewish fellowship across the Mediterranean. Another, very different, episode adds conformation. At the height of the Roman civil war, Julius Caesar found himself besieged in Alexandria in 48/47 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" A troop of three thousand Jewish soldiers marched to his rescue. But Egyptian Jews who dwelled at Leontopolis, site of a long-standing Jewish enclave, blocked their path. The stalemate, however, was swiftly broken. The Jewish commander overcame the resistance of the Leontopolitans by appealing to their common nationality and their common loyalty to the high priest in Jerusalem. No further persuasion proved necessary. The Jews of both Leontopolis and Memphis declared themselves for Caesar and helped to turn the tide of war. The connection between Judea and Diaspora held firm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A similar conclusion derives from quite a different occasion. The death of Herod the Great in 4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" prompted a major discussion in Rome on the future of the regime. Fifty envoys came to Rome from Judea urging Emperor Augustus to put an end to the rule of the Herodian family. And 8,000 Jews resident in Rome, so we are told, joined their fellow Jews in this lobbying effort. A network of connections across the Mediterranean made it possible. And the interests coincided. When a pretender to the throne of Herod emerged, claiming to be a reincarnation of one of Herod’s sons, he found widespread support from Jews in Crete, in Melos, and in Rome itself. The network was extensive. Such events provide a revealing window upon the lively interest and occasionally energetic engagement of Diaspora Jews in the affairs of Palestine.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("The affiliations emerge most dramatically in the grave crises that marked the reign of the emperor Caligula (37-41 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). Bitter conflict erupted in Alexandria, bringing harsh sufferings upon the Jews of that city. And a still worse menace loomed over Jerusalem when the eccentric and unpredictable Roman emperor proposed to have a statue for pagan worship installed in the Temple. When ")]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("Alexandrian Jews were attacked, says Philo (a contemporary of the events), the word spread like wildfire. Reports swept not only through all the districts of Egypt but from there to the nations of the East and from the borders of Libya to the lands of the West. Philo’s claims of such speedy communications may stretch a point, but the concept of tight interrelationships among Jews of the Diaspora is plain and potent. With regard to news of Caligula’s decision to erect a statue in the Temple, Philo’s description is telling: the most grievous calamity fell unexpectedly and brought peril not to one part of the Jewish people but to the entire nation at once. The disaster was averted, thanks in part to a letter of the Jewish prince Agrippa I, a friend of the emperor and recent recipient of a kingdom among the Jews. Agrippa urgently alerted Caligula to the gravity of the situation. He made it clear that an affront to Jerusalem would have vast repercussions: the Holy City was not merely the metropolis of Judea but of most nations in the world since Jewish colonies thrived all over the Near East, Asia Minor, Greece, Macedon, Africa, and the lands beyond the Euphrates. The image of Jerusalem binding together Jews everywhere in the world remained central in the self-perception of the Diaspora.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A moving passage elsewhere in Philo encapsulates this theme. Although he thrived in the Diaspora, enjoyed its advantages, and broadcast its virtues, Philo nevertheless found even deeper meaning in the land of Israel. He interprets the Shavuot festival as a celebration of the Jews’ possession of their own land, a heritage now of long standing, and a means whereby they could cease their wandering. Philo saw no inconsistency or contradiction. Diaspora Jews might find fulfillment and reward in their communities abroad. But they honored Judea as a refuge for those who were once displaced and unsettled — and the prime legacy of all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Josephus makes the point in a quite different context but with equal force. In his rewriting of Numbers he places a sweeping prognostication in the mouth of the Midianite priest Balaam. The priest projects a glorious future for the Israelites: they will not only occupy and hold forever the land of Canaan, a chief signal of God’s favor, but their multitudes will fill all the world, islands, and continents, outnumbering even the stars in the heavens. That is a notable declaration. Palestine, as ever, merits a special place. But the Diaspora, far from being a source of shame to be overcome, represents a resplendent achievement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The respect and awe one paid to the Holy Land stood in full harmony with a commitment to the local community and allegiance to Gentile governance. Diaspora Jews did not bewail their fate and pine away for the homeland. Nor, by contrast, did they shrug off the homeland and reckon the Book as surrogate for the Temple. Palestine mattered, and it mattered in a territorial sense — but not as a required residence. Gifts to the Temple and pilgrimages to Jerusalem announced simultaneously one’s devotion to the symbolic heart of Judaism and a singular pride in the accomplishments of the Diaspora.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("None of this, of course, suggests that the experience of Jews in the Diaspora was everywhere and always untroubled, serene, and harmonious. Outbursts of violence and turbulence occasionally shattered their existence. Most notoriously, tensions among Greeks, Egyptians, and Jews in Alexandria, exacerbated by insensitive Roman overlordship, resulted in a bloody assault on Jews in 38 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" A quarter century later, the outbreak of Jewish rebellion against Roman rule in Palestine also ")]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("had reverberations in the Diaspora. The Jews of Alexandria were victimized by a riot in 66 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and, when they retaliated, encountered fierce Roman reprisals administered by Tiberius Julius Alexander, himself a Jew now in Roman service. The temple at Leontopolis in Egypt, which had stood for more than two centuries, also suffered destruction in that upheaval. A still wider Diaspora rebellion occurred in 116 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", involving Jews in Cyrene, Egypt, Cyprus, and possibly Mesopotamia. What caused these uprisings remains unknown. But the Roman crackdown, ordered by the emperor Trajan, was harsh, terminating the existence of many Jewish communities in these regions.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Episodes of this sort cause little surprise in the circumstances of rivalries and tensions in multiethnic societies. What is noteworthy, however, is their remarkable rarity. Given that our sources dwell on violence and upheaval when they can, the relative absence of such turmoil in our evidence is particularly significant. Even in Egypt, over a period of four centuries, the outbreak of hostilities is very much the exception rather than the norm. Elsewhere in the Diaspora, in Italy, mainland Greece, Asia Minor, and Babylon, no serious disquiet stands on record — and Jewish communities continued to thrive.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Applebaum, Shim"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʾ")]), _vm._v("on. 1979. "), _c('em', [_vm._v("Jews and Greeks in Ancient Cyrene.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. 1996. "), _c('em', [_vm._v("Jews in the Mediterranean Diaspora.")]), _vm._v(" Edinburgh: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———, ed. 2004. "), _c('em', [_vm._v("Negotiating Diaspora: Jewish Strategies in the Roman Empire.")]), _vm._v(" London: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bartlett, John R. 2002. "), _c('em', [_vm._v("Jews in the Hellenistic and Roman Cities.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cappelletti, Silvia. 2006. "), _c('em', [_vm._v("The Jewish Community of Rome from the Second Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" to the Third Century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cohen, Shaye J. D., and Ernest S. Frerichs, eds. 1993. "), _c('em', [_vm._v("Diasporas in Antiquity.")]), _vm._v(" Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Collins, John J. 2000. "), _c('em', [_vm._v("Between Athens and Jerusalem: Jewish Identity in the Hellenistic Diaspora.")]), _vm._v(" 2d ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jewish Cult and Hellenistic Culture.")]), _vm._v(" JSJSup 100. Leiden: Brill, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feldman, Louis H. 1993. "), _c('em', [_vm._v("Jew and Gentile in the Ancient World.")]), _vm._v(" Princeton: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gafni, Isaiah M. 1997. "), _c('em', [_vm._v("Land, Center, and Diaspora.")]), _vm._v(" Sheffield: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodman, Martin, ed. 1998. "), _c('em', [_vm._v("Jews in a Graeco-Roman World.")]), _vm._v(" Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Grabbe, Lester L. 2000. "), _c('em', [_vm._v("Judaic Religion in the Second Temple Period: Belief and Practice from the Exile to Yavneh.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gruen, Erich S. 2002. "), _c('em', [_vm._v("Diaspora: Jews amidst Greeks and Romans.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1998. "), _c('em', [_vm._v("Heritage and Hellenism: The Reinvention of Jewish Tradition.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hachlili, Rachel. 1998. "), _c('em', [_vm._v("Ancient Jewish Art and Archaeology in the Diaspora.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Honigman, Sylvie. 2003. "), _c('em', [_vm._v("The Septuagint and Homeric Scholarship in Alexandria.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Horbury, William, and David Noy. 1992. "), _c('em', [_vm._v("Jewish Inscriptions of Graeco-Roman Egypt.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kasher, Aryeh. 1985. "), _c('em', [_vm._v("The Jews in Hellenistic and Roman Egypt: The Struggle for Equal Rights.")]), _vm._v(" Tübingen: Mohr-Siebeck.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("Levine, Lee I. 2000. "), _c('em', [_vm._v("The Ancient Synagogue.")]), _vm._v(" New Haven: Yale University Press.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Linder, Amon, ed. 1987. "), _c('em', [_vm._v("The Jews in Roman Imperial Legislation.")]), _vm._v(" Detroit: Wayne State University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Modrzejewski, Joseph M. 1995. "), _c('em', [_vm._v("The Jews of Egypt from Ramses II to the Emperor Hadrian.")]), _vm._v(" Philadelphia: Jewish Publication Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Overman, J. Andrew, A. Thomas Kraabel, and Robert S. MacLennan, eds. 1992. "), _c('em', [_vm._v("Diaspora Jews and Judaism.")]), _vm._v(" Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pucci Ben Zeev, Miriam. 1998. "), _c('em', [_vm._v("Jewish Rights in the Roman World: The Greek and Roman Documents Quoted by Josephus Flavius.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2005. "), _c('em', [_vm._v("Diaspora Judaism in Turmoil, 116/117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")])]), _vm._v(". Leuven: Peeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rajak, Tessa. 2001. "), _c('em', [_vm._v("The Jewish Dialogue with Greece and Rome: Studies in Cultural and Social Interaction.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2009. "), _c('em', [_vm._v("Translation and Survival: The Greek Bible of the Ancient Jewish Diaspora.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rutgers, Leonard V. 1995. "), _c('em', [_vm._v("The Jews in Late Ancient Rome.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Smallwood, E. Mary. 1976. "), _c('em', [_vm._v("The Jews under Roman Rule.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tcherikover, Victor. 1961. "), _c('em', [_vm._v("Hellenistic Civilization and the Jews.")]), _vm._v(" Trans. S. Applebaum. Philadelphia: Jewish Publication Society of America.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Trebilco, Paul R. 1991. "), _c('em', [_vm._v("Jewish Communities in Asia Minor.")]), _vm._v(" Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Williams, Margaret H. 1998. "), _c('em', [_vm._v("The Jews among the Greeks and Romans: A Diaspora Sourcebook.")]), _vm._v(" London: Duckworth.")])])])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('em', [_vm._v("The Jewish Scriptures: Texts, Versions, Canons")])])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UGENE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LRICH")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The texts that eventually came to constitute the canonical books of the Hebrew Bible or Old Testament display a pattern of developmental growth in their composition. Like a cross-section of a tree with multiple rings, they show repeated stages of new growth from their beginnings, which are usually lost in the darkness of history, continually until the end of the Second Temple period. This developmental growth did not cease until some time after the destruction of the Temple in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", when it halted rather abruptly.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Composition of the Scriptural Texts")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("The popular imagination, formed as early as rabbinic times, envisioned a few holy men (e.g., Moses, Samuel, Isaiah, Daniel) as the authors of the books that bear their names, similar to classical or modern authors who individually compose and publish books under their own name. Prior to the Enlightenment, however, several attentive readers began to raise suspicions about those views of authorship, and buoyed by the Enlightenment, questions concerning authorship gained momentum, resulting in sustained, critical analysis of the literary character of the biblical books. The overwhelming conclusion of this international and interconfessional scholarship was that the books of the biblical anthology were composed in stages. Small units of what usually began as oral material — stories, laws, songs, proverbs — were gathered into larger, growing literary complexes. Earlier source materials were brought together into a unified work by an anonymous person who is usually labeled an editor or redactor. Tradents and scribes passed on the traditions, faithfully retaining the earlier message, and at times creatively adapting them to address newer concerns that affected the successive communities. Textual critics detected further minor developments within the major stages of the compositions, noting additions to, losses from, and errors in the text of each book after it had been composed and as it continued to be recited or copied from generation to generation. ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("Thus the Scriptures were seen to be composed over the course of approximately a millennium, from source materials in the premonarchic and monarchic periods to within a generation or so of the fall of the Second Temple in 70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No manuscript evidence survives from the early centuries to provide clear details for a reconstruction of the history of Israel’s religious and cultural literature. The scholarship described above was theoretical, based not on manuscripts but on literary clues embedded within the works themselves. But the general results of that vast modern library of theoretical scholarship have now been solidly confirmed by abundant documentary evidence provided by the biblical manuscripts from Qumran.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus there are two distinct periods in the history of the biblical text: a formative period of developmental growth and pluriformity until the time of the Jewish revolts against Rome, eclipsed by the period of a uniform text tradition since the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" The dynamics of these two periods account for the character of the textual witnesses preserved and the transmission history of these books.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Texts in the Early Second Temple Period")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As the liberated Judean exiles returned from Babylon to Jerusalem and environs, they gradually rebuilt the Temple, the walls, and the city. Religious leaders also assumed the responsibility of reconstituting the literary heritage from the monarchic culture as well as producing new religious works that attempted to help the people refocus their understanding of their relationship with God after the disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The literary heritage from the monarchic era — which would have been primarily transmitted orally, even if priests or scribes possessed written copies — was rich and diverse. Early Israel in all likelihood had some kind of oral accounts of its formation as a people; it seems inconceivable that they lacked any traditional accounts of their origins. Martin Noth posited five themes of oral traditions that were eventually woven together to form what became the Tetrateuch or Hexateuch: the promise to the patriarchs, the guidance out of Egypt, the wandering through the wilderness, the revelation at Sinai, and the occupation of the land. Historically it is unlikely that any single group experienced the events behind all five of these traditions. Rather, different groups experienced different events which eventually were memorialized in these themes, and some individuals wove the themes together, probably adding new insights and commentary, to form what could be called a national epic. As the unity among the disparate groups developed, all groups increasingly accepted all components of the tradition as “our” story, giving it a pan-Israelite significance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to the origins narratives, various preexilic traditions would have survived in the memory of the people, including the Deuteronomistic History, or at least many of the tribal, royal, military, and religious traditions which served as the sources of that History. Included also in that early heritage were collections of sayings of and stories about prophets, such as Elijah, Elisha, Amos, Hosea, and Isaiah of Jerusalem, as well as collections of priestly rituals, liturgical hymns, and wisdom instructions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("For the most part Second Temple tradents or scribes assiduously recited or recopied those traditions as accurately as they could, but occasionally there were creative minds that sought to revise and expand the texts with insights addressing new situations and making the works meaningful to the current generation. A priestly edition of the Torah was produced and interwoven into the earlier origins traditions to help the people understand that the ancient covenant was not ephemeral and did not necessarily rest on land, autonomous kingship, and the historical process, but rather was eternal and rested on theocracy, Temple liturgy, and adherence to Torah. The Deuteronomistic History was also updated, putting heavier emphasis on the curse which would result in war, defeat, and exile from the land flowing with milk and honey. In contrast, certain prophetic collections with oracles of judgment were supplemented with much-needed oracles of salvation or consolation (e.g., Amos 9:11-15, and Isaiah 40–55 joined to Isaiah 1–33).")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("New compositions were also produced in reaction to the shocking loss of independence, land, king, and temple. In addition to the expanded and retheologized editions of the Torah and the Deuteronomistic History, Second Isaiah joyously trumpeted the exiles’ imminent and glorious return to Jerusalem, typologically promising a new creation, new exodus, new covenant, and new Jerusalem. Job may be seen as an attempt to understand and deal with life and the God-human relationship after the Exile. New psalms emphasized themes of lament and the ideal of Torah as wisdom. New works, such as Chronicles and Ezra, Haggai and Zechariah, also depicted the efforts at restoring the Temple, the religion, and the people.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Recognition of the Literature as Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many if not all of these works originated as, and were generally viewed as, humanly produced literature; indeed, Sir. 44:1-15 could be seen as an ancient witness to this view. There is a spectrum of theological views concerning the divine origin of the Scriptures, but here the focus must be on how the human community came to recognize these books as divinely authored. They served a variety of purposes: the early narrative strands of the Pentateuch and the Deuteronomistic History served as a national epic and national history; Leviticus, Psalms, and Esther were used for the liturgy; "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" the Deuteronomistic History, Proverbs, Job, Qohelet, and Ben Sira contributed to religious, moral, and practical education; the Song of Songs, Tobit, and Ruth were models for human love and loyalty; and Daniel provided a model for courage in perilous times. The literature grew as community literature, and countless tradents and copyists contributed to its dynamic development from its earliest origins as sayings, reports, songs, and other materials into books sufficiently well known and treasured to assure that they would be transmitted as important for successive generations. Just as the community formed the literature, so too the literature formed the community as it moved through history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of the many works produced, some came to be regarded as sacred Scripture; that is, they were regarded as in some sense having God as author. There is little evidence for reconstructing this important transition, but certain contributing factors can be proposed.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("First, God was increasingly understood to be speaking through the texts to the people. For the Greeks the "), _c('em', [_vm._v("Iliad")]), _vm._v(" and the "), _c('em', [_vm._v("Odyssey")]), _vm._v(" held essential religious importance, but they were principally seen as national epics. Similarly, the early hexateuchal narratives originally would likely have been perceived more as a national epic than as “Scripture.” Just as the gods spoke in the Homeric poems, so too did God speak in Israel’s texts. But once the priestly portions were incorporated, especially the legal materials listed as divinely spoken on Sinai, and insofar as the divine source was reinforced by the preaching of the Torah as articulating God’s will, it is quite easy to understand how God came to be viewed as the author. Already by the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", "), _c('em', [_vm._v("Jubilees")]), _vm._v(" clearly attests this: “The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" revealed to him …” ("), _c('em', [_vm._v("Jub.")]), _vm._v(" 1:4), and “The angel of the presence spoke to Moses according to the word of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", saying: ‘Write the complete history of the creation …’” ("), _c('em', [_vm._v("Jub.")]), _vm._v(" 2:1).")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The divine authorship envisioned on Sinai was extended to material that had presumably been simply the priests’ ritual handbook for Temple sacrifices. It is quite plausible that editorial framing in the Second Temple period transformed the priests’ handbook of directions for performing the various offerings. The directions in Leviticus 1–7 may at an earlier point have begun with “When any of you bring an offering of livestock to the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", you shall…” (1:2b), proceeded with the detailed sacrificial directions, and then ended with “This is the ritual of the burnt offering, the grain offering, the sin offering, the guilt offering, the ordination offering, and the sacrifice of well-being” (7:37). The editorial framing of those priestly directions would then have introduced the section with “The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" called Moses and spoke to him from the tent of meeting, saying, ‘Speak to the people of Israel and say to them’” (1:1-2a), and concluded it with “which the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" commanded Moses on Mount Sinai, when he commanded the people of Israel to bring their offerings to the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", in the wilderness of Sinai” (7:38; cf. also 4:1-2a; 5:20; 27:1-2a, 34). According to this view, the priestly ritual handbook was transformed into a divinely authored book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Just as Moses relayed God’s word in the Torah, certain prophets were seen to deliver God’s message to the king and people. But eventually the entire prophetic book, including stories about the prophets and the full editorial framework, was considered divine revelation. With the passage of time a book containing God’s word became a divinely revealed book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, the Psalms, which originated as humanly composed hymns to God, were elevated to the status of divinely authored Scripture. The largest Psalms scroll from Qumran states explicitly the divine source of David’s Psalter: “All these he spoke through prophecy that was given to him from the Most High” (11QPs"), _c('sup', [_vm._v("a")]), _vm._v(" 27:11). The divinely inspired prophetic nature of the Psalms is echoed in the Acts of the Apostles: “Since he was a prophet….Foreseeing this, David spoke of the resurrection of the Messiah …” (Acts 2:30-31).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Second, additions that enhanced the theological, pious, or festival nature of a text seem to have been influential in considering a book as Scripture. For example, the theological material in Proverbs 1–9 may well have been the factor that achieved scriptural status for that book. The older section starting in chapter 10 had probably been much more regarded as a collection of commonsense folk ")]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("wisdom and pithy sayings. But the additions — such as “the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" created [Wisdom] at the beginning” (8:22) and she was beside him “When he established the heavens…, when he made firm the skies above” (8:27-30) — helped transform the collection so that one could seek and “find the knowledge of God” (2:5). The not-excessively pious Qohelet may have gained scriptural status once the more traditional appendix, urging the reader to “fear God and keep his commandments” (Eccl. 12:9-14) was added. The same status may have been gained for the book of Esther with the institution of the feast of Purim (Esth. 9:18-32).")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, hermeneutical innovation also contributed to sacralization. The Song of Songs, which like the Psalms originated as human literature, was sublimated through a hermeneutical lens into a meditation on God’s love for Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Daniel also provides an interesting example. There was a growing cycle of Danielic materials, which perhaps drew on the righteous figure of Dan(i)el, laconically mentioned in Ezek. 14:14, 20, and which attached his name to traditions such as the anonymous Jewish healer in the Prayer of Nabonidus (4Q242). The cycle (1) achieved the form of a small literary collection of wisdom tales during the Persian period (Daniel 2–6); (2) developed into a larger collection due to the persecution of Antiochus IV (Daniel 1–12) and yet a larger collection with the Additions (1–14); and (3) continued to emerge in the form of other Pseudo-Daniel traditions (4Q243-245). Out of that developing cycle, the collections of chapters 1–12 and of 1–14 were accepted by different communities as Scripture, though not the earlier or later materials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Other factors that may also have contributed to the recognition of Israel’s literature as divinely authored Scripture were the increasing antiquity of a work, the educational or liturgical settings in which this literature was proclaimed to be speaking in the name of God or articulating the will of God, and the “resignification” or adaptability of the texts to the current community’s ongoing life, whereby they could readily identify their situation with one in which God had favored Israel in the past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious leaders and pious people sincerely trying to understand and articulate the divine will produced the religious classics of Israel. As generation after generation pondered their religious traditions in light of their current historical, political, and social reality, in one sense, the word "), _c('em', [_vm._v("about")]), _vm._v(" God became the word "), _c('em', [_vm._v("of")]), _vm._v(" God. The communities continued to hear it repeated as such, and eventually they recognized and described it explicitly as such.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Early Translations: Aramaic and Greek")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Another possible indication that the Torah was considered authoritative Scripture before the middle of the Second Temple period is the translation of those texts into the vernacular languages. The "), _c('em', [_vm._v("Iliad")]), _vm._v(" and the "), _c('em', [_vm._v("Odyssey,")]), _vm._v(" despite their central cultural importance when the Romans took over the Greek culture, were apparently never translated into Latin in antiquity. A summary of the "), _c('em', [_vm._v("Iliad")]), _vm._v(" is attributed to Baebius Italicus in Nero’s time, but it is a brief (only 1,070 hexameters) pedestrian version of the majestic original. By contrast with the Homeric poems, which were ")]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("not translated, the Torah was translated in subsequent centuries into languages that the people could understand. The texts were important not only for the educated and cultured, and spoke not only of the past; they were central to the ongoing life of the whole community and had to be applicable to the future situations that the people might encounter. So the Scriptures were translated into Aramaic and Greek, the respective languages of the Persian Empire and the Jewish community in Babylon, and of the Hellenistic Empire and the Jewish community in Alexandria.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Babylonian destruction and exile caused many fractures in Israel’s life, including that of language. Aramaic was the imperial language of the Persian Empire, and Greek the language that the successors of Alexander attempted to impose upon their conquered territories. Though there was resistance to Greek culture, an increasing number of Jews became Aramaic or Greek speakers, creating a need for translations. Because the texts were important for community identity and had to be applicable to the future situations and foreign surroundings in which the Jewish people would find themselves in the Diaspora, the Scriptures were translated into languages that the people could understand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is no early evidence, but it seems likely that by the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" the Jewish community in Babylon had begun to translate the Torah and possibly also prophetic books into Aramaic. We do not know whether these were complete, written translations or oral, functional explanations of the Hebrew. The latter scene is mirrored in Neh. 8:8, narrated probably in the fourth century: accompanying a public reading from the Hebrew scroll, the Levites translated it and gave the sense, so that the people could understand. The earliest extant manuscripts are a Targum of Leviticus (4QtgLev) from the late second or early first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and two of Job (4QtgJob, 11QtgJob) from the middle of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Apart from these Qumran texts, the witness of the Targums for text-critical purposes is reduced, however, irrespective of the date when complete Targums of the Torah and other books were finally written down, since all preserved Targum texts have subsequently been revised to agree with an early form of the Masoretic Text (MT). It is difficult to have confidence that any specific readings provide premishnaic evidence.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("Unlike the nebulous situation regarding early Aramaic translations, the probability is strong that the Jewish community in Alexandria had translated the Torah into Greek during the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The legendary "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" elaborately narrates such an early translation, though it is generally believed to have been written in support of a version making claims for hegemony about a century later. Nevertheless, plausible examples of quotations in the late third and the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" as well as manuscript evidence make a third-century date for the translation close to certain. Demetrius the Chronographer already in the late third century quotes the Greek Genesis, and Eupolemus in the mid-second century uses the Greek Chronicles, which probably means that the more important Prophets had already been translated as well. Moreover, in the last third of the second century Ben Sira’s grandson translated his grandfather’s work and only casually mentions the translation of the Torah and the Prophets and other books, which suggests that those translations were not recent but had become widely known. Finally, the ")]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("discovery of second-century manuscripts of Greek Pentateuchal books both in Egypt and in Palestine (already showing noticeable development) makes a third-century translation probable. Again, this unprecedented fact of translation may be a strong indicator that the Torah had become regarded as authoritative Scripture.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("The Value of the Early Versions")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Targums generally do not help penetrate to ancient forms of the text other than those inherited in the MT collection. The Old Greek (OG) translation, on the other hand, provides for many books an invaluable witness to Second Temple textual forms that have otherwise perished. Whereas prior to the middle of the twentieth century the value of the LXX for text-critical purposes was often denigrated, the discovery of Hebrew manuscripts from Qumran vindicated the veracity of the LXX. Scrolls such as 4QDeut"), _c('sup', [_vm._v("q")]), _vm._v(", 4QSam"), _c('sup', [_vm._v("a, b")]), _vm._v(", and 4QJer"), _c('sup', [_vm._v("b, d")]), _vm._v(" display in Hebrew the type of texts from which the OG had been faithfully translated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those manuscripts have illuminated the first of four levels that must be taken into account when dealing with the individual Hebrew parent text from which the original translation was made. Previously, it had mainly been presumed that the parent text was virtually identical with the form in the MT, but the abundant variant editions unearthed at Qumran have freed critics from that myopic vision. One must seriously consider that the Greek is a witness to a Hebrew text that may simply be no longer available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second level is that of the act and product of the translation itself. Due to the many sources of possible variation from the parent Hebrew, the Greek often presented a text at odds even with the parent Hebrew it did use. Those sources included, for example, errors or damaged spots in the Hebrew manuscript, the uncertainty involved in understanding an often ambiguous Hebrew, misreading or misunderstanding of the Hebrew on the part of the translator, and different division of sentences due to lack of punctuation. Thus, though the translator was usually attempting to translate the Hebrew source text faithfully, unintended variants were inevitable. It is often declared that every translation is an interpretation. In a restricted sense that is correct; of course, the translator must interpret what the meaning of the original is. But the degree of interpretation is at times exaggerated to include theological "), _c('em', [_vm._v("Tendenz,")]), _vm._v(" or even “actualizing exegesis,” whereby the translator deliberately changed the ancient text to highlight some current event or view. Despite the attractiveness and relatively heightened significance of such theological interpretation — if it were correct — the creative exegesis is usually to be assigned to the scholar proposing it. In light of the pluriform Hebrew and Greek manuscripts from Qumran, a Herculean burden of proof falls on one who would claim that the translator saw and understood one message in the Hebrew and deliberately produced a different message in the translation. A distinction must also be made between the meaning that the translator produced and diverse possible interpretations of that wording later.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("Messages different from the Hebrew could and did result from a third level. Roughly six centuries of copyists’ transmission elapsed between the original ")]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("translation and the earliest full copies of the LXX dating from the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" It must be presumed that textual variants, both inadvertent errors and intentional corrections or supplements, began to affect the Greek texts from the earliest copies that scribes attempted to produce, just as happened with the Hebrew. Some variants entered the text through cross-fertilization from variant Hebrew formulations. Theological changes also occasionally occurred during the transmission process, clearly exemplified in passages such as LXX Ps. 13:3, with a long insertion quoted from Rom. 3:3-10, and other patently Christian additions in the transmitted texts at Pss. 50:9 and 95:10. Variants at the transmission level multiplied voluminously over the centuries and are seen now flooding the critical apparatus of the Göttingen Septuagint editions.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A fourth level visible in LXX manuscripts took the texts in a different direction. While variants multiplied in the LXX transmission, Jewish scholars labored to unify the developing LXX text, revising it toward conformity with what they presumed was the “original” Hebrew text, which for them happened to be the collection of texts now in the MT. This recensional process — seen primarily in the work of Aquila, Symmachus, and (proto-)Theodotion, and culminating in Origen’s Hexapla — instead of unifying the ongoing Greek manuscript tradition, rather infiltrated and complicated it. To use the LXX critically, it is important to work with the first and second levels, sifting out influence from the third and fourth levels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to serving as a valuable window into ancient Hebrew text forms, the LXX also provides luminous witness to the understanding of the Scriptures in late antiquity. The Greek texts also developed a life of their own, soon no longer moored to the precise meaning of the Hebrew originals, becoming the Scriptures of both Christian and Greek-speaking Jewish communities. The Old Latin and the “daughter versions” (e.g., the Armenian, the Bohairic, etc.) were translated from the LXX and serve indirectly as witnesses to possible alternate Hebrew texts, but all the remaining versions witness uniformly to the MT collection.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Surprising Texts from the Late Second Temple Period")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Starting in the latter half of the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", light begins to shine on the textual landscape, thanks to the discovery of more than two hundred biblical manuscripts in caves near Qumran and at other sites along the western side of the Dead Sea. The biblical scrolls provide a wide-ranging parade of textual surprises that deserve close review.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Exodus")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("An extensively preserved manuscript of Exodus written in the Paleo-Hebrew script and dated to approximately the middle of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" surprised scholars shortly after the discovery of Cave 4. 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" routinely displayed the expanded text edition that was well known from the Samaritan Pentateuch (SP). In every instance where it is preserved, it displays the major expansions beyond the ")]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("MT and the LXX that are exhibited by the SP. Where it is not extant there is also no reason to suspect that it did not agree with other SP expansions, except for one instance. It apparently did not have space to contain the lengthy extra commandment added in the SP at Exod. 20:17b after the traditional commandments. That specifically Samaritan commandment (though taken from Deuteronomy 11 and 27, common to MT, SP, and LXX) to build an altar at Mt. Gerizim evidently was not in 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(", just as it is lacking in the MT and the LXX. It seems clear, then, that there were at least two variant editions of the text of Exodus in circulation within Jewish circles during the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Evidently both were used and enjoyed equal status. 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" was damaged at one point, and someone carefully sewed a patch over the large hole and reinscribed the lost words. The Samaritans made use of that secondary, expanded edition and apparently made only one theological change in two forms: they added the commandment that Israel’s central altar was to be built on Mt. Gerizim, and in the recurring formula they stressed that God had chosen Mt. Gerizim, not Jerusalem, as that central shrine where his name should dwell. Thus, the “Samaritan” Exodus was mainly a general Jewish text of Exodus. And that secondary, expanded edition that lacked the two specifically Samaritan changes continued to be used by Jews and was still being copied around the middle of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" There does not appear to be any evidence that the Jews and Samaritans were aware of or concerned about the specific text-type.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Numbers")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scholars were generally slow in digesting and accepting that new evidence from 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(", but the most extensively preserved scroll of the book of Numbers provided confirmatory evidence with a profile similar to that of the Exodus scroll. 4QNum"), _c('sup', [_vm._v("b")]), _vm._v(", written in the Jewish script and dating from the latter half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", also exhibits agreement with the additions in the SP beyond the traditional text as in the MT and LXX. But like 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(", it does not have the specifically Samaritan readings. It thus confirms the pattern seen in Exodus, that Palestinian Judaism knew at least two editions of the book of Numbers, and that the Samaritans used the secondary, already expanded Jewish tradition exemplified in 4QNum"), _c('sup', [_vm._v("b")]), _vm._v(". Again, both editions of Numbers were apparently in use by Jews in the late Second Temple period.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Joshua")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("The oldest manuscript of Joshua also provided a surprise, but in a different direction. 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(", from the latter half of the second or the first half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", presented a sequence of important episodes that was strikingly at variance with the order of events in the traditional MT. In the scroll, Joshua evidently builds the first altar in the newly entered land at Gilgal, immediately after he has traversed the River Jordan and led all the people safely across. That is, the episode ")]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("occurs at the end of chapter 4, thus prior to the circumcision and then the ensuing conquest. The scroll’s sequence seems natural and logical, and one might expect that the sanctification of the land — by the building of the first altar, the recitation of the Torah, and the rite of circumcision — would be the inaugural episode of the occupation of the promised land. In contrast, the MT locates the building of the first altar at the end of chapter 8, placing it on Mt. Ebal, which causes numerous problems. Commentators have had to struggle with that odd location, for it requires a march of twenty miles from Ai up to Ebal, the construction of the altar, then a return march south, back to Gilgal. Meanwhile, Joshua would have left that important altar abandoned in enemy territory, and, whereas Gilgal remained an important shrine (1 Sam. 11:14-15; 2 Kings 2:1), Mt. Ebal is otherwise insignificant. The problem is worsened since Josh. 9:1 logically and syntactically follows 8:29, not 8:35, suggesting that the insertion of vv. 30-35 at the end of chapter 8 is secondary. Moreover, the LXX presents yet a slightly different order, though it is in basic agreement with the MT regarding the location of the altar. But perhaps the strongest confirmation of the sequence in 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(" is provided by Josephus, who also places the altar at Gilgal ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 5.20) and who must have used as his source a biblical text that agreed with the Qumran scroll. He even adds further support ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 5.45-57) insofar as he does not narrate a building of the altar where the MT places it, between the conquest of Ai (8:1-29) and the Gibeonites’ ruse (Joshua 9). An additional piece of the puzzle is provided by the SP, which reads “Mount Gerizim,” in agreement with the Old Latin, which reads “Garzin,” at Deut. 27:4, the command that is the basis for this episode in Joshua. Thus 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(" evidently provides a more original form of the narrative. The placement of that first altar in the land has serious consequences, of course, and the most plausible reading of the textual evidence is that 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(" has the earliest sequence and that a northern faction (Samarians or Samaritans) secondarily rearranged the location of the altar at their sacred shrine on Mt. Gerizim. At a third stage, in counterreaction, southerners (Judeans or rabbis), due to religious polemics, simply changed the name of the mountain from Gerizim to Ebal, despite the anomaly created.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Judges")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The oldest manuscript of the book of Judges (4QJudg"), _c('sup', [_vm._v("a")]), _vm._v("), dating from about 50-25 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", survives in but a single small fragment. It contains Judg. 6:2-6 followed directly by vv. 11-13. It lacks 6:7-10, a separate unit whose style differs from the preceding and following verses and appears to be a later theological insertion. Thus, again, the Qumran text of Judges exhibits an early, short form of Judges 6, and the MT has a secondary, theologically expanded version.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Samuel")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("4QSam"), _c('sup', [_vm._v("a")]), _vm._v(", dating from near the mid-first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", contains a form of text that included a complete paragraph that is not present in the MT, the LXX, or any other ")]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("extant version. It narrates the oppression by Nahash the Ammonite that introduces the material now found in 1 Sam. 11:1 in the MT and other texts. The fragment itself contains a case of a scribal skip of the eye (parablepsis), which lends support to the probability that the passage was lost in the MT tradition through the same kind of error. Parallel to Josephus’ agreement with 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(", he also shows he used a text of Samuel like 4QSam"), _c('sup', [_vm._v("a")]), _vm._v(", since he also narrates the content, details, and wording of that otherwise lost paragraph ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 6.68-69).")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Isaiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Great Isaiah Scroll (1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(") was the first and most dramatic biblical manuscript to gain widespread fame. Especially because the text displays multifaceted disagreement with the traditional MT, the assumption was made that it was a Qumran text of Isaiah, that is, that its unusual features were specifically due to the “sect” that lived at Qumran and copied it there. A second Isaiah scroll (1QIsa"), _c('sup', [_vm._v("b")]), _vm._v(") was also found in Cave 1 and by contrast was nearly identical with the MT. It did indeed show that the medieval MT of Isaiah had been copied with great accuracy over the intervening thousand years. But whereas the two scrolls were first categorized as one authentic text and one “vulgar” Qumran text, in fact they demonstrated — though scholars could not yet realize it — the two principal lessons for the biblical text from the new discoveries. The MT is, for the most part, an accurate copy of some ancient text for each book; but importantly, there were also valuable variant editions of many books in antiquity that had been lost, discarded, or rejected. Though the linguistic and orthographic profile of 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" is generally secondary to that of the MT, its textual profile is earlier in numerous cases. 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" demonstrates that the MT displays a recurring pattern of a sentence or more added to the text; in seven instances the MT inserts secondary expansions of up to four verses where 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" preserves the earlier short text.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Jeremiah")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("While several scrolls show that the edition they represent is at variance with the MT, the scrolls of Jeremiah provide an example of two variant, successive editions of the book visible among the scrolls themselves. Small fragments of two manuscripts, 4QJer"), _c('sup', [_vm._v("b")]), _vm._v(" and 4QJer"), _c('sup', [_vm._v("d")]), _vm._v(", both from the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", display in Hebrew the earlier, shorter edition with one arrangement of the book that formed the basis of the OG translation. In contrast, both 4QJer"), _c('sup', [_vm._v("a")]), _vm._v(", from ca. 225-175 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", and 4QJer"), _c('sup', [_vm._v("c")]), _vm._v(", from the latter part of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", have the later, more expanded edition with a variant arrangement in agreement with the MT. Just as 4QJer"), _c('sup', [_vm._v("b")]), _vm._v(" and the OG witness to the secondary addition of vv. 6-8 and 10 into chap. 10 in the MT, 4QJer"), _c('sup', [_vm._v("a")]), _vm._v(", though it agrees with the MT in its overall edition, nonetheless exposes a large secondary addition of seven verses in the MT at Jer. 7:30-34; 8:1-3. The original scroll, copied ca. 225-175 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", lacked this lengthy pair of passages; but a later scribe, palaeographically dated a century or more later, about 100-50 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", ")]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("inserted them into the old text. He squeezed three lines of tiny script into a horizontal space in the text, continued with four lines written down the left margin, and, since there was yet more text, wrote a final line upside down in the bottom margin (DJD 15: 155 and plate 24). That this two-part passage was not part of the original Jeremiah text is suggested by the fact that it is not closely related to the context, that the prose insertion interrupts the flow of the poetic verse 7:29 into another logically following poetic verse 8:4, and that the original scribe’s omission of it would have required an unparalleled parablepsis involving about twelve lines of text.")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Psalms")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The evidence from Qumran and Masada also demonstrates that there were at least two editions of the Psalter in antiquity. One manuscript from Masada has Psalm 150 followed by a blank sheet, showing that it represented the same edition handed down in the MT. Cave 11, however, held a beautiful and generously preserved scroll with Psalms that was so different from the MT that many scholars, especially in the early decades, considered it as nonbiblical. 11QPs"), _c('sup', [_vm._v("a")]), _vm._v(" contains thirty-nine Psalms known from the MT plus ten additional compositions. Shortly after it was published, there was a vigorous debate concerning its nature, whether biblical or not. Its editor, James A. Sanders, considered it a biblical scroll and thus listed “Ps” in the title, but other major scholars challenged this classification. Their challenges included the following reasons: (1) the psalms that are familiar as biblical psalms are presented in a sequence that differs repeatedly from that of the MT; (2) it includes additional “nonbiblical” psalms not found in the MT; (3) it was characterized as “liturgical,” because even within the biblical Psalm 145 an antiphon is repeatedly added in contrast with the MT; (4) it includes in the midst of the Psalms a prose piece, “David’s Compositions”; and (5) the tetragrammaton is written in the Paleo-Hebrew script, not in the normal Jewish script used for the remainder of the scroll.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("But in light of the accumulating evidence from the biblical manuscripts, each of those objections collapsed, and the scroll is being increasingly acknowledged as an alternate edition of the biblical Psalter in ancient Judaism. (1) The MT Psalter does not have a rigorously or clearly intentionally arranged sequence to its psalms; some deliberate groupings can be postulated, but there is no discernible comprehensive plan. (2) Four of the so-called noncanonical compositions are in fact psalms found in the Greek and Syriac Psalters, and two others are found at other places in the MT or LXX, namely, 2 Sam. 23:1-7 and Sir. 51:13-30. The remaining psalms were hitherto unknown but had been composed in the ancient style of the biblical psalms, not in that of the later Qumran "), _c('em', [_vm._v("Hodayot.")]), _vm._v(" They were clearly originally Hebrew psalms, even if not eventually accepted into the MT edition of the Psalter. (3) 11QPs"), _c('sup', [_vm._v("a")]), _vm._v(" is indeed a liturgical scroll, but so is the MT Psalter by its very nature. The antiphon interspersed in Psalm 145, “Blessed be the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", and blessed be his name forever and ever,” is totally derived from verse 1 of Psalm 145, and it is systematically repeated in the identical manner in which the antiphon")]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v(" “For his faithfulness endures forever” is repeated in Psalm 136 in the MT. (4) “David’s Compositions” stakes an explicit claim for prophetic inspiration and thus scriptural status of the Psalter. It may have originally been positioned not "), _c('em', [_vm._v("within")]), _vm._v(" the collection but at the "), _c('em', [_vm._v("end")]), _vm._v(" of an earlier edition of the collection (before Psalms 140, 134, and 151 were appended), thus functioning as a quasi-colophon with the claim for scriptural status. (5) The use of the Paleo-Hebrew script for the divine name in a text written in the Jewish script had earlier been considered an indication that the text was not biblical, but several other biblical scrolls in the Jewish script have also been identified that write the tetragrammaton in the Paleo-Hebrew script. Two additional manuscripts (11QPs"), _c('sup', [_vm._v("b")]), _vm._v(" and 4QPs"), _c('sup', [_vm._v("e")]), _vm._v(") apparently witness to the 11QPs"), _c('sup', [_vm._v("a")]), _vm._v(" edition, whereas none of the ancient manuscripts found at Qumran unambiguously supports the MT sequence of Psalms against the 11QPs"), _c('sup', [_vm._v("a")]), _vm._v(" sequence.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("The (Reworked?) Pentateuch")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Four sets of fragments, three of them containing text from four or all five books of the Pentateuch, still pose challenges that deserve exploration. First, it remains undecided whether 4Q364-367, to which yet a fifth manuscript (4Q185) has been linked, represent copies of the same composition or only similar variant forms of pentateuchal development. Second, the classification is still debated. In large part the fragments present a running text of the Pentateuch but have frequent additions, a few omissions, and alternate sequences. Accordingly, they were first published as “4QReworked Pentateuch”; that is, the variants were deemed to outweigh the agreements, and thus they were not the Pentateuch but beyond the Pentateuch. A number of scholars, having digested the lessons from the many variant, developing editions of the biblical books — that additions, omissions, and altered sequences are characteristic of the biblical text in the Second Temple period — have begun to see these texts as a yet later form (or forms) of the Pentateuch, and thus refer to it as 4QPentateuch. It seems to be moderately developed beyond the expanded Jewish version used by the Samaritans; in fact, many of its variants agree with the SP, though none are sectarian. Other scholars remain somewhere in a middle position between “Pentateuch” and “reworked,” searching for a proper category and term.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Similar Examples from the MT, SP, and OG")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("Once taught by the variant editions posed by the biblical scrolls, scholars could recognize similar examples long available in familiar sources. The MT was recognized as containing revised and expanded editions when compared with the OG, in the Tabernacle account (Exodus 35–40), the account of David’s induction into Saul’s service (1 Samuel 16–17), and the book of Jeremiah. The SP was recognized as witnessing the already expanded Jewish editions of the pentateuchal books with only slight theological changes. The OG of Daniel was seen as an expanded form of ")]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("the edition in the MT — the reverse process compared with the situation in Jeremiah.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Greek papyrus 967 may well also display an edition of Ezekiel that is earlier than the edition now attested by the MT and the LXX. It has the order of chapters as 36, 38, 39, 37, and 40, and lacks 36:23c-38. Analysis suggests that this was the early form translated from a Hebrew text with that order. A later Hebrew editor transposed chap. 37 into its present (MT) position and added the last section of chap. 36 (vv. 23c-38) at the same time as a suitable eschatological introduction into chap. 37. Other ancient sources join the biblical texts in adding their witness. Josephus, for example, as seen above, used biblical texts similar to 4QJosh"), _c('sup', [_vm._v("a")]), _vm._v(" and 4QSam"), _c('sup', [_vm._v("a")]), _vm._v(", rather than the forms in the MT, for his "), _c('em', [_vm._v("Jewish Antiquities.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Lessons from the Biblical Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After reviewing the parade of biblical manuscripts from Qumran and the major variants in the MT, SP, and OG that can be seen and appreciated in clearer focus due to the Qumran scrolls, what lessons do they offer? The first headline that immediately flashes is “textual pluriformity.” The pluriformity, however, is not chaos but shows patterns that can be clearly seen and intelligibly classified. There are four principal categories of variation detectable through comparison of the Qumran manuscripts, MT, SP, and OG: (1) orthography, (2) individual textual variants, (3) isolated interpretive insertions, and (4) revised and expanded editions. Studies show that these four types of variation operate on different levels unrelated to each other.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Orthography")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The six centuries of the Second Temple period saw noticeable development in the Hebrew language, and especially its spelling practices. Scribes, through the insertion of "), _c('em', [_vm._v("matres lectionis,")]), _vm._v(" made early contributions to the interpretational process that concluded with the Masoretes’ vocalization of the texts. Since the text was sometimes ambiguous, the tendency toward fuller spelling was helpful for correct reading and preservation of correct understanding. The "), _c('em', [_vm._v("matres")]), _vm._v(" were inserted at times unintentionally, at times intentionally, insofar as the source text may have had one spelling, but the scribe nonetheless inadvertently or consciously wrote the word as he customarily spelled it, regardless of the source text. Usually the fuller form simply indicated the correct form more clearly and involved no change in meaning. For example, in Isa. 8:19 the ambiguous "), _c('em', [_vm._v("ha-")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("bwt,")]), _vm._v(" which could mean “ancestors,” was correctly vocalized in 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" as "), _c('em', [_vm._v("ha-")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ôbôt,")]), _vm._v(" “ghosts,” and similarly in the MT as "), _c('em', [_vm._v("ha-")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ōbôt.")]), _vm._v(" But in Isa. 40:6 the ambiguous "), _c('em', [_vm._v("w")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("mr")]), _vm._v(" was interpreted in the MT as third person, whereas it was clarified as first person in 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(".")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('strong', [_c('em', [_vm._v("Individual Textual Variants")])])])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The human difficulty in accurately copying large amounts of complicated text resulted in readings that differed from the parent text for virtually every ancient manuscript. Many variants were unintentional (e.g., numerous types of errors, inadvertent substitution of "), _c('em', [_vm._v("lectiones faciliores,")]), _vm._v(" loss of letters, loss of one or more words through inattention or parablepsis); others were intentional (clarifying insertions, scribal correction [whether correct or not], additional information, linguistic smoothing, euphemistic substitutions, literary flourishes, theological ideas). This general phenomenon is well known, and the traditional handbooks on textual criticism primarily deal with this level, describing general rules of thumb that remain well founded for judging variants.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Isolated Interpretive Insertions")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Learned scribes occasionally inserted into the text they were copying what they considered an appropriate piece of additional material. Comparisons between the Scrolls, the MT, the SP, and the LXX highlight insertions of up to eight verses now in one text, now in another. Depending upon the genre of book being copied, the insertions provided information (2 Sam. 5:4-5 in MT vs. 4QSam"), _c('sup', [_vm._v("a")]), _vm._v("), offered instruction (Isa. 2:22 in 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" MT vs. LXX), solved nomistic inconsistencies (Lev. 17:4 in 4QLev"), _c('sup', [_vm._v("d")]), _vm._v(" SP vs. 11QpaleoLev"), _c('sup', [_vm._v("a")]), _vm._v(" MT), stemmed from piety (Isa 2:9b in 4QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" 4QIsa"), _c('sup', [_vm._v("b")]), _vm._v(" MT LXX vs. 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v("), added prophetic apparitions (Judg. 6:7-10 in MT vs. 4QJudg"), _c('sup', [_vm._v("a")]), _vm._v("), introduced apocalyptic tendencies (Isa. 2:10 in 4QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" 4QIsa"), _c('sup', [_vm._v("b")]), _vm._v(" MT LXX vs. 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(", plus many “on that day” passages in Isaiah), or simply added similar material (Isa. 34:17b–35:2 in MT LXX vs. 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v("; Jer. 7:30–8:3 in MT 4QJer"), _c('sup', [_vm._v("a 2m")]), _vm._v(" vs. 4QJer"), _c('sup', [_vm._v("a")]), _vm._v("*) or contrasting material (Jer. 10:6-8, 10 in MT vs. 4QJer"), _c('sup', [_vm._v("b")]), _vm._v(" LXX). The prophetic books especially are replete with such expansions, and results of this activity have penetrated all texts; indeed, it seems to have been a widespread factor in the development of all the biblical books. If such interpretive insertions are isolated and not linked as part of a series, they are classified in this category. If there are a number of coordinated patterned sets showing substantial harmonizations, revisions, or insertions, these would form a new edition of a book.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("New and Expanded Editions of Biblical Books")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("The most influential method by which the texts developed in major ways was through successive revised and expanded editions of each book. From their earliest, shadowy beginnings the texts solidified and developed by faithful repetition but also by occasional creative, updated editions to form the books as we begin to see them when manuscript evidence becomes available. Source-critical examples, such as the retheologizing of the older monarchic traditions in light of the destruction and exile (traditional P), and more specifically the insertion of the P flood story into the older J story in Genesis 6–9, help illustrate the phenomenon. Those ")]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("new editions were achieved not through displacement of the old but through combination of the new with the old. A more sustained and documented example is the four or five successive editions of the book of Exodus. Exodus 35–40 is preserved in two successive editions; the OG is presumably the earlier edition (edition "), _c('em', [_vm._v("n+1")]), _vm._v(") and the MT the later (edition "), _c('em', [_vm._v("n + 2")]), _vm._v("), developed from the Hebrew parent text used by the OG. Then 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" displayed an expanded edition (edition "), _c('em', [_vm._v("n + 3")]), _vm._v(") based on but expanding the edition as in the MT, while the SP exhibited the same general edition as 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" but with such significant theological changes (albeit not significant quantitative changes) that it could be regarded as a fourth edition (edition "), _c('em', [_vm._v("n + 4")]), _vm._v("). There is now even a fifth, if 4QRP is considered 4QPentateuch (edition "), _c('em', [_vm._v("n + 5")]), _vm._v("). A similar pair of successive editions for Numbers was seen in 4QNum"), _c('sup', [_vm._v("b")]), _vm._v(", while for Genesis the MT, SP, and LXX all clearly show intentionally revised editions of the two extended passages in chaps. 5 and 11.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Nature of the Biblical Text")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before the discovery of the scrolls in 1947, scholars generally viewed the MT, the SP, and the LXX as three main, but not equal, text types. The MT, in a purified form, was seen as the “original” Bible; Gesenius had shown that the SP was derivative from the MT and thus farther from the “original,” and the LXX was usually denigrated as an inaccurate translation where it disagreed with the MT. The SP and the LXX were occasionally helpful, to be sure, but the prevailing mentality was that the MT represented the closest extant form of the "), _c('em', [_vm._v("Urtext.")]), _vm._v(" The "), _c('em', [_vm._v("Urtext")]), _vm._v(" theory was championed by Paul de Lagarde in the late nineteenth century. It envisioned a single original Hebrew text that was no longer extant in its pure form but that could largely be recovered through the MT with comparative analysis of the SP, the LXX, and the versions. Paul Kahle in the middle of the twentieth century unsuccessfully challenged it with his "), _c('em', [_vm._v("Vulgärtexte")]), _vm._v(" theory, seeing a plethora of variant texts overshadowed by the MT, the SP, and the LXX; but the genetic relationship between all texts argued strongly against it. The "), _c('em', [_vm._v("Urtext")]), _vm._v(" theory probably emerged from three factors: (1) the absence of evidence, because only a single Hebrew text form had been transmitted to posterity after the Second Jewish Revolt in 132-135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("; (2) the traditional religious view, that the biblical text was the word that God spoke to Moses and the Prophets and the Sages, and thus was unique; and (3) early scholarly views, that the books were “documents” or major written compositions by single authors or compilers. Thus, the purified MT was ultimately God’s word, and the diverse manuscripts that survive attest to the errors that human scribes have allowed to penetrate it.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("But just as the invention of the telescope and accurate observation of astronomical data allowed the Copernican heliocentric cosmology to eclipse the unquestioned Ptolemaic-medieval geocentric cosmology, so too the discovery of the biblical scrolls and accurate observation of the data they provide have eclipsed the view of the MT as the textual center of the Hebrew Bible. Though the biblical scrolls from the Judean Desert were early assumed to be sectarian, the more they are studied, the more it is obvious that there is nothing sectarian about them; they ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("constitute the most ancient and authentic witness to what the texts of the Jewish Scriptures were like at the time of the origins of Christianity and rabbinic Judaism.")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Qumran biblical manuscripts — and in their light, the LXX, the expanded Jewish text used as the basis for the SP, the biblical texts used by Josephus, and citations in the New Testament and rabbinic writings — make it clear that the MT was not the textual center. A number of lessons have emerged. First, the scrolls did confirm that the medieval codices of the MT had for over a millennium been very accurately hand-copied from texts like 4QGen"), _c('sup', [_vm._v("b")]), _vm._v(", 1QIsa"), _c('sup', [_vm._v("b")]), _vm._v(", and 4QJer"), _c('sup', [_vm._v("a, c")]), _vm._v(". But they also confirmed that the SP (in light of 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" and 4QNum"), _c('sup', [_vm._v("b")]), _vm._v(") and the LXX (in light of 4QDeut"), _c('sup', [_vm._v("q")]), _vm._v(", 4QSam"), _c('sup', [_vm._v("a, b")]), _vm._v(", and 4QJer"), _c('sup', [_vm._v("b, d")]), _vm._v(") preserved equally important witnesses to alternate ancient forms of the biblical text otherwise lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, scholars realized not only that the MT is not “the original text” or the "), _c('em', [_vm._v("Urtext")]), _vm._v(" of the Hebrew Bible, but that it is not “a text” at all. Like the LXX, it is a varied collection of texts — a different type of text for each of the books — each being simply a copy of one of the editions of that book that was circulating in late Second Temple Jewish circles. Again, the MT is not “the original text”; it is rather the only collection of texts in the "), _c('em', [_vm._v("original language")]), _vm._v(" that had been preserved (beyond the Samaritan community) since the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, there was a revival of theories making major advances in charting the history of the biblical text. The discoveries at first supported the position of the three main text types, since various scrolls agreed with the MT, the LXX, and the SP. Large fragments of 4QSam"), _c('sup', [_vm._v("a, b")]), _vm._v(" (agreeing with the LXX) and 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" (agreeing with the SP) were published early, and thus W. F. Albright and, more substantially, Frank Moore Cross posited three localities as producing the three local text types, seeing a textual development of “one-into-three” — the presumed original into the MT, the LXX, and the SP. But numerous differences in the scrolls from these three types led to further theories. Shemaryahu Talmon, noting the pluriformity, saw rather a “many-into-three” situation, noting that out of the many textual traditions only three survived. Socio-religiously only three communities survived the Roman destruction: the rabbis, the Samaritans, and the Christians, each preserving their own set of texts. But the numerous disagreements in the scrolls also dethroned the LXX and the SP from their positions as the other two “main text types.” Seeing the numerous disagreements as well as the agreements, Emanuel Tov expanded the view, proposing two other types of “nonaligned” texts and “texts written in the Qumran practice.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("Prior to the Jewish revolts against Rome, however, there was no “standard text” — whether MT, LXX, or SP — with which texts should be “aligned” or judged “non-aligned,” and thus those four categories appeared anachronistic for classifying the scrolls. Furthermore, some texts in “the Qumran practice” (e.g., 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(") may well have been copied prior to the settlement at Qumran and may simply exhibit late Second Temple scribal practice. Thus, the present author proposed a series of successive revised and expanded editions of each of the biblical books, noting that the pluriformity and great variation in the texts were not chaotic, but patterned in the four principal categories of variation discussed above. Each book had its own history and developed along its own trajectory. The main lines of development resulted from the creative revised and expanded editions of each book. Each copy of ")]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("whichever edition displayed its own particular individual textual variants, and further copies would either reproduce the orthographic profile of the source text or show modernizing tendencies in spelling practices. Occasionally, scribes would put into the text isolated interpretive insertions that had become either customary oral supplements or marginal glosses, and these would become an accepted part of the transmitted text. Each of the four kinds of variation took place independently of the other three. The MT, the LXX, and the SP should not be regarded as “the three main text types” but are merely manuscript copies for each book in their collection, each copied more or less accurately from one or other of the available editions of that book. Thus, the Masoretic texts must be judged on a par with and according to the same criteria by which the LXX, the SP, the scrolls, the versions, and all other texts are judged, word by word.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("From Collection of Scriptures to the Canon of Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The discussion thus far has centered on individual texts, since the books developed separately and were written on separate scrolls during the Second Temple period. By the third or fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", however, the collection of texts coalesced into a single text. Books considered to have divine authority formed a special group distinct from other works. The group of five books seen as the revelation to Moses became “the book of Moses” (4QMMT C10), though the authoritative status of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" in certain circles raises the question whether the category of Torah was strictly confined to the five books. The book of Moses together with an undefined collection of prophetic books (including, for most Jewish groups, Psalms and Daniel) formed a special collection of authoritative Scripture — “the Law and the Prophets” — during the late Second Temple period. Many other works, some of which would, and others of which would not, become part of the Writings, or Poetic and Wisdom books, were still finding their place in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" By approximately the third century, though the scroll format apparently continued in Jewish circles, at least for Christians the codex gradually supplanted the scroll as the preferred form, and the texts that had been placed only in a mental category were now transformed into a physical unity, a single text: the Old Testament. Thus, the idea of a collection of sacred texts originated in Judaism, but explicit discussion of a canon of sacred Scriptures and physical reproduction of it apparently arose in Christian circles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Canon” is a theological "), _c('em', [_vm._v("terminus technicus")]), _vm._v(" denoting the definitive, official list of inspired, authoritative books that constitute the recognized and accepted body of sacred Scripture which forms the rule of faith for a major religious group, that definitive list being the result of inclusive and exclusive decisions after serious deliberation. Jews, Catholics, Protestants, Orthodox, and others have differing lists of books as their canon, but the definition of “the canon of Scripture” remains the same for all, and the process leading up to the establishment of the canon was an analogous process for each.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("There is no solid evidence from the Second Temple period regarding the specific books in the canon and at best inconclusive evidence for anything beyond")]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v(" “the Law and the Prophets.” The Prologue to Ben Sira is clearest with “the Law and the Prophets and the other books of our ancestors” (8–10; cf. 1–2, 24–25). But this could mean either a tripartite or a bipartite collection: either (1) the Law, (2) the Prophets, and (3) the Writings; or (1) the Scriptures (i.e., the Law and the Prophets) and (2) other important religious literature helpful toward instruction and wisdom. Whereas both the bipartite and the tripartite (albeit quite vague for the third category) positions are defensible, in contrast, the oft-cited reference to a tripartite canon in 4QMMT C 10 (“in the book of Moses [and] in the book[s of the P]rophets and in Dav[id …]”) requires serious scrutiny. The DJD editors’ interpretation as an attestation of a tripartite canon is highly dubious on at least five levels: questionable placement of a fragment (4QMMT"), _c('sup', [_vm._v("d")]), _vm._v(" frg. 17), paleographic transcription of several letters, reconstruction of the composite text in light of disagreements between the manuscripts, awkward syntax, and the content denoted by the last phrase ("), _c('em', [_vm._v("wbd??")]), _vm._v("[ ]). That is, two of the three sections, “the book[s of]” the Prophets, and “David,” may well disappear from the alleged tripartite reference. Appeals to other biblical references — such as in Ben Sira’s own work and 1 and 2 Maccabees — are likewise unpersuasive, unless one takes a maximalist approach in which mere knowledge of or allusive mention of a book means that it, or even its entire category of books, was already considered canonical. Only toward the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" does Josephus write of an exclusive twenty-two-book collection, and "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" mentions a set of twenty-four books for the public alongside seventy to be distributed among the wise. Thus, the absence of any clear mention of a tripartite collection of Scriptures prior to the late first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" weighs in favor of a bipartite collection envisioned in the Prologue to Ben Sira.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Terminological Distinctions")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For clarity and to avoid maximalist overinterpretation, it is essential to distinguish between terms or realities that are closely associated with the concept of canon but are not identical with it. An "), _c('em', [_vm._v("authoritative")]), _vm._v(" work is one which a group, whether secular or religious, recognizes and accepts as determinative for its conduct, and as of a higher order than can be overridden by the power or will of the group or any member. An example would be a constitution or law code. A book of "), _c('em', [_vm._v("Scripture")]), _vm._v(" is a sacred authoritative work believed to have God as its ultimate author, which the community recognizes and accepts as determinative for its belief and practice; it is not necessarily a fixed text but may be still developing and circulating in several textual forms. "), _c('em', [_vm._v("A collection of authoritative Scriptures,")]), _vm._v(" as opposed to a canon, is an open collection to which more books can be added. Certainly such a collection was recognized as fundamental to the Jewish religion from sometime in the first half of the Second Temple period; at that time it was probably confined to the Law of Moses, as attested by the OG translation of the Pentateuch and the Samaritan canon. According to the distinction between “a collection of authoritative books” and “an authoritative collection of books,” throughout the Second Temple period the collection was growing and thus there was not yet a canon.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("A "), _c('em', [_vm._v("canon,")]), _vm._v(" as defined above, is a religious body’s official, definitively debated ")]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("and permanently decided, exclusive list of inspired, authoritative books that constitute its recognized corpus of sacred Scripture. The "), _c('em', [_vm._v("Bible,")]), _vm._v(" in the singular, denotes a textual form of the collection of canonical books. In contrast to the canon, which is the normative list of the books, the Bible is the text of that collection of books, conceived of as a single anthology, and usually presented physically as such. Thus, the term is probably anachronistic prior to the codex format of the collection. “The Scriptures” can be an open collection, but the “Bible” connotes an already closed collection.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("canonical process")]), _vm._v(" is the journey of the many disparate works of literature within the ongoing community from their early stages when they began to be considered as somehow authoritative, through the sifting and endorsement process, to the final judgment concerning their inspired character as the unified and defined collection of Scripture — that is, until the reflective judgment of recognition that officially constituted the canon. "), _c('em', [_vm._v("Canon")]), _vm._v(" as such is a static concept, the result of a retrospective conclusion that something has come to be. Until that final decision is reached, "), _c('em', [_vm._v("process toward canon")]), _vm._v(" or "), _c('em', [_vm._v("canonical process")]), _vm._v(" is preferable. Some speak of an “open canon” or of “adaptability” as the primary characteristic of the canon; but the canon is by definition closed, and so an “open collection” is preferable; and adaptability is a function, not the essence, of the canon — how it is used, not what it is.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("The Evidence from Qumran for the Process toward Canon")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the absence of clear early written discussion, surveying the Qumran evidence can be somewhat illuminating, especially since it generally agrees with the New Testament evidence. Criteria of varying strengths for canon or scriptural status would be: (a) a title of the canon or its parts, or a list of its books; (b) formulas that introduce explicit quotations of Scripture; (c) books explicitly quoted as Scripture; (d) multiple copies of a book; (e) books on which commentaries were written; and (f) books that were translated into the vernacular languages.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("Unfortunately, the Dead Sea Scrolls provide no conclusive evidence for determining the exact contents of the collection that the covenanters considered the authoritative books of Scripture or whether they even discussed the question. But that they regarded the Law and the Prophets as divinely revealed Scripture is clear from statements such as “[God] commanded through Moses and all his servants the prophets” (1QS 1:1-3), “As you said through Moses” (1QM 10:6), and “As God said through Isaiah the prophet” (CD 4:13). Thus, there is (a) no clear evidence for a canon of Scripture, but (b) certitude regarding the Law and the Prophets as Scripture. (c) Isaiah and the Minor Prophets are quoted nine times, pentateuchal books (but not Genesis) and Ezekiel 1–5 times; the only others are Psalms and Daniel 2, and one each for Jeremiah, Proverbs, and "), _c('em', [_vm._v("Jubilees.")]), _vm._v(" The Former Prophets and the remainder of the Writings are never quoted (except for the prophetic oracle in 2 Samuel 7). (d) There are thirty-six Hebrew copies of the Psalms, thirty of Deuteronomy, twenty-one of Isaiah, twenty of Genesis, seventeen of Exodus, fourteen of "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" thirteen of Leviticus, twelve (or twenty?) of "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" eight of the Minor Prophets and ")]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("Daniel, seven of Numbers, six of Jeremiah and Ezekiel, and five of Tobit. The Former Prophets and the Writings all have four or fewer copies — fewer than the "), _c('em', [_vm._v("Community Rule,")]), _vm._v(" the "), _c('em', [_vm._v("Damascus Document,")]), _vm._v(" the "), _c('em', [_vm._v("Hodayot,")]), _vm._v(" and the "), _c('em', [_vm._v("War Scroll.")]), _vm._v(" (e) Exegetical commentaries treat only the Law and the Prophets (Isaiah, the Minor Prophets, and Psalms). Finally, (f) the Qumran texts show only the Torah (and possibly "), _c('em', [_vm._v("1 Enoch")]), _vm._v(") translated into Greek, while Aramaic targums were rare: one for Leviticus and two for Job. The Greek Minor Prophets scroll from Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever, however, adds valuable evidence. Since this scroll from the turn of the era is already in revised Greek form, it indicates that the original Greek translation of the main prophetic books had also been accomplished at least by the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Admittedly, the evidence for each criterion is only suggestive; but the combination is quite persuasive. It is clear that the books of the Torah and the Prophets (including Psalms and Daniel) were considered Scripture. "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" have a strong claim. Job and possibly Proverbs might qualify. But regarding the Former Prophets and the remainder of the Writings, it can only be claimed that the literature was known to the Qumran covenanters; it may or may not have been considered Scripture, though the presence of four copies of Canticles presumably indicates that it was read at least as spiritual allegory.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Shifts in the Process toward Canon")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While the terminology regarding the canonical process may be clarified, and the evidence from Qumran may witness to certain Scriptures but no canon yet, the waters remain largely uncharted for the more important and intriguing issue of the socio-political struggles and theological debates that formed the path to the eventual canon. A few turns in the path, however, can be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, there was a shift from national literature to sacred Scripture, described above. Some works of Israel’s literature became recognized as having divine origin and thus were regarded as sacred Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, there was a shift in the understanding of revelation. Whereas revelation had been seen as dynamic and a continuing possibility, gradually it was viewed as verbal and recorded in the distant past. This gets expressed in the ancient (and a lingering modern) conviction regarding the cessation of prophecy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, there was a shift from a religion centered primarily on the Temple and its rituals to a religion centered on its texts. This was a result of the destruction of the Temple and the ability of shared texts to function as a unifying force even for a people spread throughout Diaspora communities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fourth, vague consciousness had to give way to clear decisions regarding the scriptural status of books toward the periphery. The new focus on sacred texts as Judaism’s centripetal force required new questions, scrutiny, debate, and decisions about the relative status of various texts. While all Jews recognized the sanctity of the Torah and most recognized divine revelation in a collection of prophetic books, now decisions had to be made concerning which books belonged in the “Prophets” collection and whether extra books might also deserve to be accorded supreme authority.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Fifth, a dramatic shift replaced textual pluriformity with uniformity. Throughout the Second Temple period, the texts were characterized by fluidity, pluriformity, and creativeness in composition. But the shocks of the two revolts and the increased importance of the texts precluded further development. This shift, which froze each book in a single textual form, happened quite abruptly in the late first or early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("; it is often referred to as “stabilization,” but “freezing” or “termination of development” is more accurate, since it was not a textual process but simply a cessation.")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sixth, the format of the books of the Scriptures shifted from individual scrolls to codex. Whereas a scroll usually contained one or at most two books, a codex could contain a large number of books. Thus, decisions whether a book was recognized as sacred Scripture were more pressing when considering its inclusion in, or exclusion from, a single collection between front and back covers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the end of the lengthy process of composition and development of the Scriptures from their beginnings and through the late shifts just described, came the Romans. After two failed revolts by the Jews, the Qumran covenanters were no more; the Samaritans remained apart; the Jewish followers of Jesus inherited a large, not yet delimited collection of Scriptures emphasizing the prophetic writings. The rabbis eventually restricted the collection to twenty-four books, rejecting "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" Ben Sira, and others; de-emphasizing certain apocalyptic and messianic aspects; and focusing on the sapiential rather than prophetic character of the Psalms and Daniel.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Abegg, Martin, Peter Flint, and Eugene Ulrich. 1999. "), _c('em', [_vm._v("The Dead Sea Scrolls Bible: The Oldest Known Bible Translated for the First Time into English.")]), _vm._v(" San Francisco: HarperSan-Francisco.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Auwers, J.-M., and H. J. De Jonge, eds. 2002. "), _c('em', [_vm._v("The Biblical Canons.")]), _vm._v(" Leuven: Leuven University Press and Peeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cross, Frank Moore, and Shemaryahu Talmon, eds. 1975. "), _c('em', [_vm._v("Qumran and the History of the Biblical Text.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fernández Marcos, N. 2000. "), _c('em', [_vm._v("The Septuagint in Context: Introduction to the Greek Versions of the Bible.")]), _vm._v(" Trans. W. G. E. Watson. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flint, Peter W., and James C. VanderKam, eds. 1998. "), _c('em', [_vm._v("The Dead Sea Scrolls after Fifty Years: A Comprehensive Assessment.")]), _vm._v(" 2 vols. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harl, Marguerite, Gilles Dorrival, and Olivier Munnich. 1988. "), _c('em', [_vm._v("La Bible grecque des Septante: Du judaïsme hellénistique au christianisme ancien.")]), _vm._v(" Paris: Cerf and C.N.R.S.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Herbert, Edward D., and Emanuel Tov. 2002. "), _c('em', [_vm._v("The Bible as Book: The Hebrew Bible and the Judaean Desert Discoveries.")]), _vm._v(" London: British Library and Oak Knoll Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McDonald, Lee M., and James A. Sanders, eds. 2002. "), _c('em', [_vm._v("The Canon Debate.")]), _vm._v(" Peabody, Mass.: Hendrickson.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mulder, Martin Jan, ed. 1988. "), _c('em', [_vm._v("Mikra: Text, Translation, Reading and Interpretation of the Hebrew Bible in Ancient Judaism and Early Christianity.")]), _vm._v(" Assen: Van Gorcum; Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Purvis, James D. 1968. "), _c('em', [_vm._v("The Samaritan Pentateuch and the Origin of the Samaritan Sect.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sanderson, Judith E. 1986. "), _c('em', [_vm._v("An Exodus Scroll from Qumran: 4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(" and the Samaritan Tradition,")]), _vm._v(" Atlanta: Scholars Press.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("Schiffman, Lawrence H., and James C. VanderKam, eds. 2000. "), _c('em', [_vm._v("The Encyclopedia of the Dead Sea Scrolls.")]), _vm._v(" 2 vols. New York: Oxford University Press.")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Shepherd, David. 2004. "), _c('em', [_vm._v("Targum and Translation: A Reconsideration of the Qumran Aramaic Version of Job.")]), _vm._v(" Assen: Van Gorcum.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sokoloff, Michael. 1974. "), _c('em', [_vm._v("The Targum to Job from Qumran Cave XI.")]), _vm._v(" Ramat-Gan: Bar-Ilan University.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tov, Emanuel 1999. "), _c('em', [_vm._v("The Greek and Hebrew Bible: Collected Essays on the Septuagint.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2001. "), _c('em', [_vm._v("Textual Criticism of the Hebrew Bible.")]), _vm._v(" 2d ed. Minneapolis: Fortress; Assen: Royal Van Gorcum.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Trebolle Barrera, Julio. 1998. "), _c('em', [_vm._v("The Jewish Bible and the Christian Bible: An Introduction to the History of the Bible.")]), _vm._v(" Leiden: Brill; Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ulrich, Eugene. 1999. "), _c('em', [_vm._v("The Dead Sea Scrolls and the Origins of the Bible.")]), _vm._v(" Grand Rapids: Eerdmans; Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Van der Ploeg, J. P. M., and A. S. van der Woude. 1971. "), _c('em', [_vm._v("Le Targum de Job de la Grotte XI de Qumrân.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("VanderKam, James C., and Peter W. Flint. 2002. "), _c('em', [_vm._v("The Meaning of the Dead Sea Scrolls: Their Significance for Understanding the Bible, Judaism, Jesus, and Christianity.")]), _vm._v(" San Francisco: HarperSanFrancisco.")])])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('em', [_vm._v("Early Jewish Biblical Interpretation")])])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" L. K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scripture was, by all accounts, a major interest, if not to say an obsession, among a broad spectrum of Jews in the Second Temple period. People argued, sometimes violently, about the meaning of this or that verse in the Torah (Pentateuch), or about the proper way to carry out one or another of its laws. People also "), _c('em', [_vm._v("wrote")]), _vm._v(" a great deal about Scripture: numerous compositions that have survived from the Second Temple period seek to explain various scriptural prophecies and songs and stories, and even those books that are not explicitly exegetical are usually replete with allusions to Scripture and scriptural interpretation. Moreover, a whole new institution emerged in this period, the synagogue, a place where people might gather specifically for the purpose of studying Scripture; indeed, the synagogue went on to become a (one might even say "), _c('em', [_vm._v("the")]), _vm._v(") major Jewish institution, both within the land of Israel and in the Diaspora.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("But perhaps the most striking evidence of Scripture’s importance comes from the Dead Sea Scrolls, a collection of writings found at Qumran, south of Jericho. This library, apparently the possession of a particular Jewish community that flourished at the end of the Second Temple period, is itself a most impressive thing, consisting of roughly 800 individual manuscripts. (It was no doubt still larger at one point: some of its original contents have certainly been lost to the depredations of nature or human hands.) The library contained not one or two copies of what was to become our Hebrew Bible, but, for example, thirty-six different manuscripts of the Psalms, twenty-nine copies of Deuteronomy, and so forth. In all, these scriptural manuscripts made up a little more than a quarter of the library’s total contents. But the remaining three-quarters were scarcely less tied to Scripture: nearly all of these other compositions seek, in one way or another, to explain, allude to, or expand upon things found in biblical books. Indeed, the rules governing the daily life of the community that lived at Qumran specify that the study of Scripture is to be a steady, ongoing activity: “Anywhere where there are ten people, let there not be lacking a man expounding the Torah day and night, continuously, concerning the right conduct of a man with his fellow. And let the ")]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("[Assembly of the] Many see to it that in the community a third of every night of the year [is spent] in reading the Book and expounding the Law and offering blessings together” (1QS 6:6-8).")])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In short, Scripture was on nearly everyone’s mind. The words of Ps. 119:97 — “How I love your Torah; I speak of it all day long” — might have served as the motto of "), _c('em', [_vm._v("all")]), _vm._v(" the different Jewish communities and sects in Second Temple times. Now when one stops to consider this state of affairs in its larger context, it should appear more than a little strange. After all, religious piety elsewhere in the ancient Near East consisted principally of the offering of animal sacrifices at one or another sanctuary, participation in mass religious revels with singing and dancing, or solemn rites to ward off evil and demonic forces. None of these elements was absent from Second Temple Judaism, but along with them, and ultimately displacing them, was the oddest sort of act: reading words written centuries earlier and acting as if they had the highest significance for people in the present age. How did this come about?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Rise of the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The idea of a specific set of writings called the Bible did not exist before the end of the Second Temple period. Before that, there existed a somewhat inchoate group of books considered sacred by one or more of the various religious communities that flourished during this period. The heart of Scripture, all communities agreed, was the Torah or Pentateuch, that is, the biblical books of Genesis, Exodus, Leviticus, Numbers, and Deuteronomy. These books were attributed to the authorship of Moses, and from an early time their laws in particular were looked to for guidance in matters of daily life. Along with them were other works — historical writings covering the period from the death of Moses to later times; prophetic books and visions associated with various figures from the past; psalms, hymns, and similar works, many attributed to King David; wise sayings and other wisdom writings, some attributed to King Solomon; and so forth. Some of these texts were actually composed within the Second Temple period, but many went back far earlier, to the time before the Babylonian exile in the sixth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" For example, most modern scholars agree that large parts of our biblical books of Isaiah, Hosea, Amos, and Micah go back to the eighth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("; to a still earlier period belong a number of other texts — for example, some of the songs and psalms found in the Bible, along with a portion of the historical and legendary material later included in different books.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("If these texts had thus been preserved for hundreds of years before the start of the Second Temple period, they must have played some active role in the lives of those who preserved them. After all, the parchment or papyrus on which texts were generally written begins to disintegrate after a century or so; recopying books was a tedious, and expensive, process. If these writings were nonetheless saved and recopied, it seems likely that, far back into the biblical period, people were using them for some purpose. Ancient laws were no doubt written down to preserve their exact wording, so that they might be explicated and applied to real-life cases; if ")]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("psalms and hymns were similarly recorded, it was probably because they were an actual part of the liturgy in use at one or another ancient sanctuary; tales of past heroes and their doings were written down to be read in court or at festive occasions; and so forth.")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, it is only some time after the return from the Babylonian Exile at the end of the sixth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" that we begin to find frequent reference to the Scripture (principally the Pentateuch) and its interpretation. This is truly the time when these ancient texts begin to move to center stage in Judaism. Several factors combined to make Scripture so important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of these is a rather universal phenomenon. Scripture may have come to play a particularly important role in Judaism, but in many religions and civilizations (some of them quite unrelated to Judaism), writings from the ancient past also play a special role — the Vedas in Hinduism, the Zoroastrian Avesta, the writings of Confucius, and so forth. What is behind this phenomenon? With regard to premodern societies, our own view of knowledge as a dynamic, ever-expanding thing is rather inappropriate. In such societies people generally conceived of knowledge as an altogether static, unchanging thing, and they therefore tended to attach great significance to the wisdom found in writings from the ancient past. Indeed, as the chronological distance between such writings and themselves increased, so too did the esteem in which these ancient pronouncements were held. After all, what the ancients knew, or what had been revealed to them, was timeless truth, part of that great, static corpus of knowledge; it could never be displaced by later insights (nor would anyone want it to be).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Israel’s ancient writings had no doubt long enjoyed a similar cachet. But added to this were several more specific things that heightened the role of Scripture in the early postexilic period. The first was the fact of the Babylonian Exile itself. Though it lasted scarcely more than half a century, it profoundly disrupted things for the exiled Jews. Institutions like the royal court, the Jerusalem Temple, and other formerly crucial centers were no more; soon, the traditions and ways of thought associated with them began to fade. Instead, the exiles’ heads were now filled with foreign institutions, a foreign language, and a way of thinking that hardly bothered to take account of the tiny nation from which they had come. Under such circumstances, Israel’s ancient writings offered an island of refuge. Here, the royal court and the Jerusalem Temple still lived in their full glory; here the God of Israel still reigned supreme, and His people and their history occupied center stage; and here was the exiles’ old language, the Judean idiom, written down in the classical cadences of its greatest prophets and sages. It seems altogether likely that, during those years in Babylon, such writings as had accompanied the Judeans into exile only grew in importance — if not for all, then at least for some significant segment of the population. And once the exile was over, these same ancient texts continued in this role: they were the history of the nation and its pride, a national literature and more than that, a statement about the ongoing importance of the remnants of that kingdom, for its God, and for the world.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('strong', [_vm._v("The Mode of Restoration")])])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When the Babylonian Empire collapsed and its conqueror, the Persian king Cyrus, issued his famous decree (538 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") allowing the exiled Judeans to return to their homeland, the ancient writings took on an additional, and still more central, role. After all, not all the exiles took up Cyrus’ offer. Some had settled into life in Babylon, whatever its hardships, and were loath to make the long trek back to an uncertain future in their ancestral home. The returnees were thus a self-selected group. All of them had, in one way or another, resolved to go back to the place of an earlier existence. No doubt their motives varied, but this "), _c('em', [_vm._v("mode of restoration,")]), _vm._v(" of going to back to what had been before, was common to all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But how exactly could one know what had been before? The landscape itself was mute; one could not pick up a rock or interrogate a tree to find out. The past lived only in those same ancient writings, and to the extent that the returnees sought consciously to restore their land and themselves to a former way of being, their first point of reference was necessarily what those texts said or implied about how things had been before the Exile. Israel’s ancient writings thus acquired a potentially "), _c('em', [_vm._v("prescriptive")]), _vm._v(" quality. What they said about the past could easily be translated into a potential program for the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course, the returnees were not all of one mind. Some wished only to settle down to life as residents of an obedient province in the Persian Empire, while others clung to the hope that their nation would soon find the opportunity to shake off foreign rule and return to political independence, indeed, to regain the political and military preeminence that had existed in the days of David and Solomon. Descendants of the former power elites — members of prominent families and clans, not to speak of the royal dynasty and the hereditary priesthood — must have hoped that the old social order would be re-created. Others — visionaries, prophets, reformers of various allegiances — saw in the return from exile just the opposite prospect, an opportunity to reshuffle the social deck. But precisely because all were in this "), _c('em', [_vm._v("mode of restoration,")]), _vm._v(" they all sought to use accounts of the past to justify their own plans for the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the most striking illustrations of this mentality is the biblical book of Chronicles, composed, according to most scholars, relatively early in the postexilic period. Although much of this book simply repeats material narrated in the biblical books of Samuel and Kings, modern scholarship has revealed subtle changes introduced here and there by the author of Chronicles, changes that embodied his own definite program for the future. He believed, for example, that the Davidic monarchy should be restored, and he looked forward to a day when the inhabitants of Judah would join forces with their northern neighbors in Samaria to form a great, United Kingdom as in days of old. He also had his own ideas about the Temple, the priesthood, and the very nature of God. Yet he did not put these ideas forth in the form of a political manifesto or religious tract. Instead, he presented them as part of a history of preexilic times, in fact, a crafty rewriting of that history that would stress all that he believed in while suppressing everything else. Why did he do so? The apparent reason is that he, and the rest of his countrymen, looked to the past for guidance about what to do in their own time.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_124"
    }
  }), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('strong', [_vm._v("The Laws of the Pentateuch")])])]), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Of all the writings that made up Israel’s Scripture, it was probably the laws of the Pentateuch that played the most important role in restored Judea. These laws covered all manner of different things: civil and criminal law, Temple procedure, ethical behavior, ritual purity and impurity, proper diet, and so forth. Nowadays, a country’s laws do not play a very active part in most people’s lives — certainly not in their religious lives. Someone who breaks the law may have to pay a fine or even go to prison, but this in itself has no particular spiritual dimension. Likewise, someone who upholds the law may be proud to be a good citizen, but nothing more. In restored Judea, by contrast, the laws of the Pentateuch were held to come from God, and this automatically gave them a wholly new significance. To break a law ordained by God was not merely to commit a crime; it was to commit a sin. Likewise, observing the laws and doing what they said was not merely good citizenship but a form of divine service, a way of actively seeking to do God’s will. This view of things may have existed in preexilic times, but it became particularly prominent after the return from exile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps it was the very course of recent events that made Second Temple Jews so concerned with biblical law. Many of them must have asked themselves why their homeland had been conquered by the Babylonians, and why the Babylonian Empire had in turn collapsed shortly thereafter. Some, no doubt, gave to these questions a purely practical answer: the Babylonian army was simply stronger than that of little Judah, so it won; similarly, once the Medes and the Persians had combined forces, they easily overcame the Babylonians and took over their whole empire. But the Bible contains a different, more theological explanation: God "), _c('em', [_vm._v("allowed")]), _vm._v(" His people to be conquered as a punishment for their failure to keep His laws, the great covenant He had concluded with their ancestors. “Surely this came upon Judah at the command of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("” (2 Kings 24:3). By the same token, lest anyone think it was by any merit of the Babylonians that Judah had been overcome, He subsequently dispatched the Persian army to reduce them to ruin. So now, returned to their ancient homeland, the Judeans (or at least some of them) set out to draw the obvious theological conclusion and avoid repeating their ancestors’ mistake. This time they would scrupulously obey all of God’s commandments; this time, everyone would be an expert in the application of divine law, so that there would be no mistakes (Jer. 31:31-34).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was probably another, more practical side to the importance attributed to these ancient laws. The Bible reports that the Persian administration actually adopted them as part of the Israelite legal system to be instituted in their new colony. The Persian king Artaxerxes I is thus reported to have written a letter to Ezra, a Jewish priest and sage who took over as a leader of the reestablished community:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“And you, Ezra, according to the God-given wisdom you possess, appoint magistrates and judges who may judge all the people in the province [of Judah] who know the "), _c('em', [_vm._v("laws of your God;")]), _vm._v(" and you shall teach those who do not know them. All who will not obey the law of your God and the law of the king, let judgment be strictly executed on them.” (Ezra 7:25-26)")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("It may always be, of course, that one or another element in the Bible is the result of exaggeration or wishful thinking on the part of the biblical historian, but skepticism in this case is probably unwarranted. Other, extrabiblical sources have shown the Persians to have generally been enlightened rulers who sought to accommodate their subject peoples by, among other things, maintaining the local legal system; it would simply have been good sense to adopt such an approach with the Judeans as well.")])]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Rise of Biblical Interpreters")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For all such reasons, Scripture came to be a major focus of attention in the Second Temple period. But Scripture needed to be interpreted in order to be understood. So it was that a new figure emerged in Judean society, the biblical interpreter, and he would soon become a central force in postexilic society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of our first glimpses of this new figure at work is found in the biblical account of Ezra’s public reading of the Torah to the assembled returnees in Jerusalem:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("When the seventh month came — the people of Israel being settled in their towns — all the people gathered together into the square before the Water Gate. They told the scribe Ezra to bring the book of the Law of Moses, which the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" had given to Israel. Accordingly, the priest Ezra brought the Law before the assembly, both men and women and all who could hear with understanding. This was on the first day of the seventh month. He read from it facing the square before the Water Gate from early morning until midday, in the presence of the men and the women and those who could understand; and the ears of all the people were attentive to the book of the Law. The scribe Ezra stood on a wooden platform that had been made for the purpose…. And Ezra opened the book in the sight of all the people, for he was standing above all the people; and when he opened it, all the people stood up. Then Ezra blessed the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", the great God, and all the people answered, “Amen, Amen,” lifting up their hands. Then they bowed their heads and worshiped the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" with their faces to the ground. Also Jeshua, Bani, Sherebiah, Jamin, Akkub, Shabbethai, Hodiah, Maaseiah, Kelita, Azariah, Jozabad, Hanan, Pelaiah, the Levites, "), _c('em', [_vm._v("helped the people to understand the law,")]), _vm._v(" while the people remained in their places. So they read from the book, from the Law of God, "), _c('em', [_vm._v("with interpretation.")]), _vm._v(" They gave the sense, so that the people understood the reading. (Neh. 7:73b–8:8)")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("A few things stand out in this account. It is not at Ezra’s initiative, but that of the people, that this great public reading is said to have taken place. Apparently, “all the people” knew that this great book of law (presumably our Pentateuch) existed, but they were still somewhat fuzzy about its contents. So they willingly stood for hours, “from early morning until midday,” in order to hear its words firsthand. It is remarkable that this assembly included “both men and women and all who could hear with understanding,” that is, children above a certain age: the Torah’s words were, according to this passage, not reserved for some elite, or even for the adult ")]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("males of the population, but were intended for the whole people to learn and apply. But — most significantly for our subject — this public reading is accompanied by a public "), _c('em', [_vm._v("explanation")]), _vm._v(" of the text. The Levites “helped the people to understand the Law, while the people remained in their places”; thus, “they read from the book, from the Law of God, "), _c('em', [_vm._v("with interpretation.")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Why should Scripture have needed interpreters? No doubt the need began with very down-to-earth matters. After all, every language changes over time, and by the Second Temple period some of the words and expressions used in preexilic texts were no longer understood. Even such basic concepts as "), _c('em', [_vm._v("get, take, need, want, time,")]), _vm._v(" and "), _c('em', [_vm._v("much")]), _vm._v(" were expressed with new terms by the end of the biblical period; the old words had either shifted their meaning or dropped out of the language entirely. Under such circumstances, some sort of interpreter would be necessary to make the meaning of the ancient text comprehensible. The same was true with regard to other things — names of places that no longer existed or historical figures or events long forgotten or social institutions that had ceased to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to such relatively mundane matters, however, interpreters ultimately came to address far broader and more consequential questions. As already discussed, the returning exiles had looked to texts from the ancient past in order to fashion their own present, and this way of approaching Scripture as "), _c('em', [_vm._v("prescriptive for the present")]), _vm._v(" went on long after the return from exile was an established fact; interpreters continued to look to these ancient writings for a message relevant to their own day. But at first glance, at least, much of Scripture must have seemed quite irrelevant. It talked about figures from the distant past: what importance could their stories have to a later day other than preserving some nostalgic memory of people and events long gone? Why should anyone care about laws forbidding things that no one did any more anyway, indeed, things that no one even understood anymore? Part of the interpreter’s task was thus to make the past relevant to the present — to find some practical "), _c('em', [_vm._v("lesson")]), _vm._v(" in ancient history, or to reinterpret an ancient law in such a way as to have it apply to present-day situations, sometimes at the price of completely distorting the text’s original meaning. It appears that interpreters only gradually assumed these functions, but as time went on, they became more daring in the way they went about things while, at the same time, settling into a more important and solid niche in Judean society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the case of Ezra’s reading, we have no way of knowing what sort of interpretation was involved. Was it a matter of explaining an odd word or phrase here or there? Or were the interpreters (as one ancient Jewish tradition has it) actually translating the whole text word-for-word, presumably into Aramaic, then the "), _c('em', [_vm._v("lingua franca")]), _vm._v(" of the Near East? Or did they go beyond even this, explaining how this or that biblical law was to be applied — what was involved in “doing no work” on the Sabbath, for example?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Interpretation inside the Bible")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("If the Bible provides no solid leads in the case of Ezra’s reading, it does offer a number of other examples of ancient biblical interpretation; in fact, the most ")]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("ancient examples of biblical interpretation that we have are found within the Bible itself, where later books explain or expand on things that appear in earlier books. Often, the things that ancient interpreters felt called to comment upon were apparent inconsistencies or contradictions within the biblical text. Take, for example, the law in Exodus about the Passover meal:")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Tell the whole congregation of Israel that on the tenth of this month they are to take a lamb for each family, a lamb for each household. If a household is too small for a whole lamb, it shall join its closest neighbor in obtaining one; the lamb shall be divided in proportion to the number of people who eat of it. Your lamb shall be without blemish, a year-old male; you may take it from the sheep or from the goats…. They shall eat the lamb that same night; they shall eat it roasted over the fire with unleavened bread and bitter herbs. Do not eat any of it raw or boiled in water, but roasted over the fire, with its head, legs, and inner organs. (Exod. 12:3-9)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This passage could hardly be less ambiguous: the Passover meal was to feature the meat of a lamb (though, apparently, goat meat was also acceptable, “from the sheep or from the goats”), and it was not to be boiled, but roasted. But if so, then how is one to explain this passage from Deuteronomy?")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("You shall offer the Passover sacrifice to the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God, from the "), _c('em', [_vm._v("flock and the herd,")]), _vm._v(" at the place that the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will choose as a dwelling for his name. You shall "), _c('em', [_vm._v("boil it")]), _vm._v(" and eat it at the place that the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God will choose; the next morning you may go back to your tents. (Deut. 16:2, 7)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The phrase “from the flock and the herd” presumably means that a calf or a bull would be just as acceptable as a lamb or goat, and whichever animal was chosen, its meat was apparently to be boiled — precisely what the earlier passage had forbidden. What was a person to do?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The author of the book of Chronicles, an early postexilic work, seems to have been aware of the contradiction between these two texts, since he addressed at least part of it in his own history:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("They [the Israelites] slaughtered the Passover offering, and the priests dashed the blood that they received from them, while the Levites did the skinning…. Then they "), _c('em', [_vm._v("boiled the Passover offering in fire")]), _vm._v(" according to the ordinance…. (2 Chron. 35:13)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Boiled” — the same word used earlier by Deuteronomy — need not necessarily mean “boiled in water,” this passage suggests; instead, it might just be a circumlocution for roasting, that is, “boiling in fire.” If so, then there really was no contradiction between the Exodus and Deuteronomy passages — both of them really meant “roast”; it was just that Deuteronomy had, for some reason, not used that word explicitly.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("Another little problem found within an early book of the Bible was addressed ")]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("by a later one; this time, the issue concerned the inheritance rights of the firstborn son. According to biblical law, the firstborn son was to receive a larger portion of his father’s estate — just because he was the firstborn. But what happened if the father had two wives and wished to give precedence to the son of his other wife, even though that son was not his first? This was probably not an uncommon situation, since the law in Deuteronomy is quite emphatic:")])]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("If a man has two wives, and one of them is favored over the other, and if both the favored one and the other have borne him sons, the firstborn being the son of the disfavored one; then on the day when he wills his possessions to his sons, he is not permitted to grant the son of the favored wife preference over the son of the other, who is the firstborn. Instead, he must acknowledge as firstborn the son of the one who is not favored, giving him a double portion of all that he has; since he is the first issue of his virility, the right of the firstborn is his. (Deut. 21:15-17)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The firstborn son is to get the double portion no matter how the father feels about the boy’s mother. But if so, then how does one explain what happened in the biblical story of Jacob and his sons? Jacob marries Leah and Rachel, but it is clear from the start that Rachel is his favorite (Gen. 29:17-18). Nevertheless, Reuben, Leah’s son, is Jacob’s oldest boy, so by rights the double portion is to be his. As things turn out, however, Reuben gets pushed aside: it is Joseph, Rachel’s son, who effectively ends up with the extra inheritance (Gen. 48:5-6). To later readers of Scripture, this surely seemed to be a blatant violation of biblical law. To make matters worse, Reuben kept being referred to as Jacob’s “first-born” (Exod. 6:14; Num. 1:20; 26:5; etc.). Was he — and if so, why did he lose his inheritance?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once again, the author of Chronicles went out of his way to explain an apparent contradiction in the text:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The sons of Reuben, the firstborn of Israel [that is, Jacob]. (He "), _c('em', [_vm._v("was")]), _vm._v(" the firstborn, but because he defiled his father’s bed, his birthright was given to the sons of Joseph son of Israel, so that he is not enrolled in the genealogy according to the birthright.) (1 Chron. 5:1)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In Reuben’s case, the Chronicler explains, an exception was made to the general rule because of Reuben’s egregious sin with his father’s concubine (Gen. 35:22). He was still, in genealogical terms, the firstborn, but the firstborn’s special inheritance (the “birthright”) was given instead to Joseph, Rachel’s son.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Interpretations outside the Bible")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("Biblical scholars have been diligent in uncovering little spots of interpretation such as these within the Hebrew Bible itself: later versions of earlier laws sometimes modify their wording or reconfigure their application; original biblical ")]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("prophecies are sometimes supplemented or rearranged to stress the new interpretation now given to them; later editors sometimes inserted phrases that glossed earlier texts whose wording was no longer understood. But considered as a whole, these inner-biblical interpretations pale before the great body of ancient interpretation that has been preserved outside of the Jewish Bible, in works composed from about the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and beyond. This was the golden age of biblical interpretation, the period in which various groups of (largely anonymous) interpreters put their stamp on the Hebrew Bible and determined the basic way in which the Bible would be interpreted for the next 2,000 years.")])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The writings in which their interpretations are attested are quite varied. Some of them are originally Jewish compositions included in Christian Bibles — identified there as “Deuterocanonical Books” or “Old Testament Apocrypha” — works such as the Wisdom of Jesus Ben Sira (second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") and the Wisdom of Solomon (first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" or "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). Others are categorized as “pseudepigrapha,” compositions falsely ascribed to ancient figures from the Bible but actually written in a later period — works such as the book of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" (early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") or the "), _c('em', [_vm._v("Testament of Abraham")]), _vm._v(" (first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" or "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). Much ancient biblical interpretation is also preserved in the Dead Sea Scrolls; some of these texts go back to the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" or earlier. Ancient translations, such as the Old Greek (Septuagint) translation of the Pentateuch (third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") or various targums, translations of the Bible into Aramaic (probably originating in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" or earlier, though later material was often added in the process of transmission), also contain reflections of ancient biblical interpretation. Hellenistic Jewish writers such as Philo of Alexandria (ca. 20 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("–ca. 50 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") and Josephus (ca. 37 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("–100 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") also present a great deal of biblical interpretation — part of it entirely of their own fashioning, but much else gathered from or influenced by the work of earlier interpreters. Christian writings of the first two centuries "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", including the New Testament and other early compositions, also contain a good deal of biblical interpretation — much of it rooted in the pre-Christian exegesis. Finally, later Jewish writings such as the Mishnah (put in its final form around 200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("), along with the Tosefta and the tannaitic midrashim (both from roughly the same period), contain a great deal of exegetical material, much of it continuing the line of earlier biblical interpretation. Considered together, this is a vast body of writings, many times greater than the Hebrew Bible itself. In studying it, scholars are able to piece together a developmental history of how the Bible was understood starting early in the second "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" or so and continuing through the next three or four hundred years — a crucial period in the Bible’s history.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("A note about the form of biblical interpretation: relatively few of the abovementioned texts are written in the form of actual "), _c('em', [_vm._v("commentaries,")]), _vm._v(" that is, writings that cite a biblical verse and then explain what the interpreter thinks the verse means. Such commentaries did exist — they were the preferred genre of Philo of Alexandria, and commentary-like texts have been found as well among the Dead Sea Scrolls. But the favorite form for transmitting biblical interpretation in writing was the "), _c('em', [_vm._v("retelling.")]), _vm._v(" Most writers simply assumed that their readers would be familiar with the biblical text, indeed, familiar with the exegetical problems associated ")]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("with this or that verse. So he or she would retell the text with little interpretive insertions: a word no longer understood would be glossed or replaced with a word whose meaning everyone knew; an apparent contradiction would be resolved through the insertion of an explicative detail; the retelling would take the trouble to explain "), _c('em', [_vm._v("why")]), _vm._v(" A or B had done what they did, or "), _c('em', [_vm._v("how")]), _vm._v(" they did it, thereby answering a question left open in the laconic biblical version of the same story. Such retellings are a common phenomenon in ancient interpretation: the book of "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" the "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" from Qumran, and Pseudo-Philo’s "), _c('em', [_vm._v("Book of Biblical Antiquities")]), _vm._v(" are good examples of compositions that are, from start to finish, interpretive retellings. So, in a sense, are Aramaic targums such as that of "), _c('em', [_vm._v("Pseudo-Jonathan")]), _vm._v(" or "), _c('em', [_vm._v("Neofiti;")]), _vm._v(" they “translate” the Pentateuch into Aramaic, but with so many interpolations that they are actually more like retellings than real translations.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Four Assumptions")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Why was this a crucial period? Because, as already mentioned, these interpreters established the general way in which the Bible was to be approached for the next two millennia — indeed, to a certain extent, their approach is still with us to this day. Their way of reading and explaining texts was anything but straightforward — it was a highly ideological (and idealistic) form of exegesis, one that relied on a somewhat idiosyncratic combination of very close reading and great exegetical freedom. The interpretations these ancient sages came up with soon acquired the mantle of authority; they were memorized and passed on from generation to generation, sometimes modified in one or more detail, but basically maintained as "), _c('em', [_vm._v("what the Bible really means")]), _vm._v(" for hundreds and hundreds of years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As best we can tell, the ancient interpreters were a highly varied lot. Some lived in the land of Judea and were steeped in the Hebrew language and traditional Jewish learning. A few others, however, seem to have lived elsewhere and had a thoroughly Hellenistic education and orientation — for example, the author of the Wisdom of Solomon or Philo of Alexandria, both of whom wrote in Greek, alluded to Greek philosophical ideas, and generally cited Scripture in its Septuagint translation. (Some contemporary scholars doubt that Philo was even competent to read the Hebrew Bible in the original.) And even among those interpreters who inhabited Judea there was great variety: the author of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" was a would-be religious innovator and a bit of a rebel; his contemporary, Ben Sira, was quite the opposite, a creature of the establishment who would probably have refused to sit at the same table with "), _c('em', [_vm._v("Jubilees’")]), _vm._v(" author. Pharisees battled with Sadducees over matters of interpretation, and the proprietors of the Dead Sea Scrolls (most likely to be identified with a third group, the Essenes) disagreed with both these other groups; some of them, having withdrawn to the desert, vowed to keep their own interpretations of Scripture hidden from all but the members of their own community, meanwhile waiting for the “day of vengeance” when God would strike down the other groups for their false teachings and errant practices.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("And yet, for all their diversity, all these ancient interpreters went about the business of interpreting in strikingly similar fashion. It seems as if they all had, as ")]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("it were, the same general set of marching orders; or, to put it differently, they all shared the same basic assumptions about "), _c('em', [_vm._v("how")]), _vm._v(" Scripture is to be interpreted and what its message ought to be. This is most surprising. It would appear likely that if they all shared the same basic approach — one which, as we will see, was very much influenced by the ancient Near Eastern concept of “wisdom” — this was because they were all descended, directly or otherwise, from a “wisdom”-influenced way of thinking about Scripture that existed even before these various groups of interpreters developed.")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("However these groups of ancient interpreters came to exist, modern scholars can, in examining their writings, deduce the basic assumptions underlying their way of explaining biblical texts. These assumptions may be broken down into four fundamental postulates:")]), _vm._v(" "), _c('p', {
    staticClass: "n-list1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("1.")]), _vm._v(" All ancient interpreters assumed that scriptural texts were basically "), _c('em', [_vm._v("cryptic;")]), _vm._v(" that is, while the text may say A, often what it really means is B.")]), _vm._v(" "), _c('p', {
    staticClass: "n-list"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("2.")]), _vm._v(" They also assumed that, although most of Scripture had been written hundreds of years earlier and seemed to be addressed to people back then, its words nevertheless were altogether "), _c('em', [_vm._v("relevant")]), _vm._v(" to people in the interpreters’ own day — its stories contained timeless messages about proper conduct; its prophecies really referred to events happening now, or in the near future; its ancient laws were to be scrupulously observed today, even if they seemed to refer to situations or practices that no longer existed; and so forth. In a word, the basic purpose of Scripture was to "), _c('em', [_vm._v("guide")]), _vm._v(" people nowadays; although it talked about the past, it was really aimed at the present.")]), _vm._v(" "), _c('p', {
    staticClass: "n-list"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("3.")]), _vm._v(" On the face of it, Scripture included texts written by different prophets and sages, people who lived hundreds of years apart from one another and who came from different strata of society. Nevertheless, these diverse writings were assumed to contain "), _c('em', [_vm._v("a single, unitary message.")]), _vm._v(" That is to say, Scripture’s different parts could never contradict one another or disagree on any matter of fact or doctrine; indeed, what Scripture taught would always be perfectly consistent with the interpreters’ own beliefs and practices, whatever they might be (Greek philosophical doctrines; common historical or geographical lore; the halakic teachings of later postbiblical teachers). In short, Scripture was altogether "), _c('em', [_vm._v("harmonious")]), _vm._v(" in all its details and altogether true; carried to its extreme, this approach postulated that there was not a single redundancy, unnecessary detail, or scribal error in the text: everything was perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "n-list"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("4.")]), _vm._v(" Some parts of Scripture directly cite words spoken by God, “And the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" said to Moses …” and so forth. Other parts, however, are not identified as divine speech — the whole court history of King David and King Solomon, for example, or the book of Psalms, whose words are addressed "), _c('em', [_vm._v("to")]), _vm._v(" God. Nevertheless, ancient interpreters came to assume that all of Scripture was "), _c('em', [_vm._v("of divine origin,")]), _vm._v(" that God had "), _c('em', [_vm._v("caused")]), _vm._v(" ancient sages or historians or psalmists to write what they wrote, or that their writings had somehow been divinely guided or inspired. In short, all of Scripture came from God and all of it was sacred.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('strong', [_vm._v("How Interpretation Worked")])])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("To see how these assumptions combined to shape the way in which interpreters interpreted, it might be appropriate to consider an actual text from the Bible, the biblical account of Abraham’s near-sacrifice of his beloved son Isaac:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotet"
  }, [_vm._v("And it came to pass, after these things, that God tested Abraham. He said to him, “Abraham!” and he answered, “Here I am.” He said, “Take your son, your only son Isaac, whom you love, and go to the land of Moriah. Then sacrifice him there as a burnt offering on one of the mountains that I will show you.” So Abraham got up early in the morning and saddled his donkey. He took two of his servants with him, along with his son Isaac; he cut the wood for the burnt offering and then set out for the place that God had told him about. On the third day, Abraham looked up and saw the place from afar. Abraham told his servants, “You stay here with the donkey while the boy and I go up there, so that we can worship and then come back to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-indent"
  }, [_vm._v("Abraham took the wood for the burnt offering and put it on his son Isaac; then he took the fire and the knife, and the two of them walked together. But Isaac said to his father Abraham, “Father?” and he said, “Here I am, my son.” And he said, “Here is the fire and the wood, but where is the lamb for the burnt offering?” Abraham said, “God Himself will provide the lamb for the burnt offering, my son.” And the two of them walked together.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-indent"
  }, [_vm._v("When they came to the place that God had told him about, Abraham built an altar and arranged the wood on it. He then tied up his son Isaac and put him on the altar on top of the wood. Abraham picked up the knife to kill his son. But an angel of the Lord called to him from heaven, and said, “Abraham, Abraham!” And he said, “Here I am.” He said, “Do not harm the boy or do anything to him. For now I know that you fear God, since you have not withheld your son, your only son, from me.” And Abraham looked up and saw a ram caught in a thicket by its horns. Abraham went and took the ram and sacrificed it as a burnt offering instead of his son. (Gen. 22:1-13)")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("Ancient interpreters were no doubt troubled by a number of elements in this story. Did not the very fact of divine omniscience seem to make this divine “test” of Abraham unnecessary? Surely God knew how it would turn out before it took place — He knew, as the angel says at the end of the story, that Abraham was one who “fears God.” So why put Abraham through this awful test? Equally disturbing was Abraham’s apparent conduct vis-à-vis his son. He never tells Isaac what God has told him to do; in fact, when Isaac asks his father the obvious question — “I see fire and the wood for the sacrifice, but where is the sacrificial animal?” — Abraham gives him an evasive answer: “God Himself will provide the lamb for the burnt offering, my son.” This actually turns out to be true; God does provide a ram at the last minute — but Abraham had no way of knowing this at the time. Along with this is Abraham’s problematic coldness. God orders him to sacrifice his son, who, God reminds him, is “your son, your only son Isaac, whom you love,” and Abraham does not utter a word of protest; in fact, ")]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("the text says explicitly that Abraham “got up early in the morning,” as if eager to carry out the deed.")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such problems were clearly on the minds of ancient interpreters when they commented on this story, and they did their best to find a solution to them. It is important to stress that ancient interpreters generally were not out to arrive at a modern-style critical or objective reading of Scripture’s words. In keeping with Assumption 2, they began with the belief that Scripture had some important lesson to teach "), _c('em', [_vm._v("them,")]), _vm._v(" and in the case of this story, it had to be a positive lesson about all concerned — not only Abraham and Isaac, but about God as well. If that lesson was not immediately apparent, then it had to be searched for through a careful weighing of every word, since, in keeping with Assumption 1, the meaning of any biblical text could be hidden: it might say A when it really meant B.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With regard to the first question mentioned above — why should God need to test anyone if He is omniscient? — interpreters set their eye on an apparently insignificant detail, the opening clause of the passage: “And it came to pass, after these things….” Such phrases are often used in the Bible to mark a transition; they generally signal a break: “The previous story is over, and now we are going on to something new.” But the word “things” in Hebrew "), _c('em', [_vm._v("(d")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ĕ")]), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("rîm)")]), _vm._v(" also means “words.” So the transitional phrase here could equally well be understood as asserting that some words had been spoken, and that “it came to pass, after these "), _c('em', [_vm._v("words,")]), _vm._v(" that God tested Abraham.” What words? The Bible did not say, but if some words had indeed been spoken, then interpreters felt free to try to figure out what the words in question might have been.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At some point, an ancient interpreter — no one knows exactly who or when — thought of another part of the Bible quite unrelated to Abraham, the book of Job. That book begins by reporting that Satan once challenged God to test His servant Job (1:6-12; 2:1-6). Since the story of Abraham and Isaac is also described as a divine test, this interpreter theorized that the “words” mentioned in the opening sentence of the passage (“And it came to pass, after these "), _c('em', [_vm._v("words,")]), _vm._v(" that God tested Abraham …”) might have been, as in the book of Job, words connected to the hypothetical challenge spoken by Satan to God: “Put Abraham to the test and see whether He is indeed obedient enough even to sacrifice his own son.” If one reads the opening sentence with this in mind, then the problem of why God should have tested Abraham disappears. Of course God knew that Abraham would pass the test — but if He nevertheless went on to test Abraham, it was because some words had been spoken leading God to take up a challenge and prove "), _c('em', [_vm._v("to Satan")]), _vm._v(" Abraham’s worthiness. One ancient interpreter who adopted this solution was the anonymous author of the book of "), _c('em', [_vm._v("Jubilees.")]), _vm._v(" Here is how his retelling of the story begins:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("There were "), _c('em', [_vm._v("words")]), _vm._v(" in heaven regarding Abraham, that he was faithful in everything that He told him, [and that] the Lord loved him, and in every difficulty he was faithful. Then the angel Mastema [i.e., Satan] came and said before the Lord, “Behold, Abraham loves his son Isaac and he delights in him above all else. Tell him to offer him as a sacrifice on the altar. Then you will see if he carries out this command, and You will know if he is faithful in everything through which you test him.” Now the Lord knew that Abraham was faithful in every difficulty which he had told him…. ("), _c('em', [_vm._v("Jub.")]), _vm._v(" 17:15-16)")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("Here, the “words” referred to in Gen. 22:1 are words of praise uttered by the other angels. “And it came to pass, after these "), _c('em', [_vm._v("words")]), _vm._v("” were uttered, that Satan felt moved to challenge God concerning his faithful servant. God takes up the challenge, but the author of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" goes to the trouble to assure his readers that there was really no need for the God to test Abraham, since “the Lord knew that Abraham was faithful in every difficulty which he had told him” and would certainly pass this test as well.")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As noted, this revised version of the biblical story contains a lesson for today (Assumption 2): Abraham was faithful to God, even when put to a very difficult test; you should be too, and you will be rewarded as Abraham was. It also illustrates Assumption 3, the idea that the Bible is not only internally consistent, but that it agrees with the interpreter’s own beliefs and practices — in this case, the belief that an all-knowing God would have no need to put Abraham to the test. (As a matter of fact, however, the idea of divine omniscience is never stated outright in the Hebrew Bible — apparently, this notion did not come into existence until later on.) Finally, it is thanks to Assumption 1, that the Bible speaks cryptically, that this interpretation was possible: When the Bible said “after these things,” although this looked at first glance like a common transitional phrase, what it really meant was “after these words,” and it thereby intended readers to think of the book of Job and the divine test with which that book begins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All this was well and good, but interpreters still had not completely resolved the matter of what God knew beforehand. They were still troubled by the way the test ended:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The angel of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" called to him from heaven and said, “Abraham! Abraham!” and he said, “Here I am.” He said, “Do not put your hand on the boy or do anything to him; for "), _c('em', [_vm._v("now I know")]), _vm._v(" that you fear God, since you have not withheld your son, your only son, from Me.” (Gen. 22:12)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("“"), _c('em', [_vm._v("Now")]), _vm._v(" I know” certainly seems to imply “I did not know before.” Why should God say such a thing if He was really omniscient? To this problem, too, the book of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" had an answer:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Then I [the angel who narrates the book of "), _c('em', [_vm._v("Jubilees")]), _vm._v("] stood in front of him [Abraham] and in front of Mastema [Satan]. The Lord said: “Tell him not to let his hand go down on the child and not to do anything to him, because I know that he is one who fears the Lord.” So I called to him from heaven and said to him: “Abraham, Abraham!” He was startled and said, “Yes?” I said to him, “Do not lay your hands on the child and do not do anything to him, because now I know that you are one who fears the Lord. You have not refused me your firstborn son.” ("), _c('em', [_vm._v("Jub.")]), _vm._v(" 18:9-11)")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("This passage is basically a rewording of the biblical verse cited above, Gen. 22:12, but the author of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" has done something that the biblical text did not: he has supplied the actual instructions that God gave His angel before the angel cried out to Abraham. God instructs the angel, “Tell him not to let his hand go down on the ")]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("child and not to do anything to him, because I know that he is one who fears the Lord.”")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The author of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" loved little subtleties. God’s instructions to the angel are identical to what the angel says in Genesis — except for one word. God does not say “"), _c('em', [_vm._v("now")]), _vm._v(" I know”; He simply says, “I know.” For the author of "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" such a scenario explained everything. The angel may not have known how the test would turn out, but God certainly did. “I "), _c('em', [_vm._v("know")]), _vm._v(" that he is one who fears the Lord,” He tells the angel in "), _c('em', [_vm._v("Jubilees —")]), _vm._v(" in fact, I’ve known it along! Thus, the words that appear in Genesis, according to "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" do not exactly represent God’s command, but the angel’s rewording of it. It is the angel who only now found out what God had known all along.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As for Abraham’s hiding his intentions from Isaac — once again it all depends on how you read the text. Ancient interpreters noticed that the passage contains a slight repetition:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Abraham took the wood for the burnt offering and put it on his son Isaac; then he took the fire and the knife, "), _c('em', [_vm._v("and the two of them walked together.")]), _vm._v(" But Isaac said to his father Abraham, “Father?” And he said, “Here I am, my son.” And he said, “Here is the fire and the wood, but where is the lamb for the burnt offering?” Abraham said, “God Himself will provide the lamb for the burnt offering, my son.” "), _c('em', [_vm._v("And the two of them walked together.")]), _vm._v(" (Gen. 22:6-8)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Repetition is not necessarily a bad thing, but ancient interpreters generally felt (in keeping with Assumption 3) that the Bible would not repeat itself without purpose. Between the two occurrences of the clause “and the two of them walked together” is the brief exchange in which Abraham apparently hides his true intentions from Isaac. Here Abraham’s words were, at least potentially, ambiguous. Since biblical Hebrew was originally written without punctuation marks or even capital letters marking the beginnings of sentences, Abraham’s answer to Isaac could actually be read as two sentences: “God Himself will provide. The lamb for the burnt offering [is] my son.” (Note that Hebrew has no verb “to be” in the present tense; thus, this last sentence would be the same whether or not the word “is” is supplied in translation.) Read in this way, Abraham’s answer to Isaac was not an evasion but the brutal truth: “You’re the sacrifice, Isaac.” If, following that, the text adds, “And the two of them walked together,” this would not be a needless repetition at all: Abraham told his son that he was to be the sacrifice, and Isaac agreed; then the two of them “walked together” in the sense that they were now of one mind to carry out God’s fearsome command. Thus, in keeping with Assumptions 1 and 3, the apparent repetition was no repetition at all, and Abraham’s apparent evasion was actually an announcement to Isaac of the plain truth. The conduct of both Abraham and Isaac was now above reproach: Abraham did not seek to deceive his son, and Isaac, far from a mere victim, actively sought to do God’s will no less than his father did. Indeed, their conduct might thus serve as an example to be imitated by later readers (Assumption 2): even when God’s decrees seem to be difficult, the righteous must follow them — and sometimes they turn out merely to be a test.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("But did interpreters actually believe their interpretations? Didn’t they know ")]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("they were distorting the text’s real meaning? This is always a difficult question. It seems likely that, at least at first, ancient interpreters were sometimes quite well aware that they were departing from the straightforward meaning of the text. But with time, that awareness began to dim. Biblical interpretation soon became an institution in ancient Israel; one generation’s interpretations were passed on to the next, and eventually they acquired the authority that time and tradition always grant. "), _c('em', [_vm._v("Midrash,")]), _vm._v(" as this body of interpretation came to be called, simply became what the text had always been intended to communicate. Along with the interpretations themselves, the interpreters’ very "), _c('em', [_vm._v("modus operandi")]), _vm._v(" acquired its own authority: this was how the Bible was to be interpreted, period. Moreover, since the midrashic method of searching the text carefully for hidden implications seemed to solve so many problems in the Bible that otherwise had no solution, this indicated that the interpreters were going about things correctly. As time went on, new interpretations were created on the model of older ones, until soon every chapter of the Bible came accompanied by a host of clever explanations that accounted for any perceived difficulty in its words.")])]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Words and Verses")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One final point about the “how” of ancient biblical interpretation: it always worked via a scrupulous examination of the precise wording of the biblical text. Even when the issues addressed by interpreters were broader — divine omniscience, Abraham’s character, Isaac’s apparent passivity — these were always approached through the interpretation of a specific verse, indeed, sometimes through a single word in the verse. “Do you want to know what ‘after these things’ means in the story of Abraham and Isaac? It means "), _c('em', [_vm._v("after these words.")]), _vm._v("” “Do you know why "), _c('em', [_vm._v("the two of them walked together")]), _vm._v(" is repeated? The second time is a hint that Abraham had just told Isaac he was to be sacrificed, and he agreed.” It was always from such precise points of wording that larger issues were approached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ancient biblical interpretation was thus, no matter how broad its intentions, formally an interpretation of single verses. And this is what enabled specific interpretations to travel so widely. Teachers in school as well as preachers in synagogue or church would, in the course of explaining a biblical text, inevitably pass on an insight into this or that verse: “Here is what it is really talking about!” Thereafter, all the listeners would know that such was the meaning of that particular verse, and they would think of it every time the verse was read in public; indeed, they would pass on the explanation to others. Since the biblical text was known far and wide and often cited — the Torah, in particular, was learned by heart at an early age — a clever answer to a long-standing conundrum would circulate quickly throughout the population.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("Nowadays, such verse-centered interpretations are known as "), _c('em', [_vm._v("exegetical motifs —")]), _vm._v(" “motifs” because, like musical motifs, they were capable of being inserted into different compositions, reworked or adapted, and combined with other motifs to make a smooth-running narrative. After a while, retellers sometimes did not even bother to allude to the particular biblical verse in question, but simply ")]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("incorporated the underlying idea into their retelling. Thus, for example, the idea that Abraham had explained to Isaac that “the lamb for the burnt offering [is you,] my son,” and that Isaac, far from fleeing, had willingly embraced his martyrdom, shows up in a variety of retellings, some of them terse, but others lovingly expanding on the basic idea:")])]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Going at the same pace — no less with regard to their thinking than with their bodies … they came to the designated place. (Philo, "), _c('em', [_vm._v("On Abraham")]), _vm._v(" 172)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This is indeed intended as a precise explanation of the two occurrences of “and the two of them walked together” in the Genesis tale; the first refers to their physical walking (what Philo designates as the motion of “their bodies”), whereas the second refers to their agreement that Isaac should be sacrificed (Philo’s “with regard to their thinking”).")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Remember … the father [= Abraham], by whose hand Isaac would have submitted to being slain for the sake of religion. (4 Macc. 13:12)")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("When the altar had been prepared (and) he had laid the cleft wood upon it and all was ready, [Abraham] said to his son: “My child, myriad were the prayers in which I beseeched God for your birth, and when you came into the world, I spared nothing for your upbringing…. But since it was by God’s will that I became your father and it now pleases Him that I give you over to Him, bear this consecration valiantly….” The son of such a father could not but be brave-hearted, and Isaac received these words with joy. He exclaimed that he deserved never to have been born at all if he were to reject the decision of God and of his father…. (Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 1.228-32)")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("And as he was setting out, he said to his son, “Behold now, my son, I am offering you as a burnt offering and I am returning you into the hands of Him who gave you to me. But the son said to the father, “Hear me, father. If [ordinarily] a lamb of the flocks is accepted with sweet savor as a sacrifice to the Lord, and if such flocks have been set aside for slaughter [in order to atone] for human iniquity, while man, on the contrary, has been designated to inherit this world — why should you be saying to me now, ‘Come and inherit eternal life and time without measure?’ Why if not that I was indeed born in this world "), _c('em', [_vm._v("in order to")]), _vm._v(" be offered as a sacrifice to Him who made me? Indeed, this [sacrifice] will be the [mark of] my blessedness over other men….” (Ps.-Philo, "), _c('em', [_vm._v("Bib. Ant.")]), _vm._v(" 32:2-3)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Wisdom Connection")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("It was suggested above that the common ancestor of all the diverse biblical interpreters of ancient Judaism and Christianity was the ancient Near Eastern sage, who pursued what the Bible calls “wisdom.” Wisdom was an international pursuit, and a very old one; some of the earliest texts that we possess from ancient Sumer and ")]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("Babylon and Egypt are collections of proverbs, the favorite medium for transmitting wisdom. What wisdom was is not given to easy summary, but its basic premise was that there exists an underlying set of rules (including, but not limited to, what we would call “laws of nature”) that governs all of reality. The sage, by studying the written words of earlier sages as well as through his own, careful contemplation of the world, hoped to come to a fuller understanding of these rules and, hence, come to know how the world works. His wise counsel was therefore sought by kings and princes, and he was often a teacher who trained the next generation of sages.")])]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At a certain point in Second Temple times, the job description of the Jewish sage was changed. Now, instead of contemplating the proverbs of previous generations, it was the Torah that occupied the sage’s attention: he became a biblical interpreter. In a sense, this transformation takes place before our eyes, in books like the Wisdom of Ben Sira (or: Sirach). The second-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" author is, in many ways, a traditional sage: his book is full of clever, pithy proverbs, many of them his own rewording of the insights from earlier generations and centuries. But along with this traditional sort of wisdom writing, Ben Sira also explains laws and stories from the Bible; indeed, his book concludes with a six-chapter review of biblical heroes and the lessons their stories are designed to impart. This is because, for him, it is the Torah that is the great repository of wisdom. Indeed, he says as much in an extended paean to wisdom in the middle of his book, in which Wisdom (here personified as a woman) tells of her own existence.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“I came forth from the mouth of the Most High, and covered the earth like a mist. I dwelt in the highest heavens, and my throne was in a pillar of cloud. Alone I compassed the vault of heaven and traversed the depths of the abyss.” (Sir. 24:3-5)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("But God then orders Wisdom to transfer her headquarters out of heaven and take up residence on earth:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("He said, “Make your dwelling in Jacob, and in Israel receive your inheritance….” [So] I took root in an honored people, in the portion of the Lord, His heritage. (Sir. 24:8, 12)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In recounting this, Ben Sira is not merely being a proud Jew who asserts that wisdom is the peculiar possession of his own people. Rather, he has something more specific in mind:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("All this is the book of the covenant of the Most High God, the Torah that Moses commanded us as an inheritance for the congregations of Jacob. (Sir. 24:23)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In other words, Wisdom "), _c('em', [_vm._v("is")]), _vm._v(" the Pentateuch, “the book of the covenant of the Most High God.” Thus, if you wish really to know how the world works, to know about the underlying set of rules that God established for it, then the Pentateuch is your basic resource.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("The wisdom connection apparent in Ben Sira explains much about the character of ancient biblical interpretation — not only for him, but for his ")]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("contemporaries and predecessors as well. For when these sages-turned-exegetes approached the Pentateuch, they brought to their reading of it many of the same expectations and interpretive techniques that they had used in reading collections of proverbs and other wisdom compositions. Thus, the full meaning of a proverb was not immediately apparent; its words had to be studied and sifted carefully before they would yield their full significance. So too did all of Scripture have to be scrutinized, since the meaning of a particular word or phrase or prophecy or story might similarly be hidden from view. And just as proverbs were full of lessons for today, so biblical texts, even though they seemed to talk about the past, were likewise understood to have a message for the present; indeed, those two favorite opposites of ancient wisdom, the “righteous” and the “wicked,” might turn out to be embodied in a biblical narrative about the (altogether righteous) Abraham or Jacob, and such (altogether wicked) figures as Lot or Esau. The insights of wise proverbs were part of a single weave of divine wisdom, the great pattern underlying all of reality; even when one proverb seemed to contradict another (see Prov. 26:4-5), there really was no contradiction. Similarly, the Bible, the great compendium of divine wisdom, could contain no real contradiction; careful contemplation of its words would always show that they agree. Finally wisdom, although it was transmitted by different sages in different periods, truly had no human author; these tradents were merely reporting bits and pieces of the great pattern that had been created by God. Similarly, the books of Scripture may be attributed to different authors, but all of them, since they are full of divine wisdom, truly have only one source, God, who guided the human beings responsible for Scripture’s various parts. The various characteristics mentioned here are, it will be noticed, none other than the Four Assumptions shared by all ancient interpreters. It seems likely, therefore, that these common elements all derive from the wisdom heritage of the earliest interpreters, going back at least to the time of Ezra, “a "), _c('em', [_vm._v("sage")]), _vm._v(" skilled in the law of Moses” (Ezra 7:6). Although Scripture’s interpreters included people from many different orientations and walks of life, wild-eyed visionaries, priests and temple officials, experts in law and jurisprudence, and so forth — "), _c('em', [_vm._v("all")]), _vm._v(" appear to have been touched by this crucial consilience of scriptural interpretation and ancient Near Eastern wisdom.")])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("Such was biblical interpretation in early Judaism. To modern eyes, some of it may not appear to be interpretation at all; certainly some of the claims made about the meaning of this or that verse or passage seem to us highly fanciful, if not patently apologetic or forced, though in fairness one ought to note that modern biblical commentaries are themselves not entirely free of such traits, even if they are usually more subtle about their intentions. But whatever one’s judgment of the work of these interpreters, their importance can scarcely be gainsaid. It is not just that, as mentioned earlier, they determined the basic way that the Bible would be approached for the next two millennia. Their Four Assumptions continued to be assumed by all interpreters until well after the Renaissance and the Protestant Reformation of the sixteenth century; indeed, they are, to a great extent, still with us today. But still more important was the effect that these ancient interpreters had ")]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("on their own contemporaries. Had they not succeeded in persuading their listeners that biblical texts did indeed have a message vital to people in their own day; and that the biblical corpus was perfectly consistent and harmonious, free of any error or defect; indeed, that these texts had been given by God for the purpose of guiding humans on their path, if only they were clever enough to understand the hidden meaning of many of its verses — had they not succeeded in getting these basic ideas and this basic approach across through myriad examples of actual interpretations, it seems quite unlikely that the writings of ancient Israel would ever have become what they did, the centerpiece of two great biblical religions, Judaism and Christianity.")])]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Anderson, Gary. 2001. "), _c('em', [_vm._v("The Genesis of Perfection: Adam and Eve in Jewish and Christian Imagination.")]), _vm._v(" Louisville: Westminster John Knox.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Borgen, Peder. 1997. "), _c('em', [_vm._v("Philo of Alexandria: An Exegete for His Time.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Campbell, Jonathan G. 2004. "), _c('em', [_vm._v("The Exegetical Texts.")]), _vm._v(" Companion to the Qumran Scrolls. London: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charlesworth, James H., and Craig A. Evans, eds. 1994. "), _c('em', [_vm._v("The Pseudepigrapha and Early Biblical Interpretation.")]), _vm._v(" Sheffield: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Endres, John C. 1987. "), _c('em', [_vm._v("Biblical Interpretation in the Book of Jubilees.")]), _vm._v(" Washington, D.C.: Catholic Biblical Association of America.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Evans, Craig A., ed. 2004. "), _c('em', [_vm._v("From Prophecy to Testament: The Function of the Old Testament in the New.")]), _vm._v(" Peabody, Mass.: Hendrickson.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feldman, Louis H. 1998. "), _c('em', [_vm._v("Josephus’s Interpretation of the Bible.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fishbane, Michael. 1985. "), _c('em', [_vm._v("Biblical Interpretation in Ancient Israel.")]), _vm._v(" Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Henze, Matthias, ed. 2005. "), _c('em', [_vm._v("Biblical Interpretation at Qumran.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hirschman, Marc G. 1996. "), _c('em', [_vm._v("A Rivalry of Genius: Jewish and Christian Biblical Interpretation in Late Antiquity.")]), _vm._v(" Albany: SUNY Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kugel, James L. 1990. "), _c('em', [_vm._v("In Potiphar’s House: The Interpretive Life of Biblical Texts.")]), _vm._v(" San Francisco: HarperSanFrancisco.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1998. "), _c('em', [_vm._v("Traditions of the Bible: A Guide to the Bible As It Was at the Start of the Common Era.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2001. "), _c('em', [_vm._v("Studies in Ancient Midrash.")]), _vm._v(" Cambridge: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2006. "), _c('em', [_vm._v("The Ladder of Jacob: Ancient Interpretations of the Biblical Story of Jacob and")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("His Children.")]), _vm._v(" Princeton: Princeton University Press. Kugel, James L., and R. A. Greer. 1986. "), _c('em', [_vm._v("Early Biblical Interpretation.")]), _vm._v(" Philadelphia: Westminster.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mulder, M. J., and H. Sysling, eds. 1988. "), _c('em', [_vm._v("Mikra: Text, Translation, Reading and Interpretation of the Hebrew Bible in Ancient Judaism and Early Christianity.")]), _vm._v(" Assen: Van Gorcum; Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Najman, Hindy. 2003. "), _c('em', [_vm._v("Seconding Sinai: The Development of Mosaic Discourse in Second Temple Judaism.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Najman, Hindy, and Judith Newman, eds. 2004. "), _c('em', [_vm._v("The Idea of Biblical Interpretation.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("White Crawford, Sidnie. 2008. "), _c('em', [_vm._v("Rewriting Scripture in Second Temple Times.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Zakovitch, Y. 1992. "), _c('em', [_vm._v("An Introduction to Inner-Biblical Interpretation.")]), _vm._v(" Even-Yehudah: Reches (in Hebrew).")])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_142"
    }
  }), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('em', [_vm._v("Apocrypha and Pseudepigrapha")])])]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OREN")]), _vm._v(" T. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TUCKENBRUCK")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The terms “apocrypha” and “pseudepigrapha” mean, respectively “hidden things (books)” and “books falsely ascribed/inscribed.” However, under the problematic headings of “Old Testament Apocrypha” and “Old Testament Pseudepigrapha” they have come to designate collections or groups of ancient Jewish writings which were either composed during the Second Temple period or which preserve traditions that arguably go back to that time. Thus these designations, as conventionally used today, are not descriptive and do not always reflect the way they (and the concepts underlying them) were sometimes used in antiquity. It is the ancient background, especially as now informed by the writings preserved among the Dead Sea Scrolls, which may suggest that what “apocrypha” and “pseudepigrapha” appropriately signify may need to be rethought. Since the contemporary use of these terms is largely determined by developments after the Second Temple period, the present discussion will review their use in Christian and Jewish tradition from late antiquity through the post-Reformation and then consider how they were being applied by some of the Jewish writers who composed them.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Apocrypha")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2a"
  }, [_c('strong', [_c('em', [_vm._v("Apocrypha during and since the Reformation and Counter-Reformation")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("Most commonly, the term “Apocrypha” refers to a collection of writings that fall outside the canons of the Hebrew Bible (Old Testament) and New Testament, but that are nonetheless included in some modern Christian translations of the Bible, usually between the Old and New Testaments. In modern translations this group of writings consists of the following: 1 Esdras (= "), _c('em', [_vm._v("3 Ezra")]), _vm._v("), 2 Esdras (= "), _c('em', [_vm._v("4, 5,")]), _vm._v(" and "), _c('em', [_vm._v("6 Ezra")]), _vm._v("), Tobit, Judith, Additions to the Book of Esther, Wisdom of Solomon, Sirach (or Ecclesiasticus), Baruch and Letter of Jeremiah, the Prayer of Azariah and the Song of the Three Young Men, Susanna, Bel and the Dragon, Prayer of Manasseh, ")]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("1 Maccabees, and 2 Maccabees. However, traditional Protestant and Catholic definitions and judgments of the value of these writings have diverged.")])]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among the Protestant Reformers, the value attributed to the “Apocrypha” was not entirely uniform. Martin Luther, whose translation of the Bible (completed in 1534) did not include 1 and 2 Esdras among the Apocrypha, defined Apocrypha as “books which are not considered equal to the Holy Scriptures” while being “profitable and good to read.” Other reformers, such as Oecolampadius, adopted a similar view, while translations such as the Dutch Bible (1526) and the Swiss-German Bible (1527-1529) preface the “Apocrypha” with statements, respectively, that these books, which are not found in the Hebrew Bible of the Jews, are “not in the canon” and “are not reckoned as biblical.” A more discriminating statement about their value was offered in 1520 by Andreas Bodenstein of Karlstadt "), _c('em', [_vm._v("(De Canonicis Scripturis Libellus):")]), _vm._v(" some works (Wisdom of Solomon, Sirach, Tobit, Judith, 1 and 2 Maccabees) outside the Hebrew canon are “holy writings” and their content “is not to be despised” (sections 114, 118), while others (1 and 2 Esdras, Baruch, Prayer of Manasseh, Prayer of Azariah, Song of the Three Young Men, Susanna, Bel and the Dragon) are so problematic that they are “worthy of a censor’s ban.” Thus, despite the inclusion of “Apocrypha” in a number of Protestant translations, sentiments comparable to those of Karlstadt were widely held (e.g., the Belgic Confession 1561, the Synod of Dort 1618-19, Westminster Confession 1647) and have led to the removal of these writings in many translations of the Bible until today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The widespread criticism of the Apocrypha among Protestant Reformers led the Roman Catholic Church to a response during the first Council of Trent. In Session VI of the deliberations in 1546, the delegates pronounced a curse against any who were not prepared to recognize all those books contained in the Latin Vulgate Bible. (Although many Latin manuscripts had also included 1 and 2 Esdras and the Prayer of Manasseh, the Council denied them the canonicity accorded to the other books. These were reinstated as appendices to the New Testament in the Clementine Bible published in 1592.) Since Sixtus of Sienna (1566), many Roman Catholic scholars have referred to Old Testament writings not included in the Jewish Hebrew Bible as “Deuterocanonical,” a term that is meant not so much to imply their secondary or inferior status as rather to acknowledge that their canonicity had not been formalized by ecclesiastical authorities until a more recent time.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Apocrypha in Orthodox Traditions")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("It is important to remember that the term “Apocrypha,” while playing an important role in Protestantism, has been of only little significance in other traditions. In this respect, we may draw attention to eastern Orthodox confessions, such as the Greek, Russian, Syriac, and Ethiopic churches, which have defined their biblical canons in a way that includes some of the “Apocrypha” and, indeed, even further writings (which vary in each tradition). Each of these ecclesiastical traditions includes a core of these writings within their Bible, while the determination of what constitutes Scripture as a whole varies, depending on factors such as the form and shape of traditions received into their respective languages, use in ")]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("liturgy, other issues in emerging self-definition, and the understanding of “canon.”")])]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among the Orthodox traditions, some thirteen writings regarded by the Council of Trent as “Deuterocanonical” have acquired some form of biblical status. While five of these appear as material attached to the end of other books (Psalm 151, Letter of Jeremiah [to Baruch], Additions to Esther, and Additions to Daniel in Prayer of Azariah, Song of the Three Young Men, Susanna, and Bel and the Dragon), the remaining seven have been transmitted as free-standing works (Tobit, Judith, Wisdom of Solomon, 1 and 2 Maccabees, Sirach, and Baruch).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Greek Orthodox Church, after some debate, these writings were labeled as “Deuterocanonical” during the Synod of Jerusalem of 1672; however, they are more often referred to as “things which are read” (Gr. "), _c('em', [_vm._v("anagignōskomena")]), _vm._v("). Not found in the Hebrew Bible, but transmitted as part of the Greek Old Testament, this group of books also includes Prayer of Manasseh, 1 Esdras, and 3 Maccabees (while 4 Maccabees, transmitted in a more limited number of biblical manuscripts, is now placed in an appendix). The affirmation of the validity of the “Deuterocanonical” writings by the Synod was more a commendation than a dogmatic pronouncement, so that opinion regarding their canonical status in the Church has varied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beyond the core list, the Russian Orthodox Church, drawing on a tradition that received the Greek Bible, included in its first published Bible in Old Church Slavonic (in Ostrog 1581) a list of writings that differs slightly from that of Greek Orthodoxy: Prayer of Manasseh, 2 Esdras (= 1 Esdras), 3 Esdras (= 2 Esdras), and 3 Maccabees. Here one may notice not only the difference in nomenclature for the Esdras books but also the complete absence of 4 Maccabees. The status of these books, however, has not been rigorously maintained in subsequent centuries, so that they now have an ambivalent place and function within the biblical canon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Ethiopian Orthodox Church has an understanding of canon that has not operated with the same degree of fixedness as found in other traditions. Moreover, unlike most of the Orthodox churches, the Ethiopic tradition did not inherit the Greek Bible. Many biblical manuscripts copied in Classical Ethiopic (Ge"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("ez) tradition contain Prayer of Manasseh (where it follows immediately upon 2 Chron. 33:12), 1 Esdras, 2 Esdras 3–14 (= "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" without the Christian additions in chaps. 1–2 and 15–16), "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" and "), _c('em', [_vm._v("Jubilees.")]), _vm._v(" The degree of recognition accorded the latter two works and, indeed, a number of books in the Old Testament may have varied during the early stages of their reception and consolidation into the Ethiopic tradition. For example, while there is little or no evidence that the scriptural status of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" was ever questioned, other works could be regarded as “disputed” (Chronicles, Esther, Job, Proverbs, Ecclesiastes, Song of Songs), while some of these and even others could be labeled as “noncanonical” (Ezra-Nehemiah, 1 Esdras, 2 Esdras, Tobit, Judith, Wisdom of Solomon, Ecclesiastes, Baruch, "), _c('em', [_vm._v("1 Enoch, Ascension of Isaiah, 4 Baruch")]), _vm._v(").")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("It is not clear whether the West-Syrian Orthodox traditions (e.g., Syriac Orthodox and Monophysite Orthodox churches), such as the Ethiopian, initially received an Old Testament based on the Hebrew Bible or derived it from the Greek. Although the Peshi"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṭ")]), _vm._v("ta, the standardizing Syriac translation of the Bible, transmitted ")]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("the Jewish Bible as its Old Testament, the Old Testament writings not in the Hebrew Bible were soon added to this tradition. Not only did the fourth-century fathers Aphrahat and Ephrem treat them as part of their Bible, but these writings are copied in the earliest complete Syriac Bibles whose manuscripts may date back as early as the sixth century. Significantly, one of these early manuscripts, designated "), _c('em', [_vm._v("7a1,")]), _vm._v(" even contained "), _c('em', [_vm._v("2 Baruch, 4 Ezra,")]), _vm._v(" and 4 Maccabees. Moreover, the oldest Syriac version of the Psalter from the twelfth century (now in Baghdad, the Library of the Chaldaean Patriarchate) includes five additional psalms (Psalms 151–155), of which Psalm 151 corresponds to the same document by that name in the Greek Psalter and, together with Psalms 154 and 155, is preserved in Hebrew among the Dead Sea manuscripts (11Q5). In addition, a fourth-century document called "), _c('em', [_vm._v("Canons of the Apostles,")]), _vm._v(" the Syriac text of which goes back to at least the seventh century, includes Judith, Tobith, and Ben Sira in its list of “accepted books.”")])]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Apocrypha in Greek Codices of the Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The “Apocrypha” are sometimes casually defined as those books or parts of books found in the Septuagint but not in the Jewish Hebrew Bible. If we consult the three prominent Greek codices that contain the Old Testament writings — Codices Sinaiticus (fourth century), Vaticanus (fourth century), and Alexandrinus (fifth century) — the following books come into view:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Sinaiticus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Vaticanus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Alexandrinus")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Greek Esther")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Greek Esther")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Greek Esther")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judith")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judith")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tobit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tobit")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tobit")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Judith")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Maccabees")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("3 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 Maccabees")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom of Solomon")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom of Solomon")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wisdom of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sirach")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sirach")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sirach")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Psalms of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Baruch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Baruch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle of Jeremiah")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle of Jeremiah")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epistle of Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Susannah")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Susannah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bel and the Dragon")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bel and the Dragon Psalms and Odes (including Prayer of Manasseh)")])])])])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("In addition, two somewhat later biblical codices preserve copies of several of these writings: Marchalianus (sixth/seventh century) includes 1 Baruch, Epistle of Jeremiah, Susannah, and Bel and the Dragon, while Venetus (eighth century) has Greek Esther, Judith, Tobit, 1-4 Maccabees, Wisdom of Solomon, Sirach, 1 Baruch, ")]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("Epistle of Jeremiah, Susannah, and Bel and the Dragon. Furthermore, the partially preserved Cologne–Chester Beatty Papyrus 967 (second-third century) contains fragmentary versions of Susannah and Bel and the Dragon alongside several biblical books (Esther, Ezekiel, Daniel). Finally, like Codex Alexandrinus, the seventh-century Codex T transmits the Prayer of Manasseh among the Odes appended to the Psalms.")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The manuscript tradition thus reflects a fluid understanding of where the boundaries for the literature not preserved in Hebrew lie. The manuscripts attest the following works, which are omitted from modern collections of the “Apocrypha” or “Deuterocanonicals”: "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" 3 and 4 Maccabees. This fluidity is echoed by the Syriac manuscript "), _c('em', [_vm._v("7a1")]), _vm._v(" (see above) and, of course, the Ethiopic Orthodox tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the same time, two works not found in the Greek but preserved in many Latin manuscripts have found their way into this collection: 2 Esdras (chaps. 3–14 of which = "), _c('em', [_vm._v("4 Ezra")]), _vm._v(") and the Prayer of Manasseh (first attested in Syriac manuscripts in the ninth century and in Latin manuscripts from the thirteenth century, but also found in the Cairo Geniza).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("“Apocrypha” in Antiquity")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Luther’s view of “apocrypha” as profitable to read without being Scripture goes back to Jerome. The prefaces to his Latin translations of Jewish and Old Testament writings (ca. 405 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") make it clear that for Jerome “apocrypha” such as Wisdom of Solomon, Sirach, Tobit, Judith, and 1 and 2 Maccabees could be read for edification in the church; however, the church does not receive them “among the canonical books,” and they should not be used to establish doctrine (so Jerome’s prologues to the book of Kings [= "), _c('em', [_vm._v("Prologus Galeatus")]), _vm._v("], Judith, Tobit, and the books of Solomon).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerome’s use of the term “apocrypha” was, however, not consistent. He not only could admit in the translation prefaces a certain overlap between what he called “apocrypha” and “pseudepigrapha” (e.g., in the case of Wisdom of Solomon), he could even appear to equate the two terms altogether. In a letter (107.12) written in the year 403, he instructs a certain Laeta to have her daughter “avoid all apocryphal writings” because they cannot be read for “the truth of the doctrines they contain,” they “are not actually written by those to whom they are ascribed,” and they have “many faults” that “have been introduced into them.” This negative assessment of “apocrypha” did not mean Jerome denied them all religious value; but it takes “great prudence "), _c('em', [_vm._v("(grandis … prudentiae)")]), _vm._v(" to find gold in the mire "), _c('em', [_vm._v("(in luto).")]), _vm._v("”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("This last-mentioned understanding of “apocrypha” was a widely held view among Jerome’s contemporaries and is reflected in the later Roman Catholic tradition. For example, Cyril of Jerusalem (mid-third century) had applied the term to “disputed” works that are not acknowledged by all; the church should neither study nor read them, so that they are best avoided altogether. For Cyril of Jerusalem Scripture consists of “twenty-two books of the Old Testament that were ")]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("translated by the seventy-two translators” of the Septuagint, though both this numeration and his description of the individual books themselves makes it clear that, except for 1 Baruch (regarded as an appendix to Jeremiah), this did not include any of the works that Jerome would have called apocrypha in any sense ("), _c('em', [_vm._v("Catechetical Lectures")]), _vm._v(" 4.33). Rufinus, an older contemporary of Cyril, was more explicit in distinguishing between three groups of writings ("), _c('em', [_vm._v("Expositio Symboli")]), _vm._v(" 34): (a) “canonical” works, that is, the “twenty-two” books of the Old Testament; (b) “ecclesiastical” books — Wisdom of Solomon, Sirach, Tobit, Judith, 1-2 Maccabees — that may be read but not in order to confirm faith; and (c) “Apocrypha,” that is, falsely ascribed writings (pseudepigrapha) and heretical books that should not be received in the church at all, as indicated in the preface to a list of “apocrypha” in the Gelasian Decree (fifth century). This last use of the term is aptly illustrated as early as the late second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" by Irenaeus who, in his "), _c('em', [_vm._v("Against Heresies")]), _vm._v(" (1.20.1), referred to the existence of “an unspeakable number of apocryphal and spurious writings” that confuse the foolish and ignorant. Similarly, Origen in the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" declared that certain writings are called "), _c('em', [_vm._v("apocryphae")]), _vm._v(" because “many things in them are corrupt and contrary to true faith” ("), _c('em', [_vm._v("Commentary on Song of Songs;")]), _vm._v(" cf. also "), _c('em', [_vm._v("Commentary on Matthew")]), _vm._v(" 10.18.13.57). The equation of “secret” books with deception, though applied by Irenaeus (and Origen) to inauthentic traditions about Jesus, would in time be applied to “pseudepigraphal” Jewish compositions as well.")])]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In summary, Jerome’s twofold use of “apocrypha” would be picked up, respectively, in the Reformation (Luther) and Counter-Reformation (Council of Trent). The Protestant “Apocrypha” had their counterpart in the Roman Church’s “Deuterocanonicals,” while the latter has regarded “Apocrypha” as the remaining (mostly pseudepigraphal) religious writings from Jewish antiquity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The reason for the use of “apocrypha” to designate noncanonical works during the fourth century may be found in the widespread notion of “hidden” or “sealed” books in Greco-Roman and especially Jewish antiquity (Dan. 8:26; 12:4, 9-10; "), _c('em', [_vm._v("Sib. Or.")]), _vm._v(" 11.163-71; "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" 12:37; 14:5-6; 14:44-47; "), _c('em', [_vm._v("2 Bar.")]), _vm._v(" 20:3-4; 87:1; implied in "), _c('em', [_vm._v("Jub.")]), _vm._v(" 1:5; "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 82:1-3; 107:3; "), _c('em', [_vm._v("2 Enoch")]), _vm._v(" 35:1-3). In a number of Jewish apocalyptic writings, authors sometimes presented themselves (or, rather, those ancient figures whose names they were using) as having been instructed by God or an angel to “seal” or “hide” their works. This fictional instruction functioned as a way of explaining how such works attributed to such ancient authors had not been in circulation until the present. The existence of these books was a “secret” until the time when they actually appeared. A closely related idea is the instruction that a writer “seal” the book so that its contents will not be accessible until the appropriate time.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("In this regard, three texts in particular seem to have exercised some influence: Daniel, "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch.")]), _vm._v(" (a) The book of Daniel presents itself as an apocryphal work. The writer is told to “seal up the vision” given to him, “for it refers to many days from now” (8:26). This instruction is then echoed in 12:4 (“keep the words secret and the book sealed until the time of the end”), while according to 12:9-10 the seer, who has completed writing down his revelations, is to consign his work “to remain secret and sealed until the time of the end.” This self-presentation of Daniel is closely bound up with the view that the special revelation in this book will be comprehended only by the wise (12:10). (b) "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" picks up ")]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("similar ideas in several passages. In 12:37-38 the command that the seer record his visions is accompanied by the directive that he deposit them “in a hidden place”; similar to Daniel, the hidden status of the writing establishes its contents as teaching for “the wise … whose hearts … are able to comprehend and keep these secrets.” In a later passage (14:5-6) the figure of Moses himself is presented as having been the recipient of a double revelation (cf. Deut. 29:29), one being open and available to all, the other being secret and restricted in access. While the generally available teaching refers to the Mosaic Torah, the esoteric teaching involves “the secrets of the times” and “the end of the times.” Near the end of the book (14:44-47), the seer, who patterns himself after Moses, claims to have been given, along with five men with him, ninety-four books to record during forty days of revelation. Of these books, the twenty-four to be made public are to be read by “the worthy and unworthy,” while the remaining seventy are to be given to “the wise” in whom there are “the springs of understanding,” “the fountains of wisdom,” and “the river of knowledge.” The association of esoteric revelation with more discerning readers is reminiscent of Daniel. It is tempting to see here a distinction between “canonical” and “noncanonical” writings. However, the force of the passage emphasizes that both groups of writings, though distinct, are equally revelatory. Indeed, if from "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" 12:37-38 one has the impression that the activity behind "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" itself is “hidden,” in 14:37-48 the writer presents himself as the primary mediator among those who produced all ninety-four books (without even mentioning Moses). It was only later, for example, in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", that Epiphanius of Salamis ("), _c('em', [_vm._v("De Mensuris et Ponderibus")]), _vm._v(" 10, Armenian), perhaps influenced by "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" 14, turned the partition of the same number of writings into a classification of first- and second-rank books in the Septuagint: twenty-two works of the Old Testament and seventy-two “apocryphal” works. This ranking, however, says less about "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" itself than about ideas of canonicity that had developed by Epiphanius’ time. (c) In "), _c('em', [_vm._v("2 Baruch")]), _vm._v(" the seer, having been instructed to seal divine commands given to him (20:3-4), concludes his work by saying, “I folded it, sealed it cautiously, and bound it to the neck of the eagle. And I let it go and sent it away” (87:1).")])]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The passages just cited from Daniel and "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" make clear that their intended reception among a more exclusive class of “wise” readers underscores their special value rather than having anything to do with any measure of inferiority later associated with the term “apocrypha” as, for example, would later be the case with Rufinus and Jerome. Instead, revelation for a privileged group would have underscored its particular value. An analogy for this may be detected in Jesus’ exclusive teaching of parables to his disciples preserved in the Synoptic Gospels (see Mark 4:10-11; Matt. 13:10-11; Luke 8:9-10).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The self-presentation of Daniel, "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch")]), _vm._v(" as “hidden” works shows the degree to which the term “apocrypha” does not describe the character of those books that would later be collected under this designation. Indeed, while Daniel came to be understood as “biblical,” "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" was treated as “deuterocanonical” or “apocryphal,” and "), _c('em', [_vm._v("2 Baruch")]), _vm._v(" was assigned to the “pseudepigrapha.”")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_149"
    }
  }), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('strong', [_c('em', [_vm._v("Recent Use of “Apocrypha” as a Title for Ancient Documents")])])])]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Whereas the notion of “hiddenness” is part of the literary technique employed by the authors of Daniel, "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch,")]), _vm._v(" the term “apocryphon” has more recently been applied more loosely to those writings that represent or contain traditions whose existence was unknown before they were discovered in modern times. This is the case with a number of documents from the Dead Sea Scrolls, of which the more prominent examples would be "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" (1Q20), "), _c('em', [_vm._v("Apocryphon of Moses")]), _vm._v(" (1Q22, 1Q29, 2Q21, 4Q375, 4Q376, 4Q408), "), _c('em', [_vm._v("Apocryphal Prophecy")]), _vm._v(" (1Q25, 2Q23, 6Q12), 2QApocryphon of David (2Q22), 4QApocryphal Lamentations (4Q179, 4Q501), 4QApocryphal Daniel (4Q246), 4QApocryphal Pentateuch A (4Q368), 4QApocryphon of Joshua (4Q378), 4QApocryphon of Jeremiah (4Q383, 4Q385a, 4Q387, 4Q387a, 4Q388a, 4Q389-390), 4QApocryphon of Elisha (4Q481a), 4QApocryphon of Malachi (5Q10), and 11QApocryphal Psalms (11Q11). While the titles assigned to some of these works have varied, here “apocryphon” has functioned as a designation for a previously unknown tradition related to a biblical book or figure. As such, the term could be a source of confusion, since it has been made to refer to neither “apocrypha” in the senses it has acquired in Catholic and Protestant circles nor to works which formally use “hiddenness” as a way of presenting themselves.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Coherence of the “Old Testament Apocrypha”")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If neither the technical nor ecclesiastical usage is properly descriptive, how are the books called “apocrypha” in Protestant tradition to be characterized? First, we may recognize that the great codices from the fourth and fifth centuries as well as the Protestant “Apocrypha” or Roman Catholic “Deuterocanonicals” include very different kinds of literature: (a) Several works were composed as supplementary materials to already existing biblical books: Esther (expansions with further chapters in Greek); additions to Daniel (Prayer of Azariah, Song of the Three Young Men, Susannah, and Bel and the Dragon); and 1 Baruch and the Epistle of Jeremiah. (b) Two of the works are historiographical: 1 and 2 Maccabees. (c) Two may be classified as literary tales: Tobit and Judith. (d) Liturgical prayer is also included: Prayer of Manasseh (see also "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" Psalms and Odes, and Psalm 151). (e) The sapiential or wisdom literature is represented by Ben Sira and Wisdom of Solomon. Finally, (f) "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" is an apocalyptic vision. The only sense in which these diverse compositions are all “apocrypha” is if one eschews any etymological meaning and simply regards them as a modern (and somewhat fluid) collection of books.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("Second, these writings were originally composed in different languages. For several of the documents an original composition in Hebrew or Aramaic is confirmed through the evidence from the Dead Sea Scrolls. Most chapters of Tobit are found in fragments from one Hebrew manuscript (4Q200) and in four Aramaic manuscripts (4Q196-199); Hebrew texts of Ben Sira exist in two manuscripts from the Qumran caves (2Q18 [from 6:14-15 or 1:19-20 and 6:20-31]; 11Q5 21:1–22:1 [from Sirach 51]) and the Ben Sira scroll from Masada (fragmentary text of 39:27–")]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("44:17); Psalm 151 is found in 11Q5 col. 28, though, unlike in the Greek Orthodox Psalter, it is divided into two psalms separated by a "), _c('em', [_vm._v("vacat")]), _vm._v(" and carrying their own superscriptions (151A in 11Q5 28:3-12; 151B in 28:13); and, finally, Hebrew texts for Psalms 154 and 155 from the Syriac Psalter are preserved, respectively, in 11Q5 18:1-16 and 24:3-17.")])]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition, linguistic studies have made it likely that several documents preserved only in Greek or Latin versions derive from now-lost Semitic versions: Judith, 1 Esdras, Epistle of Jeremiah (preserved in a Greek fragment from Qumran, 7Q2), Prayer of Azariah, the Song of the Three Young Men, Bel and the Dragon, and 1 Maccabees. Interestingly, Jerome claims to have known Semitic versions of Tobit (Aramaic), Ben Sira (Hebrew), and Judith (Hebrew). Less certain is whether and to what extent a Semitic version lies behind the Greek texts of 1 Baruch, Prayer of Manasseh, and Susanna. On the other hand, several of the works were originally composed in Greek. These are Greek Esther, Wisdom of Solomon, 2 Maccabees, and 3-4 Maccabees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, though it is impossible to be precise about the date of composition for each of the Protestant “apocrypha,” it is at least certain that they emerged during the period between Alexander the Great’s conquests in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and the Bar Kokhba Revolt in 132-135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" The writing of Tobit, Ben Sira, and Epistle of Jeremiah falls within the early part of this period, that is, from 300 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" until the Maccabean crisis in 175-164 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Most of the books derive from the time between the Maccabean wars until the turn of the Common Era: 1 Esdras, Judith, Greek Esther, Prayer of Azariah, the Song of the Three Young Men, Susannah, Bel and the Dragon, 1 and 2 Maccabees, and possibly Prayer of Manasseh. The latest composition is "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" (ca. 100 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("), which addresses circumstances arising from the destruction of the Second Temple in Jerusalem by the Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The diverse linguistic origin, literary genre, and date of these works indicate why it was that they would not become a collection of books during the Second Temple period. Only with the development of the codex (which made larger collections of books possible) and only when decisions came to be made about canonicity were they formally brought together in different forms, first in Greek and then in Latin. Far from descriptive, then, the term “apocrypha” is anachronistic, and it remains a problem to find terminology that more accurately accords with the respective ways the books present themselves while at the same time recognizing their history of reception among Jews and Christians during the last two millennia.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("The “Outside Books” in Jewish Tradition")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("A related problem to the early development of classifications for “Scripture,” on the one hand, and books deemed heretical or rejected, on the other, is found in the rabbinic designation “outside books” "), _c('em', [_vm._v("(s")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ĕ")]), _c('em', [_vm._v("f")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("rîm ha-")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("î")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣō")]), _c('em', [_vm._v("nîm),")]), _vm._v(" which first occurs in "), _c('em', [_vm._v("m. Sanh.")]), _vm._v(" 10:1, where a saying attributed to R. Akiba states that those who have no place in the World to Come include anyone “who reads the outside books.” The Babylonian and Palestinian Talmud commentaries on this passage single out “the ")]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("books of Ben Sira” as a poignant example. However, this condemnation is not unequivocal. For example, in the Babylonian Talmud ("), _c('em', [_vm._v("b. Sanhedrin")]), _vm._v(" 100b), after R. Akiba’s condemnation is endorsed by a ruling of Rabbi Joseph, the latter himself is nonetheless made to permit the use of Ben Sira for instruction. This tension is underscored in the number of instances in which the Rabbinate continued to cite Ben Sira with the same respect shown to biblical works ("), _c('em', [_vm._v("b. Berakot")]), _vm._v(" 48a; "), _c('em', [_vm._v("y. Berakot")]), _vm._v(" 11b; "), _c('em', [_vm._v("y. Nazir")]), _vm._v(" 54b; "), _c('em', [_vm._v("Bereshit Rabbah")]), _vm._v(" 91:3; "), _c('em', [_vm._v("Qohelet Rabbah")]), _vm._v(" 7:11), presumably because its teaching could be seen as consistent with the Torah. In its condemnation of readers of Ben Sira, the Palestinian Talmud ("), _c('em', [_vm._v("y. Sanhedrin")]), _vm._v(" 10a) adds those who make use of the books of a so-called “Ben Laana.” The text, however, states that a further category of literature, enigmatically called “the books of "), _c('em', [_vm._v("hamiras")]), _vm._v("” (Homeric works?), is not problematic at all: “the one who reads them is like one who reads a letter” "), _c('em', [_vm._v("(ha-qōrê")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _vm._v(" "), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("-hen k")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ĕ")]), _c('em', [_vm._v("-qōrê")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _vm._v(" "), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("-")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("igeret).")]), _vm._v(" Crucially, then, the text leaves the impression that the danger of Ben Sira consists in its potential for being confused with Torah, while no such difficulty exists for ancient literature held to be nonreligious. While it may be misleading to generalize from Ben Sira to other books, this broad classification suggests that for the rabbis the “outside books” would have at least consisted of the sort of Jewish writings that later Christian tradition would regard as “Old Testament Apocrypha” and “Old Testament Pseudepigrapha.”")])]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Apocryphal Collections in Medieval Jewish Manuscripts")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The comparative devaluation of “outside books” in Jewish tradition did not mean an avoidance of them altogether. A number of Aramaic and Hebrew Jewish manuscripts from the Middle Ages contain short collections of works that to some extent resemble what would become the Protestant “apocrypha.” Here, the texts for each of the works were either secondary versions (e.g., Tobit and Judith, translated from Latin and/or Greek; Epistle of Jeremiah), summaries (e.g., Baruch, Ben Sira, Esther, 1-4 Maccabees, Susanna, Prayer of Manasseh), or adaptations (Bel and the Dragon), related materials (to Esther: The Dream of Mordecai and the Books of Ahasuerus), and often additional obscure pieces (with titles such as the Book of Yashar, Proverbs of Solomon, the Book of Enoch [neither "), _c('em', [_vm._v("1")]), _vm._v(" nor "), _c('em', [_vm._v("2 Enoch")]), _vm._v("], the Fables of Aesop, the Proverbs of Sandabar, The Deed of the Jerusalemite, The Speech of Aphar and Dinah, and so forth). The reason for such collections within manuscripts — that is, whether they were driven by an internal Jewish dynamic or in some sense were meant as counterparts to existing Christian compilations — has yet to be studied properly.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Pseudepigrapha")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2a"
  }, [_c('strong', [_c('em', [_vm._v("The Problematic Term “Pseudepigrapha”")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("The difficulties described above in relation to the use of “apocrypha” apply to “pseudepigrapha” as well. First, if “pseudepigraphon” refers to a work falsely ")]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("ascribed to a figure who is not the real author, then it does not pertain to a discrete collection of works. Indeed, several books in the Hebrew Bible are arguably pseudepigrapha (e.g., Deuteronomy, Proverbs, Qoheleth, Daniel, and the Davidic Psalms), while the same may be said regarding “apocrypha” such as 1 Baruch, Epistle of Jeremiah, Prayer of Manasseh, Psalm 151 (and Syriac Psalms 154–155), Wisdom of Solomon, and "), _c('em', [_vm._v("4 Ezra.")]), _vm._v(" Second, as already noted, in Roman Catholic tradition it is pseudepigraphal works outside the “Deuterocanonicals” that are called “Apocrypha”; this accords with ancient usage of the term “apocrypha.” Third, since the term does not describe a set of writings that can be distinguished from other existing collections (e.g., “biblical,” “apocryphal”), it often refers today to an ever-growing and fluid corpus of documents preserved from antiquity. In this latter sense, the narrow definition of “pseudepigrapha” does not describe all documents which have occasionally been collected under this heading. A good case in point is James H. Charlesworth’s edition of "), _c('em', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(" (1983-1985), which, for example, includes a number of works or parts of works associated with their real authors’ names (e.g., Aristeas the Exegete, Aristobulus, Artapanus, Cleodemus Malchus, Demetrius the Chronographer, Eupolemus, Ezekiel the Tragedian, and Theodotus).")])]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several considerations make a more precise understanding and definition of an ancient Jewish “pseudepigraphon” possible. (a) The designation is formally a subset of “anonymous” writings, that is, those compositions for which the historical author’s identity remains unknown. This means that any information about the writers depends on what they reveal about themselves in the texts. (b) Following from this, a “pseudepigraphon” usually takes one of two basic forms: a writer either (i) communicates in the first person by directly taking on the name of an important or ancient paradigmatic figure (e.g., "), _c('em', [_vm._v("1 Enoch, 2 Baruch, Testament of Job, Sibylline Oracles")]), _vm._v("); or, more loosely, (ii) composes a third-person account that attributes revelatory knowledge, instruction, or activity to such a figure (e.g., "), _c('em', [_vm._v("Jubilees")]), _vm._v(" [Moses], "), _c('em', [_vm._v("Life of Adam and Eve, Proverbs of Ahiqar, Testament of Abraham")]), _vm._v("). (c) Thus, while the assumption of an ancient ideal figure’s name is fictive in itself, it does not follow that ancient novella or legendary stories such as Tobit, Judith, "), _c('em', [_vm._v("Joseph and Aseneth, Book of Giants,")]), _vm._v(" or 11QMelchizedek are “pseudepigrapha” in the strict sense. (d) Sometimes ancient compositions combine these literary forms. Several examples illustrate this point. In the "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" (1Q20) an anonymous author strings together a series of smaller first-person accounts attributed to different patriarchs such as Lamech, Noah, and Abraham to form a larger work that as a whole is not a pseudepigraphon. While the macro-genre of Tobit is that of a tale, part of it is presented as the words of the protagonist, Tobit; in this case, the first-person idiom, the extent of which differs among the versions of the book, forms a relatively small part of the work. Finally, in a number of works the predominant first-person discourse is introduced or framed by a brief third-person narrative that provides a setting (e.g., "), _c('em', [_vm._v("Testament of the Twelve Patriarchs, Testament of Job, Testament of Moses, Ladder of Jacob")]), _vm._v("). It is not always clear in these cases whether the use of the third person is secondary or original to a given work.")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('strong', [_c('em', [_vm._v("Why “Pseudepigraphal” Writings?")])])])]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("To today’s readers the notion of a falsely ascribed literary work can carry with it the connotation of “forgery.” It is precisely this caricature that has made it difficult for religious communities to value “pseudepigrapha” for their theological ideas. To be sure, in antiquity a writer’s use of another name was sometimes criticized, and the criterion of authenticity or nonauthenticity could be invoked as a reason, respectively, for a book’s inclusion or noninclusion among sacred traditions. Josephus in the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", for example, treated the book of Daniel as written during the Babylonian exile by a prophet of that name; since what he prophesied about the Greeks’ accession to power came true through the conquests of Alexander the Great, the “books” of Daniel (i.e., including the additions preserved in Greek) are to be found “among the sacred writings” ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 10.210; cf. 10.190-281; 11.337-38; 12.322). Furthermore, insofar as "), _c('em', [_vm._v("1 Enoch,")]), _vm._v(" for example, was treated as coming from the patriarch Enoch himself, it could be regarded as scripture ("), _c('em', [_vm._v("Epistle of Barnabas")]), _vm._v(" 4:3; 16:5-6; Tertullian, "), _c('em', [_vm._v("De Cultu Feminarum")]), _vm._v(" 3, "), _c('em', [_vm._v("De Idololatria")]), _vm._v(" 4; cf. Jude 14-15) or at least highly valued (Irenaeus, "), _c('em', [_vm._v("Adversus Haereses")]), _vm._v(" 4.16; Clement of Alexandria, "), _c('em', [_vm._v("Eclogae Prophetarum")]), _vm._v(" 2 and 53; Anatolius of Alexandria, "), _c('em', [_vm._v("Paschal Canon")]), _vm._v(" 5; Ethiopic Orthodox tradition), even though the main criterion for value was based more on the importance accorded to the contents of the book. On the other hand, as noted above, spuriousness was frequently held out by Jews and Christians as a reason to reject the use of certain writings (Tertullian, "), _c('em', [_vm._v("De Cultu Feminarum")]), _vm._v(" 3; cf. Origen, "), _c('em', [_vm._v("Contra Celsum")]), _vm._v(" 5.54; Augustine, "), _c('em', [_vm._v("De Civitate Dei")]), _vm._v(" 18.38).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For all the growing worry about pseudepigraphy expressed by Jewish and Christian writers during the first centuries of the Common Era, it remains true that the phenomenon itself was not only widespread but also widely received. This was so much the case that the notion of false ascription to authors could not be applied as a criterion for rejection in every case; the use of some books in faith communities had, for various reasons, gained an irreversible momentum. The main question to ask, however, is why pseudepigraphy was so popular, that is, why so many in antiquity were prepared to write under the name of an important personage. To this question several answers may be given.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, libraries such as the great one in Alexandria were keen to collect copies of works by well-known writers. In response to such advertising, a supply of writings could be produced for purchase that met this demand. Not only was the Greek translation of the Jewish Torah reportedly produced for such a reason during the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" (see the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v("), during the first several centuries many “heretical” works of suspicious value were brought to the Library of Alexandria, which perhaps on that account was subjected to destructive activities in 48 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" (Julius Caesar), 270-275 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" (Aurelian), and especially 391 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" (the decree by the emperor Theodosius) and 634 (by the order of the caliph Umar).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("Second, writing under the name of someone important frequently served to gain a hearing for one’s own views. Thus the analogies between the time of the real author and the ancient figure invoked could not always hide the very real and immediate concerns behind the composition. Examples of this abound, more obviously in pseudepigraphal documents that contain historical allusions to present ")]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("or more recent events (so the "), _c('em', [_vm._v("post-eventum")]), _vm._v(" prophecies of "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 85–90 and 91:11-17; 93:1-10; Daniel 8-11; "), _c('em', [_vm._v("2 Baruch")]), _vm._v("). For example, where the biblical book of Ezra is associated with the return from exile, the erection and rededication of a new Temple, and the reestablishment of the Torah among the people, "), _c('em', [_vm._v("4 Ezra")]), _vm._v(" is concerned more immediately with the aftermath of the destruction of the Second Temple by the Romans. Thus the affinities between biblical context and the time of writing were overwhelmed by the real author’s pressing interests. Moreover, the process of transmission attempted to reshape or redirect received pseudepigraphal traditions to address new circumstances and theological issues; this can be observed in the later activities of Christian scribes who edited and even interpolated into the texts (e.g., "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs, Testament of Job, Testament of Abraham, 3 Baruch, 4 Baruch, 2 Enoch, Apocalypse of Zephaniah")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, in some streams of tradition, such as philosophical schools or apocalyptic circles, the notion of writing in one’s own name could simply be regarded as unethical. This was the case during generations subsequent to Pythagoras and Plato among students who produced a vast number of writings in the names of their teacher. Such a practice was regarded by the writers as a reasonable way for them to express their humility, indebtedness, and devotion in relation to the received tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A fourth reason is related to the previous two: the name of a famous teacher or well-known figure of the past could be invoked in order to combat or refute other interpretations or views of the same tradition. This was especially true, again, in the literary output of philosophical schools and in the reception, transmission, and reappropriation of earlier pseudepigraphical tradition. An example of this is provided in the second-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" "), _c('em', [_vm._v("Epistle of Enoch")]), _vm._v(" at "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 104:10-11, a passage preserved in Ethiopic and Greek texts:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Ethiopic")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Greek")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(10) And now I know this mystery, that many times the sinners will alter and pervert the word of truth; and they will speak evil words, and lie, and make big works and write my books in their own words.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(10) …] of truth they will alter; and the sinners co[py] and change many things, and lie and fashion great works and w[rit]e down books in their own names.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(11) And would that they would write down all the words accurately in their languages and neither pervert nor omit (anything) from my words, but accurately write down everything which I have testified before concerning you.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(11) An[d] would that [they wou]ld write all my words accurately in their names and [nei]ther omit nor change these words, but write all things accurately which I testify to them.")])])])])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("It has argued by some, especially on the basis of the Greek version, that the writer of this passage is engaged in a defense of his own work as a pseudepigraphon. If this is so, the possible charge of writing under someone else’s name is met by reversing the accusation: those who write “in their own names” are the ones who ")]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("perpetrate falsehood and corrupt the truth. It is not clear, however, that this reading reflects the sense of the text in its entirety. The emphasis in both versions on “my words” in verse 11 suggests that the writer’s attack is predominantly concerned with those who, from his point of view, have subverted or misrepresented the Enoch tradition they have all received. The writer, in using Enoch’s name, claims to be the authentic interpreter and transmitter of Enochic revelation and shows that he is aware of others who have deliberately taken it upon themselves to make improper use of it. While the polemic here may be directed against the construals of the figure of Enoch in works such as Ben Sira, "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" or "), _c('em', [_vm._v("Pseudo-Eupolemus,")]), _vm._v(" the fictive character of the "), _c('em', [_vm._v("Epistle of Enoch")]), _vm._v(" momentarily gives way to an admission that the real author is not, in fact, Enoch himself. If this admission is sufficiently plain, then the text assumes a reception among its readers as a pseudepigraphon.")])]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One should, of course, be cautious in regarding "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 104:10-11 as paradigmatic for how other pseudepigraphal authors understood what they were doing. In almost all the extant literature, the writers offer little or no direct hints about their "), _c('em', [_vm._v("own")]), _vm._v(" persona, and it is notoriously difficult to identify the context of origin and the groups for which they were writing. Nevertheless, from the perspective of the authors themselves, “pseudepigrapha” is a misleading label. They presented their works as divine revelation that is binding on its readers. “Truth” in content was more important than the literary genre or idiom chosen to convey it. By attributing the instructions and story lines to remote figures, the writers of pseudepigraphal works contextualized their messages within or in relation to master narratives that had been circulating widely and for a long time. Thus the effectiveness of their communication may have depended on what readers could be expected to be already familiar with from ancient tradition and, on the basis of such familiarity, be able to draw inferences from the analogies for themselves. On the other hand, the pseudepigraphal writings set their own terms of reference and already filtered through the ancient traditions in particular ways (as in the historical apocalypses or in reviews of the sacred past), so that direct acquaintance with such traditions would not have been necessary. To this extent, the implied readers are drawn into the sacred world being set before them: stark distinctions drawn between the faithful pious and the disobedient apostates in narratives and between divine or heavenly wisdom and errant knowledge in instructions invite readers, especially if they are ideally aligned with an author’s intentions, to participate imaginatively in the religious "), _c('em', [_vm._v("truths")]), _vm._v(" being revealed to them. In those apocalyptic works that anticipate eschatological judgment, readers are presented with a decision: whether to align themselves with the way the righteous are described in the book and be rewarded or to reject the author’s message, knowing that for this they will suffer the consequences of punishment. Thus, at the behest of the fictive protagonist, readers are transported into a “biblical” world that has extended into and beyond their time. Problems that beset the readers in the present — whether religious marginalization, social and political oppression, apostasy, or some other form of religious disorder — are resolved by an appeal to a paradigm in the remote past and imminent future. The pseudepigraphal idiom would have reminded readers that divine activity on behalf of the pious lies essentially outside the time in which they live. Now is the time for action, for a clear-cut decision to be faithful, whatever the circumstances.")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_156"
    }
  }), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('strong', [_c('em', [_vm._v("Pseudepigrapha since the Enlightenment and the Dead Sea Scrolls")])])])]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Since the beginning of the nineteenth century there has been a significant growth in textual witness to a number of pseudepigraphal writings. Many of these texts survive in the following languages: Latin, Greek, Old Slavonic, Armenian, Georgian, Rumanian, Coptic, Syriac, and Ethiopic; as such, they demonstrate how much the preservation of Jewish traditions composed during or derived from the Second Temple period depended on the activity of Christian writers, translators, editors, and copyists through many centuries since the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The discovery of the Dead Sea Scrolls in eleven caves from 1947 to 1956 made a significant impact on the study of ancient pseudepigraphy. This is so in two main respects. First, the Dead Sea materials have yielded non-Christian Jewish evidence for at least some of this literature. Among the previously known pseudepigrapha (if we take the technical meaning of the term as the point of departure), the following works have been confirmed as present at Qumran:")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" (Aramaic)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Book of Watchers")]), _vm._v(" (chaps. 1–36): 4Q201, 4Q202, 4Q204, 4Q205, 4Q206, XQpapEnoch")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Astronomical Book")]), _vm._v(" (chaps. 72–82): 4Q208, 4Q209, 4Q210, 4Q211")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Animal Apocalypse")]), _vm._v(" (chaps. 85–90): 4Q204, 4Q205, 4Q206, 4Q207")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Exhortation")]), _vm._v(" (91:1-10, 18-19): 4Q212")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Apocalypse of Weeks")]), _vm._v(" (93:1-10; 91:11-17): 4Q212")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Epistle of Enoch")]), _vm._v(" (92:1-5; 94:1–105:2): 4Q204, 4Q212")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Birth of Noah")]), _vm._v(" (chaps. 106–7): 4Q204")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Daniel (Aramaic): 1Q71, 1Q72, 4Q12, 4Q13, 4Q14, 4Q15, 4Q16, 6Q7")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('em', [_vm._v("Jubilees")]), _vm._v(" (Hebrew): 1Q17, 1Q18, 2Q19, 2Q20, 3Q5, 4Q176 frgs. 17-19, 4Q216, 4Q217, 4Q218, 4Q219, 4Q220, 4Q221, 4Q222, 4Q223-224, 11Q12")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Materials related to "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament of Judah")]), _vm._v(" [?]: 3Q7 Hebrew, 4Q484 Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament of Naphtali:")]), _vm._v(" 4Q215 Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Aramaic Levi Document")]), _vm._v(" (Aramaic): 1Q21, 4Q213, 4Q213a, 4Q213b, 4Q214, 4Q214a, 4Q214b")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Psalms 151, 154, 155: 11Q5")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Related, though not formally a pseudepigraphon, is the Aramaic "), _c('em', [_vm._v("Book of Giants")]), _vm._v(" (1Q23, 1Q24, 2Q26, 4Q203, 4Q206a, 4Q530, 4Q531, 4Q532, 4Q533, 6Q8).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Second, pseudepigraphal documents for which there has not been previous evidence have come to light through fragments from the Dead Sea:")])]), _c('p', {
    staticClass: "bullett"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("• Traditions related to the biblical book of Daniel (Aramaic)")])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Prayer of Nabonidus")]), _vm._v(" (4Q242)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Four Kingdoms")]), _vm._v(" (4Q552, 4Q553)")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Testamentary material (Aramaic)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament of Jacob")]), _vm._v(" (4Q537)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament")]), _vm._v(" (or "), _c('em', [_vm._v("Apocryphon")]), _vm._v(") "), _c('em', [_vm._v("of Judah")]), _vm._v(" (4Q538)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament")]), _vm._v(" (or "), _c('em', [_vm._v("Apocryphon")]), _vm._v(") "), _c('em', [_vm._v("of Joseph")]), _vm._v(" (4Q539)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament")]), _vm._v(" (or "), _c('em', [_vm._v("Apocryphon")]), _vm._v(") "), _c('em', [_vm._v("of Levi")]), _vm._v(" (4Q540, 4Q541)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Testament of Qahat")]), _vm._v(" (4Q542)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Visions of Amram")]), _vm._v(" (4Q543, 4Q544, 4Q545, 4Q546, 4Q547, 4Q548)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" (Aramaic) (1Q20)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-para"
  }, [_c('em', [_vm._v("New Jerusalem")]), _vm._v(" (Aramaic) (1Q32, 2Q24, 4Q554, 4Q555, 5Q15, 11Q18)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Again, related materials to these include a number of documents which, in their preserved forms, show no evidence of being pseudepigrapha: "), _c('em', [_vm._v("Pseudo-Daniel")]), _vm._v(" (4Q243, 4Q244, 4Q245); "), _c('em', [_vm._v("Aramaic Apocalypse")]), _vm._v(" (4Q246); "), _c('em', [_vm._v("Apocalypse?")]), _vm._v(" (4Q489, 4Q490); "), _c('em', [_vm._v("Noah")]), _vm._v(" (4Q534, 4Q535, 4Q536; and 1Q19, 1Q19 bis); "), _c('em', [_vm._v("Daniel Susanna?")]), _vm._v(" (4Q551); and "), _c('em', [_vm._v("Four Kingdoms")]), _vm._v(" (4Q552, 4Q553).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While these materials, preserved in manuscripts dating from the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" until the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", both confirm and augment the existence of pseudepigraphal writing in Second Temple Judaism, two points should be noted. First, none of them are documents whose origins can be traced to the Qumran community, whose extant literature was invariably composed by (formally) anonymous writers. This means that, while the collection and, possibly, copying of these materials imply that the Qumran community did not reject them, the phenomenon of pseudepigraphy was fairly widespread among Hebrew and especially Aramaic-speaking Jews of the time. Second, these texts, especially those which can be said to pre-date the Maccabean revolt "), _c('em', [_vm._v("(Book of Watchers, Astronomical Book)")]), _vm._v(" or contain pre-Danielic tradition "), _c('em', [_vm._v("(Aramaic Levi Document, Prayer of Nabonidus, Visions of Amram, Testament of Qahat),")]), _vm._v(" demonstrate that the practice of attributing wisdom and speech was well established during the third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" This undergirds our confidence that a number of other works showing little or no overt sign of Christian editorial intrusion are originally Jewish and were composed during the Second Temple period (or at least before the Bar Kokhba Revolt): examples of this include "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 108 "), _c('em', [_vm._v("(Eschatological Admonition), 4 Ezra, 2 Baruch, Apocalypse of Abraham, Testament of Abraham, Letter of Aristeas, Pseudo-Philo")]), _vm._v(" (= "), _c('em', [_vm._v("Liber Antiquitatum Biblicarum")]), _vm._v("), "), _c('em', [_vm._v("Psalms of Solomon, Similitudes of Enoch")]), _vm._v(" (= "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" 37–71), "), _c('em', [_vm._v("Testament of Job, Testament of Moses, Joseph and Aseneth, Life of Adam and Eve, Pseudo-Phocylides,")]), _vm._v(" 3 Maccabees, 4 Maccabees, and Prayer of Manasseh.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("But for all their importance, the manuscripts from Qumran should not mislead one to assume that many or most of the “Old Testament” pseudepigrapha not attested at Qumran were also composed during the Second Temple period. To begin with, many of these compositions are simply Christian or contain very little ")]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("trace of direct borrowing from non-Christian Jewish tradition ("), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" books 6–8, "), _c('em', [_vm._v("5 Ezra, 6 Ezra, Questions of Ezra, Greek Apocalypse of Ezra, Vision of Ezra, Apocalypse of Elijah, Apocalypse of Zephaniah, Apocalypse of Sedrach, Apocalypse of Daniel, Testament of Adam, Testament of Isaac, Testament of Jacob, Testament of Solomon, Ascension of Isaiah, Odes of Solomon")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A number of others seem to be so predominantly Christian in outlook and tone that indicators of Jewish tradition seem best explained as a matter of reception or borrowing by Christian or Jewish-Christian writers ("), _c('em', [_vm._v("Lives of the Prophets, Sibylline Oracles")]), _vm._v(" books 1–2 and 14, "), _c('em', [_vm._v("History of the Rechabites")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More Jewish in outlook, several documents may derive from at least some Jewish written sources that have been edited, supplemented, or interpolated by Christian scribes (so, e.g., "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" books 3, 4 and 5; "), _c('em', [_vm._v("3 Baruch; 4 Baruch;")]), _vm._v(" the "), _c('em', [_vm._v("Hellenistic Synagogal Prayers;")]), _vm._v(" and "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")]), _vm._v("). Here, some of the Christian interpolations are easy to identify ("), _c('em', [_vm._v("4 Bar.")]), _vm._v(" 8:12–9:32; "), _c('em', [_vm._v("Sib. Or.")]), _vm._v(" 1.324-400; "), _c('em', [_vm._v("Sib. Or.")]), _vm._v(" 3.776; "), _c('em', [_vm._v("T. Levi")]), _vm._v(" 4:4; 10:2-3; 14:2; 16:3, passim; "), _c('em', [_vm._v("Hell. Syn. Prayers")]), _vm._v(" 5:4-8 and 20-24; 7:4, etc.). Finally, some writings may have circulated in both Jewish and Christian circles, but show very little direct influence from either "), _c('em', [_vm._v("(Ahiqar Proverbs, Sentences of the Syriac Menander).")]), _vm._v(" These classifications are not clear-cut; it sometimes remains difficult, if not impossible, to determine whether a given document or one of its passages without obviously Christian ideas therefore stems from a non-Christian Jewish tradition (e.g., many parts of "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, when non-Christian Jewish and Christian traditions have come together in a composition, scholarship in recent years has begun to shift from the assumption that a Jewish source has been reworked by Christians to a default view that attributes the essential form of the document to Christians who were inspired by Jewish traditions. Such a shift has been noticeable in recent treatments of "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")]), _vm._v(" (de Jonge, in numerous works from 1953 to 2003), "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(" (Norelli 1995), "), _c('em', [_vm._v("Lives of the Prophets")]), _vm._v(" (Satran 1995), "), _c('em', [_vm._v("3 Baruch")]), _vm._v(" (Harlow 1996), and "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" (Kraemer 1998). A methodological corollary to this shift is that, when the earliest evidence for such documents exists in Christian manuscripts, it is these Christian contexts that should provide the point of departure for study and analysis (Kraft 2001; Davila 2005). With regard to Early or Second Temple Judaism, then, it becomes crucial to identify and make use of criteria which might (or might not) assist in determining the extent to which pseudepigraphal writings originated among Jewish (or Jewish-Christian) groups. Scholars will continue to debate about how far each of these writings can be classified in precisely the ways outlined above. However, the different possibilities listed here illustrate (a) the complexities students of the materials face when attempting to determine their date and religious provenience, (b) the occasionally stark differences between Jewish and Christian tradition, and yet (c) how similar and, indeed, often indistinguishable, Jewish, Jewish-Christian, and non–Jewish-Christian traditions could be.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_159"
    }
  }), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_c('strong', [_vm._v("Conclusion")])])]), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Today the terms “Apocrypha” and “Pseudepigrapha” refer to collections of writings of which many do not strictly reflect the literal meaning of these terms. The Apocrypha (or, for Roman Catholicism, Deuterocanonicals) is a fluid collection if one compares the lists of them among the different ecclesiastical traditions. However, within each ecclesiastical tradition, their identification has been remarkably stable. These writings may be confidently regarded as Jewish in origin; in addition, they all date to before the Bar Kokhba Revolt (132-135 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(") and, except for "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" were all originally composed before the destruction of the Second Temple (70 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("). At the same time, the free use of the term “apocryphon” for a number of documents discovered among the Dead Sea Scrolls reflects the ancient meaning of “hidden” traditions without, however, being “hidden” in the more technical sense found in Daniel, "), _c('em', [_vm._v("4 Ezra,")]), _vm._v(" and "), _c('em', [_vm._v("2 Baruch.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By contrast, collections of “pseudepigrapha” (or “apocrypha” in Roman Catholic tradition) have been anything but stable. This is due to a number of factors: (a) The term “pseudepigraphon” has often not been applied in its narrow meaning of a writing falsely ascribed. Instead, it has sometimes served as a broad category that refers to religious Jewish and Christian writings that are neither found in the “Bible” nor included in a church’s list of “Apocrypha.” (b) Since the beginning of the nineteenth century, when entrepreneurs and collectors brought ancient manuscripts to Europe from monasteries in Africa and the Middle East, and until the present, as manuscripts for new documents from Ethiopia, Armenia, and the Dead Sea have continued to come to light, collections of pseudepigrapha (however the term is defined) have been growing in number. (c) Modern collections of translated works — here we may take German and English publications since 1900 as an example — have each differed from one another in what to (and not to) include. Some of these differences can be attributed to nomenclature, that is, whether or not a given editor focused on “pseudepigrapha” per se (Kautzsch 1900, Charles 1913, Charlesworth 1983-1985, Sparks 1984: “apocryphal Old Testament”), more generally on works “outside the Bible” (Riessler 1927), or on Jewish writings from the Greco-Roman period (the series Jüdische Schriften aus hellenistisch-römischer Zeit [JSHRZ] 1973-present). These more widely disseminated collections, however, have fluctuated greatly on the number and selection of documents: Kautzsch (thirteen documents), Charles (seventeen), Riessler (sixty-one, including "), _c('em', [_vm._v("Shemoneh Esreh, Megillat Ta")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("anit,")]), _vm._v(" Heraclitus of Ephesus, Theodotus, "), _c('em', [_vm._v("Caves of Treasures")]), _vm._v("), Sparks (twenty-five), Charlesworth (sixty-five, though ten nonpseudonymous works are included within a supplementary section entitled “Fragments of Lost Judeo-Hellenistic Works”), and JSHRZ (fifty, including “Apocrypha”).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("Beyond the writings included in these collections, a number of further documents could be included. The significance of the Dead Sea Scrolls has been noted for the addition of new materials, and there is little doubt that these materials were composed during the Second Temple period. A further project entitled "), _c('em', [_vm._v("More Old Testament Pseudepigrapha")]), _vm._v(" (MOTP), based at the University of St. Andrews under the direction of James Davila, is seeking to supplement the Charlesworth edition with an additional fifty pseudepigraphal writings, plus nearly thirty more that ")]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("are found either in fragments or in quotations. The MOTP collection is casting its net more widely to include pseudepigrapha composed by Jews and Christians all the way up to 600 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" and the rise of Islam. With some notable exceptions (e.g., "), _c('em', [_vm._v("Aramaic Levi Document, Book of Giants, Hebrew Naphtali, Balaam Text")]), _vm._v(" [from Deir Alla], "), _c('em', [_vm._v("Hebrew Apocalypse of Elijah, Geniza Wisdom Text, Sword of Moses, Massekhet Kelim, Midrash Vayissa")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("u, Eighth Book of Moses, Sepher ha-Razim, Sepher Zerubbabel")]), _vm._v("), many of the additional works in MOTP are Christian compositions and face the same issues regarding the relation between Jewish and Christian tradition outlined above. Accordingly, the net has been cast more widely here to include some pseudepigraphal documents in the Dead Sea Scrolls, but also works composed until 600 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" Thus the significance of each work for the Second Temple period varies widely and will require analysis on a case-by-case basis.")])]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The problems that beset the terms “Apocrypha” and “Pseudepigrapha” have not prevented scholars from applying them to discrete collections of ancient works that stand alongside other recognized collections of works such as the Dead Sea Scrolls, rabbinic literature, the Hekhalot texts, the Nag Hammadi Library, and the works of Philo and Josephus. These different, though sometimes overlapping classifications of texts cannot hide the fact that in order to be interpreted, they need to be read together for a more comprehensive understanding of the diversities of Judaism that flourished during the centuries leading up to and after the turn of the Common Era.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Baum, Armin Daniel. 2001. "), _c('em', [_vm._v("Pseudepigraphie und literarische Fälschung im frühen Christentum.")]), _vm._v(" Tübingen: Mohr-Siebeck.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charles, Robert H., ed. 1913. "), _c('em', [_vm._v("The Apocrypha and Pseudepigrapha of the Old Testament.")]), _vm._v(" 2 vols. Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Charlesworth, James H., ed. 1983-1985. "), _c('em', [_vm._v("The Old Testament Pseudepigrapha.")]), _vm._v(" 2 vols. New York: Doubleday.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chazon, Esther G., and Michael E. Stone, eds. 1997. "), _c('em', [_vm._v("Pseudepigraphic Perspectives: The Apocrypha and Pseudepigrapha in Light of the Dead Sea Scrolls.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Collins, John J. 1998. "), _c('em', [_vm._v("The Apocalyptic Imagination: An Introduction to Jewish Apocalyptic Literature.")]), _vm._v(" 2d ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Davila, James R. 2005. "), _c('em', [_vm._v("The Provenance of the Pseudepigrapha: Jewish, Christian, or Other?")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("de Jonge, Marinus. 2003. "), _c('em', [_vm._v("Pseudepigrapha of the Old Testament as Part of Christian Literature: The Case of the Testaments of the Twelve Patriarchs and the Greek Life of Adam and Eve.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("DeSilva, David. 2002. "), _c('em', [_vm._v("Introducing the Apocrypha: Message, Context and Significance.")]), _vm._v(" Grand Rapids: Baker.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flint, Peter W. 1999. “‘Apocrypha,’ Other Previously-Known Writings, and ‘Pseudepigrapha’ in the Dead Sea Scrolls.” In "), _c('em', [_vm._v("The Dead Sea Scrolls after Fifty Years.")]), _vm._v(" 2 vols. Ed. Peter W. Flint and James C. VanderKam. Leiden: Brill, 1:24-66.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harlow, Daniel C. 1996. "), _c('em', [_vm._v("The Greek Apocalypse of Baruch (3 Baruch) in Hellenistic Judaism and Early Christianity.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harrington, Daniel J. 1999. "), _c('em', [_vm._v("Invitation to the Apocrypha.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hollander, Harm W., and Marinus de Jonge. 1985. "), _c('em', [_vm._v("The Testaments of the Twelve Patriarchs: A Commentary.")]), _vm._v(" Leiden: Brill.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_161"
    }
  }), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("Kautzsch, Emil, ed. 1900. "), _c('em', [_vm._v("Die Apokryphen und Pseudepigraphen des Alten Testaments.")]), _vm._v(" 2 vols. Tübingen: Mohr.")])]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Kraemer, Ross S. 1998. "), _c('em', [_vm._v("When Aseneth Met Joseph: A Late Antique Tale of the Biblical Patriarch and His Egyptian Wife, Reconsidered.")]), _vm._v(" Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kraft, Robert A. 2001. “The Pseudepigrapha and Christianity Revisited: Setting the Stage and Framing Some Central Questions.” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 32: 371-95.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nickelsburg, George W. E. 2001. "), _c('em', [_vm._v("1 Enoch 1.")]), _vm._v(" Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2005. "), _c('em', [_vm._v("Jewish Literature between the Bible and the Mishnah.")]), _vm._v(" 2d ed. Philadelphia: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Norelli, Enrico. 1995. "), _c('em', [_vm._v("Ascensio Isaiae,")]), _vm._v(" vol. 1, "), _c('em', [_vm._v("Commentarius.")]), _vm._v(" Turnhout: Brepols.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Riessler, Paul. 1927. "), _c('em', [_vm._v("Altjüdisches Schrifttum ausserhalb der Bibel.")]), _vm._v(" Heidelberg: Kerl.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Satran, David. 1995. "), _c('em', [_vm._v("Biblical Prophets in Byzantine Palestine: Reassessing the “Lives of the Prophets.”")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sparks, H. F. D., ed. 1984. "), _c('em', [_vm._v("The Apocryphal Old Testament.")]), _vm._v(" Oxford: Clarendon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stone, Michael E. 1990. "), _c('em', [_vm._v("Fourth Ezra.")]), _vm._v(" Minneapolis: Fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1996. “The Dead Sea Scrolls and the Pseudepigrapha.” "), _c('em', [_vm._v("DSD")]), _vm._v(" 3: 270-96.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stuckenbruck, Loren T. 2007. "), _c('em', [_vm._v("1 Enoch 91–108.")]), _vm._v(" Berlin: de Gruyter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wyrick, Jed. 2004. "), _c('em', [_vm._v("The Ascension of Authorship: Attribution and Canon Formation in Jewish, Hellenistic, and Christian Traditions.")]), _vm._v(" Cambridge: Harvard University Press.")])])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('em', [_vm._v("The Dead Sea Scrolls")])])]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERT")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGCHELAAR")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In a comprehensive sense, the Dead Sea Scrolls include all texts from Wadi Daliyeh, Ketef Jericho, Qumran, Wadi en-Nar, Wadi Ghweir, Wadi Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Wadi Sdeir, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al Arugot, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever/Wadi "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ṣ")]), _vm._v("eiyâl, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al Mishmar, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ṣ")]), _vm._v("e"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("elim, Masada, as well as Khirbet Mird. In common usage, and in this essay, the term “Dead Sea Scrolls” refers specifically to the texts found between 1947 and 1956 in the caves near Qumran, close to the northwestern shore of the Dead Sea. Some fragments that are reported to have been found in caves near Qumran may in fact stem from other sites that were discovered by the Bedouin in the same period, notably Wadi Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at and Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever/Wadi "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ṣ")]), _vm._v("eiyâl. Likewise, the origin of some fragments in private collections is unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The importance of the Dead Sea Scrolls for the history of early Judaism lies in the combination of the size, the antiquity, and the nature of the corpus. The scrolls are by far the largest collection of Jewish religious texts from the Second Temple period, preserving fragments of more than a hundred different religious compositions, most of which were hitherto unknown. For many different aspects of Judaism, the Dead Sea Scrolls provide the first literary evidence. Thus, for example, the corpus contains the oldest Hebrew and Greek biblical manuscripts, the first Aramaic translations of biblical books, the oldest "), _c('em', [_vm._v("tefillin,")]), _vm._v(" the earliest liturgies for fixed prayers, the oldest nonbiblical halakic works, as well as the oldest exorcistic prayers. In many cases we find hitherto-unknown precursors to or roots for phenomena found in rabbinic Judaism, such as the hymns embedded in the Hekhalot literature. At the same time, some scrolls attest to Second Temple practices and beliefs that did not become part of later normative Judaism, which is why they sometimes are called sectarian. This goes, for example, for so-called rule texts that discuss the membership of the movement of the “renewed covenant,” exegetical works that apply scriptural prophecies to the contemporary history and future of the group, eschatological works dealing with the final war, and religious calendrical texts based on a 364-day calendar.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("Because of the content of so-called sectarian texts, especially the "), _c('em', [_vm._v("Rule of the")])]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_c('em', [_vm._v("Community,")]), _vm._v(" scholars in the 1950s framed the Qumran-Essene hypothesis of the provenance of the Dead Sea Scrolls, which at the end of that decade had become the paradigm of scrolls scholarship. The scrolls were assumed to be the remnants of the library of an Essene, or Essene-like, sectarian community that dwelt at Qumran, composed and copied texts, and hid their manuscripts in various caves before the Romans conquered the site in 68 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" At present there are many different modifications of this paradigm. Most importantly, there is a broad recognition that not all the compositions and scrolls can be attributed to this one “sectarian” group, and that many texts may have been composed or written somewhere else, before they were brought to Qumran. Some archaeologists even deny that Qumran would have been a religious center and therefore assume that all the scrolls were brought from elsewhere. The following survey offers an overview of the corpus, a description of the texts and their contribution to our knowledge of Judaism in the Second Temple period, and critical reflections on the nature of the corpus.")])]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Contours of the Corpus")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although generally the Dead Sea Scrolls are discussed as one corpus, they comprise the inscribed material from eleven different caves in the vicinity of the ruins of Qumran. The finds in the caves share many commonalities but also differ in important respects. Largely or partially intact scrolls have been found only in Caves 1 and 11. The completely preserved Cave 3 "), _c('em', [_vm._v("Copper Scroll")]), _vm._v(" stands out because of its material, contents, and language. Cave 4, which yielded more than 15,000 fragments that can be assigned to at least 700 different manuscripts, surrendered far more manuscripts than all other caves together. In Cave 7 only fragments of Greek texts were found, and Cave 6 produced a relatively large number of papyrus texts. According to the current paleographical dating, the texts from Caves 1 and 4 are on average considerably older than those from Caves 2, 3, 5, 6, and 11. Caves 9 (one shred of papyrus with a few letters) and 10 (a shard of pottery with two letters) can be ignored in this overview.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most characteristic feature of both the entire corpus and the collections of the individual caves is that virtually all the manuscripts contain texts of a religious nature or touching upon religious issues. Only a few, badly preserved fragments are the remnants of nonliterary texts such as letters, accounts, or deeds, and it cannot be excluded that some of those actually stem from Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The present inventory of Dead Sea Scrolls lists around 930 items. In most cases one item corresponds to one manuscript, but in view of the many unidentified fragments that have not been included in the lists, it is plausible that the materials known to us stem from more than a thousand different manuscripts. Only in a few cases do substantial parts of manuscripts remain, and often a manuscript consists of no more than a few identified fragments.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_vm._v("Most Dead Sea Scrolls were written on skins of domesticated goats and ibexes. Some exceptionally thick scrolls, like 11Q5, might be calfskin. Ten to fifteen percent of the manuscripts were written on papyrus. The Cave 3 "), _c('em', [_vm._v("Copper Scroll")]), _vm._v(" is the only text written on metal. Both in and near the caves (Caves 4, 6, 7, 8, and 10), and ")]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("at the site of Qumran, jars and shards with inscriptions or incisions were found. Notable are the ostraca found at Qumran, as well as a small limestone plaque of five lines with what may be a literary text (KhQ 2207). Some fragments, both of skin and of papyrus, were found to be written on both sides.")])]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The majority of the manuscripts are written in Hebrew. About 12 percent (or 17 percent of the nonbiblical, nondocumentary texts) are written in Aramaic. Almost 3 percent of the inventory items are written in Greek, but the percentage drops to less than 1 percent if we bracket out Cave 7. All but two Aramaic manuscripts and most Hebrew ones are written in the so-called square or Aramaic script. Two Aramaic manuscripts are written in a Nabatean script. Some Hebrew texts use the Paleo-Hebrew script, or several kinds of so-called cryptic scripts, the most common one being referred to as Cryptic A. The square script is attested in formal, semiformal, and semicursive hands, and a few of the documentary texts are written in a cursive hand. Some Hebrew texts display the orthography and morphology known from the Masoretic manuscripts of the Hebrew Bible; others have a distinct full orthography and special morphological features that are unattested or rare in Hebrew texts outside the corpus. Many manuscripts with those morphological features also have specific nontextual scribal features, so Emanuel Tov has proposed that we have within the corpus a large group of documents written according to a special “Qumran scribal practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The traditional paleographic dating of the manuscripts ranges from the mid-third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", but the vast majority of the manuscripts date to the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Radiocarbon analysis of manuscripts by and large gives date ranges from the late third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", even though for specific samples paleographic and radiocarbon datings disagree. No manuscripts are internally dated, and the few texts that mention identifiable historical persons refer to figures that lived in the second century and especially in the first half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The near completion of the publication of all materials in the 1990s has enabled new approaches to the corpus, by allowing scholars to correlate different kinds of subsets within the corpus. For example, one may contrast collections from different caves, compare “biblical” texts written in the so-called Qumran scribal practice to other “biblical” texts, or use the date of the hands of manuscripts in order to trace chronological developments in the corpus.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Scholarly Categorizations Old and New")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("Classifications of the different kinds of Dead Sea Scrolls have shifted over time, as more scrolls became known, and as scholarly concepts, terminology, and interpretations changed. Initially, on the basis of the Cave 1 finds, the scrolls were roughly classified in three categories: (1) biblical or canonical; (2) apocryphal and/or pseudepigraphal; and (3) sectarian or Essene. This old categorization was partly based on genre and content of texts but also implied a historical view according to which (with the exception of Daniel) canonical books preceded apocryphal and pseudepigraphal ones, which in turn were older than the sectarian texts. At the ")]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("same time, this three-part division was thought to reflect the literature of respectively all Jews, some Jews, and only the Dead Sea Scrolls sect. Gradually, the problematic categories of apocrypha and pseudepigrapha were subsumed in a broader general category of “parabiblical texts,” and the initial tripartite scholarly categorization was in practice limited to two sets of oppositions, “biblical” versus “non-biblical,” and “sectarian” versus “nonsectarian,” which influence scholarship up to the present.")])]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The publication of all the Cave 4 materials and their subsequent analysis has required a thorough revision of those earlier classifications. The corpus does not conform to anachronistic assumptions connected to the term “biblical.” This realization has provoked discussions of whether texts like the "), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" manuscripts are biblical, or whether "), _c('em', [_vm._v("Jubilees")]), _vm._v(" or the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" had scriptural status for the group that collected the scrolls. Also, consideration of the corpus as a whole challenges the view that all the hitherto-unknown texts were written by only one group and suggests that they originated in different movements at different times. The result is that the sharp contrasts between the two sets of oppositions, “biblical” versus “nonbiblical” and “sectarian” versus “nonsectarian,” has broken down; scholars now allow for different degrees of authoritativeness of scriptures and varying kinds of sectarianism. From a practical view, a classification with two sets of oppositions also has limited value, since most newly published manuscripts should have been assigned to the categories “nonbiblical” and “nonsectarian.” The large increase in known materials does, however, enable one to classify the materials differently, according to literary form, content, or function of compositions. Such new classifications of the material can be found in the translations of García Martínez and Vermes, and in a more elaborate form in Lange’s overview in DJD 39. In Lange’s classification of the nonbiblical texts, which has been adopted by the "), _c('em', [_vm._v("Dead Sea Scrolls Reader,")]), _vm._v(" we find categories such as “parabiblical,” “exegetical,” “concerned with religious law,” “calendrical,” “poetical,” “liturgical,” “sapiential,” “historical,” “apocalyptic,” “eschatological,” and more.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Texts and Early Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The present survey does not aim at a strict categorization of the manuscripts but rather discusses the corpus and the most important texts thematically. It aspires to relate the materials to present scholarly discussion and to clarify what they contribute to the knowledge of early Judaism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Authoritative Scriptures and the Formation of the Bible")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("In general the term “biblical” is used, anachronistically, but for practical reasons, for those scrolls which contained the text, or part of the text, of one or more compositions that would later be included in the Tanak. Altogether, the corpus contains more than two hundred Hebrew and Aramaic “biblical” manuscripts,” five manuscripts with Greek translations of pentateuchal books, three with Aramaic ")]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("translations "), _c('em', [_vm._v("(targumim),")]), _vm._v(" and thirty-three phylacteries and "), _c('em', [_vm._v("mezuzot.")]), _vm._v(" In addition, many of the “nonbiblical” manuscripts are in various ways intertextually related to the “biblical” books. While the “biblical” manuscripts give direct witness to the forms of the biblical books and their text in the period just before the final stage of the formation of the Hebrew Bible, the corpus as a whole gives indirect witness to those compositions and their text, but also sheds light on the authoritativeness of scriptures for the group(s) behind the corpus.")])]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The “biblical” Dead Sea Scrolls reflect a wide diversity of textual variants and recensions. Whereas many manuscripts present a text that stands fairly close to the Masoretic Text (MT), there are also scrolls that preserve variants and even recensions that correspond to those of the Old Greek (e.g., 4QJer"), _c('sup', [_vm._v("b")]), _vm._v("), or to the Samaritan Pentateuch (4QpaleoExod"), _c('sup', [_vm._v("m")]), _vm._v(", 4QNum"), _c('sup', [_vm._v("b")]), _vm._v(", and 4QDeut"), _c('sup', [_vm._v("n")]), _vm._v("). But many other “biblical” manuscripts do not closely correspond to any of those three texts, since they either have multiple unique variant readings, or have readings that cannot be aligned with only one of the traditional texts. Therefore, with regard to textual readings, we do not have a limited number of text types but multiple texts. With regard to recensions, the manuscripts generally correspond with the types of recensions found in the MT or the LXX (where book by book the one or the other may be older), or with the harmonizing kind of recensions that are also found in the Samaritan Pentateuch (SP). Famous is the case of 4QJer"), _c('sup', [_vm._v("b")]), _vm._v(", which displays the recensional differences in which the LXX differs from MT. But here again, some scrolls preserve recensions that are independent from other known texts (e.g., 4QJudg"), _c('sup', [_vm._v("a")]), _vm._v("). None of the variants or recensions has a clearly “sectarian” concern, though some of the 1QIsa"), _c('sup', [_vm._v("a")]), _vm._v(" variants have been interpreted as expressing the self-understanding of the Dead Sea Scrolls community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For the assessment of the LXX and the SP, the scrolls are invaluable because they demonstrate that divergent readings and recensions of the Old Greek (OG) often go back to a Hebrew "), _c('em', [_vm._v("Vorlage")]), _vm._v(" and are not tendentious innovations of the translator, and that the harmonizations in the SP were already present in the text the Samaritans chose. The variety of the “biblical” manuscripts from Qumran may be contrasted with the homogeneity of the post-70-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" “biblical” manuscripts found at Wadi Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Wadi Sdeir, and Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever/Wadi "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ṣ")]), _vm._v("eiyâl, which preserve a text that is virtually identical to the MT. This contrast has been explained chronologically and sociologically: the Qumran “biblical” manuscripts, the majority of which stem from the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" and the early first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(", reflect the textual variety before the post-70-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" move toward textual standardization that influenced the other Judean Desert “biblical” manuscripts; or, mainstream (Pharisaic, proto-rabbinic) Judaism promoted a standardized text, whereas the group who collected or copied the Dead Sea Scrolls did not. The pre-73-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" “biblical” manuscripts found at Masada make the issue even more complex, since they are found at the same site as “nonbiblical” manuscripts comparable to those from Qumran but seem to display a text that is arguably closer to the MT than the “biblical” Dead Sea Scrolls are.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("Equally important is the phenomenon of multiple, probably successive, recensions and rewritings of “biblical” books. For several biblical books, the LXX and the MT preserve two different recensions, and for the Pentateuch we have the ")]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("systematically harmonizing recension of the SP. Yet another recension is found in the so-called "), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" manuscripts (4Q158; 4Q364-367), which contain editions of the Pentateuch characterized by harmonizations and relocations of materials, but also by additions of new text relating to, for example, the festival laws. Discussions of whether these manuscripts should be called biblical or authoritative scripture relate both to the analysis of the manuscripts and to suppositions regarding the concepts “biblical” and “authoritative.” From a literary point of view, the recension in the "), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" goes one step beyond that of the SP by adding new materials, generally based on exegesis of the text. The techniques used in this recension are comparable to those used in some of the LXX recensions, for example, 3 Kingdoms and Esther. Whether these expansionist "), _c('em', [_vm._v("Reworked Pentateuch")]), _vm._v(" texts were biblical in the precanonical sense of authoritative depends on whether one assumes a strict boundary between texts or recensions of texts that were regarded as authoritative and those that were not.")])]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From the perspective of the later canon, one may ask to what extent the books of the Tanak already were scriptural among the Dead Sea Scrolls. The partially reconstructed reference in 4QMMT to “the book of Moses, the books of the prophets, and David (?)” has been taken to refer to a threefold structure of scriptures, but this is only one of several possible readings, reconstructions, and interpretations of this passage. Copies of all books of the Hebrew Bible have been identified among the scrolls, with the exception of Esther (though the status of one fragment with a section of Chronicles and of another text is unclear). The quantity of preserved scrolls per book differs considerably, and one may contrast the large number of copies of the books of the Pentateuch, Isaiah, and Psalms (several of which are attested by twenty copies or more) with the small number of preserved copies (three or less) of Joshua, Judges, Kings, Proverbs, Qohelet, Ezra, and Chronicles. There are no "), _c('em', [_vm._v("a priori")]), _vm._v(" grounds for assuming that all the later biblical books of the Tanak were already scriptural or authoritative to the same degree. It seems that a core group of scriptures (Pentateuch, Isaiah, the Minor Prophets, and Psalms), were differently transmitted, interpreted, and granted a different degree of authority than other scriptures. For example, the textual transmission of Isaiah and the Minor Prophets is fairly stable: we have only one major recension. Also, there are pesharim interpreting those books, which indicates that the contents were seen as authoritative but in need of interpretation. In contrast, there are different recensions of Jeremiah and Ezekiel, and instead of pesharim we find parabiblical literature connected to those books. Some of the Ketuvim are extensively used in other Dead Sea Scrolls, such as the Psalms, Daniel, Proverbs, and Lamentations. Other Ketuvim, like Canticles, Ruth, Ecclesiastes, Esther, and Ezra, are not known to have been used or referred to in other texts.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("Criteria that may cumulatively indicate the importance or authority that a group attached to a text include (a) the number of preserved copies of a composition, (b) the existence of commentaries on those works, (c) quotations or references to a text in other compositions, (d) the existence of translations of those texts, (e) implicit or explicit claims to authority in a work, and (f) attribution of a text to preexilic authors. Hence, it has been suggested that "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and (some of) the books of "), _c('em', [_vm._v("Enoch,")]), _vm._v(" but possibly also texts like the "), _c('em', [_vm._v("Aramaic Levi Document")]), _vm._v(" and the ")]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('em', [_vm._v("Apocryphon of Joshua,")]), _vm._v(" may have been authoritative scriptures for groups behind the Dead Sea Scrolls. But here, too, the question is whether one should assume a sharp distinction between scriptural and nonscriptural.")])]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Extending Scriptures by Interpretative Rewriting")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since the 1990s, the term “parabiblical” has gained popularity in Dead Sea Scrolls studies as an umbrella term for a large variety of texts that are closely related to texts or themes of the Hebrew Bible. This category includes both those texts that were formerly described as “rewritten bible” or “biblical interpretation,” and those compositions that are attributed or connected to biblical figures and that often were characterized as pseudepigraphal and apocryphal. Even though there sometimes is an overlap, as in the case of rewritings attributed to Moses or Ezekiel, these are two distinct types, and the general but vague term “parabiblical” obfuscates the differences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first type consists of interpretative rewritings of earlier scripture, in the form of “rewritten scripture,” or as a paraphrase or retelling of either entire books, or sections of books, or even as a pastiche of different passages. These rewritings sometimes have expansions that may go back to older sources or traditions, or derive from the interpretation of the author. The best-preserved examples of the first type are the book of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll,")]), _vm._v(" both of which contain extensive interpretative rewritings of parts of the Torah, as well as parts that have no direct correspondence in the Torah and that may have been taken from other sources or traditions. Less well-preserved examples are the "), _c('em', [_vm._v("Apocryphon of Joshua")]), _vm._v(" and many other fragmentary manuscripts that deal with events from the Torah and Joshua. These include some parts of the "), _c('em', [_vm._v("Genesis Apocryphon,")]), _vm._v(" some of the Moses Apocrypha, notably "), _c('em', [_vm._v("Words of Moses")]), _vm._v(" (1Q22) and "), _c('em', [_vm._v("Apocryphal Pentateuch A")]), _vm._v(" (4Q368) and "), _c('em', [_vm._v("B")]), _vm._v(" (4Q377). A few texts are related to the books of Samuel and Kings, such as "), _c('em', [_vm._v("Vision of Samuel")]), _vm._v(" (a misnomer for 4Q160) or "), _c('em', [_vm._v("Paraphrase of Kings")]), _vm._v(" (4Q382), and to the prophets, especially the "), _c('em', [_vm._v("Pseudo-Ezekiel")]), _vm._v(" manuscripts. We also find works of this type relating to the books later collected as Ketuvim, for example "), _c('em', [_vm._v("Apocryphal Lamentation A")]), _vm._v(" (4Q179), which rewrites parts of Lamentations, and "), _c('em', [_vm._v("Wiles of the Wicked Woman")]), _vm._v(" (4Q184) and "), _c('em', [_vm._v("Beatitudes")]), _vm._v(" (4Q525; 5Q16), which are copies of one or two works closely related to the text of Proverbs 1–9.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("These compositions represent different degrees and kinds of rewriting. In the case of "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll,")]), _vm._v(" the compositions both rewrite Torah and claim to be Torah themselves. They complement the pentateuchal Torah as its valid and authoritative interpretation. For other rewritten Mosaic texts, a similar relation to the Pentateuch may be assumed but cannot be established because the texts are too fragmentary. The "), _c('em', [_vm._v("Apocryphon of Joshua")]), _vm._v(" is a good example of different aspects of the process of rewriting: the author tackles exegetical problems in the scriptural book of Joshua, reworks Joshua according to his own agenda (the centrality of Jerusalem and the status of the land of Israel), and provides an interpretation of the prophetic curse in Josh. 6:26. In cases like this, it is not clear whether the "), _c('em', [_vm._v("Apocryphon")]), _vm._v(" intended to complement or supplement the book of Joshua. In any ")]), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_vm._v("case, the preserved manuscripts of the "), _c('em', [_vm._v("Apocryphon of Joshua")]), _vm._v(" outnumber those of the scriptural Joshua. On the other hand, it is not clear to what extent the extensive use and reworking of Proverbs 1–9 in 4QBeatitudes and 4QWiles of the Wicked Woman was meant as authoritative interpretation of scripture, or rather as imitation of a scriptural example.")])]), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a few cases it is demonstrable that such rewritings of scriptures actually gained, at least in some circles, some kind of scriptural status. The quotation of Josh. 6:26 in "), _c('em', [_vm._v("Testimonia")]), _vm._v(" (4Q175) follows the text of the "), _c('em', [_vm._v("Apocryphon of Joshua.")]), _vm._v(" A series of fragmentary manuscripts called "), _c('em', [_vm._v("Pseudo-Jubilees")]), _vm._v(" (4Q225-227, but also 4Q217 and perhaps 4Q228) are new rewritings based on the text of "), _c('em', [_vm._v("Jubilees.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This phenomenon of interpretative rewriting sheds an interesting light on the issue of scriptures in the second and first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The very act of interpretation and rewriting endorses the authoritative and foundational character of “biblical” scriptures, but at the same time extends this authority to the interpretative reworking of those scriptures.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Expanding Scripture by Ascribing Traditions to Foundational Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Apart from new scriptures that are primarily based on interpretative rewriting of a scriptural text, there is a group of largely or entirely new compositions attributed or closely related to scriptural authors or figures. This second type is not based primarily on the text of Scripture but consists largely of a series of compositions, written in Aramaic, and ascribed to pre-Mosaic figures, from Enoch through Amram. Included in this category are several books of "), _c('em', [_vm._v("Enoch,")]), _vm._v(" the "), _c('em', [_vm._v("Aramaic Levi Document,")]), _vm._v(" the Lamech and Noah sections of the "), _c('em', [_vm._v("Genesis Apocryphon,")]), _vm._v(" a series of very fragmentary works that have been described as testaments of Jacob and several of his sons "), _c('em', [_vm._v("(Testament of Qahat,")]), _vm._v(" the "), _c('em', [_vm._v("Visions of Amram,")]), _vm._v(" and possibly the "), _c('em', [_vm._v("New Jerusalem).")]), _vm._v(" Also relevant here were compositions written in Hebrew that are attributed to Moses (especially the "), _c('em', [_vm._v("Apocryphon of Moses")]), _vm._v(" texts) and to Jeremiah "), _c('em', [_vm._v("(Apocryphon of Jeremiah C),")]), _vm._v(" and perhaps also those attributed to David (noncanonical psalms in 11Q5; the "), _c('em', [_vm._v("Apocryphal Psalms")]), _vm._v(" of 11Q11).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Aramaic texts ascribed to Enoch, Noah, and the pre-Mosaic patriarchs should be considered a separate group of compositions. Here we find first-person narrative, generally with ancestral instruction, sometimes visionary reports, and, more rarely, exegetical expansions of scriptural narrative. The use of first-person narration is a feature common to other Aramaic literature (Ahiqar, Tobit) and may be regarded as a stylistic preference. The contents of these Aramaic texts suggest that some might have a pre-Maccabean origin in priestly-Levitical circles who had knowledge of Mesopotamian lore and science. They were influenced by Persian ideas and emphasize revelation through dreams and visions, as well as the transmission of ancestral traditions above or alongside the interpretation of the Scriptures. Though some of these Aramaic texts include interpretative or paraphrastic sections, the main link is with the ancestral “scriptural” figure, not with the scriptural text.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_vm._v("The Hebrew examples of new writings attributed or connected to Moses, ")]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("Jeremiah, and David belong to a somewhat different category than the Aramaic examples. The former may be seen as foundational figures according to the functions ascribed to them in the Scriptures. All the new texts attributed to Moses belong to a Mosaic discourse in which specific interpretations of the Law were regarded as divine revelation to Moses on Sinai. Likewise, the "), _c('em', [_vm._v("Apocryphon of Jeremiah C")]), _vm._v(" is based on the image of Jeremiah being the leader and teacher of the nation after the destruction of the Temple.")])]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of these texts have in common that their ascription to ancestral patriarchs or foundational figures may be seen as an expansion of Scripture, although only in some cases is there evidence that they achieved scriptural status in some circles. This goes for the Enochic writings, the "), _c('em', [_vm._v("Aramaic Levi Document,")]), _vm._v(" and perhaps the "), _c('em', [_vm._v("Apocryphon of Jeremiah C,")]), _vm._v(" if 2 Macc. 2:1-4 is connected to that text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More importantly, the Dead Sea Scrolls call for a more sophisticated approach toward the phenomenon of pseudepigraphy, which ranges from no more than a purely literary device in some texts (like the "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(") to attribution of one’s traditions to ancestral figures to an authority-conferring strategy of presenting one’s new interpretation of authoritative Scripture.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Expounding Scripture in Commentaries and Pesharim")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whereas rewritten texts and paraphrases are implicitly interpretative, a special category of texts makes an explicit distinction between scripture and commentary. The clearest examples are the so-called continuous pesharim, such as the "), _c('em', [_vm._v("Habakkuk Pesher")]), _vm._v(" and "), _c('em', [_vm._v("Nahum Pesher")]), _vm._v(" and the pesharim on Isaiah, some Minor Prophets, and some of the Psalms. They feature a quotation of one or more verses from a “prophetic” Scripture, a commentary on the quoted verse(s), a quotation of the next verses, its interpretation, and so on. Characteristic is the explicit introduction of the commentary by means of the term "), _c('em', [_vm._v("pišrô,")]), _vm._v(" “its interpretation” (or "), _c('em', [_vm._v("pešer ha-d")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("bar,")]), _vm._v(" “the interpretation of the passage”), which often involves the identification of the subject of the scriptural verse with subjects that were active just before or during the author’s time, or expected to become active in the near future. Other commentaries, like "), _c('em', [_vm._v("Florilegium")]), _vm._v(" (4Q174) and "), _c('em', [_vm._v("Catena A")]), _vm._v(" (4Q177), which probably are two copies of one and the same composition "), _c('em', [_vm._v("Eschatological Midrash,")]), _vm._v(" as well as "), _c('em', [_vm._v("Melchizedek")]), _vm._v(" (11Q13), have been called either midrash (on the basis of the use of the term in 4Q174), or “thematic pesharim,” since they do not interpret a running scriptural text but rather select different verses which, according to the interpretation, relate to the same theme. A special case is "), _c('em', [_vm._v("Ages of Creation")]), _vm._v(" (or "), _c('em', [_vm._v("Pesher on the Periods;")]), _vm._v(" 4Q180), which includes a series of notes commenting on the text of Genesis and explaining problematic issues in the text.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("Some manuscripts seem to combine rewritten scripture with implicit exegesis and commentary with explicit exegesis. This holds, for example, for "), _c('em', [_vm._v("Commentary on Genesis A")]), _vm._v(" (4Q252), which starts out with a rewriting of the flood story in Genesis 7–8, consisting mainly of scriptural verses and chronological additions, continues with a discussion of problematic sections of Genesis, and ends with a commentary of Jacob’s blessings, including the technical "), _c('em', [_vm._v("pišrô")]), _vm._v(" phrase. These different kinds of ")]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("interpretative writing in 4Q252 may owe to a compilation of various sources. Or they may reflect the gradual transition from implicit interpretative rewriting (down to the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(") to explicit commentaries, which came into existence in the first half of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" However, the explicit "), _c('em', [_vm._v("pišrô")]), _vm._v(" (and "), _c('em', [_vm._v("pešer ha-d")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("bar")]), _vm._v(") formula is used specifically with regard to “prophetic” texts, including Psalms and Jacob’s prophecies in Genesis 49, which would explain the different exegetical techniques used in the same text. In 4Q180, and probably also in the fragmentary "), _c('em', [_vm._v("Exposition on the Patriarchs")]), _vm._v(" (4Q464), we find a different use of the phrase "), _c('em', [_vm._v("pišrô")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al,")]), _vm._v(" “interpretation concerning,” as a section heading for new topics. The official title of 4Q247, "), _c('em', [_vm._v("Pesher on the Apocalypse of Weeks,")]), _vm._v(" is misleading in at least two aspects. First, the sparse text of the extant fragment does not use the term "), _c('em', [_vm._v("pesher,")]), _vm._v(" nor are there any other indications that the text is exegetical. Second, though the scheme of weeks corresponds to that also found in the "), _c('em', [_vm._v("Apocalypse of Weeks,")]), _vm._v(" there is no indication that the fragment rewrites or interprets that specific text.")])]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These different forms of extending, expanding, and expounding Scripture underline how by the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" at the latest Judaism had become thoroughly scripturalized, even though the borders between scripture and interpretation may have been somewhat shifting, since some interpretation itself claims revelation and hence authoritativeness. Also fluid are the transitions from interpretative rewriting to explicit commentary, and from exegesis of texts to attribution of nonscriptural materials to foundational figures. The Dead Sea Scrolls therefore illustrate various kinds of exegetical techniques, as well as different strategies for conferring authority in early Judaism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Special attention should be given to "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" which combines rewritten Scripture, the adaptation of other traditions, and the attribution of the text to the founding figure of Moses. More importantly, "), _c('em', [_vm._v("Jubilees")]), _vm._v(" is related to many other texts in the corpus. It includes material found in the oldest Enochic books and in the "), _c('em', [_vm._v("Aramaic Levi Document;")]), _vm._v(" it shares halakic traditions with the "), _c('em', [_vm._v("Temple Scroll;")]), _vm._v(" it is in its turn imitated or rewritten in the "), _c('em', [_vm._v("Pseudo-Jubilees")]), _vm._v(" manuscripts; and diverse texts such as the "), _c('em', [_vm._v("Words of Moses")]), _vm._v(" and the "), _c('em', [_vm._v("Apocryphon of Jeremiah C")]), _vm._v(" are dependent on it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Interpreting the Law in Legal Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some interpretative works deal partly or exclusively with the interpretation of the Law of Moses. But whereas the corpus includes much legal material, only a few texts are primarily focused on legal questions. Without a doubt, the two most important legal texts are the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" and the so-called "), _c('em', [_vm._v("Halakic Document,")]), _vm._v(" now known as MMT for "), _c('em', [_vm._v("Miq")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("at Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("a")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("ê ha-Torah,")]), _vm._v(" one of the phrases in the text. Other legal texts include the legal section of the "), _c('em', [_vm._v("Damascus Document,")]), _vm._v(" the remnants of different "), _c('em', [_vm._v("Tohorot")]), _vm._v(" compositions, the Moses Apocrypha (including "), _c('em', [_vm._v("Apocryphal Pentateuch A")]), _vm._v("), and compositions referred to as "), _c('em', [_vm._v("Ordinances")]), _vm._v(" (4Q159; 4Q513-514), "), _c('em', [_vm._v("Halaka A")]), _vm._v(" (4Q251) and "), _c('em', [_vm._v("B")]), _vm._v(" (4Q264a), and "), _c('em', [_vm._v("Miscellaneous Rules")]), _vm._v(" (4Q265).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Temple Scroll,")]), _vm._v(" which is based on Deuteronomy but presented as God’s word spoken in the first person at Sinai, contains the most extensive collection of ")]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("legal material. It also discusses the construction of the sanctuary, its altar, and its courtyards, the festival calendar and festal sacrificial offerings; and purity laws. And it engages in a rewriting of Deuteronomy 12–23, into which are inserted the so-called Law of the King and other regulations regarding the Levites and crucifixion. The composition has been described as a utopian vision of the present age, and a polemic against Hasmonean policies and Pharisaic rulings.")])]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("MMT is as an epistolary treatise of which the central part (called B by the editors) consists of a survey of legal issues. They deal mainly with the purity of the sanctuary. The authors (“we”) apparently disagree (sometimes with a direct appeal to Scripture) with either contemporary Temple practices or their opponents’ views. In several cases, the points of discussion are known from rabbinic literature, where the “we” position of MMT is ascribed to the Zadokites/Sadducees and the opposite position to the Pharisees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The publication of both texts and their subsequent study had a large impact on Scrolls studies. It became clear that the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" did not fit in with the then known “sectarian” texts, and this confirmed the suspicion that the corpus contained works from different, albeit related, groups. MMT has been interpreted as a foundational document, summing up the calendrical and legal disputes with the Jerusalem priests and the Pharisees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For the study of early Judaism, the legal texts confirm that the rabbinic descriptions of legal discussions between Sadducees and Pharisees were not anachronistic inventions but debates already current in the Hasmonean era. Also, the legal texts attest to practices that are much earlier than the rabbinic texts in which they are recorded. This goes, for example, for the "), _c('em', [_vm._v("minyan")]), _vm._v(" (minimum of ten men) described in "), _c('em', [_vm._v("Rule of the Congregation")]), _vm._v(" (1QSa), the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" (1QS), and the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" (CD). More generally, the mere existence of written law codes in Second Temple Judaism is at odds with the Pharisaic-rabbinic rule that extrabiblical legal traditions should remain oral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The topics under discussion in the legal texts shed light on issues that had become important in the second and first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", such as Sabbath and purity. This holds for purity concerns in general, and for the purity of the Temple and Jerusalem in particular, an issue that may reflect a reaction to the defilement of the Temple by Antiochus Epiphanes. Typical of the purity laws included in the corpus is that they are in general more stringent than the later rabbinic purity laws. Some texts extend the concept of purity from ritual to moral issues.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Harmonizing Times and Festivals: Calendrical Documents and Annals")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("The corpus contains a small amount of generally badly preserved calendrical documents, most of which are actually lists. These lists include enumerations of the number of days per month, registers of the holy festivals on their respective dates in a 364-day year, registers of the priestly watches or "), _c('em', [_vm._v("mišm")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("rōt")]), _vm._v(" related to this calendar, lists relating phases in the monthly revolution of the moon to corresponding dates of the 364-day year, and the so-called "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot")]), _vm._v(" list synchronizing the six-year "), _c('em', [_vm._v("mišm")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ā")]), _c('em', [_vm._v("rōt")]), _vm._v(" cycles with the seven-year "), _c('em', [_vm._v("shemitah")]), _vm._v(" and the forty-nine-year jubilee cycle. ")]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_vm._v("In some cases calendrical lists are part of larger documents. For example, "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot")]), _vm._v(" (4Q319) is actually the end of one of the Cave 4 copies of the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" (4Q259), and a calendrical list is found at the beginning of one of the MMT manuscripts (4Q394). A special, related case is the two very fragmentary works ("), _c('em', [_vm._v("Historical Texts D")]), _vm._v(" and "), _c('em', [_vm._v("E;")]), _vm._v(" 4Q332 and 4Q333) that list historical events, including proper names, in relation to dates and priestly watches.")])]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Virtually all the calendrical documents attest to the 364-day calendar defended in the Enochic "), _c('em', [_vm._v("Book of the Luminaries")]), _vm._v(" and in "), _c('em', [_vm._v("Jubilees,")]), _vm._v(" and implied in most other texts in the corpus — exceptions could be "), _c('em', [_vm._v("Daily Prayers")]), _vm._v(" (4Q503) and "), _c('em', [_vm._v("Zodiology and Brontology")]), _vm._v(" (4Q318). These documents are the result of exegetical activity and try to harmonize the different scriptural prescriptions for Sabbaths and dates of festivals, as well as priestly watches and larger cycles, into a coherent system. Many of the liturgical texts are based on this calendrical system, and the lists can therefore be seen as the legal basis for the priestly service and the liturgical and festal year. The difference between the 364-day calendar and the 354-day calendar known from other Jewish sources is crucial, since it implies a different festival calendar and would have provoked a major schism in early Judaism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Performing Scripture: Liturgical and Poetical Manuscripts")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some poetical manuscripts in the corpus have explicit markers that indicate an intended liturgical or ritual use; other collections of poems lack such evidence. A large number of texts may be categorized as hymns and prayers. These include liturgies for evening and morning blessings for all days of the month, prayers for the days of the week, songs for the Sabbath sacrifice, and festival prayers. All of these texts are the oldest liturgies for fixed prayer times on record. Scholars are divided on two questions. First, whether these liturgies for fixed prayers were specifically sectarian or were rather representative of liturgies of Second Temple Judaism at large. Second, how these prayers relate to rabbinic prayer material. Because of the paleographic dating of "), _c('em', [_vm._v("Words of the Luminaries"), _c('sup', [_vm._v("a")])]), _vm._v(" (4Q504) around 150 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", and the lack of explicit sectarian terminology, it has been suggested that "), _c('em', [_vm._v("Words of the Luminaries (Divre Ha-me")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("orot)")]), _vm._v(" may plausibly be presectarian. The composition apparently utilized the same periodization of history found in the Enochic "), _c('em', [_vm._v("Apocalypse of Weeks,")]), _vm._v(" which may indicate a provenance in groups with affinities to the Enochic writings. Many thematic and vocabulary correspondences between the prayers in the Scrolls and rabbinic prayers have been adduced, but only very rarely are they unique. More generally, the vocabulary and character of both groups of prayers are dependent on Scripture, and specific shared features should probably be attributed to common streams of tradition rather than direct literary dependence. Even though there is no direct relation between the two corpora, the scrolls demonstrate that the fixation of prayer after Yavneh was not a new invention but the institutionalization of practices that already existed in Second Temple times.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_vm._v("Similar issues of comparison may be made for the "), _c('em', [_vm._v("Songs for the Sabbath Sacrifice,")]), _vm._v(" the "), _c('em', [_vm._v("Blessings")]), _vm._v(" (4Q286-290), and the hymnic material in "), _c('em', [_vm._v("Mysteries"), _c('sup', [_vm._v("c")])]), _vm._v(" (4Q301), which have been characterized as mystical due to the language of awe and mystery. ")]), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_vm._v("Even though the medieval Hekhalot literature attests to a different kind of mystical practice, the style of the hymns in the Hekhalot seems to go back to such Second Temple precursors.")])]), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whereas a specific ritual is assured for the "), _c('em', [_vm._v("Blessings,")]), _vm._v(" the "), _c('em', [_vm._v("Purification Liturgies,")]), _vm._v(" and the prayers and songs with an exorcistic character, it is disputed whether, for example, the "), _c('em', [_vm._v("Hodayot,")]), _vm._v(" the "), _c('em', [_vm._v("Bless My Soul,")]), _vm._v(" and the "), _c('em', [_vm._v("Noncanonical Psalms")]), _vm._v(" were composed for private prayer or reading or for communal recitation. The different collections of "), _c('em', [_vm._v("Hodayot")]), _vm._v(" from Caves 1 and 4 stand apart in the corpus on account of the highly unique and personal songs in the middle of the large Cave 1 "), _c('em', [_vm._v("Thanksgiving Scroll.")]), _vm._v(" These songs have been read as autobiographical expressions of a leading figure praising God for release from affliction, for the revelation of his wonders, and for having placed hymns in his mouth to instruct the lowly. More than other hymns, they contrast God’s greatness to human smallness. The suggestion that the author may be the Teacher of Righteousness mentioned in the pesharim (hence the name “Teacher Hymns”) is attractive but remains hypothetical. Some "), _c('em', [_vm._v("Hodayot")]), _vm._v(" collections also contain community hymns in which the “I” of the hymn may refer to individual members of the group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whereas older scholarship generally referred only to the anthological style of the hymns and prayers, it has become clear that they are often scripturalized in multiple respects. They use scriptural language but often interpret and allude to specific passages; they sometimes use scriptural patterns but also emulate or rework specific biblical sections, such as Psalm 18 in 1QH"), _c('sup', [_vm._v("a")]), _vm._v(" XI and in the "), _c('em', [_vm._v("Prayer of the Man of God")]), _vm._v(" in "), _c('em', [_vm._v("Noncanonical Psalms B")]), _vm._v(" (4Q381).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Understanding All There Is: Sapiential Texts")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The term “wisdom literature” is used in a general way for those texts that have several, but not necessarily all, of the following characteristics: instructional or admonitory style; practical, proverbial, or didactic advice; intellectual reflection on the order of creation, human nature, and society; a concern with the meaning of human life and fate after death; and overtly sapiential terminology. The most substantial wisdom texts in the corpus are three very different works, 4QInstruction, the "), _c('em', [_vm._v("Book of Mysteries,")]), _vm._v(" and "), _c('em', [_vm._v("Beatitudes.")]), _vm._v(" 4QInstruction combines practical advice on many different matters of life with descriptions of eschatological judgment. The work contains discourses on the predestined order of creation and the nature of human beings. It is based in part on exegesis of Genesis and displays an interest in the angelic world. The multiple levels of discourse in the text and the different topics and addressees suggest that the composition may have been a handbook for a specific group of religious teachers, who in their turn had to instruct others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("Book of Mysteries")]), _vm._v(" comprises many diverse materials, ranging from depiction of the eschatological judgment based on interpretations of the prophets, proverbial riddles, taunts of opponents, legal discussion of Temple issues, to a Hekhalot-like hymn in 4Q301. "), _c('em', [_vm._v("Beatitudes")]), _vm._v(" (and "), _c('em', [_vm._v("Wiles of the Wicked Woman")]), _vm._v(") can be characterized as an eschatologizing rewriting of Proverbs 1–9 and is more homogeneous than the other sapiential works.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_175"
    }
  }), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("4QInstruction, and to some extent also "), _c('em', [_vm._v("Mysteries,")]), _vm._v(" attest to a transformation of older wisdom traditions. These works appropriate originally non-Jewish scientific concepts (such as the horoscope and Platonic ideas about the spirit) and expand the topic of wisdom to include not only earthly but transcendent realities. The acquisition of insight depends both on the pursuit of truth (including the exegesis of Scripture) and on divine enlightenment, which allows one to have insight into transcendent secrets. One may refer to this phenomenon as the apocalypticizing of wisdom. A less speculative concern with transcendent realities, but nonetheless a concern with divine judgment, is also found in wisdom texts such as "), _c('em', [_vm._v("Sapiential Work")]), _vm._v(" (4Q185) and "), _c('em', [_vm._v("Beatitudes.")]), _vm._v(" The connection of practical and religious instruction with eschatology may have a parenetic function, but it seems to reflect the status of specific scribes or teachers as knowledgeable of everything.")])]), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such scribal sapiential interest also explains the presence of various scientific texts in the corpus, such as 4QHoroscope (4Q186), 4QPhysiognomy (4Q561), 4QZodiology and Brontology (4Q318), and perhaps also the various astronomical texts, such as "), _c('em', [_vm._v("Astronomical Enoch")]), _vm._v(" and 4QLunisolar Calendar (4Q317).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The major contribution of the Dead Sea Scrolls sapiential texts is that they illustrate the merging of many different kinds of knowledge, including the appropriation of non-Jewish concepts, and the fusion of diverse literary genres. This is turn suggests the rise of a new kind of Jewish scholarship that tried to integrate all available disciplines and fields of knowledge.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Envisioning the End: Apocalypses and Other Eschatological Texts")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The corpus contains a variety of texts that are in some way focused on the future. Those include many Aramaic apocalyptic and visionary texts, such as the texts assigned to "), _c('em', [_vm._v("Enoch")]), _vm._v(" and the "), _c('em', [_vm._v("New Jerusalem")]), _vm._v(" text, which may be a vision of Jacob, as well as texts related to the figure or the book of Daniel, such as "), _c('em', [_vm._v("Apocryphal Daniel")]), _vm._v(" (4Q246), the pseudo-Danielic compositions (4Q243-245), and perhaps the "), _c('em', [_vm._v("Four Kingdoms")]), _vm._v(" (4Q552, 4Q553, and 4Q553a). One may add the "), _c('em', [_vm._v("Words of Michael")]), _vm._v(" (4Q529, 4Q571, and 6Q23) and other small fragmentary visionary or prophetic Aramaic manuscripts. It is remarkable that most apocalyptic and visionary works are written in Aramaic, which may reflect a literary preference or a special provenance for those texts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With the possible exception of "), _c('em', [_vm._v("Vision and Interpretation")]), _vm._v(" (4Q410) and "), _c('em', [_vm._v("Narrative A")]), _vm._v(" (4Q458), eschatological texts written in Hebrew rarely have a visionary form. Instead, there are poetic descriptions of the eschatological period, such as "), _c('em', [_vm._v("Time of Righteousness")]), _vm._v(" (4Q215a), "), _c('em', [_vm._v("Renewed Earth")]), _vm._v(" (4Q475), and "), _c('em', [_vm._v("Messianic Apocalypse")]), _vm._v(" (4Q521), a composition on the messianic period and resurrection, as well as rules for the congregation and blessings for the “last days” (1QSa, 1QSb). The corpus includes a series of related but different manuscripts on the eschatological war. They describe the final war between the children of light and the children of darkness, assisted by the angels and the troops of Belial, respectively, and prescribe the prayers to be said at different stages of the war. Other works, like the sapiential texts and the “Treatise of the Two Spirits” (1QS 3-4), contain eschatological sections.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_176"
    }
  }), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("These eschatological texts do not present a homogeneous worldview. For example, they do not seem to share the same messianic expectations. Three general aspects of the eschatological texts illustrate their contribution to the study of early Judaism. First, most Hebrew eschatological works are based on interpretation of Scripture, including perhaps the books of "), _c('em', [_vm._v("Enoch.")]), _vm._v(" For example, the rules for purity in the "), _c('em', [_vm._v("War Scroll")]), _vm._v(" are modeled on the prescriptions in Numbers, whereas the prayers in the scroll refer to other victories described in the Scriptures (e.g., David beating Goliath). Further, both "), _c('em', [_vm._v("Time of Righteousness")]), _vm._v(" and "), _c('em', [_vm._v("Renewed Earth")]), _vm._v(" are based on prophetic texts. Second, the fusion of descriptive and prescriptive elements in the war scrolls, 1QSa, and 1QSb — which include instructions for purity and other legal issues, as well as hymns, prayers, and blessings — suggests that these texts may have had a performative use. Third, these eschatological works attest to a series of different apocalyptic themes, such as the periodization of history, expectation of the end, communion with the heavenly world, and the eschatological war. These themes are also found in other works in and outside the corpus and may therefore be seen as reflecting a broader apocalyptic mentality.")])]), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Returning to the Law: Community Rules and Related Texts")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The corpus contains several so-called community rules, the most important ones being the "), _c('em', [_vm._v("Serekh ha-Ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad (Rule of the Community),")]), _vm._v(" and especially its core as found in 1QS 5–9 and in 4Q256 and 4Q258; the so-called "), _c('em', [_vm._v("Damascus Document;")]), _vm._v(" and the "), _c('em', [_vm._v("Serek ha-Edah (Rule of the Congregation).")]), _vm._v(" Each of these documents gives rules pertaining to the entry into a specific group, the organization and officials of the group, responsibilities of the members, and organization of its meetings. The "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" discuss such issues as transgressions and punishments, and they describe in some detail the aims of the groups. In general terms, these rules can be compared to other rules for ancient voluntary associations. These two large rules each contain sections not preserved in the other one. Thus, the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" has a large admonitory review of history and a substantial legal section, including Sabbath and purity laws. Some versions of the "), _c('em', [_vm._v("Rule of the Community,")]), _vm._v(" including 1QS, include a description of an annual covenant ceremony and the “Treatise on the Two Spirits,” and end with a thanksgiving hymn, whereas the version preserved in 4Q259 ends with a calendrical text "), _c('em', [_vm._v("(")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot).")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("The groups depicted in the main rules differ in various respects. The "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" describes different groups but focuses on the congregation of those Israelite households or families who lived in cities and camps throughout the land, and who committed themselves to return to the Law of Moses as it should apply to all Israel, according to its correct interpretation. The "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" uses another word, "), _c('em', [_vm._v("ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad,")]), _vm._v(" to refer to groups at different locations. It never refers to women or families but only to the “men of the community.” The work mentions an oath to return to the Law of Moses, stresses communal activities, emphasizes the handing over of one’s property to the inspector, and describes a complex admission procedure. Both rules refer to a subgroup that aspires to a higher degree of holy perfection, but whereas this is mentioned only in passing in CD 7, the "), _c('em', [_vm._v("Rule of")])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('em', [_vm._v("the Community")]), _vm._v(" discusses at length a real or ideal subgroup of twelve men and three priests who in some way had a higher degree of holiness. The example of the "), _c('em', [_vm._v("Rule of the Congregation,")]), _vm._v(" which refers to both “the congregation” and “the council of the "), _c('em', [_vm._v("ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad,")]), _vm._v("” cautions that one cannot make an easy distinction between the congregation and the "), _c('em', [_vm._v("ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad.")])])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several manuscripts in the corpus may be directly connected to the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" or the "), _c('em', [_vm._v("Community Rule,")]), _vm._v(" due to shared organizational expressions that are not found elsewhere. Thus, for example, the term “the Community” is very rare outside of the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" and the "), _c('em', [_vm._v("Rule of the Congregation,")]), _vm._v(" and the few other manuscripts with this term would seem to refer to the same group. This goes for several of the pesharim, for legal texts like "), _c('em', [_vm._v("Miscellaneous Rules")]), _vm._v(" (4Q265) and "), _c('em', [_vm._v("Harvesting")]), _vm._v(" (4Q284a), and for the liturgical text "), _c('em', [_vm._v("Blessings,")]), _vm._v(" which includes blessings and curses that are very similar to those mentioned in 1QS 2. Another document, "), _c('em', [_vm._v("Rebukes of the Overseer")]), _vm._v(" (4Q477), records rebukes as described both in the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and the "), _c('em', [_vm._v("Rule of the Community,")]), _vm._v(" and mentions the "), _c('em', [_vm._v("ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad.")]), _vm._v(" The Teacher of Righteousness appears in the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and has a special role in several pesharim, specifically the "), _c('em', [_vm._v("Habakkuk Pesher,")]), _vm._v(" which also refers to the "), _c('em', [_vm._v("ya")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ad.")]), _vm._v(" The fragmentary manuscripts "), _c('em', [_vm._v("Communal Ceremony")]), _vm._v(" (4Q275) and "), _c('em', [_vm._v("Rule")]), _vm._v(" (5Q13), which mention the “overseer” and refer to an annual ceremony, may be connected to either of the main rules.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Taken in themselves, these different rules give an unprecedented insight into aspects of the formation, organization, practices, and beliefs of early Jewish groups or movements on the basis of their different interpretation of the Law.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Nature and Significance of the Corpus")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Apart from specific organizational expressions, the rule scrolls attest to communal ritual, disagreements about calendrical matters, legal rulings with regard to everyday practices, a cosmological and ethical dualistic worldview, apocalyptic or eschatological expectations, and views on Scripture and authority. Many other texts in the corpus reflect the same or similar interests or views, sometimes expressed in identical formulations. For example, the introduction of 1QS is directly connected to 1QM since both oppose the “sons of light” to the “sons of darkness.” Or, with hindsight, now that we know all the Cave 4 calendrical texts, it is easy to recognize how both the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and the "), _c('em', [_vm._v("Hymn of the Maskil")]), _vm._v(" at the end of the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" put forth a 364-day calendar, a point which is made even more explicit by the inclusion of the "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot")]), _vm._v(" in one of the "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" manuscripts. A third example — in various compositions, including the two rules — is the attribution to the "), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("kîl")]), _vm._v(" of laws, hymns, and instructions, which probably indicates that this sage was to recite or teach them. In other cases, connections between texts consist of multiple shared locutions, such as those between the "), _c('em', [_vm._v("Apocryphon of Jeremiah")]), _vm._v(" and the "), _c('em', [_vm._v("Damascus Document.")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_vm._v("Such connections illustrate that many works in the corpus are interlinked and should be related to a current in early Judaism that comprised the movements described in the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and the "), _c('em', [_vm._v("Rule of the Community,")]), _vm._v(" and probably ")]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_vm._v("also to the circles responsible for "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll.")]), _vm._v(" It is a challenge for scholarship to unravel the precise relationships among different texts and groups. However, the different versions of both the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" and the "), _c('em', [_vm._v("Rule of the Community,")]), _vm._v(" and the likelihood of different layers in those works, show that within this current the different movements and their compositions were in flux and that they changed and influenced one another. Likewise, manuscripts of other compositions may have been edited or revised in order to appropriate them, or to adjust them to the interests of specific copyists or movements, a phenomenon which can be seen, for example, in the Cave 4 versions of the "), _c('em', [_vm._v("Aramaic Levi Document.")])])]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is no evidence that before their deposit in the caves all the manuscripts of the corpus were together as a single collection. Nor can one know, for that matter, whether all those manuscripts that were together at a certain time in the same place were actively read and studied or were merely deposited. Even the status of Cave4 — as a library, repository, temporary place of concealment, or perhaps even a genizah — is unclear. And we do not know the precise historical events that led to their deposit in different caves near Qumran. But from the contents of the manuscripts, we may conclude that the corpus is not a random reflection of all kinds of available Jewish texts of the time but representative of a specific current in early Judaism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Two vital perspectives are constitutive of the corpus. First, the corpus as a whole — from "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" to the pesharim, legal texts, and Moses apocrypha — attests to a variety of strategies for interpreting Scripture, ranging from reworking and various degrees of rewriting, to expansion with new scriptures, exegesis, and commentary. Some texts in the corpus imply, others indicate explicitly, that the correct interpretation of Scripture is attained by exegesis, which may be confirmed by divine revelation of those things that hitherto had been hidden (i.e., not included in the Scriptures). The authority of interpreted Scripture may also go beyond the traditional “rewritten Scripture” texts and hold true for hymns and prayers like the "), _c('em', [_vm._v("Hodayot.")]), _vm._v(" For the study of the corpus, this perspective demands a more sophisticated approach in differentiating between the Scriptures and other writings, between revelation and interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, by and large the corpus represents a legal interpretive tradition that can be related to both "), _c('em', [_vm._v("Jubilees")]), _vm._v(" and the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" (notwithstanding differences between those two works). The most decisive element is the 364-day calendar as the basis for the religious festival calendar, which is either stated explicitly or implied in a variety of texts of the corpus (e.g., "), _c('em', [_vm._v("Jubilees, Temple Scroll, David’s Compositions")]), _vm._v(" in the Cave 11 "), _c('em', [_vm._v("Psalms Scroll, Commentary on Genesis A, Songs of the Sabbath Sacrifice,")]), _vm._v(" as well as a variety of calendrical texts). It is moot to what extent this 364-day festival calendar was actually designed on the basis of scriptural exegesis, or was practiced in some form in pre-Seleucid times. In both cases, the adherence to a 364-day calendar, as opposed to the one observed in the Temple, links the different circles and movements represented in the corpus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From this perspective, and with the limited undisputed historical data we have, it makes most sense to study the corpus primarily as the product of a specific early Jewish current consisting of different interlinked groups and movements with a common interpretative approach to Scripture and a shared legal tradition.")])]), _c('p', {
    staticClass: "bib-head"
  }, [_c('a', {
    attrs: {
      "id": "page_179"
    }
  }), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])])]), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Alexander, Philip. 2006. "), _c('em', [_vm._v("The Mystical Texts: Songs of the Sabbath Sacrifice and Related Manuscripts.")]), _vm._v(" London: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Collins, John J. 2002. "), _c('em', [_vm._v("Apocalypticism in the Dead Sea Scrolls.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2007. “The Nature and Aims of the Sect Known from the Dead Sea Scrolls.” In "), _c('em', [_vm._v("Flores Florentino: Dead Sea Scrolls and Other Early Jewish Studies in Honour of Florentino García Martínez.")]), _vm._v(" Ed. Anthony Hilhorst et al. Leiden: Brill, 31-52.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Duhaime, Jean. 2004. "), _c('em', [_vm._v("The War Texts: 1QM and Related Manuscripts.")]), _vm._v(" London: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Falk, Daniel K. 2007. "), _c('em', [_vm._v("The Parabiblical Texts: Strategies for Extending the Scriptures among the Dead Sea Scrolls.")]), _vm._v(" London: T&T Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flint, Peter W., and James C. VanderKam, eds. 1998-1999. "), _c('em', [_vm._v("The Dead Sea Scrolls after Fifty Years: A Comprehensive Assessment.")]), _vm._v(" 2 vols. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("García Martínez, Florentino. 1996. "), _c('em', [_vm._v("The Dead Sea Scrolls Translated.")]), _vm._v(" 2d ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2008. “¿Sectario, no-sectario, o qué? Problemas de una taxonomía correcta de los textos qumránicos.” "), _c('em', [_vm._v("RevQ")]), _vm._v(" 23/91: 383-94.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goff, Matthew J. 2007. "), _c('em', [_vm._v("Discerning Wisdom: The Sapiential Literature of the Dead Sea Scrolls.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jokiranta, Jutta. 2005. “Identity on a Continuum: Constructing and Expressing Sectarian Social Identity in Qumran Serakhim and Pesharim.” Dissertation, University of Helsinki.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lange, Armin, with Ulrike Mittman-Richert. 2002. “Annotated List of the Texts from the Judaean Desert Classified by Content and Genre.” In "), _c('em', [_vm._v("The Texts from the Judaean Desert: Indices and an Introduction to the Discoveries in the Judaean Desert Series.")]), _vm._v(" Ed. Emanuel Tov. Oxford: Clarendon, 115-64.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lim, Timothy H. 2002. "), _c('em', [_vm._v("Pesharim.")]), _vm._v(" Sheffield: Sheffield Academic Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Parry, Donald, and Emanuel Tov, eds. 2004-2005. "), _c('em', [_vm._v("The Dead Sea Scrolls Reader.")]), _vm._v(" 6 vols. Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Reed, Stephen A. 2007. “Find-Sites of the Dead Sea Scrolls.” "), _c('em', [_vm._v("DSD")]), _vm._v(" 14: 199-221.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schiffman, Lawrence H. 2008. "), _c('em', [_vm._v("The Courtyards of the House of the Lord: Studies on the Temple Scroll.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———, and James C. VanderKam, eds. 2000. "), _c('em', [_vm._v("Encyclopedia of the Dead Sea Scrolls.")]), _vm._v(" 2 vols. New York: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tov, Emanuel. 2004. "), _c('em', [_vm._v("Scribal Practices and Approaches Reflected in the Texts Found in the Judean Desert.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ulrich, Eugene. 1999. "), _c('em', [_vm._v("The Dead Sea Scrolls and the Origins of the Bible.")]), _vm._v(" Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vermes, Geza. 1997. "), _c('em', [_vm._v("The Complete Dead Sea Scrolls in English.")]), _vm._v(" New York: Lane.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("White Crawford, Sidnie. 2008. "), _c('em', [_vm._v("Rewriting Scriptures in Second Temple Times.")]), _vm._v(" Grand Rapids: Eerdmans.")])])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_c('em', [_vm._v("Early Jewish Literature Written in Greek")])])]), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATELL")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERTHELOT")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A large number and great variety of early Jewish works were composed in Greek, but many of them survive only in excerpts quoted by church fathers. Our knowledge of Jewish thought and literature in the Greek-speaking Diaspora therefore depends to a large extent on the care with which Christian authors and scribes quoted and copied their Jewish sources. Yet the selective interests and apologetic agendas of the Christian transmitters means that they handed on only what was of use to them. These works not only enriched Judaism but also engaged Hellenism. Taken together, they demonstrate that Jews were able to embrace several aspects of Hellenistic culture while maintaining their Jewish identity in a creative, critical, and at times even subversive appropriation of Greek literary genres, mythological figures, and philosophical concepts. Many of these works take their inspiration from biblical traditions and attempt to solve exegetical problems or else refashion them. Others celebrate the superiority of Judaism over pagan religions in an attempt to strengthen the identity of their Jewish readerships.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Nature of the Corpus")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Several Greek texts will be set aside here, either because their original language was Hebrew or Aramaic (e.g., 1 Maccabees and Tobit), because their Jewish origin is uncertain (e.g., Thallus and Theophilus, who were probably pagan writers), because they have been significantly altered or perhaps even composed by Christians (e.g., "), _c('em', [_vm._v("3 Baruch, 4 Baruch, Testament of Abraham")]), _vm._v("), or because their original language of composition is uncertain (e.g., "), _c('em', [_vm._v("2 Enoch, Life of Adam and Eve")]), _vm._v("). The decision to put aside Greek translations of texts originally written in Hebrew or Aramaic means that we will not deal with the Septuagint as such. We will, however, discuss writings in the Septuagint that were composed in Greek and have occasion to emphasize that many Jewish authors writing in Greek used the Septuagint and were influenced by its terminology.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_181"
    }
  }), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("Jewish writings composed in Greek are not the only documents to qualify as Hellenistic Jewish literature or Judeo-Hellenistic literature. Every piece of Jewish literature produced during the Hellenistic and early Roman periods may be labeled “Hellenistic” regardless of the language in which it was written. For this reason, “Hellenistic” is too vague a term, except as a chronological label for the period extending from the conquests of Alexander the Great in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" to the end of the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" It is also somewhat problematic: for those who think that “authentic” Judaism necessarily expressed itself in Hebrew or Aramaic, the term “Hellenistic” carries strong pejorative connotations. More to the point, Hellenism was itself a mingling of different cultures, that of the Greco-Macedonians and that of the Eastern peoples whom they conquered. To single out some Jewish texts written in Greek as “Hellenized” implies that Hellenism and Judaism are two different and intrinsically antagonist cultural phenomena, a view that is certainly advocated by the author of 2 Maccabees but that does not necessarily reflect the historical reality of that time. The relationship between Greek and Jewish culture was far more complex.")])]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Since some of the relevant texts adapt distinctively Greek genres, such as tragedy (Ezekiel the Tragedian) and epic poetry (Theodotus), one might well speak of Greek literature that is Jewish instead of Jewish literature written in Greek. When the latter expression is used, the focus is laid right from the start on the Jewish character of this literature, implying that the linguistic dimension is secondary. But how are we to define Jewish literature in antiquity? What makes an ancient text Jewish? Scholars have traditionally appealed to two criteria: (1) content based on biblical tradition or containing distinctively Jewish themes or terminology; (2) the Jewishness of the author, which may be attested by reliable external sources or inferred from his name or from the topic (which takes us back to the first criterion). These criteria have their limits in some cases. The "), _c('em', [_vm._v("Sentences")]), _vm._v(" of Pseudo-Phocylides offers a good example. For centuries this text was regarded as an original composition of Phocylides, a sixth-century-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" Greek poet, and not as a Jewish text. It was only in the sixteenth century that Joseph Scaliger pointed up its Jewish origin. The content is not so distinctively Jewish as to allow the reader to identify its author as a Jew. This interesting example should warn us that a Greek text attributed to a Greek philosopher or historian may be a Jewish text. Not all Jewish literature is “obviously Jewish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Due to a lack of information, we must exclude from the corpus texts written by Jews who either had no commitment to their cultural heritage and religious tradition, or who chose to express themselves on topics that had little or nothing to do with the characteristic features of Judaism. Conversely, we will mention in passing authors who are not Jewish but who excerpted Jewish writings (e.g., Alexander Polyhistor) or who mentioned Jews and Judaism in a way that invited a response from early Jewish authors (Manetho, Apion).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("One more reason to be cautious is that nearly all the Jewish texts written in Greek have been transmitted to us through Christian channels. Moreover, some of the church fathers — Clement of Alexandria and Eusebius, in particular — depended on Alexander Polyhistor, a Greek historian active during the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" The evidence we have is thus indirect, and it should not been taken for granted that we have the "), _c('em', [_vm._v("ipsissima verba")]), _vm._v(" of the Jewish authors whose works are ")]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_vm._v("now lost. What is more, the church fathers who quoted early Jewish writers such as Aristobulus, Eupolemus, and Artapanus did not attempt to preserve Jewish literature as such. They were looking for proofs of the antiquity of biblical revelation, in order to respond to pagan critics such as Celsus and Porphyry. What they ultimately wanted to show was that Christianity was not a new cult but a respectable religion with very ancient roots, even older than Greek civilization itself. Since Jewish authors had taken pains to demonstrate the antiquity of the Jewish people and the influence Moses exercised on Homer, Pythagoras, Plato, and others, their writings represented a providential pool of arguments for the church fathers. In Josephus, they also valued references to events contemporary with Jesus’ life and the view that the Jewish defeat in the First Revolt was a punishment for the sins of the Jewish people, the Christian interpretation of what Josephus wrote being that the Jews had sinned in rejecting Jesus. The case of Philo is different, since many church fathers sincerely admired his work and took inspiration from his allegorical exegesis. Nevertheless, they used Jewish literature written in Greek with their own agenda in mind, an agenda that was clearly apologetic. They frequently manipulated the works they were quoting, either by omitting the context or by modifying the text. In short, the preservation and transmission of early Jewish literature written in Greek is itself problematic. This, in turn, helps explain why so many of the texts rewrite, explicate, or refer to the Bible: the corpus itself reflects to a great extent the church fathers’ selective interests.")])]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Use of Biblical Traditions")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most early Jewish works composed in Greek that have come down to us deal with biblical topics. Obviously, in the case of works that survive only in fragments, we do not know exactly what topics were dealt with in the sections that have not been preserved. At any rate, the evidence we have looks roughly as follows: ten works deal partly or exclusively with the book of Genesis and eight with the book of Exodus; one is based on a story from the book of Judges; two refer in some way to the history of the kings of Judah (roughly 2 Samuel through 2 Kings); one is based on the book of Jonah; and two retell the story of Job. The works of Philo and Josephus, which are particularly long and well preserved, deal with a greater variety of biblical texts: the whole Pentateuch and even, in the case of Josephus, most of the books eventually included in the Masoretic canon, plus a few others.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Writings Based on Genesis")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Among the Jewish writers who wrote about Genesis, Demetrius probably comes first. He evokes the episode of Isaac’s sacrifice, the fate of Jacob, his two wives and his twelve sons, and the story of Joseph, focusing on chronological issues (frgs. 1 and 2). Then we have Artapanus, who recalls Abraham’s descent to Egypt, mentions that he taught Pharaoh astrology, and retells the story of Joseph, attributing to him agricultural reform as well as the invention of measures (frgs. 1 and 2).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_183"
    }
  }), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("Other creative rewritings of the Genesis account include fragments of two authors known through Polyhistor: Cleodemus and Pseudo-Eupolemus. Cleodemus freely elaborates upon Gen. 25:1-4, which lists Abraham’s offspring by his wife Keturah. He imagines that two sons of Abraham helped Heracles fight Antaeus, and that one of them, called Aphran, even gave him his daughter in marriage. Pseudo-Eupolemus, who probably was a Samaritan, and who seems to have used Berossus’ "), _c('em', [_vm._v("Babyloniaca,")]), _vm._v(" focuses on Abraham’s discovery of astrology and astronomy, a science that he taught to the Phoenicians. He further refers to the war Abraham waged to free his nephew Lot, to the way he was welcomed in the sanctuary located on Mt. Gerizim (hence the identification of Pseudo-Eupolemus as a Samaritan), and to his encounter with Melchizedek. Like Artapanus, Pseudo-Eupolemus also mentions Abraham’s stay in Egypt and says that he taught astrology and other sciences to the Egyptian priests. The first discovery of astrology is said to go back to Enoch, whereas the Babylonians attributed it to Belus and the Greeks to Atlas.")])]), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From a completely different perspective, the exegete and philosopher Aristobulus treats the significance of the Sabbath, which he connects to the creation account in Genesis 1 rather than to the liberation from Egypt, as in Deuteronomy 5. The epic poet Philo deals with the Binding of Isaac in Genesis 22 (frgs. 1 and 2), evidently construing it as a ritual that was pleasing to God. He also mentions the patriarchs Abraham, Isaac, Jacob, and Joseph (frg. 3). The epic poet Theodotus focuses especially on the story of Dinah and the vengeance against Shechem (Genesis 34), at least in the forty-seven lines that have come down to us from Eusebius, who took his excerpts from Alexander Polyhistor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Philo of Alexandria deals at length with the book of Genesis in several of his works, especially in the allegorical commentary and in his "), _c('em', [_vm._v("Questions and Answers on Genesis.")]), _vm._v(" Josephus rewrites Genesis at the beginning of his "), _c('em', [_vm._v("Jewish Antiquities.")]), _vm._v(" Finally, the anonymous work entitled "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" tells the story of the conversion of Aseneth, the daughter of an Egyptian priest, to Judaism, and of her marriage to the patriarch Joseph. Other texts allude here and there to characters or episodes from the book of Genesis — for instance, 4 Maccabees 13:12 and 16:20 refer to the "), _c('em', [_vm._v("Aqedah —")]), _vm._v(" but these matters do not constitute the main topic of the book.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Writings Based on Exodus")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The book of Exodus is well represented too, sometimes in the same works. Demetrius addresses chronological as well as exegetical issues concerning the exodus (frgs. 3-5). Artapanus rewrites not only the story of Joseph but also that of Moses, whom he presents as the teacher of Orpheus and the inventor of several branches of learning, including philosophy. According to Artapanus, Moses was a great cultural benefactor who gave Egypt its political and religious institutions. Artapanus also retells the story of the exodus.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("Eupolemus (frg. 1) writes that Moses was the first wise man as well as the first lawgiver and that he invented the alphabet and gave it to the Jews, who then passed it down to the Phoenicians, who in turn taught it to the Greeks. Aristobulus tries to ")]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("explain some anthropomorphisms in the book of Exodus, such as the expression “the hand of God” (frg. 2), and addresses the issue of the date of the Passover (frg. 1).")])]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A certain Ezekiel wrote a whole tragedy based on the story of the Exodus, in which he recalls the events from Moses’ birth until the destruction of the Egyptian army. Fragment 16 mentions the arrival of the Hebrews at Elim (Exod. 15:27), and fragment 17 describes the extraordinary bird known as the phoenix. The Wisdom of Solomon also deals at length with the story of the exodus and the fate of the Egyptians, in order to demonstrate the perfection of God’s justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Philo of Alexandria probably examined every verse of the book of Exodus in his "), _c('em', [_vm._v("Questions and Answers on Exodus,")]), _vm._v(" most of which is now lost. He also comments on the exodus in his "), _c('em', [_vm._v("Life of Moses")]), _vm._v(" and in several passages throughout his corpus. Josephus rewrites Exodus in the "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" and also deals with the historical accuracy of the biblical account in his apologetic book "), _c('em', [_vm._v("Against Apion,")]), _vm._v(" in which he tries to refute slanderous accounts of the origins of the Jewish people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To this list one may add the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" and 3 Maccabees, insofar as the biblical story of the exodus constitutes an implicit background for both. However, apart from very limited references, the exodus is not explicitly dealt with in these two works, which are concerned with more recent “historical” events.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Writings Based on Other Biblical Books")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The other books of the Torah — Leviticus, Numbers, and Deuteronomy — were apparently given much less attention, but this is probably a misleading picture. The church fathers who quoted Jewish authors were not interested in their interpretation of specific commandments but were looking for testimonies about the patriarchs — hence their interest in passages from Genesis and the beginning of Exodus. However, the Wisdom of Solomon (chap. 12) alludes to specific passages from Deuteronomy (and perhaps from Joshua) that refer to the fate of the Canaanites. The works that deal most extensively with Leviticus, Numbers, and Deuteronomy are Philo’s "), _c('em', [_vm._v("On the Special Laws")]), _vm._v(" and Josephus’ "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" (3.208–4.331).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("Occasionally, other biblical books inspired works written in Greek. Demetrius’ work was actually entitled "), _c('em', [_vm._v("Concerning the Kings in Judea,")]), _vm._v(" and the sixth fragment is a chronological summary of Israel’s history based on material from 2 Kings. One of Eupolemus’ works is also known as "), _c('em', [_vm._v("Concerning the Kings in Judea.")]), _vm._v(" Fragments 2 to 4, which refer to another book by Eupolemus entitled "), _c('em', [_vm._v("Concerning the Prophecy of Elijah,")]), _vm._v(" rely on the Deuteronomistic History in general, especially 2 Samuel though 2 Kings, and perhaps Jeremiah as well. Eupolemus (frg. 5) also attempted chronological calculations, from Adam to the reign of Demetrius I Soter (162-150 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v("). He seems to have been followed by Justus of Tiberias, who apparently wrote a "), _c('em', [_vm._v("Chronicle of Jewish Kings")]), _vm._v(" (from Moses to Agrippa II), perhaps a comprehensive world chronicle, which was used by later Christian chroniclers but has not survived. In his "), _c('em', [_vm._v("Jewish Antiquities,")]), _vm._v(" Josephus rewrites the history of the Jewish people from Adam to the time of Nero and therefore uses a great diversity of biblical books, including ones written in the Hellenistic period like Daniel and Esther. He ")]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("also uses Jewish books that were not included in the rabbinic canon, such as the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" and 1 Maccabees.")])]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among the Jewish authors quoted by the church fathers is a certain Aristeas, often called “the Exegete” to distinguish him from the narrator of the "), _c('em', [_vm._v("Letter of Aristeas.")]), _vm._v(" He wrote the book "), _c('em', [_vm._v("On the Jews")]), _vm._v(" and summarized the story of Job, probably at the end of his account of Genesis (since Job is presented as a son of Esau). The pseudepigraphic "), _c('em', [_vm._v("Testament of Job")]), _vm._v(" rewrites more extensively the story of this pious character, presenting him as a convert who purifies a nearby temple from its idolatrous cult and as a consequence is persecuted by Satan. Finally, two Jewish synagogal sermons originally written in Greek and wrongly attributed to Philo have been transmitted to us in an Armenian translation. The first one is based on the book of Jonah, the second on the story of Samson in the book of Judges.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Writings with Little or No Basis in Biblical Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before we turn to a different aspect of Jewish literature written in Greek, a few words should be said about the works that do not evoke biblical characters and topics in an explicit or significant way. To this category belong several pseudepigrapha: the Pseudo-Orphic verses, Pseudo-Hecataeus, the Jewish "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" and Pseudo-Phocylides. To this group we may add the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" which is not a pseudepigraph "), _c('em', [_vm._v("stricto sensu,")]), _vm._v(" since no famous Greek writer named Aristeas is known to us, but which pretends to be written by a Greek instead of a Jew. That no reference to the Bible should be found in texts purportedly written by non-Jews comes as no surprise. However, there are biblical expressions or implicit references to biblical texts in works like the "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" and the "), _c('em', [_vm._v("Sentences")]), _vm._v(" of Pseudo-Phocylides. Sometimes explicit references can be found too, as in the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" in which the dietary laws of Leviticus 11 are openly discussed along with other biblical and Jewish notions. But even in the case of the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" the topic of the work does not come from a biblical book. Other works that do not have their point of departure in biblical tradition include those that deal with religious persecutions (2, 3, and 4 Maccabees), with Jewish history during the Hellenistic and Roman periods (Philo’s "), _c('em', [_vm._v("In Flaccum")]), _vm._v(" and "), _c('em', [_vm._v("Legatio ad Gaium,")]), _vm._v(" Justus of Tiberias’ history of the Jewish war, Josephus’ "), _c('em', [_vm._v("Jewish War")]), _vm._v(" and the final part of his "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v("), and with apologetics (Josephus’ "), _c('em', [_vm._v("Against Apion")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Literary Genres Represented")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("Jewish texts composed in Greek employ a great diversity of literary genres. The texts can be classified most broadly as poetry or prose. To the first category belong Philo the Epic Poet, Theodotus, Ezekiel the Tragedian, the "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" Pseudo-Orpheus and other forged verses of Greek poets, Pseudo-Phocylides, and the Wisdom of Solomon. To the second belong Demetrius, Artapanus, Aristobulus, the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" Eupolemus, Pseudo-Eupolemus, Aristeas the Exegete, 2 Maccabees, Pseudo-Hecataeus, the Prologue to Ben Sira, Cleodemus Malchus, ")]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("3 Maccabees, Philo of Alexandria, Justus of Tiberias, Josephus, "), _c('em', [_vm._v("Joseph and Aseneth,")]), _vm._v(" 4 Maccabees, the "), _c('em', [_vm._v("Testament of Job,")]), _vm._v(" and the synagogal sermons "), _c('em', [_vm._v("On Jonas")]), _vm._v(" and "), _c('em', [_vm._v("On Samson.")]), _vm._v(" These texts can be further classified according to literary genre, even though one work may blend together several genres. The "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" for instance, is a good example of the Hellenistic taste for "), _c('em', [_vm._v("poikilia —")]), _vm._v(" literary and stylistic diversity within a single work.")])]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Prose Works Dealing with the Past")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Several Jewish works composed in Greek are prose literature about the past, a rather loose category that includes genres such as chronography, historiography, and ethnography but also historical fiction "), _c('em', [_vm._v("(Joseph and Aseneth).")]), _vm._v(" Several authors and texts belong to this group: Demetrius, Artapanus, the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" Aristeas the Exegete, Eupolemus, Pseudo-Eupolemus, Cleodemus Malchus, Pseudo-Hecataeus, 2 Maccabees, 3 Maccabees, Philo’s "), _c('em', [_vm._v("In Flaccum")]), _vm._v(" and "), _c('em', [_vm._v("Legatio ad Gaium,")]), _vm._v(" Justus of Tiberius, Josephus’ "), _c('em', [_vm._v("Jewish War")]), _vm._v(" and "), _c('em', [_vm._v("Jewish Antiquities,")]), _vm._v(" and "), _c('em', [_vm._v("Joseph and Aseneth.")]), _vm._v(" The term “history” has completely different meanings from one text to another. In several cases, history means biblical history, and the work may not look like history at all to the modern reader, who would classify it either as rewritten Bible (a rather anachronistic label) or as midrashic literature. However, these ancient writers certainly thought that they were writing history. Moreover, when dealing either with biblical history or with events more or less contemporaneous with the author, many texts contain sometimes glaring inaccuracies and frequently describe miracles and interventions by angels, so that the distinction between historiography and legend is blurred. Obviously, ancient texts should not be judged according to modern historiographic standards, especially given the variety of genres represented, from the nearly classical historiography exemplified by Josephus’ "), _c('em', [_vm._v("Jewish War,")]), _vm._v(" to the very creative rewriting of Exodus by Artapanus, to the highly fictional story told in 3 Maccabees.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Sapiential and Parenetic Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sapiential and parenetic literature comprise a second group of texts, to which the following works belong: Prologue to Ben Sira, Pseudo-Phocylides, Wisdom of Solomon, "), _c('em', [_vm._v("Testament of Job,")]), _vm._v(" 4 Maccabees, and the synagogal sermons "), _c('em', [_vm._v("On Jonas")]), _vm._v(" and "), _c('em', [_vm._v("On Samson.")]), _vm._v(" Once again, nearly every text belongs to a specific subgenre, such as gnomic poetry (Pseudo-Phocylides), sermon, testament, and so on. The Prologue to the Wisdom of Ben Sira, written by Ben Sira’s grandson, is not a sapiential work in itself but merely introduces the Greek translation of Ben Sira’s ethical teaching, which closely resembles the biblical book of Proverbs. The Wisdom of Solomon is also strongly reminiscent of Proverbs (especially Proverbs 8) but is much more concerned with the fate of the righteous after death. 4 Maccabees can be considered both a diatribe and a panegyric, but it aims at religious edification. The work may have been delivered orally at some unknown commemorative festival.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_187"
    }
  }), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("Although most Jewish texts written in Greek deal with biblical traditions, there are very few exegetical works. Demetrius addresses the origin of the weapons held by the Israelites in the desert (frg. 5); because they departed from Egypt unarmed, the question of how they acquired weapons naturally presented itself. Similarly, in his "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" Josephus implicitly or explicitly deals with exegetical problems. But in neither case is the prime focus of the work on exegesis as such. Rather, the use of scriptural material for the purpose of historiography prompts the writer to analyze problematic aspects of the biblical text. In contrast, Aristobulus and Philo focus on the explanation of the biblical text as such and read the texts at different levels, both literally and symbolically or allegorically.")])]), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Philosophy")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Philosophical treatises in the strict sense of the term are even rarer. Philo of Alexandria is the only early Jewish author known to have written whole treatises dedicated to philosophical questions (e.g., "), _c('em', [_vm._v("De Aeternitate Mundi")]), _vm._v(" and "), _c('em', [_vm._v("Quod Omnis Probus Liber Sit")]), _vm._v("). The use of philosophical concepts or vocabulary in exegetical treatises such as Aristobulus’ work, or in sapiential or parenetic texts such as the Wisdom of Solomon and 4 Maccabees, does not allow us to characterize these works as philosophical treatises "), _c('em', [_vm._v("stricto sensu.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Apology")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There are at least two Jewish apologetic works written in Greek, Philo’s "), _c('em', [_vm._v("Hypothetica")]), _vm._v(" (preserved only in part in Eusebius’ "), _c('em', [_vm._v("Praeparatio Evangelica")]), _vm._v("), and Josephus’ "), _c('em', [_vm._v("Against Apion.")]), _vm._v(" However, there are many apologetic passages in the rest of Philo’s and Josephus’ works. Furthermore, Jewish works written in Greek often emphasize the superiority of Judaism over Greek culture and are therefore not devoid of apologetic overtones.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Autobiography")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Josephus produced a work belonging to yet another literary genre, the "), _c('em', [_vm._v("Life,")]), _vm._v(" which is the fullest surviving example of Roman autobiography before Augustine’s "), _c('em', [_vm._v("Confessions.")]), _vm._v(" It was appended to the "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" and was often read as an integral part of the latter but nevertheless remains an early example of personal memoir.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Epic Poetry and Drama")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("Epic poetry is represented by Philo the Epic Poet and Theodotus. Other poetic texts belong to different categories. The "), _c('em', [_vm._v("Sibylline Oracles,")]), _vm._v(" for instance, represent a specific type of oracular poetry. Finally, we have one Jewish tragedy on the exodus, ")]), _c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_vm._v("written by an Egyptian Jew named Ezekiel who wrote in Alexandria in the middle of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(" He wrote his play in iambic trimeters, the standard meter used in Greek drama. He relied on the Septuagint but introduced several interesting haggadic embellishments. The most famous and debated scene has Moses report a dream that he had in which he was enthroned in heaven. His drama was certainly performed for a Jewish audience, perhaps in a synagogue.")])]), _c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("The Influence and Reshaping of Greek Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In most cases, the Jewish authors writing in Greek show a great familiarity with Greek literary themes and ideas, not only from the classical period but also from the Hellenistic age. This is especially true of the poetic texts. Theodotus uses Homeric expressions in a very skillful way, so that the fight of Simeon and Levi against Shechem and Hamor is reminiscent of Homeric battle scenes. In particular, the image of Shechem on his knees, clutching at the knees of Levi, recalls the image of Lycaon clutching the knees of Achilles, who slays him ("), _c('em', [_vm._v("Iliad")]), _vm._v(" 21.65). But Theodotus also uses non-Homeric terms that occur in Hellenistic epic poetry. Philo the Epic Poet’s language is notably obscure, and his style has been characterized as pretentious, but it is actually quite typical of this form of Hellenistic epic. Pseudo-Phocylides was clever enough for his dactylic hexameters written in the old Ionic dialect to be considered authentic for many centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only were Jewish authors writing in Greek able to imitate the styles and literary models of well-known Greek poets and tragedians, but they were also very familiar with Greek mythology, historiography, and philosophy. The Jewish “historians” were able to connect biblical figures to Greek, Babylonian, and Egyptian divine or heroic figures. For instance, Pseudo-Eupolemus identifies Bel with Cronos and presents him as the grandfather of Canaan, whom he considers the ancestor of the Phoenicians. He also equates Atlas with Enoch. In the "), _c('em', [_vm._v("De Praemiis et Poenis")]), _vm._v(" (23), Philo of Alexandria writes that Noah and Deucalion are the same person. At the beginning of his "), _c('em', [_vm._v("Jewish Antiquities,")]), _vm._v(" Josephus allusively establishes a relationship between the Nephilim (Gen. 6:4) and the giants, probably with reference to Hesiod’s "), _c('em', [_vm._v("Theogony")]), _vm._v(" ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 1.73). This is not unparalleled in Hebrew or Aramaic literature; both "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" (10:2) and "), _c('em', [_vm._v("Jubilees")]), _vm._v(" (5:6) implicitly link the Watchers (the angels who mated with women) to the Titans bound in Tartarus. Josephus also endeavors to compare biblical chronologies with those of other cultures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although Justus of Tiberias’ work has not been preserved, he seems to have made use of the Hellenistic universal chronicles even more intensively than Josephus did. Josephus himself was inspired by Greek precursors to a considerable extent, and he mastered the conventions of Greek historiography. He seems to have been particularly influenced by Thucydides and Dionysius of Halicarnassus. Before Josephus, Jewish authors who produced historiographical works or historical fiction, such as Eupolemus and the author of 3 Maccabees, also displayed great ability in imitating the language used in official Hellenistic and Roman documents.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_189"
    }
  }), _c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_vm._v("Greek philosophy was also relatively well known by several Jewish authors, even if they generally did not write philosophical treatises. Aristobulus is introduced by Clement of Alexandria as a Peripatetic philosopher ("), _c('em', [_vm._v("Stromateis")]), _vm._v(" 1.15.72.4), whereas the fragments quoted show that he was well acquainted with Stoic allegorical readings of Homer and with Pythagorean theories of numbers. Philo’s command of Greek philosophy and of the debates among the different philosophical schools of his time is remarkable and ranks far beyond that of any other Jewish author writing in Greek. Yet the way in which the author of 4 Maccabees freely presents Stoic notions such as the mastery of reason over the passions in Jewish garb also shows a familiarity with Hellenistic philosophical teachings.")])]), _c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In short, Jewish texts written in Greek are especially interesting for their complex intertextual relationship with biblical or Jewish literature on the one hand and with Greek literature on the other. Jewish authors had a rather good knowledge of Greek literature and philosophy, and even quoted Greek texts along with biblical ones to illustrate a specific point. Their efforts to adapt biblical narratives to Greek literary forms such as poetry and drama also led to significant literary achievements. Thus, Hellenistic culture was also the culture of these Jewish authors, especially in the case of Aristobulus, Theodotus, Pseudo-Phocylides, and Philo. It was "), _c('em', [_vm._v("theirs,")]), _vm._v(" even if not in the same way as biblical traditions were. Obviously, Jewish culture had its own integrity, whereas Greek culture was originally foreign to Judaism. But in Jewish authors writing in Greek, we may indeed speak of Greek-Jewish culture because both cultures were closely intertwined. The use of the Greek language was not a mere stopgap to make up for a deficient knowledge of Hebrew or Aramaic but an intrinsic part of the identity and worldview of early Jewish authors. And since words do not convey meanings in a neutral way, even the simplest statement of Jewish beliefs and customs in Greek took on a slightly different meaning than one formulated in Hebrew or Aramaic and gave birth to a different kind of Judaism. This is not to say that early Jewish writings composed in Greek did not share common themes or characteristics with their counterparts in Hebrew or Aramaic. A closer look at the issues tackled by the former will help us evaluate their connections with the latter.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Some Important Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Regardless of their literary genre, all early Jewish works composed in Greek convey a religious message at one level or another. Even Josephus’ "), _c('em', [_vm._v("Jewish War")]), _vm._v(" contains considerable theological interpretation, and Philo’s arguments against the rationality of animals in "), _c('em', [_vm._v("De Animalibus,")]), _vm._v(" to cite but one example, have an implicit biblical background: the first chapters of Genesis, which establish the superiority of human beings over animals. So there is no “profane” Jewish literature written in Greek, even if many texts perform functions besides religious edification and even aim at entertaining their audience. Humor, pleasure, aesthetics, polemics, and religious or moral instruction are not mutually exclusive goals.")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_190"
    }
  }), _c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_c('strong', [_c('em', [_vm._v("Jews and Foreign Rulers")])])])]), _c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Beyond this general statement, several key issues can be emphasized. First, a strikingly recurrent theme of Jewish literature written in Greek consists in reflections about the relationship between the king or the emperor and his Jewish subjects. It represents a major topic in the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" 2 Maccabees, 3 Maccabees, Philo’s "), _c('em', [_vm._v("In Flaccum")]), _vm._v(" and "), _c('em', [_vm._v("Legatio ad Gaium,")]), _vm._v(" Josephus’ "), _c('em', [_vm._v("Jewish War")]), _vm._v(" and part of his "), _c('em', [_vm._v("Jewish Antiquities.")]), _vm._v(" It also appears, though to a lesser extent, in 4 Maccabees. All these works convey a certain vision of what a good king or emperor should be. The good monarch is the one who protects the Jews and grants them the right to live according to their ancestral laws and customs. In the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" the king even bows down in front of the Mosaic law and gives orders for the banquet to be prepared according to Jewish dietary laws. Moreover, he is willing to take advice on how to rule from the Jewish sages who come from Jerusalem. In works that describe a historical or fictional religious persecution, either perpetrated or only planned — Antiochus IV in 2 Maccabees and 4 Maccabees, Ptolemy IV in 3 Maccabees, Ptolemy VI in Josephus, "), _c('em', [_vm._v("Against Apion")]), _vm._v(" 2.51-55, Caligula, and Flaccus — a negative portrait of the ruler is drawn that helps to define what a good and just sovereign should be. In many instances, the monarch or his representatives repents of his wicked ways and recognizes the greatness of the God of Israel. This is the case with Heliodorus and Antiochus IV in 2 Maccabees and with Ptolemy IV in 3 Maccabees. The alternative scenario is the death of the impious ruler, as in the case of Flaccus and Caligula. However, a quite different picture emerges from Josephus’ writings, due to his perspective on the First Revolt and his position as a protégé of the Flavians. In the "), _c('em', [_vm._v("Jewish War,")]), _vm._v(" he is at pains to describe Vespasian and Titus in a positive light, even if he is not as uncritical as some commentators have thought. In the "), _c('em', [_vm._v("Antiquities,")]), _vm._v(" he also insists on the “privileges” granted to the Jews by the Roman senate and the Roman emperors, who generally allowed the Jews to live according to their ancestral traditions. In this respect, Josephus’ conception of the just ruler is similar to that of his predecessors from Alexandria.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another leitmotiv in these texts is the Jews’ faithfulness to the king. It is stressed again and again that the Jews are loyal subjects. According to these texts, the normal or ideal relationship between Jews and Hellenistic or Roman rulers is one of mutual trust and collaboration: the king protects the Jews and grants them the right to live according to their laws, at least in certain matters, and the Jews serve the king, pray for his welfare and that of his kingdom, dedicate "), _c('em', [_vm._v("proseuchai")]), _vm._v(" (houses of prayers) to him and his family, and even offer sacrifices at the Jerusalem Temple on his behalf. The same theme also appears in works composed in Hebrew and Aramaic, such as Daniel, Esther, and 1 Maccabees. Yet these works tend to depict non-Jewish sovereigns in a harsher light than do the Jewish texts written in Greek, and to present a less optimistic vision of the relationship between Jews and foreign rulers. There is no Hebrew or Aramaic counterpart of the "), _c('em', [_vm._v("Letter of Aristeas.")]), _vm._v(" This fact likely owes to the different ways in which Ptolemaic and Seleucid rule were experienced by Jews in Eretz Israel and in the Diaspora.")])]), _c('h1', {
    staticClass: "sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_191"
    }
  }), _c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_c('strong', [_c('em', [_vm._v("Jews and Non-Jews")])])])]), _c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A second issue is the relationship between Jews and non-Jews. Especially prominent is the topic of endogamy, the prohibition against marrying non-Jews. It is not always stated explicitly but can arise from small modifications to the biblical narrative. For instance, in Demetrius’ account of the life of Moses (frg. 3), Zipporah, Moses’ wife, whom the biblical text describes as a Midianite (Exod. 2:21), becomes a descendant of Abraham. Theodotus is more straightforward; when retelling the rape of Dinah, he omits Jacob’s condemnation of his sons’ violence. Moreover, the Shechemites are depicted as utterly wicked and are denied the possibility of joining the people of Israel through circumcision and of marrying the daughters of Israel. Philo is also quite explicit about the prohibition of marriage to foreigners ("), _c('em', [_vm._v("Spec. Leg.")]), _vm._v(" 3.29), but since he is merely paraphrasing Deut. 7:4, which refers to the Canaanites, it is not clear how he understood this interdiction in his own context. From the rest of his work, one may guess that he accepted intermarriage only with non-Jews who converted to Judaism. The synagogue sermon "), _c('em', [_vm._v("On Samson")]), _vm._v(" uses the example of Samson’s unhappy relationship with Delilah (Judges 14–16) to insist on the danger represented by a union with a foreign woman (see especially §§22-23, 33). Similarly, in his "), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" Josephus paraphrases the biblical account of the reign of Solomon and condemns his passion for foreign women ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 8.190-96). In the "), _c('em', [_vm._v("Testament of Job")]), _vm._v(" (45:3), Job exhorts his children not to marry foreign women. Like Demetrius, the author of "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" addresses a problem that stems from the biblical text: the reference to Joseph’s marriage to the daughter of an Egyptian priest (Gen. 41:45). The author could have solved the problem by noting that Joseph lived before the Law was given at Mt. Sinai and therefore did not know the Mosaic legislation concerning forbidden unions, but he took a different approach. One passage in "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" (8:6) bluntly emphasizes that Joseph hated foreign women. Aseneth therefore becomes a convert, an outcome that the very beginning of the work foreshadows by stating that she did not look like the daughters of the Egyptians but rather like the daughters of the Hebrews, and even like Sarah, Rebecca, and Rachel (1:7-8).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jewish authors writing in Greek, then, seem unanimous in their condemnation of exogamy. However, there are a few exceptions. Artapanus and Ezekiel the Tragedian do not seem to have been bothered by the foreign wives of Joseph and Moses. Moreover, Artapanus apparently had a very open definition of the descendants of Israel. According to him, Joseph anticipated the conspiracy of his brothers and willingly traveled to Egypt with the help of the kings of the Arabs, who were “sons of Abraham and brothers of Isaac” and, as such, “descendants of Israel” (Eusebius, "), _c('em', [_vm._v("Praep. Evang.")]), _vm._v(" 9.23.1). Whereas the condemnation of forbidden unions can also be found in Jewish literature written in Hebrew (e.g., in "), _c('em', [_vm._v("Jubilees")]), _vm._v("), Artapanus’ and Ezekiel’s lenient attitude is peculiar to Jewish literature written in Greek.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_vm._v("Circumcision is an issue closely connected with endogamy and with the preservation of Jewish identity, but it is not mentioned that often in Jewish texts written in Greek. Apart from Theodotus’ epic poem, it is referred to in 2 Maccabees, in the context of the persecution ordered by Antiochus IV. The author tells us that ")]), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("circumcision was prohibited but that pious Jews resisted and even died rather than give up circumcising their children (2:10). 4 Maccabees also reports the fact, without building upon it except to introduce the story of the martyrs. Philo justifies the commandment of circumcision at some length at the beginning of the "), _c('em', [_vm._v("Special Laws,")]), _vm._v(" whereas Josephus refers to it only briefly in his retelling of the life of Abraham ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 1.192) and mentions it again in connection with the conversion of non-Jews to Judaism (especially in "), _c('em', [_vm._v("Ant.")]), _vm._v(" 20.38-48, the story of the conversion of King Izates).")])]), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The dietary laws constitute yet another frequent theme pertaining to the general issue of the relationships between Jews and non-Jews. In the "), _c('em', [_vm._v("Letter of Aristeas,")]), _vm._v(" the high priest Eleazar explains the dietary laws in a symbolic way and emphasizes that they are supposed to lead to justice in social relationships (§§143-69), but he also states that they belong to the purity laws that are meant to separate the Jews from people who practice idolatry (§§139, 142). 3 Maccabees tends to equate faithfulness to the Torah with observance of the dietary rules. Moreover, its author acknowledges that these laws separate the Jews from their non-Jewish neighbors, and that this social "), _c('em', [_vm._v("amixia")]), _vm._v(" is perceived as a mark of hostility by those who are themselves hostile to the Jews. He does not give the commandments up for all that, but rather affirms that Jews have won for themselves a good reputation in social intercourse thanks to their righteousness (3:4-7). The issue of the dietary laws is found in the most dramatic way in 2 and 4 Maccabees, where it is linked to the story of the prohibition of Judaism by Antiochus IV. The old Eleazar, the seven brothers, and their mother are all put to death because they refuse to eat pork (2 Macc. 6:18–7:42; 4 Maccabees 5–18). Both Philo and Josephus frequently refer to the Jews’ faithfulness to their ancestral laws, including the dietary laws. Philo explains them in a symbolic or allegorical way ("), _c('em', [_vm._v("Spec. Leg.")]), _vm._v(" 4.100-118) but also insists on the necessity of putting them into practice ("), _c('em', [_vm._v("De Migratione Abrahami")]), _vm._v(" 90–93). Finally, in "), _c('em', [_vm._v("Joseph and Aseneth,")]), _vm._v(" Joseph refuses to kiss Aseneth because she worships idols and eats impure food (8:5). Jewish texts written in Hebrew and Aramaic take up the issue of dietary laws too, but they tend to focus on halakic aspects rather than on the question of the laws’ implications for the relationship with pagans. And in comparison with 2 Maccabees, 1 Maccabees is much less concerned with the dietary laws.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("To conclude on the theme of the relationships between Jews and non-Jews, a few words should be said about the issue of conversion. Interestingly enough, converts and conversions appear in rather late texts. Philo praises proselytes who abandon idolatry or wrong conceptions about God and join Israel (see especially "), _c('em', [_vm._v("De Virtutibus")]), _vm._v(" 179, 182, and 219). In the "), _c('em', [_vm._v("Antiquities,")]), _vm._v(" Josephus reports the story of the conversion of the king of Adiabene, and mentions other cases as well. In "), _c('em', [_vm._v("Against Apion,")]), _vm._v(" he follows Philo in stating that Judaism’s openness to proselytes is a mark of "), _c('em', [_vm._v("philanthrōpia")]), _vm._v(" (2.261). But in the "), _c('em', [_vm._v("Antiquities")]), _vm._v(" and the "), _c('em', [_vm._v("Life,")]), _vm._v(" Josephus also confronts the issue of forced conversions to Judaism, in the context of the Hasmonean wars and the war against Rome (see "), _c('em', [_vm._v("Ant.")]), _vm._v(" 13.257-58; 318-19; "), _c('em', [_vm._v("Life")]), _vm._v(" 112–13). Other texts that refer to proselytes are "), _c('em', [_vm._v("Joseph and Aseneth")]), _vm._v(" and the "), _c('em', [_vm._v("Testament of Job,")]), _vm._v(" whose main characters are converts. They both date from the first century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v(" (if not later). This list probably reflects the fact that the very notion of conversion ")]), _c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_vm._v("and the ritual surrounding it — which should be distinguished from mere recognition of the God of Israel as the one true God — emerged and developed only at the end of the Hellenistic period. Among Greek translations of Jewish texts originally written in Hebrew or Aramaic, Esther LXX (8:17) and Judith (5:5–6:20) allude to or explicitly deal with conversions, but these translations are late as well (and the original version of Judith itself only dates from the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("Judaism’s Superiority over Paganism")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A third theme frequently found in Jewish texts written in Greek, perhaps the most widespread of all, is the superiority of Judaism over paganism. This theme has important biblical roots but received a new impetus in the Hellenistic age. On the one hand, as in biblical texts, idols are condemned and mocked as handmade objects with no power to save, and those who worship them are depicted as foolish, wicked, or abominable. This is the case in several texts, including the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" (134–38 in particular), Pseudo-Hecataeus (who, through the story of Mosollamus, mocks pagan superstitious belief in omens), 3 Maccabees (4:16 in particular), Wisdom of Solomon, Philo, Josephus, "), _c('em', [_vm._v("Testament of Job,")]), _vm._v(" and "), _c('em', [_vm._v("Joseph and Aseneth.")]), _vm._v(" On the other hand, a monotheistic creed is attributed to well-known figures much admired by the Greeks, such as Orpheus, Homer, Hesiod, Pythagoras, Plato, and a few others, but they are said to have been inspired by Abraham, Joseph, or Moses. Thus, even if Greek culture is not utterly rejected as vile paganism, it is still considered inferior to Judaism since it derives its truth and its beauty from Judaism — hence the efforts of Josephus and others to demonstrate the great antiquity of the Jewish people and of the Mosaic revelation, which in their view predated the beginnings of Greek civilization. Hence, also, the use of pseudepigraphy in the pseudo-Orphic poem and the other verses attributed to famous Greek poets, and in the "), _c('em', [_vm._v("Sibylline Oracles.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All these works were conceived of as pagan testimonies to the truth and superior wisdom of Judaism. Even Artapanus, who presents Moses as the founder of Egyptian animal cults, was motivated by a sense of Judaism’s superiority to Egyptian paganism. True, his perception of the latter is not as negative as in other Jewish texts (especially the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" and Philo, who abhor Egyptian animal cults). But Moses’ role as cultural benefactor in Egypt is still a mark of the superiority of Judaism over the culture of the natives. And the worship of animals is explained euhemeristically, implying that they are only animals that Moses judged to be useful. Moreover, Moses is identified with Mousaeus, the teacher of Orpheus. Thus, Artapanus celebrates the superiority of Judaism over both Egyptian and Greek culture, which is why his work can be considered an example of “competitive historiography.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_c('strong', [_c('em', [_vm._v("The Mutual Faithfulness of God and Israel")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_vm._v("A fourth theme prevalent in Jewish literature written in Greek is the mutual faithfulness of God and Israel. Several texts highlight God’s justice and his providential ")]), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("care for Israel or reward of the righteous. For instance, in contrast to 1 Maccabees, 2 Maccabees introduces the episode of Heliodorus and of God’s miraculous intervention to preserve the Temple in Jerusalem (chap. 3) and describes Antiochus IV’s agony at length (chap. 9). Similarly, 3 Maccabees celebrates God’s intervention at the Jerusalem Temple but also at the hippodrome in Alexandria (1:8–2:24 and 5:46–6:29, respectively). Philo makes it very clear that Flaccus’ disgrace was a divine punishment ("), _c('em', [_vm._v("In Flaccum")]), _vm._v(" 180–91). Even Artapanus gives an example of divine retribution when he writes that, because of his treatment of the Jews, the Egyptian ruler Chenephres was the first man to contract elephantiasis (frg. 3 in Eusebius, "), _c('em', [_vm._v("Praep. Evang.")]), _vm._v(" 9.27.20). The Wisdom of Solomon also recalls God’s intervention in favor of Israel and his chastisement of the Egyptians and the Canaanites. Yet it argues first and foremost that the righteous will be blessed with eternal life, whereas his adversaries will be punished and disappear forever. Similarly, the "), _c('em', [_vm._v("Testament of Job")]), _vm._v(" describes the righteous hero who suffers but is finally rewarded and achieves immortality, in contrast to the wicked Elihu, who is condemned to permanent destruction. In all cases, what is at stake is divine justice and the ways it manifests itself, either in this world or in the afterlife, at a collective or individual level. In the latter, eschatological concerns lead to the belief in bodily resurrection (2 Maccabees, "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" 4) and the immortality of the soul (Wisdom of Solomon, Philo, "), _c('em', [_vm._v("Testament of Job")]), _vm._v("). Messianic expectations do not figure prominently in Jewish literature written in Greek, although some hints may be found in Philo, Josephus, and "), _c('em', [_vm._v("Sibylline Oracles")]), _vm._v(" 5.")])]), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To God’s faithfulness toward Israel corresponds Israel’s faithfulness to God and his Law. Jewish texts written in Greek tend to present the Jewish people as pious. Apostates are few. In 2 Maccabees, impious Jews in Jerusalem try to introduce a Greek way of life and to alter the ancestral customs, thus causing the wrath of God to fall on the Judeans (4:7-17). In 3 Maccabees, some Jews yield to Ptolemy’s threats and promises, and apostatize through their initiation into the Dionysian mysteries (2:31-33). However, in both these books the vast majority of the Jews remain faithful to the covenant. At a more individual level, Aristeas and the "), _c('em', [_vm._v("Testament of Job")]), _vm._v(" retell the story of Job, the righteous man who continued to trust in God despite his great hardships. Particularly interesting are the stories of martyrdom or readiness to undergo martyrdom in 2, 3 and 4 Maccabees, as well as in several passages in Philo and Josephus (though martyrdom should be distinguished from noble death and suicide). Martyrdom is the supreme expression of the Jews’ faithfulness to God’s laws. Jewish readiness to die for the Law is emphasized by several authors, including Philo and Josephus. Conversely, apart from allusions in Daniel and 1 Maccabees (whose account is much shorter than that of 2 Maccabees and does not promote martyrdom), this theme does not appear frequently in Jewish literature written in Hebrew or Aramaic, even if apocalyptic literature often refers to a period of trials before the final reward of the elect. However, the more general issue of God’s justice and Israel’s faithfulness to the covenant is a recurring topic in Jewish literature written in Hebrew or Aramaic too.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("This list of themes is not exhaustive; Jewish texts written in Greek engage other issues as well. But some themes are strikingly absent or marginal: messianism and cultic prescriptions, to name just a few. If one were to add to the corpus ")]), _c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_vm._v("texts such as "), _c('em', [_vm._v("3 Baruch, 4 Baruch (Paraleipomena Jeremiou), Testament of Abraham,")]), _vm._v(" and "), _c('em', [_vm._v("2 Enoch,")]), _vm._v(" heavenly visions and angelic revelations would feature more prominently in the general picture. The Jewish or Christian provenance of these works, though, continues to be disputed. Also conspicuous is the lack of liturgical and halakic texts. Here again, though, the shape of the corpus likely reflects the selective interests of the church fathers.")])]), _c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Ideological Features")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jewish works composed in Greek do not display uniform ideological features. For instance, Theodotus’ epic poem reflects a nationalistic and exclusive conception of Judaism. As mentioned above, he completely omits Jacob’s condemnation of the aggression perpetrated by Simeon and Levi against the Shechemites (Gen. 34:30). By contrast, the author of 4 Maccabees refers to this condemnation and even quotes Gen. 49:7: “Cursed be their anger, for it is fierce, and their wrath, for it is cruel.” According to him, the very fact that Jacob says about Simeon and Levi “May their anger be cursed” means that reason is able to restrain anger (4 Macc. 2:19-20). The violence with which the two brothers avenged their sister, which seemed so praiseworthy to Theodotus that he presented it as the fulfillment of an oracle from God, is depicted as a reprehensible passion by the author of 4 Maccabees. The same degree of disagreement can be noticed concerning other issues. For example, as we noted above, not all Jewish authors writing in Greek condemned marriages to foreign women. Moreover, had the writings of extreme allegorizers of Scripture (criticized by Philo in "), _c('em', [_vm._v("De Migratione Abrahami")]), _vm._v(" 89–90) been preserved, we would probably have an even more diverse picture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The use of the Greek language and the mastery of Greek literary forms, then, does not in itself predetermine the ideological or philosophical orientation of the writer. In particular, writing in Greek is not synonymous with openness to Gentiles or universalism. Still, in Second Temple literature the most universalistic texts are indeed to be found among those written in Greek, especially those of Aristobulus and Philo. Universalism, though, is not based primarily on a willingness to welcome proselytes but rather on a broad understanding of God’s law and of the cult at the Jerusalem Temple. Some Jewish authors writing in Greek boldly conceived of the Torah as a universal law that could appeal to every human being, mainly through reason. Philo goes so far as to present Israel as a priest offering sacrifices and prayers to God for the sake of all human beings ("), _c('em', [_vm._v("Spec. Leg.")]), _vm._v(" 2.163-67). It is especially in Jewish literature composed in Greek, then, that the relationship between Israel and the rest of humankind is thought out in its deepest and most positive way.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_vm._v("Scholars debate whether Jewish works composed in Greek should be labeled “apologetic” literature. On the one hand, this is not a missionary literature, even if the evidence shows that proselytes and God-fearers were welcome in the Jewish communities of the Diaspora. On the other hand, although the intended audience of the vast majority of these texts was Jewish, apologetic interests are not to be denied in some cases. To claim the superiority of Judaism over paganism and Greek ")]), _c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_vm._v("philosophy, or to provide a rationale for dietary laws and circumcision, is to engage in apologetics. But the apologia was an affirmation of the superiority of Judaism directed in most cases to Jews themselves, to help them face the challenges of their Greco-Roman environment and to strengthen and comfort them in their religious and cultural identity.")])]), _c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Significance")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jewish literature written in Greek is significant for several reasons. First, it constitutes the main literary testimony to the ways people in the ancient Near East rose to the challenge of Hellenism. Although other cultures produced important works in Greek, these works have not survived, or only in fragments, as in the case of Manetho’s "), _c('em', [_vm._v("Aegyptiaca,")]), _vm._v(" which is known mainly through Josephus’ "), _c('em', [_vm._v("Against Apion.")]), _vm._v(" Jewish literature written in Hebrew or Aramaic during the Hellenistic and early Roman periods also offers important testimony to the encounter of Judaism with Greek civilization, at least in some cases. Moreover, the archaeological and documentary evidence (inscriptions, papyri, coins, and other artifacts) sheds crucial light on the processes of acculturation that took place during the Greco-Roman period. However, Jewish works composed in Greek remain our main and most explicit evidence for the Jewish engagement with Hellenism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This literature documents a remarkable attempt to embrace Greek culture while maintaining a distinctive Jewish identity. On the one hand, it demonstrates the huge interest that Greek culture aroused among Jewish elites, and how much they could feel at home in the Greek-speaking world. On the other hand, it also shows that Jews remained very much aware of their distinctive cultural and religious identity. Admittedly, some Jews abandoned the ancestral customs of their people. We know, for instance, of Dositheos son of Drimylos and of Philo’s nephew, Tiberius Julius Alexander. “Apostasy,” if we may call it that, was probably more common among the elites than among the ordinary people. But in the case of Greco-Roman Egypt, which we know better than other places in the Diaspora, both the literary and the papyrological evidence show that, in general, Jews who expressed themselves in Greek did not indulge in religious paganism or give up the commandments of the Torah. Their culture and identity were bipolar and their relationship to Hellenism selective. They showed a great deal of creativity and boldness in appropriating Greek literary genres, Greek mythology, and Greek philosophical concepts, but used them for their own purposes. In other words, their relationship with Greek culture was not passive but active — and critical. Even when dealing with the biblical or Jewish traditions they inherited, however, they showed great exegetical freedom (a freedom not unparalleled in Hebrew and Aramaic compositions).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_vm._v("That Jews in the Hellenistic and early Roman eras borrowed concepts, literary motifs, and vocabulary from the surrounding culture was nothing new or exceptional. The biblical texts already attest many borrowings from Canaanite, Babylonian, and Persian cultures. Whatever its stage of development, Judaism was never impermeable or completely inward-looking. What was new was the attempt to ")]), _c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_vm._v("translate the tradition into a language and cultural idiom that were not Semitic. Obviously, for texts to be translated one first needed to have them reach a certain state of completion. This was achieved in the course of the Hellenistic period, as the collection of manuscripts from Qumran shows. This was a major historical and cultural phenomenon that would leave important marks on the cultural history of the world.")])]), _c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This process of translation was not merely a linguistic one. Even the Septuagint — a collection of Hebrew and Aramaic texts translated into Greek — represented a "), _c('em', [_vm._v("cultural")]), _vm._v(" translation, an endeavor to transpose Jewish beliefs and traditions into a different key. Since Jewish beliefs and traditions were not set once and for all, this transposition also gave birth to new ways of expressing Jewish identity and faith. However, the term “syncretism,” which is sometimes used in connection with Jewish texts written in Greek, is generally ill chosen. In most Jewish works composed in Greek, there is no syncretism at all, even if Greek terminology is used and Greek gods or heroes are referred to. For instance, that the narrator of the "), _c('em', [_vm._v("Letter of Aristeas")]), _vm._v(" compares the God of Israel with Zeus (16) is no proof of syncretism on the part of the real author of the "), _c('em', [_vm._v("Letter,")]), _vm._v(" since the narrator is a Greek. The comparison is part of playing the game of pseudonymous attribution. But even if “Aristeas” had been a Jew, the comparison with Zeus would still not count as religious syncretism but remain an example of cultural translation: in the mind of a Greek living in the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.E.")]), _vm._v(", the name “Zeus” did not necessarily conjure up all the mythological tales told by the poets. It could be used in a more philosophical way and refer to a more sophisticated conception of the divine. So an imperfect correlation could indeed be established between the God of Israel and what “Zeus” represented from a Greek philosophical perspective. Accordingly, “Aristeas” defines Zeus as the universal source of life and being, a definition not completely inappropriate to the God of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Above all, one should bear in mind that Jews writing in Greek frequently used Greek terminology in a subversive way. The use of a Greek term did not necessarily imply that the writer accepted the traditional Greek meaning of the word or all of its cultural implications. For example, the author of 3 Maccabees uses features of the Hellenistic kings to describe the God of Israel. One could argue that he was thoroughly Hellenized. His command of Greek and his knowledge of the language of the Ptolemaic court are certainly beyond doubt. However, the vocabulary he chose to use also conveys the idea that God alone is the true king of the world, above all human kingships. Similarly, the Wisdom of Solomon uses the term "), _c('em', [_vm._v("myst")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("ria")]), _vm._v(" to designate both the holy revelations of Wisdom (2:22) and the abominable ceremonies of the Dionysian cult (14:23). Yet the use of the term "), _c('em', [_vm._v("myst")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ē")]), _c('em', [_vm._v("ria")]), _vm._v(" in connection with Judaism is not a mark of religious syncretism but a way to oppose Judaism to pagan mysteries and to celebrate the superiority of the former. At a more distinctly philosophical level, Philo sometimes uses the Stoic term "), _c('em', [_vm._v("oikeiōsis")]), _vm._v(" (“appropriation”), which carried philosophical implications quite contrary to Jewish ethical principles. But he subverts its meaning by endowing it with the sense of "), _c('em', [_vm._v("homoiōsis t")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ō")]), _vm._v(" "), _c('em', [_vm._v("theō,")]), _vm._v(" the Platonic “assimilation to God,” which could easily be linked with the Jewish ideal of the imitation of God.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_vm._v("The encounter with Greek culture certainly represented a challenge to Jews in ")]), _c('a', {
    attrs: {
      "id": "page_199"
    }
  }, [_vm._v("the Hellenistic and early Roman periods. But it also prompted them to explore new ways of expressing their identity and to elaborate the very notion of "), _c('em', [_vm._v("Ioudaismos.")])])]), _c('a', {
    attrs: {
      "id": "page_199"
    }
  }, [_c('p', {
    staticClass: "bib-head"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bar-Kochva, Bezalel. 1996. "), _c('em', [_vm._v("Pseudo-Hecataeus on the Jews: Legitimizing the Jewish Diaspora.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. 1996. "), _c('em', [_vm._v("Jews in the Mediterranean Diaspora.")]), _vm._v(" Edinburgh: Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Burchard, Christoph. 2003. "), _c('em', [_vm._v("Joseph und Aseneth.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Collins, John J. 2000. "), _c('em', [_vm._v("Between Athens and Jerusalem: Jewish Identity in the Hellenistic Diaspora.")]), _vm._v(" 2d ed. Grand Rapids: Eerdmans.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2005. "), _c('em', [_vm._v("Jewish Cult and Hellenistic Culture: Essays on the Jewish Encounter with Hellenism and Roman Rule.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Davila, James R. 2005. "), _c('em', [_vm._v("The Provenance of the Pseudepigrapha: Jewish, Christian, or Other?")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Denis, Albert-Marie. 1970. "), _c('em', [_vm._v("Introduction aux pseudépigraphes grecs d’Ancien Testament.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 2000. "), _c('em', [_vm._v("Introduction à la littérature religieuse judéo-hellénistique.")]), _vm._v(" 2 vols. Turnhout: Brepols.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Herr, Moshe D. 1990. “Les raisons de la conservation des restes de la littérature juive de l’Époque du Second Temple.” In "), _c('em', [_vm._v("La fable apocryphe I.")]), _vm._v(" Ed. P. Geoltrain, E. Junod, and J.- C. Picard. Turnhout: Brepols, 219-30.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodman, Martin. 1986. “Jewish Literature Composed in Greek.” In E. Schürer, "), _c('em', [_vm._v("The History of the Jewish People in the Age of Jesus Christ (175 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.–A.D.")]), _vm._v(" 135).")]), _vm._v(" Vol. 3, Part 1. Rev. and ed. Geza Vermes, Fergus Miller, and Martin Goodman. Edinburgh: Clark, 470-704.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gruen, Erich S. 1998. "), _c('em', [_vm._v("Heritage and Hellenism: The Reinvention of Jewish Tradition.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Holladay, Carl. 1983-1996. "), _c('em', [_vm._v("Fragments from Hellenistic Jewish Authors.")]), _vm._v(" 4 vols. Atlanta: Scholars Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Honigman, Sylvie. 2003. "), _c('em', [_vm._v("The Septuagint and Homeric Scholarship in Alexandria: A Study in the Narrative of the Letter of Aristeas.")]), _vm._v(" London: Routledge.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Inowlocki, Sabrina. 2006. "), _c('em', [_vm._v("Eusebius and the Jewish Authors: His Citation Technique in an Apologetic Context.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, Sarah R. 2004. "), _c('em', [_vm._v("Historical Fictions and Hellenistic Jewish Identity: Third Maccabees in Its Cultural Context.")]), _vm._v(" Berkeley: University of California Press.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lanfranchi, Pierluigi. 2006. "), _c('em', [_vm._v("L’Exagoge d’Ezéchiel le tragique: Introduction, texte, traduction et commentaire.")]), _vm._v(" Leiden: Brill.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Motzo, Raimondo Bacchisio. 1977. "), _c('em', [_vm._v("Ricerche sulla letteratura e la storia giudaico-ellenistica.")]), _vm._v(" Roma: Centro Editoriale Internazionale.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Walter, Nikolaus. 1976. "), _c('em', [_vm._v("Fragmente jüdisch-hellenistischer Historiker.")]), _vm._v(" JSHRZ I, 2. Gütersloh: Gerd Mohn, 89-164.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1983. "), _c('em', [_vm._v("Fragmente jüdisch-hellenistischer Epik: Philon, Theodotos. Pseudepigraphische jüdisch-hellenistische Dichtung: Pseudo-Phokylides, Pseudo-Orpheus, Gefälschte Verse auf Namen griechischer Dichter.")]), _vm._v(" JSHRZ IV, 3. Gütersloh: Gerd Mohn.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. 1989. “Jewish-Greek Literature of the Greek Period.” In "), _c('em', [_vm._v("The Cambridge History of Judaism,")]), _vm._v(" vol. 2, "), _c('em', [_vm._v("The Hellenistic Age.")]), _vm._v(" Ed. W. D. Davies and L. Finkelstein. Cambridge: Cambridge University Press, 385-408.")])])])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467466097',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(244)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(246);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 246 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.268f091a7bf35ea4ca50.js